{
  "reporting.title": "Custom Data Export",
  "reporting.description": "Choose your report, reporting period and columns, then download a spreadsheet-ready CSV.",
  "reporting.builder": "Back to report builder",
  "reporting.queue": "My Report Queue",
  "reporting.queueEmpty": "Your generated reports will appear here.",
  "reporting.design.emptyQueuePage": "There are no reports on this page.",
  "reporting.design.firstQueuePage": "Return to the first page",
  "reporting.reportType": "Report type",
  "reporting.layout": "CSV layout",
  "reporting.layout.SPREADSHEET": "Spreadsheet — tests in columns",
  "reporting.layout.RESULT_LIST": "Detailed list — results in rows",
  "reporting.layout.TABLE": "Table",
  "reporting.meaning.SPREADSHEET": "Tests appear as columns for each specimen. Repeated results use extra rows; unrelated repeat readings are kept separate.",
  "reporting.meaning.RESULT_LIST": "Each independent result appears on its own row. Repeated results are preserved.",
  "reporting.meaning.TABLE": "Each recorded occurrence appears on its own row.",
  "reporting.dateFrom": "Date from",
  "reporting.dateTo": "Date to",
  "reporting.dates.required": "Required",
  "reporting.dates.requiredFrom": "Choose a start date.",
  "reporting.dates.requiredTo": "Choose an end date.",
  "reporting.dates.invalid": "Choose a valid calendar date.",
  "reporting.dates.reversed": "End date must be on or after the start date.",
  "reporting.dates.tooLong": "Choose a period of {days} days or fewer, including both dates.",
  "reporting.dates.range": "Choose an ordered period within the maximum shown above.",
  "reporting.periodHelp": "Uses {dateMeaning} in {timezone}, including both dates. Maximum period: {days} days.",
  "reporting.dateAnchor.collectionDate": "specimen collection dates",
  "reporting.dateAnchor.requestDate": "referral request dates",
  "reporting.dateAnchor.sentDate": "referral sent dates",
  "reporting.dateAnchor.eventOrRecordedDate": "event dates when known, otherwise recorded dates (identified by Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "non-conformance event dates",
  "reporting.dateAnchor.enteredDate": "recorded rejection dates",
  "reporting.labSections": "Lab sections",
  "reporting.allAccessibleSections": "All accessible lab sections",
  "reporting.tests": "Тестове",
  "reporting.allTests": "All tests",
  "reporting.resultStatuses": "Result statuses",
  "reporting.finalized": "Финализирано",
  "reporting.all": "Всички",
  "reporting.available": "Available columns",
  "reporting.search": "Search columns",
  "reporting.selected": "Selected columns",
  "reporting.selectedCount": "Selected columns ({count})",
  "reporting.group.sample": "Sample and order",
  "reporting.group.referrals": "Препращания",
  "reporting.group.nonConformance": "Non-Conformance / Rejections",
  "reporting.group.patient": "Пациент",
  "reporting.group.result": "Result details",
  "reporting.group.tests": "Configured tests",
  "reporting.group.components": "Configured result components",
  "reporting.group.turnaround": "Turnaround time",
  "reporting.group.testTurnaround": "Turnaround by test",
  "reporting.group.componentTurnaround": "Turnaround by result component",
  "reporting.group.observations": "Additional questions",
  "reporting.headerPreview": "CSV header preview",
  "reporting.moveUp": "Move {field} up",
  "reporting.moveDown": "Move {field} down",
  "reporting.remove": "Remove {field}",
  "reporting.position": "{field}: position {position} of {count}",
  "reporting.review": "Review report",
  "reporting.edit": "Edit report",
  "reporting.generate": "Generate CSV",
  "reporting.submitting": "Submitting report…",
  "reporting.generating": "Preparing your CSV…",
  "reporting.download": "Download CSV",
  "reporting.loading": "Loading report options…",
  "reporting.currentReport": "Your current report",
  "reporting.previous": "Предишен",
  "reporting.next": "Напред",
  "reporting.rows": "{count, plural, one {# row} other {# rows}}",
  "reporting.state.QUEUED": "Queued",
  "reporting.state.GENERATING": "Generating",
  "reporting.state.READY": "Ready to download",
  "reporting.state.FAILED": "Неуспешно",
  "reporting.state.EXPIRED": "Изтекъл срок",
  "reporting.state.CANCELLED": "Анулиран",
  "reporting.loadError": "Could not load reporting information",
  "reporting.submitError": "Could not generate the report",
  "reporting.requestError": "The request could not be completed. Your choices have been retained; try again.",
  "reporting.networkError": "The server could not be reached. Your choices have been retained; try again.",
  "reporting.request.invalid": "Check your reporting period, filters and selected columns, then try again.",
  "reporting.request.conflict": "This submission identifier was already used for different report choices. Start a new report.",
  "reporting.columns.stale": "Some selected columns are no longer available. Remove them and choose from the current catalog.",
  "reporting.jobs.limit": "You have reached the active-report limit. Wait for a report to finish, then try again.",
  "reporting.access.denied": "Your current OpenELIS access does not permit this report.",
  "reporting.access.scopeChanged": "Your access to the selected lab sections has changed. Review the report with your current access.",
  "reporting.access.noSections": "No accessible lab sections are available for this report.",
  "reporting.access.signIn": "Sign in to OpenELIS to continue.",
  "reporting.definition.changed": "The report definition has changed. Review the current report options before running again.",
  "reporting.definition.unavailable": "This report type is no longer available.",
  "reporting.tests.stale": "Some selected tests are no longer available. Review your test selection.",
  "reporting.status.invalid": "Choose an available result status.",
  "reporting.filters.unsupported": "Some requested filters are unavailable for this report. Review the current report options.",
  "reporting.filters.unavailable": "Some previous filters are unavailable for this report. Review the current filters before generating.",
  "reporting.job.generationFailed": "The CSV could not be generated. Your report request has been retained.",
  "reporting.job.expired": "This file has expired. Run the report again with a new reporting period.",
  "reporting.job.notReady": "This report is not ready to download yet.",
  "reporting.job.notFound": "This report could not be found.",
  "reporting.saved.library": "Shared reports",
  "reporting.saved.search": "Search shared reports",
  "reporting.saved.loading": "Loading shared reports…",
  "reporting.saved.loadError": "Could not load shared reports",
  "reporting.saved.empty": "No shared reports have been saved yet.",
  "reporting.saved.shared": "Available to everyone who can use reports.",
  "reporting.saved.open": "Open",
  "reporting.saved.save": "Save report",
  "reporting.saved.update": "Update shared report",
  "reporting.saved.copy": "Save a copy",
  "reporting.saved.delete": "Delete shared report",
  "reporting.saved.name": "Report name",
  "reporting.saved.confirmSave": "Save shared report",
  "reporting.saved.confirmDelete": "Изтрий",
  "reporting.saved.confirmUpdate": "Update",
  "reporting.saved.cancel": "Отказ",
  "reporting.saved.copyName": "Copy of {name}",
  "reporting.saved.created": "Saved as {name}.",
  "reporting.saved.updated": "Updated {name}.",
  "reporting.saved.freshDates": "Choose fresh dates before running this report.",
  "reporting.saved.deleteHelp": "Delete {name} from the shared report library? Existing generated files are retained.",
  "reporting.saved.updateHelp": "Replace {name} with the choices currently shown in the builder?",
  "reporting.saved.changed": "Someone changed this shared report after you opened it. Your choices are still here; reopen the current saved report or save a copy.",
  "reporting.saved.invalid": "Review the report choices before saving.",
  "reporting.saved.nameInvalid": "Enter a report name of 200 characters or fewer.",
  "reporting.saved.notFound": "This shared report is no longer available.",
  "reporting.saved.pageInvalid": "The shared report list request was invalid.",
  "accept.action.button": "Приеми",
  "accessDenied.message": "Нямате достъп до този модул, моля свържете се със системния администратор",
  "accessDenied.okButton": "ОК",
  "accessDenied.title": "Достъпът е отказан",
  "accession.entry": "Въвеждане на номер на акцесия",
  "activityReportByPanel": "Отчет за дейността по панел",
  "activityReportByTest": "Отчет за дейността по тест",
  "activityReportByTestSection": "Отчет за дейността по тестова секция",
  "add.age.range": "Добавяне на друг възрастов диапазон +",
  "add.aliquot": "Добавяне на аликот",
  "add.new.dictionary.menu": "Добавяне на ново меню на речника",
  "address.search.label": "Quick Address Search",
  "adjustment.button": "Коригиране на количество",
  "adjustment.newQuantity": "Ново количество",
  "adjustment.notes": "Бележки",
  "adjustment.notes.placeholder": "Предоставете подробности за тази корекция",
  "adjustment.reason": "Причина за корекция",
  "adjustment.reason.select": "Изберете причина",
  "adjustment.success": "Количеството на партидата е коригирано успешно",
  "adjustment.title": "Коригиране на количество на партида",
  "admin.dashboard.subtitle": "Choose an administration area to configure OpenELIS.",
  "admin.dashboard.title": "Admin dashboard",
  "admin.formEntryConfig": "Общи конфигурации",
  "admin.programs.title": "Programs",
  "admin.programs.subtitle": "The initiatives that orders are filed under — each with a domain, one or more lab units, and an optional order-entry questionnaire.",
  "admin.programs.add": "Add Program",
  "admin.programs.search": "Search by name",
  "admin.programs.selector.new": "Нова програма",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Program actions",
  "admin.programs.list.column.name": "Име",
  "admin.programs.list.column.domain": "Domain",
  "admin.programs.list.column.active": "Статус",
  "admin.programs.list.column.units": "Lab unit(s)",
  "admin.programs.list.status.active": "Активен",
  "admin.programs.list.status.inactive": "Неактивен",
  "admin.programs.list.filter.domain.label": "Domain",
  "admin.programs.list.filter.domain.all": "All domains",
  "admin.programs.list.toggle.showDeactivated": "Show deactivated",
  "admin.programs.action.deactivate": "Деактивирай",
  "admin.programs.action.reactivate": "Reactivate",
  "admin.programs.deactivate.modal.title": "Deactivate this Program?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" has no orders and will simply stop appearing for new orders. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.confirm": "Деактивирай",
  "admin.programs.deactivate.modal.cancel": "Отказ",
  "admin.programs.reactivate.success": "{programName} reactivated",
  "admin.programs.deactivate.success": "{programName} deactivated",
  "admin.programs.domain.confirm.heading": "Change Program Domain?",
  "admin.programs.domain.confirm.body": "Historical orders were evaluated against the {from} domain's rules. Changing to {to} is forward-looking: existing orders keep their program coding and are not re-coded, and the program will only be offered on {to} orders from now on.",
  "admin.programs.list.empty": "No programs match the current search and filters.",
  "admin.programs.basicInfo.labUnits.selectAll": "Select all",
  "admin.programs.basicInfo.labUnits.placeholder": "Type to filter lab units",
  "orderEntry.programPicker.empty": "No programs are currently active. An administrator can activate one under Admin › Programs.",
  "orderEntry.programPicker.empty.domain": "No {domain} programs are currently active. An administrator can activate one under Admin › Programs.",
  "admin.programs.basicInfo.programName.label": "Име на програмата",
  "admin.programs.basicInfo.programName.placeholder": "e.g. HBV Antenatal Screening",
  "admin.programs.basicInfo.code.label": "Programme Code",
  "admin.programs.basicInfo.code.placeholder": "e.g. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Use letters, digits, spaces, or underscores only.",
  "admin.programs.basicInfo.programName.tooLong": "Use at most {max} characters.",
  "admin.programs.basicInfo.labUnits.label": "Lab unit(s)",
  "admin.programs.basicInfo.domain.label": "Domain",
  "admin.programs.basicInfo.domain.required": "Domain is required",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "What does each Domain mean?",
  "admin.programs.guidance.domain.toggle.hide": "Hide",
  "admin.programs.guidance.domain.clinical": "Patient testing — form captures patient identifiers, provider, prior history.",
  "admin.programs.guidance.domain.environmental": "Compliance/surveillance sampling (water, food, air). No patient fields.",
  "admin.programs.guidance.domain.vector": "Specimen surveillance (mosquito, tick) — species, pool manifest.",
  "admin.programs.guidance.gui.emptyState.body": "No questions yet — add questions one at a time, or paste a Questionnaire in JSON mode.",
  "admin.programs.guidance.gui.emptyState.action": "Add First Question",
  "admin.programs.guidance.json.referenceCard.format": "Format: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— allowed item.type: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Visual Builder",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Question Text",
  "admin.programs.questionnaire.question.type.label": "Question Type",
  "admin.programs.questionnaire.question.addNew": "Add New Question",
  "admin.programs.questionnaire.question.actions.aria": "Question actions",
  "admin.programs.questionnaire.question.actions.delete": "Delete question",
  "admin.programs.questionnaire.answerOptions.section.title": "Answer options",
  "admin.programs.questionnaire.answerOptions.addOption": "Add option",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Delete option",
  "admin.programs.questionnaire.answerOptions.empty": "No options yet — add at least one so reception can pick a value.",
  "admin.programs.questionnaire.answerOptions.coded": "coded",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Coded options come from a terminology and are shown read-only here. Edit them in JSON mode.",
  "admin.programs.questionnaire.preview.label": "Пример",
  "admin.programs.questionnaire.preview.empty": "No questions yet — start adding questions to see the preview.",
  "admin.programs.questionnaire.preview.untitled": "(untitled)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Yes ◯ No",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "number",
  "admin.programs.questionnaire.preview.quantity.unit": "unit",
  "admin.programs.questionnaire.json.validate": "Validate JSON",
  "admin.programs.questionnaire.json.reformat": "Reformat",
  "admin.programs.questionnaire.json.validated": "Validated — {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Invalid Questionnaire",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType must be \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item must be an array",
  "admin.programs.questionnaire.json.error.itemShape": "each item must have linkId, text, and type in [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "duplicate linkId \"{linkId}\" — each item must have a unique linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "Advanced features (enableWhen, Quantity units via unit/unitOption, nested items) are edited here in JSON — the Visual Builder preserves them but does not surface them.",
  "admin.programs.basicInfo.domain.helper": "Controls where this program appears — reception only sees programs matching the order's domain.",
  "admin.programs.editor.status.noHardDelete": "No hard delete — deactivate preserves history.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. {orderCount, plural, one {Its # historical order keeps its program coding} other {Its # historical orders keep their program coding}} and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. Historical orders keep their program coding and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.questionnaire.question.unsupported": "This is a \"{type}\" item, which this builder does not edit. It is kept exactly as it is when you save. Edit it in JSON mode.",
  "admin.programs.questionnaire.question.type.boolean": "Yes / No",
  "admin.programs.questionnaire.question.type.choice": "Choice",
  "admin.programs.questionnaire.question.type.checkbox": "Checkbox",
  "admin.programs.questionnaire.question.type.integer": "Whole number",
  "admin.programs.questionnaire.question.type.decimal": "Decimal number",
  "admin.programs.questionnaire.question.type.date": "Дата",
  "admin.programs.questionnaire.question.type.time": "Време",
  "admin.programs.questionnaire.question.type.string": "Short text",
  "admin.programs.questionnaire.question.type.text": "Long text",
  "admin.programs.questionnaire.question.type.quantity": "Количество",
  "admin.programs.questionnaire.question.typeExample.boolean": "Yes/no answer. Example: \"First antenatal visit?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "One option from a fixed list. Example: \"Specimen condition\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Multiple options can be selected. Example: \"Symptoms present\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Whole numbers only. Example: \"Gestational age (weeks)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Numbers with decimals. Example: \"Maternal weight (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Calendar date. Example: \"Date of last menstrual period\".",
  "admin.programs.questionnaire.question.typeExample.time": "Time of day. Example: \"Time of sample collection\".",
  "admin.programs.questionnaire.question.typeExample.string": "Short free-text. Example: \"Provider name\".",
  "admin.programs.questionnaire.question.typeExample.text": "Long free-text. Example: \"Clinical notes\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "A number plus a unit (e.g. \"Volume collected — 5 mL\"). The allowed unit(s) come from a FHIR extension set in JSON mode; a GUI-only Quantity accepts any unit.",
  "admin.config.logo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "admin.config.logo.formats": "Formats: JPG, PNG, GIF (max 2MB)",
  "admin.label": "Админ",
  "admin.labUnit.basicInfo.domain.clinical": "Clinical",
  "admin.labUnit.basicInfo.domain.environmental": "Environmental",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "Historical orders/results were evaluated against the prior domain's rules. New orders will use the new domain's rules.",
  "admin.labUnit.domain.confirm.heading": "Change Lab Unit Domain?",
  "admin.labUnit.edit.select": "Select Lab Unit",
  "admin.labUnit.edit.title": "Edit Lab Unit Domain",
  "admin.labUnit.list.filter.domain": "Filter by Domain",
  "admin.legacy": "Стара администрация (Legacy)",
  "button.back": "← Back to List",
  "button.labUnit.add": "Add Lab Unit",
  "button.labUnit.create": "Create Lab Unit",
  "button.labUnit.creating": "Създаване...",
  "button.labUnit.tests.assign": "Assign tests",
  "button.labUnit.tests.assign.confirm": "Assign {count, plural, one {# test} other {# tests}}",
  "button.labUnit.tests.reassign": "Reassign selected ({count})",
  "button.labUnit.tests.reassign.confirm": "Reassign {count, plural, one {# test} other {# tests}}",
  "configuration.labUnit.manage": "Lab Unit Management",
  "error.labUnit.description.maxLength": "Description must be {max} characters or less",
  "error.labUnit.domain.required": "Domain is required",
  "error.labUnit.list.load": "Error loading lab units",
  "error.labUnit.name.duplicate": "This lab unit name already exists",
  "error.labUnit.name.maxLength": "Name must be {max} characters or less",
  "error.labUnit.name.required": "Name is required",
  "heading.labUnit.add": "Add New Lab Unit",
  "heading.labUnit.editing": "Editing: {name}",
  "heading.labUnit.filtered": "Showing {filtered} of {total} lab units",
  "heading.labUnit.management": "Lab Unit Management",
  "heading.labUnit.subtitle": "Configure lab units (lab sections), domain classification, test assignments, and display order.",
  "heading.labUnit.total": "Total: {total} lab units",
  "helper.labUnit.description": "Short internal description of this lab unit for lab staff reference",
  "helper.labUnit.domain": "Determines which order entry and sample collection fields apply to orders routed to this lab unit.",
  "helper.labUnit.name": "Enter a unique name for this lab unit (e.g., \"Hematology\", \"Microbiology\")",
  "label.labUnit.actions": "Действия",
  "label.labUnit.active": "Активен",
  "label.labUnit.description": "Описание",
  "label.labUnit.displayOrder": "Позиция",
  "label.labUnit.displayOrder.addHint": "Save this lab unit first, then set its display order.",
  "label.labUnit.displayOrder.current": "Current",
  "label.labUnit.displayOrder.intro": "Position this lab unit in the system-wide lab unit menus and dropdowns. Enter a position and save — the remaining lab units are renumbered automatically.",
  "label.labUnit.displayOrder.loading": "Loading display order...",
  "label.labUnit.displayOrder.saved": "Display order saved",
  "label.labUnit.displayOrder.saveError": "Failed to save display order",
  "label.labUnit.domain": "Domain",
  "label.labUnit.filterStatus": "Filter by status",
  "label.labUnit.list.loading": "Loading lab units...",
  "label.labUnit.loading": "Loading lab unit...",
  "label.labUnit.name": "Име",
  "label.labUnit.nameInLocale": "Name ({language})",
  "error.labUnit.tests.action": "Test assignment action failed",
  "heading.labUnit.tests.assign": "Assign Tests to This Lab Unit",
  "heading.labUnit.tests.reassign": "Reassign Tests",
  "label.labUnit.tests.assign.explain": "Tests belong to exactly one lab unit. Assigning a test here moves it out of its current lab unit (shown next to each test).",
  "label.labUnit.tests.assign.none": "No assignable tests found.",
  "label.labUnit.tests.reassign.destination": "Destination lab unit",
  "label.labUnit.tests.reassign.explain": "Reassignment takes effect immediately. New orders route to the destination lab unit; completed results keep their original data.",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# test} other {# tests}} will be moved:",
  "message.labUnit.tests.assigned": "Tests assigned to this lab unit.",
  "message.labUnit.tests.reassigned": "Tests reassigned successfully.",
  "placeholder.labUnit.tests.reassign.destination": "Select destination...",
  "placeholder.labUnit.tests.search": "Търсене на тестове...",
  "label.labUnit.section.assigned-tests": "Assigned Tests",
  "label.labUnit.section.basic-info": "Basic Info",
  "label.labUnit.section.display-order": "Display Order",
  "label.labUnit.status": "Статус",
  "label.labUnit.testCount": "Тестове",
  "label.labUnit.tests.addHint": "Save this lab unit first, then assign tests to it.",
  "label.labUnit.tests.count": "{count, plural, one {# test assigned} other {# tests assigned}}",
  "label.labUnit.tests.loadError": "Unable to load assigned tests",
  "label.labUnit.tests.loading": "Loading assigned tests...",
  "label.labUnit.tests.none": "No tests are assigned to this lab unit yet.",
  "label.labUnit.tests.testName": "Име на тест",
  "message.labUnit.add.success": "Lab unit created successfully.",
  "message.labUnit.edit.success": "Lab unit saved successfully.",
  "message.labUnit.noResults": "No lab units found matching your criteria",
  "placeholder.labUnit.filter.domain": "All domains",
  "placeholder.labUnit.filter.status": "All statuses",
  "placeholder.labUnit.search": "Search lab units...",
  "sidenav.label.admin.labUnit.addingNew": "Adding new lab unit",
  "sidenav.label.admin.labUnit.backToList": "← All Lab Units",
  "sidenav.label.admin.labUnit.editing": "Editing: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Editing lab unit",
  "sidenav.label.admin.labUnit.sectionsHelper": "Click a lab unit to edit its sections",
  "sidenav.label.admin.labUnitManagement": "Lab Units Editor",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Добави",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Деактивирай",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Изход",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Промени",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Запази",
  "admin.page.configuration.formEntryConfigMenu.description": "Описание",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Редактиране на запис",
  "admin.page.configuration.formEntryConfigMenu.name": "Име",
  "admin.page.configuration.formEntryConfigMenu.select": "Избери",
  "admin.page.configuration.formEntryConfigMenu.value": "Стойност",
  "admin.labelPresets.title": "Label Presets",
  "admin.labelPresets.addButton": "Add Preset",
  "admin.labelPresets.search.placeholder": "Search presets...",
  "admin.labelPresets.col.name": "Име",
  "admin.labelPresets.col.barcodeType": "Barcode Type",
  "admin.labelPresets.col.dimensions": "Размери",
  "admin.labelPresets.col.scope": "Scope",
  "admin.labelPresets.col.status": "Статус",
  "admin.labelPresets.col.actions": "Действия",
  "admin.labelPresets.systemTag": "System",
  "admin.labelPresets.status.active": "Активен",
  "admin.labelPresets.status.inactive": "Неактивен",
  "admin.labelPresets.scope.order": "Поръчка",
  "admin.labelPresets.scope.sample": "Проба",
  "admin.labelPresets.action.edit": "Редактиране",
  "admin.labelPresets.action.duplicate": "Duplicate",
  "admin.labelPresets.action.activate": "Активирай",
  "admin.labelPresets.action.deactivate": "Деактивирай",
  "admin.labelPresets.duplicateName": "Copy of {name}",
  "admin.labelPresets.duplicated": "Preset duplicated",
  "admin.labelPresets.duplicateFailed": "Duplicate failed",
  "admin.labelPresets.activated": "Preset activated",
  "admin.labelPresets.deactivated": "Preset deactivated",
  "admin.labelPresets.toggleFailed": "Status change failed",
  "admin.labelPresets.saveFailed": "Запазването е неуспешно",
  "admin.labelPresets.editor.titleAdd": "Add Label Preset",
  "admin.labelPresets.editor.titleEdit": "Edit Label Preset",
  "admin.labelPresets.editor.section.basicInfo": "Basic Info",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Barcode Settings",
  "admin.labelPresets.editor.section.printScope": "Print Scope & Quantities",
  "admin.labelPresets.field.name": "Preset Name",
  "admin.labelPresets.field.isActive": "Активен",
  "admin.labelPresets.field.heightMm": "Height (mm)",
  "admin.labelPresets.field.widthMm": "Width (mm)",
  "admin.labelPresets.field.barcodeType": "Barcode Type",
  "admin.labelPresets.field.defaultPerOrder": "Default per Order",
  "admin.labelPresets.field.maxPerOrder": "Max per Order",
  "admin.labelPresets.field.defaultPerSample": "Default per Sample",
  "admin.labelPresets.field.maxPerSample": "Max per Sample",
  "admin.labelPresets.validation.name.required": "Name is required",
  "admin.labelPresets.validation.name.toolong": "Name must not exceed 120 characters",
  "admin.labelPresets.validation.dimension.range": "Dimension must be between 5 and 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Barcode type is required",
  "admin.labelPresets.validation.scope.required": "At least one print scope (Order or Sample) must be selected",
  "admin.labelPresets.validation.max.lte": "Max must be greater than or equal to default",
  "advanced.search": "Разширено търсене",
  "alert.expired.title": "Елементи с изтекъл срок",
  "alert.expiring.title": "Изтичащи скоро",
  "alert.lowStock.title": "Предупреждение за ниска наличност",
  "alerts.acknowledge.button": "Потвърди",
  "alerts.acknowledge.comment": "Resolution Comment",
  "alerts.acknowledge.comment.placeholder": "Describe how this alert was addressed...",
  "alerts.acknowledge.comment.required": "Resolution comment is required for critical alerts",
  "alerts.acknowledge.error": "Failed to acknowledge alert",
  "alerts.acknowledge.success": "Alert acknowledged successfully",
  "alerts.acknowledge.title": "Acknowledge Alert",
  "alerts.autoRefresh": "Auto-refresh every 60 seconds",
  "alerts.dashboard.title": "Alerts Dashboard",
  "alerts.empty": "No alerts to display",
  "alerts.eqaDeadlineSummary.critical": "Критична",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} upcoming deadlines",
  "alerts.eqaDeadlineSummary.subtitle": "Upcoming EQA submission deadlines grouped by provider",
  "alerts.eqaDeadlineSummary.title": "EQA Deadline Summary",
  "alerts.eqaDeadlineSummary.viewAll": "View All",
  "alerts.filter.myAlerts": "My Alerts",
  "alerts.filter.search": "Search alerts...",
  "alerts.filter.severity": "Сериозност",
  "alerts.filter.status": "Статус",
  "alerts.filter.type": "Тип сигнал",
  "alerts.severity.critical": "Критична",
  "alerts.severity.warning": "Предупреждение",
  "alerts.status.acknowledged": "Потвърдена",
  "alerts.status.open": "Open",
  "alerts.status.resolved": "Resolved",
  "alerts.summary.critical": "Critical Alerts",
  "alerts.summary.eqaDeadlines": "EQA Deadlines",
  "alerts.summary.sampleExpiration": "Samples Expiring",
  "alerts.summary.statOverdue": "Overdue STAT Orders",
  "alerts.summary.totalOpen": "Total Open",
  "alerts.table.actions": "Действия",
  "alerts.table.created": "Създадено",
  "alerts.table.message": "Съобщение",
  "alerts.table.severity": "Сериозност",
  "alerts.table.status": "Статус",
  "alerts.table.type": "Тип",
  "alerts.type.critical_result": "Critical Result",
  "alerts.type.equipment_failure": "Повреда на оборудването",
  "alerts.type.freezer_humidity": "Freezer Humidity",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Freezer Temperature",
  "alerts.type.inventory_low": "Inventory Low",
  "alerts.type.other": "Друг",
  "alerts.type.referral_critical_result": "Referral Critical Result",
  "alerts.type.referral_rejected": "Referral Rejected",
  "alerts.type.sample_tracking": "Sample Tracking",
  "alerts.type.critical_unacknowledged": "Unacknowledged Critical",
  "alerts.type.eqa_deadline": "EQA Deadline",
  "alerts.type.microbiology_critical": "Microbiology Critical",
  "alerts.type.required_by_deadline": "Required By Deadline",
  "alerts.type.sample_expiration": "Sample Expiration",
  "alerts.type.stat_overdue": "STAT Overdue",
  "alerts.type.stat_upcoming": "STAT Upcoming",
  "aliquot": "Аликот",
  "aliquot.analyses.count": "Анализи: {count}",
  "aliquot.id": "ID на аликот",
  "aliquot.quantity": "Количество на аликот",
  "aliquot.quantity.not.balanced": "Количеството не е балансирано за типа проба",
  "aliquot.save.error": "Грешка при запазване на данните за аликотиране.",
  "aliquot.save.success": "Данните за аликотиране са запазени успешно.",
  "aliquot.tests.not.assigned": "Не са зададени тестове за типа проба",
  "aliquot.validation.errors": "Грешки при валидация",
  "aliquoting": "Аликотиране",
  "aliquoting.section": "Секция за аликотиране",
  "all.label": "Всички",
  "all.tests.assigned": "Всички тестове са зададени",
  "allocated.to.aliquots": "Разпределено към аликоти",
  "analysis.count": "Брой анализи",
  "analysis.details": "Подробности за анализа",
  "analyzer.action.add": "Добавяне на анализатор",
  "analyzer.action.configureConnection": "Configure connection",
  "analyzer.action.deactivate": "Деактивирай",
  "analyzer.action.editSetup": "Edit setup",
  "analyzer.action.qualityControl": "Контрол на качеството",
  "analyzer.action.reactivate": "Reactivate",
  "analyzer.combinationName.notification": "Комбинацията от анализатор и име на тест на анализатора трябва да бъде уникална",
  "analyzer.fhirImport.error.importFailed": "FHIR bundle import failed",
  "analyzer.fhirImport.error.invalidBundleType": "Bundle type must be 'transaction' or 'batch', got: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle contains no Observation resources with results",
  "analyzer.deliveryIssues.attention.review": "Review undelivered results",
  "analyzer.deliveryIssues.attention.subtitle": "The Analyzer Bridge is holding results it could not deliver to OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# analyzer result was} other {# analyzer results were}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Действия",
  "analyzer.deliveryIssues.column.analyzer": "Анализатор",
  "analyzer.deliveryIssues.column.detail": "Details",
  "analyzer.deliveryIssues.column.reason": "Reason",
  "analyzer.deliveryIssues.column.received": "Received",
  "analyzer.deliveryIssues.column.status": "Статус",
  "analyzer.deliveryIssues.description": "Results the Analyzer Bridge received but has not delivered to OpenELIS. Retry sends a result again once its cause is fixed; Dismiss hides it and keeps it in the Bridge for audit.",
  "analyzer.deliveryIssues.dismiss": "Dismiss",
  "analyzer.deliveryIssues.empty": "The Bridge has no undelivered results.",
  "analyzer.deliveryIssues.error.actionFailed": "The action could not be completed. Reload and try again.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "The Analyzer Bridge sent a response OpenELIS could not read.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS has no Analyzer Bridge address configured.",
  "analyzer.deliveryIssues.error.bridgeRefused": "The Bridge refused this action ({reason}). Reload to see its current state.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.deliveryIssues.error.invalidId": "This result reference is not valid.",
  "analyzer.deliveryIssues.loadFailed": "Undelivered results could not be loaded from the Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Checking the Analyzer Bridge for undelivered results",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "More than one analyzer connection could own this message. Give each analyzer a distinct address, then retry.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "The analyzer sent over a connection type its setup does not accept.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS declined the result because of its own setup. Fix the analyzer setup, then retry.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS rejected the result.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS answered with a redirect, so the result was not delivered. Check the Bridge's OpenELIS address.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "The message contained no results to deliver.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "The Bridge could not convert the message for OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS stayed unreachable until every retry was used. The result is intact; retry once OpenELIS is reachable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "The analyzer's connection has no analyzer type revision, so its results cannot be read.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "The sender matches no saved analyzer connection. Set up the analyzer, then retry.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS has not accepted the result yet; the Bridge keeps retrying.",
  "analyzer.deliveryIssues.reason.unknown": "The Bridge could not deliver this result ({code}).",
  "analyzer.deliveryIssues.retry": "Retry",
  "analyzer.deliveryIssues.state.deadLettered": "Not delivered",
  "analyzer.deliveryIssues.state.retrying": "Retrying",
  "analyzer.deliveryIssues.title": "Undelivered analyzer results",
  "analyzer.deliveryIssues.unrecognizedSender": "Unrecognized sender {source}",
  "analyzer.importIssues.accession": "Номер на акцесия",
  "analyzer.importIssues.action": "Действие",
  "analyzer.importIssues.description": "Review microbiology analyzer events that could not be matched or processed. Held results are reviewed in each analyzer's results worklist.",
  "analyzer.importIssues.empty": "No failed microbiology analyzer events require attention",
  "analyzer.importIssues.event": "Event",
  "analyzer.importIssues.event.astQcFail": "AST quality control failure",
  "analyzer.importIssues.event.astResultAvailable": "AST result available",
  "analyzer.importIssues.event.unknown": "Analyzer event ({code})",
  "analyzer.importIssues.events.description": "Correct the analyzer mapping or target information before the source sends the result again.",
  "analyzer.importIssues.events.title": "Stuck analyzer events",
  "analyzer.importIssues.failure.astRunNotMatched": "No AST run matched the analyzer and card identifiers.",
  "analyzer.importIssues.failure.processingFailed": "The analyzer event could not be processed.",
  "analyzer.importIssues.failure.unknown": "The analyzer event could not be processed ({code}).",
  "analyzer.importIssues.loadFailed": "Analyzer import issues could not be loaded",
  "analyzer.importIssues.loading": "Loading analyzer import issues",
  "analyzer.importIssues.openMappings": "Open mappings",
  "analyzer.importIssues.openResults": "Open analyzer results",
  "analyzer.importIssues.reason": "Failure reason",
  "analyzer.importIssues.received": "Received",
  "analyzer.importIssues.result": "Резултат",
  "analyzer.importIssues.source": "Source ID",
  "analyzer.importIssues.staging.description": "These imported result rows need corrected analyzer configuration before validation.",
  "analyzer.importIssues.staging.title": "Staged result issues",
  "analyzer.importIssues.target": "Target reference",
  "analyzer.importIssues.test": "Тест",
  "analyzer.importIssues.title": "Analyzer import issues",
  "analyzer.fieldCreation.acceptedUnits.label": "Приети единици",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Изберете приети единици",
  "analyzer.fieldCreation.cancel": "Отказ",
  "analyzer.fieldCreation.confirmation": "Разбирам, че това поле ще бъде достъпно за мапинг веднага след създаването му",
  "analyzer.fieldCreation.create": "Създай поле",
  "analyzer.fieldCreation.createNew": "Създай ново поле",
  "analyzer.fieldCreation.description.label": "Описание (по избор)",
  "analyzer.fieldCreation.description.placeholder": "Въведете описание на полето",
  "analyzer.fieldCreation.entityType.label": "Тип обект (Entity Type)",
  "analyzer.fieldCreation.entityType.placeholder": "Изберете тип обект",
  "analyzer.fieldCreation.error.generic": "Неуспешно създаване на поле",
  "analyzer.fieldCreation.error.title": "Грешка при създаване на поле",
  "analyzer.fieldCreation.fieldName.label": "Име на поле",
  "analyzer.fieldCreation.fieldName.placeholder": "Въведете име на полето",
  "analyzer.fieldCreation.fieldType.label": "Тип на полето",
  "analyzer.fieldCreation.fieldType.placeholder": "Изберете тип на полето",
  "analyzer.fieldCreation.loincCode.label": "LOINC код (по избор)",
  "analyzer.fieldCreation.loincCode.placeholder": "Въведете LOINC код",
  "analyzer.fieldCreation.modal.subtitle": "Създайте ново поле, което ще бъде достъпно за мапинг веднага",
  "analyzer.fieldCreation.modal.title": "Създаване на ново OpenELIS поле",
  "analyzer.fieldCreation.success.message": "Полето вече е достъпно за мапинг",
  "analyzer.fieldCreation.success.title": "Полето е създадено успешно",
  "analyzer.fieldCreation.validation.entityType.required": "Типът обект е задължителен",
  "analyzer.fieldCreation.validation.fieldName.required": "Името на полето е задължително",
  "analyzer.fieldCreation.validation.unique": "Поле с това име вече съществува",
  "analyzer.fieldCreation.validation.units.required": "Приетите единици са задължителни за числови полета",
  "analyzer.filter.lifecycleStage.all": "Всички етапи на жизнения цикъл",
  "analyzer.filter.lifecycleStage.label": "Етап на жизнения цикъл",
  "analyzer.filter.status": "Статус",
  "analyzer.filter.status.all": "Всички статуси",
  "analyzer.filter.status.label": "Статус",
  "analyzer.filter.testUnit": "Тестова единица",
  "analyzer.filter.type": "Тип анализатор",
  "analyzer.form.activeStatus": "Активен статус",
  "analyzer.form.activeStatus.description": "Разреши този анализатор за събиране на данни",
  "analyzer.form.addTitle": "Добавяне на нов анализатор",
  "analyzer.form.cancel": "Отказ",
  "analyzer.form.communicationMode": "Communication Mode",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyzer → LIS (analyzer connects to OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectional (both directions)",
  "analyzer.form.communicationMode.help": "Who initiates the connection. Most analyzers use Analyzer → LIS.",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Analyzer (OpenELIS connects to analyzer)",
  "analyzer.form.createdBy": "Създаден от",
  "analyzer.form.createdDate": "Дата/час на създаване",
  "analyzer.form.defaults.error": "Неуспешно зареждане на конфигурация по подразбиране",
  "analyzer.form.defaults.loaded": "Конфигурацията по подразбиране е заредена",
  "analyzer.form.defaults.loaded.subtitle": "Шаблонът за {name} е зареден. Персонализирайте преди запазване.",
  "analyzer.form.editTitle": "Редактиране на анализатор",
  "analyzer.form.error.invalidCommunicationMode": "Invalid communication mode: {value}. Valid values: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Invalid protocol version: {value}. Valid values: {validValues}",
  "analyzer.form.error.save": "Неуспешно запазване на анализатора",
  "analyzer.form.error.unknown": "Възникна неизвестна грешка",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Шаблон на идентификатор",
  "analyzer.form.identifierPattern.helperText": "Regex шаблон за съпоставяне на входящи идентификатори за рутиране",
  "analyzer.form.identifierPattern.placeholder": "напр. ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "IP адрес",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Дата/час на последна промяна",
  "analyzer.form.loadDefaultConfig": "Зареди конфигурация по подразбиране",
  "analyzer.form.loadDefaultConfig.helperText": "Бърза настройка чрез шаблони за GenericASTM и GenericHL7 плъгини",
  "analyzer.form.loadDefaultConfig.placeholder": "Изберете шаблон на анализатор",
  "analyzer.form.name": "Име на анализатора",
  "analyzer.form.name.placeholder": "напр. Hematology Analyzer 1",
  "analyzer.form.pluginType": "Тип плъгин",
  "analyzer.form.pluginType.helperText": "Плъгинът, който ще обработва входящите съобщения",
  "analyzer.form.pluginType.placeholder": "Изберете тип плъгин...",
  "analyzer.form.port": "Порт",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Версия на протокола",
  "analyzer.form.save": "Запази",
  "analyzer.form.status": "Статус",
  "analyzer.form.status.helperText": "Статусът се променя автоматично. Ръчна промяна е възможна само към INACTIVE, SETUP или VALIDATION.",
  "analyzer.form.subtitle": "Конфигуриране на настройки за връзка и тестови единици",
  "analyzer.form.success.save": "Анализаторът е запазен успешно",
  "analyzer.form.testConnection": "Тествай връзката",
  "analyzer.form.testConnection.error": "Connection Failed",
  "analyzer.form.testUnits": "Задаване на тестови единици",
  "analyzer.form.testUnits.helper": "Изберете една или повече тестови единици за този анализатор",
  "analyzer.form.testUnits.placeholder": "Изберете тестови единици...",
  "analyzer.form.type": "Тип анализатор",
  "analyzer.form.type.helperText": "Select the reusable Analyzer Type for this installed connection.",
  "analyzer.form.type.invalidSelection": "That Analyzer Type revision is unavailable or deactivated",
  "analyzer.form.type.loadError": "Analyzer Types could not be loaded",
  "analyzer.form.type.other": "Друг",
  "analyzer.form.type.placeholder": "Изберете тип анализатор",
  "analyzer.form.type.revision": "{name}, revision {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Невалиден формат на IP адрес",
  "analyzer.form.validation.name.required": "Името на анализатора е задължително",
  "analyzer.form.validation.type.required": "Типът на анализатора е задължителен",
  "analyzer.hl7.insertError": "HL7 грешка при вмъкване",
  "analyzer.hl7.parseError": "HL7 грешка при парсване",
  "analyzer.hl7.unknownAnalyzer": "Неуспешна идентификация на анализатора от HL7 MSH",
  "analyzer.list.subtitle": "Управление на лабораторни анализатори и мапинги на полета",
  "analyzer.list.title": "Анализатори",
  "analyzer.lifecycle.deactivate.cancel": "Cancel deactivation",
  "analyzer.lifecycle.deactivate.confirm": "Deactivate analyzer",
  "analyzer.lifecycle.deactivate.error": "The analyzer could not be deactivated.",
  "analyzer.lifecycle.deactivate.errorTitle": "Deactivation failed",
  "analyzer.lifecycle.deactivate.message": "Deactivate {name}? New runtime use will stop. Its configuration and history will be retained, and it can be reactivated later.",
  "analyzer.lifecycle.deactivate.title": "Deactivate analyzer",
  "analyzer.lifecycle.reactivate.blockedMessage": "Complete these setup requirements before reactivating. Open Edit setup on this analyzer to verify its mappings and connection.",
  "analyzer.lifecycle.reactivate.blockedTitle": "Analyzer is not ready",
  "analyzer.lifecycle.reactivate.cancel": "Cancel reactivation",
  "analyzer.lifecycle.reactivate.confirm": "Reactivate analyzer",
  "analyzer.lifecycle.reactivate.error": "The analyzer could not be reactivated.",
  "analyzer.lifecycle.reactivate.errorTitle": "Reactivation failed",
  "analyzer.lifecycle.reactivate.message": "Reactivate {name}? Its setup will be checked again before it can be used.",
  "analyzer.lifecycle.reactivate.title": "Reactivate analyzer",
  "analyzer.connection.choice.select": "Select a value",
  "analyzer.connection.field.apiToken": "API token",
  "analyzer.connection.field.connectionRole": "Connection role",
  "analyzer.connection.field.directory": "Directory",
  "analyzer.connection.field.directory.help": "Directory on the Analyzer Bridge host",
  "analyzer.connection.field.enabled": "Enabled",
  "analyzer.connection.field.filePattern": "File pattern",
  "analyzer.connection.field.filePattern.help": "File name pattern watched by Analyzer Bridge",
  "analyzer.connection.field.host": "Host",
  "analyzer.connection.field.host.help": "The analyzer's IP address. Optional when the analyzer connects to the Analyzer Bridge. Leave it blank if the analyzer reaches the bridge through NAT or a proxy, and use the instrument system name instead.",
  "analyzer.connection.field.port": "Порт",
  "analyzer.connection.field.senderId": "Instrument system name",
  "analyzer.connection.field.senderId.help": "The name this instrument sends in its messages (ASTM H.5 or HL7 MSH-3), such as the GeneXpert System Name. Needed only when several analyzers share this port and address.",
  "analyzer.connection.field.serialPort": "Serial device",
  "analyzer.connection.field.transport": "Transport",
  "analyzer.connection.field.unavailable": "Connection setting",
  "analyzer.connection.role.client": "Client",
  "analyzer.connection.role.server": "Server",
  "analyzer.connection.reference.configured": "Bridge connection configured",
  "analyzer.connection.reference.missing": "Connection setup required",
  "analyzer.connection.transport.RS-232": "Serial (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Network (TCP/IP)",
  "analyzer.connection.validation.invalid": "Check this value.",
  "analyzer.connection.validation.required": "This field is required.",
  "analyzer.setup.close": "Close analyzer setup",
  "analyzer.setup.connect.address.required": "Enter the analyzer address",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge has not acknowledged this exact setup.",
  "analyzer.activation.blocker.connection": "Connection settings are incomplete or invalid.",
  "analyzer.activation.blocker.dataFlow": "The selected data flow is not supported by this analyzer type.",
  "analyzer.activation.blocker.labUnit": "Assign at least one active lab unit.",
  "analyzer.activation.blocker.mappings": "Analyzer mappings must be verified again.",
  "analyzer.activation.blocker.name": "Enter an analyzer name.",
  "analyzer.activation.blocker.profile": "The selected analyzer type revision is unavailable or no longer matches this analyzer.",
  "analyzer.activation.blocker.recognition": "Control recognition must be verified again.",
  "analyzer.activation.blocker.transport": "The selected connection type is not supported by this analyzer type.",
  "analyzer.setup.connect.activation.active": "Analyzer is active",
  "analyzer.setup.connect.activation.activating": "Activating analyzer",
  "analyzer.setup.connect.activation.blockerUnknown": "Analyzer setup is not ready to activate.",
  "analyzer.setup.connect.activation.cancel": "Отказ",
  "analyzer.setup.connect.activation.error": "Analyzer readiness could not be checked.",
  "analyzer.setup.connect.activation.finish": "Finish and activate",
  "analyzer.setup.connect.activation.loading": "Checking analyzer readiness",
  "analyzer.setup.connect.activation.readiness": "Activation readiness",
  "analyzer.setup.connect.activation.ready": "Analyzer is ready to activate",
  "analyzer.setup.connect.activation.saveChanges": "Save changes",
  "analyzer.setup.connect.activation.saveLater": "Save and finish later",
  "analyzer.setup.connect.activation.saving": "Saving analyzer",
  "analyzer.setup.connect.activation.verifyMappings": "Verify mappings",
  "analyzer.setup.connect.analyzerAddress": "Analyzer address",
  "analyzer.setup.connect.check.analyzer.address.missing": "No analyzer address is saved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "The analyzer address {host} could not be resolved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.reachable": "The Bridge reached the analyzer at {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "The Bridge could not reach the analyzer at {host}. Analyzers that connect to the Bridge often cannot be reached from it (a firewall, NAT, or a hosted server). Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "This connection mode is not supported by the Bridge.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Enter the analyzer file directory before testing.",
  "analyzer.setup.connect.check.directory.not.directory": "The configured path is not a directory.",
  "analyzer.setup.connect.check.directory.not.found": "The configured directory was not found.",
  "analyzer.setup.connect.check.directory.not.readable": "The Bridge cannot read the configured directory.",
  "analyzer.setup.connect.check.directory.path.invalid": "The configured directory path is invalid.",
  "analyzer.setup.connect.check.directory.ready": "Directory is ready.",
  "analyzer.setup.connect.check.http.configuration.missing": "Enter the analyzer web address before testing.",
  "analyzer.setup.connect.check.http.connection.error": "The Bridge could not connect to the analyzer web address.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "This analyzer sends files to the Bridge, so the Bridge cannot test the connection from here. A delivered file is the proof.",
  "analyzer.setup.connect.check.http.interrupted": "The web connection test was interrupted.",
  "analyzer.setup.connect.check.http.ready": "The analyzer web address is reachable.",
  "analyzer.setup.connect.check.http.server.error": "The analyzer web address returned a server error.",
  "analyzer.setup.connect.check.http.timeout": "The analyzer web address did not respond before the timeout.",
  "analyzer.setup.connect.check.http.url.invalid": "The analyzer web address is invalid.",
  "analyzer.setup.connect.check.listener.configuration.missing": "Enter the Bridge listener port before testing.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "The Bridge listener address is not configured.",
  "analyzer.setup.connect.check.listener.not.listening": "The Bridge listener is not accepting connections.",
  "analyzer.setup.connect.check.listener.port.in.use": "The configured Bridge listener port is already in use.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "The pinned profile does not define a compatible Bridge listener.",
  "analyzer.setup.connect.check.listener.ready": "Bridge listener is ready.",
  "analyzer.setup.connect.check.listener.timeout": "The Bridge listener did not respond before the timeout.",
  "analyzer.setup.connect.check.remote.astm.ready": "The analyzer completed the ASTM handshake.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "The analyzer returned an invalid ASTM handshake response.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Enter the analyzer address and port before testing.",
  "analyzer.setup.connect.check.remote.connection.error": "The Bridge could not connect to the analyzer.",
  "analyzer.setup.connect.check.remote.hl7.ready": "The analyzer completed the HL7 handshake.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "The analyzer returned an invalid HL7 handshake response.",
  "analyzer.setup.connect.check.remote.host.unknown": "The analyzer address could not be resolved.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "This analyzer protocol does not support a remote connection test.",
  "analyzer.setup.connect.check.remote.refused": "The analyzer refused the connection.",
  "analyzer.setup.connect.check.remote.timeout": "The analyzer did not respond before the timeout.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Enter the analyzer serial device before testing.",
  "analyzer.setup.connect.check.serial.not.found": "The configured serial device was not found.",
  "analyzer.setup.connect.check.serial.not.readable": "The Bridge cannot read the configured serial device.",
  "analyzer.setup.connect.check.serial.path.invalid": "The configured serial device path is invalid.",
  "analyzer.setup.connect.check.serial.ready": "The analyzer serial device is ready.",
  "analyzer.setup.connect.checkKind.analyzer": "Analyzer (for information)",
  "analyzer.setup.connect.checkKind.directory": "Directory",
  "analyzer.setup.connect.checkKind.http_endpoint": "Web address",
  "analyzer.setup.connect.checkKind.http_input": "Analyzer file upload",
  "analyzer.setup.connect.checkKind.listener": "Bridge listener",
  "analyzer.setup.connect.checkKind.other": "Connection check",
  "analyzer.setup.connect.checkKind.remote_protocol": "Analyzer protocol",
  "analyzer.setup.connect.checkKind.serial_device": "Serial device",
  "analyzer.setup.connect.checkStatus.failed": "Connection check failed.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Connection settings are incomplete.",
  "analyzer.setup.connect.checkStatus.passed": "Connection check passed.",
  "analyzer.setup.connect.checkStatus.skipped": "This check could not be run.",
  "analyzer.setup.connect.checkStatus.timed_out": "Connection check timed out.",
  "analyzer.setup.connect.configureEndpoint": "Configure the analyzer to use",
  "analyzer.setup.connect.dataFlow": "Data flow",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Results only",
  "analyzer.setup.connect.dataFlow.twoWay": "Two-way",
  "analyzer.setup.connect.directory": "Analyzer file directory",
  "analyzer.setup.connect.directory.required": "Enter the analyzer file directory",
  "analyzer.setup.connect.error": "Connection settings could not be saved or tested.",
  "analyzer.setup.connect.evidence": "Connection evidence",
  "analyzer.setup.connect.loadError": "The saved analyzer connection could not be loaded.",
  "analyzer.setup.connect.loading": "Loading analyzer connection",
  "analyzer.setup.connect.outcome.failure": "Connection failed",
  "analyzer.setup.connect.outcome.missing_configuration": "Connection settings are incomplete",
  "analyzer.setup.connect.outcome.success": "Connection ready",
  "analyzer.setup.connect.outcome.timeout": "Connection timed out",
  "analyzer.setup.connect.port": "Analyzer port",
  "analyzer.setup.connect.port.invalid": "Enter a port from 1 to 65535",
  "analyzer.setup.connect.sourceAddress": "Analyzer source address",
  "analyzer.setup.connect.test": "Test connection",
  "analyzer.setup.connect.testing": "Testing connection",
  "analyzer.setup.connect.title": "Свързване",
  "analyzer.setup.connect.useResultsOnly": "Use Results only",
  "analyzer.setup.instrument.continue": "Continue to Verify",
  "analyzer.setup.instrument.labUnits": "Lab units",
  "analyzer.setup.instrument.labUnits.placeholder": "Select lab units",
  "analyzer.setup.instrument.labUnits.required": "Select at least one lab unit",
  "analyzer.setup.instrument.name": "Analyzer name",
  "analyzer.setup.instrument.name.required": "Enter an analyzer name",
  "analyzer.setup.instrument.notListed": "Instrument not listed?",
  "analyzer.setup.instrument.saveError": "The analyzer could not be saved. Try again.",
  "analyzer.setup.instrument.saving": "Saving analyzer",
  "analyzer.setup.instrument.summary": "Saved instrument details",
  "analyzer.setup.step.edit": "Edit {step}",
  "analyzer.setup.instrument.type": "Тип",
  "analyzer.setup.instrument.type.helper": "Choose the listed type for your instrument, even if it will only send results. Whether it sends results only or also receives orders is set later, in Connect.",
  "analyzer.setup.instrument.type.placeholder": "Search analyzer types",
  "analyzer.setup.instrument.type.required": "Select an analyzer type",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · revision {revision}",
  "analyzer.setup.instrument.title": "Instrument",
  "analyzer.setup.steps": "Analyzer setup steps",
  "analyzer.setup.title": "Set up a new analyzer",
  "analyzer.setup.verify.attention": "Verification needs attention",
  "analyzer.setup.verify.continue": "Continue to Connect",
  "analyzer.setup.verify.selecting": "Applying mappings...",
  "analyzer.setup.verify.selectionError": "Could not apply the reviewed mappings. Reload Verify and try again.",
  "analyzer.setup.verify.counts": "Mapping readiness",
  "analyzer.setup.verify.heading": "Review analyzer type mappings",
  "analyzer.setup.verify.loadError": "Mapping verification could not be loaded.",
  "analyzer.setup.verify.loading": "Loading mapping verification",
  "analyzer.setup.verify.profile": "{name} · {protocol} · revision {revision}",
  "analyzer.setup.verify.resultsReady": "{ready} of {total} result values ready",
  "analyzer.setup.verify.summary": "Mappings reviewed for this setup",
  "analyzer.setup.verify.summary.stale": "Mappings need to be verified again",
  "analyzer.setup.verify.review": "Review mappings in Analyzer Types",
  "analyzer.setup.verify.testsReady": "{ready} of {total} tests ready",
  "analyzer.setup.verify.title": "Verify",
  "analyzer.navigation.analyzerTypes": "Analyzer Types",
  "analyzer.navigation.analyzers": "Анализатори",
  "analyzer.navigation.analyzersList": "Списък с анализатори",
  "analyzer.navigation.fieldMappings": "Мапинги на полета",
  "analyzer.navigation.qc": "Контрол на качеството (QC)",
  "analyzer.navigation.qcDashboard": "QC Dashboard",
  "analyzer.navigation.qcAlerts": "QC сигнали и нарушения",
  "analyzer.navigation.qcCorrectiveActions": "Коригиращи действия",
  "analyzerType.action.deactivate": "Деактивирай",
  "analyzerType.action.editMappings": "Edit mappings",
  "analyzerType.action.history": "View history",
  "analyzerType.action.reactivate": "Reactivate",
  "analyzerType.action.updateShared": "Update shared",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyzer using this type} other {Analyzers using this type}}",
  "analyzerType.affectedAnalyzers.updateAvailable": "Update available",
  "analyzerType.actions.ariaLabel": "Actions for {name}",
  "analyzerType.button.create": "Create Profile",
  "analyzerType.button.cancel": "Отказ",
  "analyzerType.button.duplicate": "Duplicate Profile",
  "analyzerType.button.publish": "Publish Profile",
  "analyzerType.button.startUpdate": "Start update",
  "analyzerType.column.actions": "Действия",
  "analyzerType.column.protocol": "Протокол",
  "analyzerType.column.resultsMapped": "Results mapped",
  "analyzerType.column.status": "Статус",
  "analyzerType.column.testsMapped": "Tests mapped",
  "analyzerType.column.type": "Тип",
  "analyzerType.column.usedBy": "Used by",
  "analyzerType.dataFlow.resultsOnly": "Results only",
  "analyzerType.dataFlow.twoWay": "Two-way",
  "analyzerType.duplicate.lineage.subtitle": "The new profile starts from {name} revision {revision}. Later changes do not alter the source profile or its analyzers.",
  "analyzerType.duplicate.lineage.title": "New profile with preserved lineage",
  "analyzerType.draft.created.subtitle": "The draft is saved in Analyzer Bridge. It must be completed and validated before it can be published for analyzer setup.",
  "analyzerType.draft.created.title": "Profile draft created",
  "analyzerType.draft.loading": "Loading profile draft",
  "analyzerType.draft.publish.ready.subtitle": "{name} has a unique Bridge-owned identity and preserves its source lineage.",
  "analyzerType.draft.publish.ready.title": "Ready to publish",
  "analyzerType.draft.publish.review.subtitle": "Review and save the control-recognition behavior for {name} before publishing.",
  "analyzerType.draft.publish.review.title": "Complete profile review",
  "analyzerType.draft.update.loading": "Loading profile update draft",
  "analyzerType.draft.update.subtitle": "The shared analyzer type is unchanged until this draft is completed and published. Existing analyzers remain pinned to their current revisions.",
  "analyzerType.draft.update.title": "Profile update draft created",
  "analyzerType.empty.subtitle": "Adjust the search or filters to see other analyzer types.",
  "analyzerType.empty.title": "No analyzer types match",
  "analyzerType.explainer.subtitle": "Identical analyzers can share one type. Duplicate a type when an analyzer needs different behavior; deactivate types instead of deleting their history.",
  "analyzerType.explainer.title": "Reusable analyzer setup",
  "analyzerType.error.nameUnique": "Profile names must be unique",
  "analyzerType.field.connectionTest": "Supports connection testing",
  "analyzerType.field.dataFlow": "Data flow",
  "analyzerType.field.fileFormat": "File format",
  "analyzerType.field.filePattern": "File name pattern",
  "analyzerType.field.manufacturer": "Производител",
  "analyzerType.field.model": "Model",
  "analyzerType.field.newProfileName": "New profile name",
  "analyzerType.field.profileName": "Profile name",
  "analyzerType.field.protocol": "Протокол",
  "analyzerType.field.resultColumn": "Result column",
  "analyzerType.field.sampleColumn": "Sample ID column",
  "analyzerType.field.sourceProfile.placeholder": "Select an analyzer type",
  "analyzerType.field.sourceProfile": "Source analyzer type",
  "analyzerType.field.testColumn": "Test code column",
  "analyzerType.filter.all": "Всички",
  "analyzerType.filter.mapping": "Mapping status",
  "analyzerType.filter.protocol": "Протокол",
  "analyzerType.filter.showDeactivated": "Show deactivated",
  "analyzerType.filter.source": "Създадено",
  "analyzerType.history.action.created": "Създадено",
  "analyzerType.history.action.deactivated": "Deactivated",
  "analyzerType.history.action.duplicated": "Duplicated",
  "analyzerType.history.action.reactivated": "Reactivated",
  "analyzerType.history.action.shipped": "Shipped",
  "analyzerType.history.action.updated": "Актуализирано",
  "analyzerType.history.actor": "Changed by",
  "analyzerType.history.change": "Change",
  "analyzerType.history.loading": "Loading profile history",
  "analyzerType.history.revisionValue": "Revision {revision}",
  "analyzerType.history.revision": "Revision",
  "analyzerType.history.status": "Статус",
  "analyzerType.history.time": "Changed at",
  "analyzerType.lineage": "Derived from {profileId} revision {revision}",
  "analyzerType.loading": "Loading analyzer types",
  "analyzerType.mapping.complete": "Fully mapped",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} marked Do not receive",
  "analyzerType.mapping.incomplete": "Needs mapping",
  "analyzerType.mapping.notApplicable": "Not applicable",
  "analyzerType.mapping.notStarted": "Not mapped",
  "analyzerType.mappingEditor.alias": "Alias: {alias}",
  "analyzerType.mappingEditor.confirm": "Confirm mappings and control recognition",
  "analyzerType.mappingEditor.confirmation.by": "Confirmed by {actor} on {date}",
  "analyzerType.mappingEditor.confirmation.current": "Current confirmation",
  "analyzerType.mappingEditor.confirmation.stale": "Confirmation is stale",
  "analyzerType.mappingEditor.confirmation.summary.current": "Current",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Stale",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Not confirmed",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Not confirmed",
  "analyzerType.mappingEditor.confirmation": "Потвърждение",
  "analyzerType.mappingEditor.confirmed": "Mappings and control recognition confirmed",
  "analyzerType.mappingEditor.error.confirm": "Confirmation failed",
  "analyzerType.mappingEditor.error.load": "Analyzer Type mappings could not be loaded",
  "analyzerType.mappingEditor.error.route": "A valid Analyzer Type revision is required",
  "analyzerType.mappingEditor.error.save": "Mappings could not be saved",
  "analyzerType.mappingEditor.excludeResult.short": "Do not receive",
  "analyzerType.mappingEditor.excludeResult": "Do not receive {value}",
  "analyzerType.mappingEditor.excludeTest": "Do not receive {code}",
  "analyzerType.mappingEditor.incomplete": "Resolve or explicitly exclude every source row before confirmation.",
  "analyzerType.mappingEditor.loading": "Loading Analyzer Type mappings",
  "analyzerType.mappingEditor.normalized": "Normalized identity",
  "analyzerType.mappingEditor.observed": "Observed in held results",
  "analyzerType.mappingEditor.recognition.heading": "Control result recognition",
  "analyzerType.mappingEditor.recognition.none": "This Analyzer Type explicitly declares that the interface transports no control results.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Choose an OpenELIS result",
  "analyzerType.mappingEditor.resultPicker": "OpenELIS result for {value}",
  "analyzerType.mappingEditor.results.empty": "This Test has no active result options",
  "analyzerType.mappingEditor.results.heading": "Results - {name}",
  "analyzerType.mappingEditor.results.loading": "Loading result options",
  "analyzerType.mappingEditor.results.openCatalog": "Add result options in Test Catalog",
  "analyzerType.mappingEditor.results.testFirst": "Choose an OpenELIS Test before mapping its results",
  "analyzerType.mappingEditor.results": "Results mapped",
  "analyzerType.mappingEditor.return": "Analyzer Types",
  "analyzerType.mappingEditor.save": "Update shared mappings",
  "analyzerType.mappingEditor.saved": "Mappings saved",
  "analyzerType.mappingEditor.shared.subtitle": "Changes create a new mapping candidate for {count, plural, =0 {this Analyzer Type} one {# analyzer using this type} other {# analyzers using this type}}. Existing active configurations do not move until the candidate is confirmed and adopted.",
  "analyzerType.mappingEditor.shared.title": "Shared Analyzer Type mappings",
  "analyzerType.mappingEditor.sourceCode": "Analyzer code",
  "analyzerType.mappingEditor.state.bound": "Мапирано",
  "analyzerType.mappingEditor.state.excluded": "Do not receive",
  "analyzerType.mappingEditor.state.unresolved": "Needs mapping",
  "analyzerType.mappingEditor.subtitle": "{protocol} · revision {revision}",
  "analyzerType.mappingEditor.suggestion": "Suggested match: {name}",
  "analyzerType.mappingEditor.summary": "Mapping summary",
  "analyzerType.mappingEditor.testPicker.placeholder": "Search by name, code, or LOINC",
  "analyzerType.mappingEditor.testPicker": "OpenELIS test for {code}",
  "analyzerType.mappingEditor.tests.heading": "Test and result mappings",
  "analyzerType.mappingEditor.tests.help": "Review each analyzer code independently. Map it to an active OpenELIS Test or explicitly exclude it.",
  "analyzerType.mappingEditor.tests": "Tests mapped",
  "analyzerType.mappingEditor.title": "{name} mappings",
  "analyzerType.mappingEditor.unsaved": "Unsaved mapping changes",
  "analyzerType.mappingEditor.useSuggestion": "Use suggested test",
  "analyzerType.modal.deactivate.subtitle": "Existing analyzers and revision history stay linked. This profile will no longer be available for new analyzer setup.",
  "analyzerType.modal.deactivate.title": "Deactivate {name}",
  "analyzerType.modal.history.title": "{name} history",
  "analyzerType.modal.reactivate.subtitle": "This profile will be available for new analyzer setup again. Existing analyzers remain pinned to their selected revisions.",
  "analyzerType.modal.reactivate.title": "Reactivate {name}",
  "analyzerType.modal.update.subtitle": "This starts a new immutable revision from revision {revision}. {count, plural, one {# analyzer remains pinned to its current revision.} other {# analyzers remain pinned to their current revisions.}}",
  "analyzerType.modal.update.title": "Update {name}",
  "analyzerType.notification.action.error.subtitle": "Try the profile action again.",
  "analyzerType.notification.action.error": "Profile action failed",
  "analyzerType.notification.create.success": "Profile created",
  "analyzerType.notification.deactivate.success": "Profile deactivated",
  "analyzerType.notification.duplicate.success": "Profile duplicated",
  "analyzerType.notification.update.success": "Profile updated",
  "analyzerType.notification.loadError.subtitle": "Check the Analyzer Bridge connection, then try again.",
  "analyzerType.notification.loadError": "Analyzer types could not be loaded",
  "analyzerType.notification.reactivate.success": "Profile reactivated",
  "analyzerType.page.subtitle": "The reusable setups behind your analyzers.",
  "analyzerType.page.title": "Analyzer Types",
  "analyzerType.protocol.file": "Flat file",
  "analyzerType.recognition.none.affirmation": "I confirm this interface does not transmit control results",
  "analyzerType.recognition.none.subtitle": "Publish this profile only when the analyzer interface sends no control results. Profiles that transmit controls require explicit recognition rules.",
  "analyzerType.recognition.none.title": "No automatic control-result recognition",
  "analyzerType.recognition.condition.add": "Add condition",
  "analyzerType.recognition.condition.fieldValue": "{source} value",
  "analyzerType.recognition.condition.new": "New recognition condition",
  "analyzerType.recognition.condition.prefixValue": "Specimen ID prefix",
  "analyzerType.recognition.condition.remove": "Remove condition",
  "analyzerType.recognition.condition.select.placeholder": "Choose a condition",
  "analyzerType.recognition.condition.select": "New condition",
  "analyzerType.recognition.condition.sourceContains": "{source} contains",
  "analyzerType.recognition.condition.sourceEquals": "{source} equals",
  "analyzerType.recognition.condition.specimenPrefix": "Specimen ID starts with",
  "analyzerType.recognition.condition.summary.configuredPattern": "Specimen ID matches a configured pattern",
  "analyzerType.recognition.condition.summary.contains": "{source} contains {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} equals {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} starts with {value}",
  "analyzerType.recognition.condition.summary.unknown": "Control-result recognition",
  "analyzerType.recognition.error.load": "Control recognition could not be loaded.",
  "analyzerType.recognition.error.save": "Control recognition could not be saved.",
  "analyzerType.recognition.error.title": "Control recognition needs attention",
  "analyzerType.recognition.heading": "Control result recognition",
  "analyzerType.recognition.loading": "Loading control recognition",
  "analyzerType.recognition.mode.none": "This interface does not transmit control results",
  "analyzerType.recognition.mode.none.short": "No control-result recognition",
  "analyzerType.recognition.mode.rules": "Recognize controls using these conditions",
  "analyzerType.recognition.mode.rules.short": "Rule-based control recognition",
  "analyzerType.recognition.mode": "How does this interface identify control results?",
  "analyzerType.recognition.rules.help": "A result is treated as a control when any condition matches.",
  "analyzerType.recognition.save": "Save control recognition",
  "analyzerType.recognition.saved": "Control recognition saved",
  "analyzerType.recognition.source.specimenId": "Specimen ID",
  "analyzerType.recognition.validation.title": "Profile draft still needs attention",
  "analyzerType.revision": "revision {revision}",
  "analyzerType.search.label": "Search analyzer types",
  "analyzerType.search.placeholder": "Search by name, manufacturer, or model",
  "analyzerType.source.shipped": "Shipped",
  "analyzerType.source.site": "Site-created",
  "analyzerType.status.active": "Активен",
  "analyzerType.status.inactive": "Deactivated",
  "analyzerType.summary.ariaLabel": "Analyzer type summary",
  "analyzerType.summary.deactivated": "Deactivated",
  "analyzerType.summary.inUse": "В употреба",
  "analyzerType.summary.needsAttention": "Needs Attention",
  "analyzerType.summary.total": "Analyzer Types",
  "analyzerType.usedBy": "{count, plural, =0 {Not in use} one {# analyzer} other {# analyzers}}",
  "analyzer.navigation.qcControlLots": "Control Lots",
  "analyzer.navigation.qcRuleConfig": "Rule Configuration",
  "analyzer.page.addButton": "Добави анализатор",
  "analyzer.page.hierarchy.list": "Списък с анализатори",
  "analyzer.page.hierarchy.mappings": "Мапинги на полета",
  "analyzer.page.hierarchy.root": "Анализатори",
  "analyzer.page.title": "Анализатори",
  "analyzer.plugin.missing": "Липсващ плъгин",
  "analyzer.qc.alerts.message": "Функциите за сигнали и нарушения ще бъдат налични скоро.",
  "analyzer.qc.alerts.title": "QC сигнали и нарушения",
  "analyzer.qc.corrective.message": "Функциите за коригиращи действия ще бъдат налични скоро.",
  "analyzer.qc.corrective.title": "Коригиращи действия",
  "analyzer.qc.placeholder.message": "Функциите за Контрол на качеството ще бъдат налични скоро.",
  "analyzer.qc.placeholder.title": "Контрол на качеството",
  "analyzer.action.viewResults": "View results",
  "analyzer.results.held.code": "Analyzer code: {code}",
  "analyzer.results.held.reviewMapping": "Review Analyzer Type mapping",
  "analyzer.results.held.subtitle": "Held results cannot be accepted. Resolve the Analyzer Type mapping so the next matching result can enter the normal review workflow.",
  "analyzer.results.held.tag": "Held",
  "analyzer.results.held.title": "{count, plural, one {# analyzer result needs attention} other {# analyzer results need attention}}",
  "analyzer.qualitativeMapping.isDefault": "По подразбиране",
  "analyzer.qualitativeMapping.mappings": "Мапинги на стойности",
  "analyzer.qualitativeMapping.noValues": "Няма налични стойности от анализатора за мапинг",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Изберете OpenELIS код",
  "analyzer.qualitativeMapping.subtitle": "Мапиране на качествени стойности за {fieldName}",
  "analyzer.qualitativeMapping.title": "Мапинг на качествени стойности",
  "analyzer.qualitativeMapping.validation.error": "Грешка при валидация",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Моля, коригирайте грешките по-долу",
  "analyzer.qualitativeMapping.validation.noDefault": "Няма стойност по подразбиране",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Поне един мапинг трябва да бъде маркиран като по подразбиране",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS кодът е задължителен",
  "analyzer.query.button": "Запитване към анализатора",
  "analyzer.query.cancel": "Отказ",
  "analyzer.query.modal.logs": "Логове на връзката",
  "analyzer.query.modal.noLogs": "Все още няма логове.",
  "analyzer.query.modal.progress": "Прогрес",
  "analyzer.query.modal.state": "Състояние",
  "analyzer.query.modal.subtitle": "Извличане на налични полета от анализатора",
  "analyzer.query.modal.title": "Запитване към анализатора",
  "analyzer.query.progress": "{percent}% завършени",
  "analyzer.search.label": "Търсене",
  "analyzer.search.placeholder": "Търсене на анализатори...",
  "analyzer.attention.review": "Review held results",
  "analyzer.attention.subtitle": "Map unknown tests or result values before using these results clinically.",
  "analyzer.attention.tag": "Needs attention",
  "analyzer.attention.title.many": "{count} analyzers have held results",
  "analyzer.attention.title.one": "{name} has held results",
  "analyzer.stat.active": "Активни",
  "analyzer.stat.inactive": "Неактивни",
  "analyzer.stat.needsAttention": "Needs attention",
  "analyzer.stat.setup": "In Setup",
  "analyzer.stat.total": "Общо анализатори",
  "analyzer.stats.active": "Активни анализатори",
  "analyzer.stats.inactive": "Неактивни анализатори",
  "analyzer.stats.total": "Общо анализатори",
  "analyzer.status.active": "Активен",
  "analyzer.status.deleted": "Изтрит",
  "analyzer.status.error_pending": "Грешка (изчакваща)",
  "analyzer.status.inactive": "Неактивен",
  "analyzer.status.offline": "Офлайн",
  "analyzer.status.setup": "Настройка",
  "analyzer.status.validation": "Валидация",
  "analyzer.success.save": "Анализаторът е запазен успешно",
  "analyzer.table.actions": "Действия",
  "analyzer.table.connection": "Връзка",
  "analyzer.table.header.connection": "Връзка",
  "analyzer.table.header.lastModified": "Последна промяна",
  "analyzer.table.header.name": "Име",
  "analyzer.table.header.status": "Статус",
  "analyzer.table.header.testUnits": "Тестови единици",
  "analyzer.table.header.type": "Тип",
  "analyzer.table.lastModified": "Последна промяна",
  "analyzer.table.name": "Име",
  "analyzer.table.status": "Статус",
  "analyzer.table.testUnits": "Тестови единици",
  "analyzer.table.type": "Тип",
  "analyzer.table.type.loading": "Loading analyzer type",
  "analyzer.table.type.unavailable": "Analyzer type unavailable",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Cannot reach bridge health endpoint at {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge returned HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge is not configured",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge returned an unparseable response",
  "analyzer.testConnection.bridge.unreachable": "Cannot reach bridge: {detail}",
  "analyzer.testConnection.close": "Затвори",
  "analyzer.testConnection.logs": "Логове на връзката",
  "analyzer.testConnection.requestBuildFailed": "Failed to build request: {detail}",
  "analyzer.testConnection.success": "Връзката е успешна",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge is not configured, so analyzer reachability cannot be tested",
  "analyzer.testConnection.testAgain": "Тествай отново",
  "analyzer.testConnection.testing": "Тестване на връзката...",
  "analyzer.testConnection.title": "Тестване на връзката",
  "analyzer.testMapping.activeMappings": "{count} активни мапинга",
  "analyzer.testMapping.analyzerInfo": "Информация за анализатора",
  "analyzer.testMapping.analyzerName": "Име на анализатора",
  "analyzer.testMapping.analyzerType": "Тип анализатор",
  "analyzer.testMapping.appliedMappings": "Приложени мапинги",
  "analyzer.testMapping.entityPreview": "Преглед на OpenELIS обекти",
  "analyzer.testMapping.errors": "Грешки",
  "analyzer.testMapping.loading": "Обработка на прегледа...",
  "analyzer.testMapping.messageInput": "Примерно ASTM съобщение",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} символа",
  "analyzer.testMapping.messageInput.helper": "Въведете примерно ASTM съобщение, за да видите как ще бъде интерпретирано",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Примерно ASTM съобщение *",
  "analyzer.testMapping.noResults": "Все още няма резултати. Въведете ASTM съобщение и кликнете върху „Преглед на мапинга“.",
  "analyzer.testMapping.parsedFields": "Парснати полета",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM реф.",
  "analyzer.testMapping.parsedFields.fieldName": "Име на поле",
  "analyzer.testMapping.parsedFields.interpretation": "Интерпретация",
  "analyzer.testMapping.parsedFields.mappedTo": "Мапирано към",
  "analyzer.testMapping.parsedFields.rawValue": "Сурова стойност",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Опции за преглед",
  "analyzer.testMapping.previewOptions.detailedParsing": "Показване на детайлни стъпки при парсване",
  "analyzer.testMapping.previewOptions.validateAll": "Валидиране на всички мапинги",
  "analyzer.testMapping.results": "Резултати от прегледа",
  "analyzer.testMapping.saveTestCase": "Запази като тестов сценарий",
  "analyzer.testMapping.submit": "Преглед на мапинга",
  "analyzer.testMapping.subtitle": "Преглед на това как се интерпретират примерните ASTM съобщения",
  "analyzer.testMapping.testAnother": "Тествай друго съобщение",
  "analyzer.testMapping.title": "Тестване на мапинги на полета",
  "analyzer.testMapping.validation.invalidFormat": "Невалиден формат на ASTM съобщение",
  "analyzer.testMapping.validation.messageRequired": "ASTM съобщението е задължително",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM съобщението надвишава максималния размер от 10KB",
  "analyzer.testMapping.warnings": "Предупреждения",
  "analyzer.unitMapping.analyzerUnit": "Изходна единица (Анализатор)",
  "analyzer.unitMapping.analyzerUnit.helper": "Единица, отчетена от анализатора",
  "analyzer.unitMapping.conversionFactor": "Коефициент на преобразуване",
  "analyzer.unitMapping.conversionFactor.helper": "Коефициент за преобразуване от {from} към {to} (напр. 0.0555 за mg/dL към mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Целева единица (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Канонична единица, използвана в OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Изберете целева единица",
  "analyzer.unitMapping.rejectIfMismatch": "Отхвърли при несъответствие на единиците",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Отхвърляне на съобщения, ако единиците не съвпадат и не е предоставен коефициент",
  "analyzer.unitMapping.subtitle": "Конфигуриране на мапинг на единици за {fieldName}",
  "analyzer.unitMapping.title": "Мапинг на единици",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Изходната единица е задължителна",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Коефициентът трябва да бъде положително число",
  "analyzer.unitMapping.validation.conversionFactor.required": "Коефициентът е задължителен при различни единици",
  "analyzer.unitMapping.validation.error": "Грешка при валидация",
  "analyzer.unitMapping.validation.error.subtitle": "Моля, коригирайте грешките по-долу",
  "analyzer.unitMapping.validation.openelisUnit.required": "Целевата единица е задължителна",
  "analyzerTestName.header.analyzerName": "Analyzer - Analyzer Test Name",
  "analyzerTestName.modal.add.heading": "Add Analyzer Test Name",
  "analyzerTestName.modal.update.heading": "Update Analyzer Test Name",
  "assigned.cytopathologist.label": "Зададен цитопатолог",
  "assigned.pathologist.label": "Зададен патолог",
  "assigned.technician.label": "Зададен лаборант",
  "audittrail.table.heading.action": "Действие",
  "audittrail.table.heading.identifier": "Идентификатор",
  "audittrail.table.heading.item": "Елемент",
  "audittrail.table.heading.newvalue": "Нова стойност",
  "audittrail.table.heading.oldvalue": "Стара стойност",
  "audittrail.table.heading.time": "Време",
  "audittrail.table.heading.user": "Потребител",
  "audittrail.table.title.patientResults": "Резултати на пациента",
  "availabletests.title": "Налични тестове",
  "back.action.button": "Назад",
  "banner.menu.administration": "Админ",
  "banner.menu.alerts": "Alerts",
  "banner.menu.alerts.tooltip": "Alerts and quality assurance dashboard",
  "banner.menu.aliquot": "Аликот",
  "banner.menu.aliquot.tooltip": "Аликотиране на проба",
  "banner.menu.billing": "Фактуриране",
  "banner.menu.billing.tooltip": "Фактуриране",
  "banner.menu.createDouble": "Двойно въвеждане",
  "banner.menu.createInitial": "Първоначално въвеждане",
  "banner.menu.eorders": "Входящи поръчки",
  "banner.menu.eqa": "EQA",
  "banner.menu.eqa.distribution": "EQA Distributions",
  "banner.menu.eqa.distribution.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.management": "EQA Programs",
  "banner.menu.eqa.management.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt": "EQA Management",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Manage organization enrollment in EQA programs",
  "banner.menu.eqa.mgmt.programs": "Programs",
  "banner.menu.eqa.mgmt.programs.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt.results": "Results & Analysis",
  "banner.menu.eqa.mgmt.results.tooltip": "EQA results collection and statistical analysis",
  "banner.menu.eqa.mgmt.tooltip": "Manage EQA programs, participants, and distributions",
  "banner.menu.eqa.tests": "EQA Tests",
  "banner.menu.eqa.tests.myPrograms": "My Programs",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Manage self-enrollment in external EQA programs",
  "banner.menu.eqa.tests.orders": "Поръчки",
  "banner.menu.eqa.tests.orders.tooltip": "View and manage EQA test orders",
  "banner.menu.eqa.tests.tooltip": "EQA test orders and program enrollment",
  "banner.menu.eqa.tooltip": "External Quality Assurance",
  "banner.menu.generic.sample": "Обща проба",
  "banner.menu.generic.sample.edit": "Редактиране на поръчка",
  "banner.menu.generic.sample.import": "Импорт на проби",
  "banner.menu.generic.sample.order": "Създаване на поръчка",
  "banner.menu.generic.sample.results": "Въвеждане на резултати",
  "banner.menu.help": "Помощ",
  "banner.menu.help.about": "Видео уроци",
  "banner.menu.help.contact": "Бележки по версията",
  "banner.menu.help.documents": "Документация на процесите",
  "banner.menu.help.formDBS": "Формуляр DBS",
  "banner.menu.help.formVL": "Формуляр VL",
  "banner.menu.help.usermanual": "Ръководство за потребителя",
  "banner.menu.home": "Начало",
  "banner.menu.inventory": "Инвентар",
  "banner.menu.inventory.catalog": "Управление на каталог",
  "banner.menu.inventory.dashboard": "Табло",
  "banner.menu.inventory.list": "Инвентарни наличности",
  "banner.menu.inventory.reports": "Отчети",
  "banner.menu.nonconformity": "Несъответствия",
  "banner.menu.nonconformity.correctiveActions": "Коригиращи действия",
  "banner.menu.nonconformity.dashboard": "All NCEs",
  "banner.menu.nonconformity.report": "Докладване на несъответствие",
  "banner.menu.nonconformity.view": "Преглед на нови несъответствия",
  "banner.menu.patient": "Пациент",
  "banner.menu.patient.Create": "Проучване",
  "banner.menu.patient.addOrEdit": "Добави/Редактирай пациент",
  "banner.menu.patient.merge": "Обединяване на пациенти",
  "banner.menu.patient.merge.tooltip": "Обединяване на дублиращи се записи",
  "banner.menu.patientConsult": "Преглед",
  "banner.menu.patientEdit": "Редактирай",
  "banner.menu.patienthistory": "История на пациента",
  "banner.menu.printBarcode": "Баркод",
  "banner.menu.referredOut": "Препратени",
  "banner.menu.report.validation.backlog": "Забавена валидация",
  "banner.menu.reports": "Отчети",
  "banner.menu.reports.routine": "Рутинни",
  "banner.menu.reports.study": "Проучване",
  "banner.menu.results": "Резултати",
  "banner.menu.results.CobasIntegra400": "Биохимия: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Имунология: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Имунология: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Имунология: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Биохимия: Импортер за автоматични анализатори",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Хематология: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL Анализатор",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXPAnalyzer",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP Анализатор",
  "banner.menu.results.accession": "По поръчка",
  "banner.menu.results.analyzer": "Анализатор",
  "banner.menu.results.cobasc111analyzer": "Биохимия: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "По звено",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Поръчка на програми",
  "banner.menu.results.patient": "По пациент",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "По тест, дата или статус",
  "banner.menu.results.sysmexanalyzer": "Хематология: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Хематология: Sysmex XT импортер",
  "banner.menu.results.taqman48dbsanalyzer": "Вирусология: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "По дата на теста",
  "banner.menu.results.unified": "Results Entry",
  "banner.menu.results.unified.tooltip": "Unified results entry worklist",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Валидация",
  "banner.menu.resultvalidation.bacteria": "Бактерии",
  "banner.menu.resultvalidation.bench": "По работно място",
  "banner.menu.resultvalidation.biochemistry": "Биохимия",
  "banner.menu.resultvalidation.cytobacteriology": "Цитобактериология",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Ендокринология",
  "banner.menu.resultvalidation.genotyping": "Генотипиране",
  "banner.menu.resultvalidation.hemato-immunology": "Хемато-имунология",
  "banner.menu.resultvalidation.hematology": "Хематология",
  "banner.menu.resultvalidation.immunology": "Имунология",
  "banner.menu.resultvalidation.immunology.Haiti": "Имунология-Вирусология",
  "banner.menu.resultvalidation.immunologyHematology": "Имунология - Хематология",
  "banner.menu.resultvalidation.liquidBio": "Течна биология",
  "banner.menu.resultvalidation.malaria": "Малария",
  "banner.menu.resultvalidation.molecularBio": "Молекулярна биология",
  "banner.menu.resultvalidation.mycobacteriology": "Микобактериология",
  "banner.menu.resultvalidation.mycology": "Микология",
  "banner.menu.resultvalidation.parasitology": "Паразитология",
  "banner.menu.resultvalidation.serology": "Серология",
  "banner.menu.resultvalidation.serology-immunology": "Серология-Имунология",
  "banner.menu.resultvalidation.viralload": "Вирусен товар",
  "banner.menu.resultvalidation.virology": "Вирусология",
  "banner.menu.resultvalidation_routine": "Рутинна",
  "banner.menu.resultvalidation_study": "Проучване",
  "banner.menu.sample": "Поръчка",
  "banner.menu.sample.shipment": "Sample Shipment",
  "banner.menu.sampleAdd": "Добавяне на поръчка",
  "banner.menu.sampleBatchEntry": "Групово въвеждане на поръчки",
  "banner.menu.sampleConsult": "Преглед",
  "banner.menu.sampleCreate": "Проучване",
  "banner.menu.sampleEdit": "Редактиране на поръчка",
  "banner.menu.sampleManagement": "Управление на проби",
  "banner.menu.sampleManagement.tooltip": "Меню Управление на проби",
  "banner.menu.storage": "Съхранение",
  "banner.menu.storage.tooltip": "Управление на съхранението на проби",
  "banner.menu.study.eorders": "Електронни поръчки",
  "banner.menu.workplan": "Работен план",
  "banner.menu.workplan.batch": "Batch Workplan",
  "banner.menu.workplan.batch.tooltip": "Batch Workplan",
  "banner.menu.workplan.bench": "По звено",
  "banner.menu.workplan.panel": "По панел",
  "banner.menu.workplan.priority": "По приоритет",
  "banner.menu.workplan.test": "По тип тест",
  "banner.menu.workplan.unit": "По тестова секция",
  "barcode.additionalInvalidLevels.message": "Баркодът съдържа нива извън валидната част. Попълнени са само валидните нива.",
  "barcode.additionalInvalidLevels.warning": "Засечени са допълнителни невалидни нива",
  "barcode.autoOpenForm": "Отваряне на формата за местоположение с валидна йерархия",
  "barcode.debounce.warning": "Моля, изчакайте, преди да сканирате друг баркод",
  "barcode.error": "Невалиден баркод",
  "barcode.firstMissingLevel": "Първо липсващо ниво: {level}",
  "barcode.format": "Формат на баркода",
  "barcode.header": "Баркод(ове)",
  "barcode.invalidFormat": "Невалиден формат на баркода. Очакван: ROOM-DEVICE или ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Block label",
  "barcode.label.freezer": "Freezer label",
  "barcode.label.helper.text": "Въведете стойности в: mm",
  "barcode.label.order": "Order label",
  "barcode.label.slide": "Slide label",
  "barcode.label.specimen": "Specimen label",
  "barcode.label.info.blockCaseNumber": "Block Case Number",
  "barcode.label.info.blockId": "Block ID",
  "barcode.label.info.blockNumber": "Block Number",
  "barcode.label.info.boxid": "Box ID",
  "barcode.label.info.caseNumber": "Case Number",
  "barcode.label.info.collectedBy": "Взето от",
  "barcode.label.info.collectionDate": "Дата на вземане",
  "barcode.label.info.collectionDateTime": "Дата и час на вземане",
  "barcode.label.info.created": "Създадено",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Expiry Date",
  "barcode.label.info.labNumber": "Номер на акцесия",
  "barcode.label.info.patientDobFull": "Дата на раждане на пациента",
  "barcode.label.info.patientId": "ID на пациент",
  "barcode.label.info.patientName": "Име на пациента",
  "barcode.label.info.patientSexFull": "Пол на пациента",
  "barcode.label.info.samplecount": "Проби",
  "barcode.label.info.siteId": "Site ID",
  "barcode.label.info.slideId": "Slide ID",
  "barcode.label.info.slideNumber": "Slide Number",
  "barcode.label.info.specimenType": "Specimen Type",
  "barcode.label.info.stainType": "Stain Type",
  "barcode.label.info.storageLocation": "Място за съхранение",
  "barcode.label.info.temperature": "Temperature",
  "barcode.label.info.tests": "Тестове",
  "barcode.labels.order.row": "Order labels",
  "barcode.labels.running.total": "Running total",
  "barcode.labels.sample.row": "Specimen labels sample {sampleNumber}",
  "barcode.labels.section.title": "Label quantities",
  "barcode.locationNotFound": "Местоположението не е намерено",
  "barcode.notification.save": "Конфигурациите на баркода са запазени.",
  "barcode.partialMatch": "Частично съвпадение - някои компоненти са валидни",
  "barcode.print.button": "Print",
  "barcode.print.dialog.quantityFor": "Quantity to print for {label}",
  "barcode.print.dialog.title": "Print labels",
  "barcode.print.done": "Done",
  "barcode.print.individual.button": "Печат на етикет",
  "barcode.print.later": "Skip — Print Later",
  "barcode.print.preprint": "Предварително отпечатване на баркодове",
  "barcode.print.preprint.button": "Предварително отпечатване на етикети",
  "barcode.print.preprint.note": "ЗАБЕЛЕЖКА: Ако се добави лечебно заведение и/или проба и тест, те ще бъдат отпечатани на ВСЕКИ етикет",
  "barcode.print.reprint.dialog": "Reprint labels",
  "barcode.print.section.set": "Печат на комплекти",
  "barcode.print.set.button": "Печат на комплект",
  "barcode.print.set.instruction": "Печат на комплект етикети (2 за поръчка + 1 за всяка проба)",
  "barcode.print.skip": "Skip",
  "barcode.print.title": "Печат на баркод етикети",
  "barcode.ready": "Готовност за сканиране",
  "barcode.scan": "Сканирай баркод",
  "barcode.scan.error": "Order not found",
  "barcode.scan.placeholder": "Scan barcode or enter lab number...",
  "barcode.scan.success": "Order loaded successfully",
  "barcode.scanning": "Сканиране...",
  "barcode.scanOrType": "Сканирайте баркод или въведете местоположение",
  "barcode.success": "Местоположението е намерено",
  "barcode.validHierarchyPrefilled": "Валидните нива на йерархията са предварително попълнени",
  "barcode.validation.altPrefix": "Input should be alphanumeric and have a maximum length of 4 characters.",
  "barcode.validationFailed": "Валидацията на баркода е неуспешна",
  "barcodeconfiguration.browse.title": "Конфигурация на баркод",
  "breadcrumb.home": "Начало",
  "breadcrumb.caseView": "Case View",
  "breadcrums.admin.managment": "Административно управление",
  "calendar.management.title": "Calendar Management",
  "calendar.management.description": "Manage public holidays and weekend configuration for working time TAT calculations",
  "calendar.management.addHoliday": "Add Holiday",
  "calendar.management.editHoliday": "Edit Holiday",
  "calendar.management.deleteConfirm": "Are you sure you want to delete this holiday?",
  "calendar.management.holidayName": "Holiday Name",
  "calendar.management.date": "Дата",
  "calendar.management.recurring": "Recurring",
  "calendar.management.annual": "Annual",
  "calendar.management.oneTime": "One-time",
  "calendar.management.active": "Активен",
  "calendar.management.inactive": "Неактивен",
  "calendar.management.weekend": "Weekend",
  "calendar.management.weekendDays": "Weekend Days (excluded from Working Time)",
  "calendar.management.weekendSaved": "Weekend configuration saved",
  "calendar.management.importCsv": "Import CSV",
  "calendar.management.exportCsv": "Export CSV",
  "calendar.management.importPreview": "Import Preview",
  "calendar.management.year": "Year",
  "calendar.management.noHolidays": "No holidays configured for {year}. Click \"Add Holiday\" to get started.",
  "calendar.management.duplicateDate": "A holiday already exists for this date",
  "calendar.management.imported": "{count} holidays imported",
  "calendar.management.skipped": "{count} holidays skipped",
  "calendar.management.holidayCount": "{count} holidays configured for {year}",
  "calendar.management.saveError": "Error saving holiday",
  "calendar.management.loadError": "Error loading holidays",
  "calendar.management.save": "Запази",
  "calendar.management.cancel": "Отказ",
  "calendar.management.actions": "Действия",
  "calendar.management.status": "Статус",
  "calendar.management.column.date": "Дата",
  "calendar.management.column.holidayName": "Holiday Name",
  "calendar.management.column.recurring": "Recurring",
  "calendar.management.column.status": "Статус",
  "calendar.management.column.actions": "Действия",
  "calendar.management.day.sun": "Sun",
  "calendar.management.day.mon": "Mon",
  "calendar.management.day.tue": "Tue",
  "calendar.management.day.wed": "Wed",
  "calendar.management.day.thu": "Thu",
  "calendar.management.day.fri": "Fri",
  "calendar.management.day.sat": "Sat",
  "calendar.management.chooseFile": "Choose CSV file",
  "calendar.management.csvColumns": "Columns: date, name, recurring (true/false)",
  "calendar.management.rowsFound": "{count} rows found",
  "calendar.management.column.csvDate": "Дата",
  "calendar.management.column.csvName": "Име",
  "calendar.management.column.csvRecurring": "Recurring",
  "calendar.management.importing": "Импортиране...",
  "caseView.action.discard": "Discard changes",
  "caseView.action.saveDraft": "Save draft",
  "caseView.banner.unsavedChanges": "This case has unsaved changes. Leave the page and lose them?",
  "caseView.badge.notApplicable": "Няма информация",
  "caseView.badge.readOnly": "Read only",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Case progress",
  "caseView.label.caseSummary": "Case summary",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— not recorded",
  "caseView.label.unsavedChanges": "Unsaved changes",
  "caseView.locked.awaitingStage": "Available once the case reaches {stage}",
  "caseView.locked.prerequisite": "Available once this case's earlier steps are complete",
  "column.qc.accession": "QC Sample",
  "column.qc.detail": "Detail",
  "column.qc.result": "Резултат",
  "column.qc.test": "Тест",
  "column.qc.type": "Тип",
  "compliance.dashboard.chart.comparison.title": "Site Comparison — Current Period Compliance %",
  "compliance.dashboard.chart.drilldown.title": "Site Drill-Down — Per-Parameter Trend",
  "compliance.dashboard.chart.trend.title": "Compliance Rate Trend — All Sites",
  "compliance.dashboard.descriptive.excluded": "Descriptive parameters excluded from trend chart",
  "compliance.dashboard.drilldown.placeholder": "Select a site…",
  "compliance.dashboard.empty": "No data matches the selected filters",
  "compliance.dashboard.export.pdf": "Export PDF",
  "compliance.dashboard.filter.allStandards": "All Standards",
  "compliance.dashboard.filter.dateRange": "Период",
  "compliance.dashboard.filter.dateRangeEnd": "End date",
  "compliance.dashboard.filter.drilldownSite": "Drill down by site",
  "compliance.dashboard.filter.sites": "Sampling Sites",
  "compliance.dashboard.filter.standard": "Compliance Standard",
  "compliance.dashboard.kpi.complianceRate": "Compliance Rate",
  "compliance.dashboard.kpi.exceedances": "Total Exceedances",
  "compliance.dashboard.kpi.sitesMonitored": "Sites Monitored",
  "compliance.dashboard.kpi.totalOrders": "Total Orders",
  "compliance.dashboard.loading.comparison": "Loading comparison…",
  "compliance.dashboard.loading.drilldown": "Loading drill-down…",
  "compliance.dashboard.loading.exceedances": "Loading exceedances…",
  "compliance.dashboard.loading.generating": "Generating…",
  "compliance.dashboard.loading.trend": "Loading trend…",
  "compliance.dashboard.lowData": "Low data (< 3 orders)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Дата",
  "compliance.dashboard.table.col.labNumber": "Lab #",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Резултат",
  "compliance.dashboard.table.col.site": "Site",
  "compliance.dashboard.table.col.status": "Статус",
  "compliance.dashboard.table.col.threshold": "Threshold",
  "compliance.dashboard.table.exceedances.title": "Exceedance Summary",
  "compliance.dashboard.title": "Environmental Compliance Dashboard",
  "error.referOut.emailFormat": "Enter a valid email address (e.g. lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Handoff Date/Time is required to dispatch.",
  "error.referOut.maxLength": "Maximum {max} characters.",
  "error.referOut.phoneFormat": "Enter a valid phone number with country code prefix (e.g. +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Select a referring lab.",
  "error.validation.qc.ackFailed": "Failed to record QC acknowledgment. Please try again.",
  "holding.time.exceeded.message": "The SOP max holding time has been exceeded for: {tests}",
  "holding.time.exceeded.note": "WARNING: Result entered after SOP max holding time was exceeded.",
  "holding.time.exceeded.title": "Holding Time Exceeded",
  "instructions.results.entry.unified.route": "When enabled, the unified Results Entry worklist replaces the legacy result entry pages: the Results menu shows a single Results Entry item and the old result entry links redirect to it. Disable to restore the legacy pages.",
  "label.button.edit.details": "Edit details",
  "label.expand.poolDetails": "Expand pool details",
  "label.pool.collapse": "Hide individual specimens",
  "label.pool.expand": "Show individual specimens",
  "label.pool.expansion.next": "Напред",
  "label.pool.expansion.page": "Page {page} of {total}",
  "label.pool.expansion.prev": "Предишен",
  "label.pool.expansion.title": "{animal} specimens ({count})",
  "label.qc.fail": "Fail",
  "label.qc.pass": "Pass",
  "label.referOut.action.dispatch": "Dispatch",
  "label.referOut.action.edit": "Редактиране",
  "label.referOut.action.referOut": "Refer Out",
  "label.referOut.action.save": "Save Referral",
  "label.referOut.action.view": "Преглед",
  "label.referOut.column.actions": "Действия",
  "label.referOut.column.referringLab": "Referring Lab",
  "label.referOut.column.sampleId": "ID на проба",
  "label.referOut.column.sampleType": "Тип проба",
  "label.referOut.column.status": "Subcontract Status",
  "label.referOut.column.tests": "Тестове",
  "label.referOut.dispatch.error": "Failed to dispatch referral.",
  "label.referOut.dispatch.notSaved": "Save the referral before dispatching.",
  "label.referOut.dispatch.success": "Referral dispatched.",
  "label.referOut.empty.subtitle": "Samples appear here once they are saved. Save the order first to refer specimens out.",
  "label.referOut.empty.title": "No samples available for referral",
  "label.referOut.field.agreementReference": "Agreement Reference",
  "label.referOut.field.cocContactEmail": "Chain-of-Custody Contact Email",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Chain-of-Custody Contact Name",
  "label.referOut.field.cocContactPhone": "Chain-of-Custody Contact Phone",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Expected Return Date",
  "label.referOut.field.handoffDate": "Handoff Date",
  "label.referOut.field.handoffDatetime": "Handoff Date/Time",
  "label.referOut.field.handoffTime": "Handoff Time",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Бележки",
  "label.referOut.field.referringLab": "Referring Lab",
  "label.referOut.field.referringLab.placeholder": "Select a referring lab",
  "label.referOut.save.error": "Failed to save referral.",
  "label.referOut.save.success": "Referral saved.",
  "label.referOut.section.description": "Refer specimens to an external lab. Each sample carries its full chain-of-custody metadata.",
  "label.referOut.section.title": "Refer Out / Subcontract",
  "label.referOut.status.cancelled": "Анулиран",
  "label.referOut.status.closed": "Closed",
  "label.referOut.status.completed": "Завършен",
  "label.referOut.status.dispatched": "Dispatched",
  "label.referOut.status.draft": "Чернова",
  "label.referOut.status.inProgress": "In progress",
  "label.referOut.status.notReferred": "In-house",
  "label.referOut.status.received": "Received",
  "label.referOut.status.rejected": "Rejected",
  "label.referOut.status.requested": "Requested",
  "label.referOut.status.resultsReturned": "Results Returned",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Client sample",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "I have reviewed the QC failures and assessed their impact on the result release",
  "label.validation.qc.ack.heading": "Required Acknowledgment",
  "label.validation.qc.banner.subtitle": "Review and acknowledge below before releasing results.",
  "label.validation.qc.banner.title": "QC failures detected — {count} QC sample(s) failed acceptance criteria",
  "label.validation.qc.failedSamples": "Failed QC Samples",
  "label.validation.qc.justification": "Justification",
  "label.validation.checkBeforeRelease": "Check before release",
  "label.validation.triage.filterLabel": "Filter by signal",
  "label.validation.filter.all": "Всички",
  "label.validation.filter.needsReview": "Needs review",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "QC fail",
  "label.validation.filter.modified": "Modified",
  "label.validation.filter.ackPending": "Ack pending",
  "label.validation.filter.critical": "Критична",
  "label.validation.filter.abnormal": "Abnormal",
  "label.validation.lane.clear": "Изчисти",
  "label.validation.lane.needsReview": "Needs review",
  "label.validation.signal.nce": "NCE open",
  "label.validation.signal.qcFail": "QC fail",
  "label.validation.signal.modified": "Modified",
  "label.validation.signal.ackPending": "Ack pending",
  "label.validation.signal.nonconforming": "Nonconforming",
  "label.validation.signal.critical": "Критична",
  "label.validation.review.result": "Резултат",
  "label.validation.review.units": "Единици",
  "label.validation.review.normalRange": "Reference range",
  "label.validation.review.criticalRange": "Критичен диапазон",
  "label.validation.review.method": "Method",
  "label.validation.review.analyzer": "Анализатор",
  "label.validation.review.performedAt": "Performed at",
  "label.validation.review.enteredBy": "Entered by",
  "label.validation.review.enteredDate": "Entered on",
  "label.validation.review.collected": "Collected",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC passed",
  "label.validation.review.qc.FAIL": "QC failed",
  "label.validation.review.notRecorded": "Не е записано",
  "label.validation.review.beforeRelease": "Before releasing, check:",
  "label.validation.review.components": "Components",
  "label.validation.review.component": "Component",
  "label.validation.review.flag": "Flag",
  "label.validation.review.primary": "Основен",
  "label.validation.review.reference": "Reference",
  "label.validation.review.notes": "Бележки",
  "label.validation.review.notes.summary": "{count} notes",
  "label.validation.review.notes.empty": "No notes yet",
  "label.validation.review.notes.add": "Validation note",
  "label.validation.review.notes.placeholder": "Add a validation note…",
  "label.validation.review.notes.visibility": "Visibility",
  "label.validation.review.notes.internal": "Internal",
  "label.validation.review.notes.external": "Send with result",
  "label.validation.review.notes.externalWarning": "This note will appear on the patient report.",
  "label.validation.review.notes.contextHint": "Context: Validation (recorded automatically).",
  "label.validation.review.notes.context.result": "Result note",
  "label.validation.review.modify.reason": "Reason for modification",
  "label.validation.review.modify.reasonRequired": "A reason is required to modify a result.",
  "label.validation.review.modify.newValue": "New result",
  "label.validation.review.modify.notEditable": "This result type is edited on the Results Entry page.",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Reagent and control lots for this analysis are reviewed on the Results Entry page.",
  "label.validation.review.action.release": "Validate & release",
  "label.validation.review.action.modify": "Modify result",
  "label.validation.review.action.saveModification": "Save modification",
  "label.validation.review.action.cancel": "Отказ",
  "label.validation.review.action.refer": "Refer this test",
  "label.validation.review.release.qcAckFirst": "Acknowledge the failed QC below before releasing.",
  "label.validation.review.error.notAwaitingValidation": "This result changed since the page loaded. Reload and review it again.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Failed QC in this batch must be acknowledged before release.",
  "label.validation.review.error.modificationReasonRequired": "A reason is required to modify a result.",
  "label.validation.review.error.modifyRoleRequired": "Your role does not permit modifying results.",
  "label.validation.review.error.resultRequired": "Enter a result value before saving.",
  "label.validation.review.error.invalidResult": "The result is incomplete; check the qualified value.",
  "label.validation.review.error.generic": "The action could not be completed.",
  "label.validation.review.success.released": "Result validated and released.",
  "label.validation.review.success.modified": "Result modified. It stays in the validation queue.",
  "esig.context.validateSingle": "Validate and release {test} for accession {accession}",
  "label.validation.bulk.releaseAllClear": "Release all clear ({count})",
  "label.validation.bulk.heading": "Release all clear results",
  "label.validation.bulk.body": "These {count} results are in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. Releasing commits one e-signature for the whole set; a result that stops being clear before the release is skipped.",
  "label.validation.bulk.disabled": "Bulk release is turned off for this laboratory.",
  "label.validation.emptyState.signals": "{count} results in this queue carry something to check before release.",
  "label.validation.emptyState.signalsDetail": "Most common: {signals}.",
  "label.validation.emptyState.noReference": "{count} results are for tests with no reference value recorded in the test catalogue, so they cannot be judged as normal.",
  "label.validation.emptyState.noReferenceHint": "Record an expected normal value for these tests in the Test Catalogue to let their results clear.",
  "label.validation.emptyState.queueEmpty": "Nothing is waiting for validation.",
  "label.validation.release.scope": "Clearance checks the reference range, result flags, non-conformities, edits after save and critical acknowledgment, and stops any result with a recorded quality-control failure. It does not confirm that quality control was performed.",
  "label.validation.bulk.none": "No clear results to release.",
  "label.validation.bulk.column.accession": "Lab No.",
  "label.validation.bulk.success": "{count} clear result(s) released.",
  "label.validation.bulk.partial": "{released} released; {skipped} skipped because they were no longer clear.",
  "label.validation.bulk.error.bulkReleaseDisabled": "Bulk release is turned off for this laboratory.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Failed QC in this batch must be acknowledged before release.",
  "label.validation.bulk.error.nothingReleased": "None of the selected results is still clear; nothing was released.",
  "label.validation.bulk.error.generic": "The bulk release could not be completed.",
  "label.validation.review.action.review": "Review →",
  "esig.context.releaseAllClear": "Release {count} clear result(s) for {accession}",
  "instructions.validation.bulk.release": "When enabled, the Validation page offers \"Release all clear\", which releases only results in the Clear lane (in range, no recorded QC failure, no signals) under one e-signature. Disable to require every result to be released individually after review.",
  "instructions.validation.retest.note": "When enabled, a validator sending a result back for retest must write a note for the bench.",
  "label.validation.review.action.retest": "Send for retest",
  "label.validation.review.action.reject": "Reject (file NCE)",
  "label.validation.review.retest.note": "Note for the bench",
  "label.validation.review.retest.noteRequired": "A note is required to send a result for retest.",
  "label.validation.review.retest.hint": "The result goes back to Results Entry and the pipeline restarts at level 1.",
  "label.validation.review.reject.hint": "Rejecting files a non-conformity event; complete the form to record it.",
  "label.validation.review.reject.disabled": "Result rejection is turned off for this laboratory.",
  "label.validation.review.error.stale": "This result was changed by {who} at {when}. Reloading the queue…",
  "label.validation.review.error.retestNoteRequired": "A note is required to send a result for retest.",
  "label.validation.review.error.rejectionDisabled": "Result rejection is turned off for this laboratory.",
  "label.validation.review.success.retest": "Result sent back for retest.",
  "label.validation.review.success.rejected": "Result rejected; the non-conformity event is recorded.",
  "label.validation.bulk.error.stale": "The queue changed while you were reviewing. Reloading…",
  "label.validation.autoValidated.toggle": "Include auto-validated",
  "label.validation.autoValidated.heading": "Auto-validated results ({count})",
  "label.validation.autoValidated.tag": "Auto-validated",
  "label.validation.autoValidated.empty": "No auto-validated results for this accession.",
  "label.validation.autoValidated.hint": "Released at result entry without a validator; shown for review only.",
  "label.validation.autoValidated.releasedOn": "Released on",
  "laporanHasil.action.generatePdf": "Generate PDF",
  "laporanHasil.action.regeneratePdf": "Re-generate PDF",
  "laporanHasil.col.actions": "Действия",
  "laporanHasil.col.collectionDate": "Дата на вземане",
  "laporanHasil.col.compliance": "Compliance",
  "laporanHasil.col.labNumber": "Лабораторен номер",
  "laporanHasil.col.lastGenerated": "Last Generated",
  "laporanHasil.col.site": "Site",
  "laporanHasil.col.standard": "Standard",
  "laporanHasil.col.tests": "Тестове",
  "laporanHasil.detail.ambientTemp": "Ambient Temp",
  "laporanHasil.detail.collectionDateTime": "Collection Date/Time",
  "laporanHasil.detail.collectionMethod": "Collection Method",
  "laporanHasil.detail.complianceSummary": "Compliance Summary",
  "laporanHasil.detail.conditions": "Collection Conditions",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Lab Analyst",
  "laporanHasil.detail.labManager": "Lab Manager",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Preservation",
  "laporanHasil.detail.result": "Резултат",
  "laporanHasil.detail.signatures": "Signatures",
  "laporanHasil.detail.site": "Site",
  "laporanHasil.detail.siteInfo": "Информация за обекта",
  "laporanHasil.detail.standard": "Standard",
  "laporanHasil.detail.status": "Статус",
  "laporanHasil.detail.threshold": "Threshold",
  "laporanHasil.detail.waterTemp": "Water Temp",
  "laporanHasil.detail.weather": "Weather",
  "laporanHasil.empty": "No orders found for the selected filters.",
  "laporanHasil.error": "Failed to load report. Please try again.",
  "laporanHasil.filter.all": "Всички",
  "laporanHasil.filter.allSites": "All Sites",
  "laporanHasil.filter.allStandards": "All Standards",
  "laporanHasil.filter.complianceStatus": "Compliance Status",
  "laporanHasil.filter.dateFrom": "Date From",
  "laporanHasil.filter.dateTo": "Date To",
  "laporanHasil.filter.generated": "Generated",
  "laporanHasil.filter.generationStatus": "Generation Status",
  "laporanHasil.filter.notGenerated": "Not Yet Generated",
  "laporanHasil.filter.samplingSite": "Sampling Site",
  "laporanHasil.filter.standard": "Compliance Standard",
  "laporanHasil.loading": "Loading compliance report...",
  "laporanHasil.status.borderline": "Borderline",
  "laporanHasil.status.compliant": "Compliant",
  "laporanHasil.status.ineligible": "No standard linked",
  "laporanHasil.status.nonCompliant": "Non-Compliant",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Generate compliance certificates for validated environmental orders",
  "laporanHasil.tile.generated": "Generated",
  "laporanHasil.tile.ineligible": "Ineligible",
  "laporanHasil.tile.ineligible.desc": "Not validated or no standard linked",
  "laporanHasil.tile.notGenerated": "Not Yet Generated",
  "laporanHasil.title": "Compliance Report",
  "lhu.amendment.error.generic": "Failed to reissue the report. Please try again.",
  "lhu.amendment.modal.description": "You are reissuing LHU for lab number {labNumber}. The reissued report will be identified as an amendment to the previously released certificate.",
  "lhu.amendment.modal.heading": "Reissue LHU with Amendment",
  "lhu.amendment.modal.submit": "Reissue & Download PDF",
  "lhu.amendment.reason.helper": "State why the original report is being amended (required for ISO 17025 §7.8.8 compliance).",
  "lhu.amendment.reason.label": "Amendment reason",
  "lhu.amendment.reason.placeholder": "e.g. Incorrect pH result — instrument was not calibrated",
  "lhu.amendment.reason.required": "Amendment reason is required",
  "lhu.amendment.reissue": "Reissue with Amendment",
  "lhu.amendment.submitting": "Reissuing…",
  "nce.close.error": "Failed to close NCE",
  "nce.close.success": "NCE closed successfully",
  "nce.correctiveAction.error": "Failed to advance NCE status",
  "nce.correctiveAction.success": "NCE moved to Corrective Action",
  "notificationtrigger.activetriggers.heading": "Active Triggers",
  "notificationtrigger.activetriggers.subtitle": "Each row controls one notification event type. Toggle On to activate. Channel and recipient settings only apply when the trigger is enabled.",
  "notificationtrigger.channel.email": "Имейл",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.column.channels": "Channels",
  "notificationtrigger.column.enabled": "Enabled",
  "notificationtrigger.column.eventcode": "Event Code",
  "notificationtrigger.column.override": "Per-Lab-Unit Override",
  "notificationtrigger.column.recipients": "Recipients",
  "notificationtrigger.column.trigger": "Trigger",
  "notificationtrigger.config.subtitle": "Enable or disable notification triggers, select delivery channels, and configure recipient types per event.",
  "notificationtrigger.config.title": "Notification Trigger Configuration",
  "notificationtrigger.disabled.hint": "Enable this trigger to configure its channels and recipients.",
  "notificationtrigger.override.comingsoon": "Per-lab-unit override is not available yet.",
  "notificationtrigger.override.configure": "Configure",
  "notificationtrigger.recipient.coccontact": "CoC Contact",
  "notificationtrigger.recipient.orderingprovider": "Ordering Provider",
  "notificationtrigger.recipient.submittinguser": "Submitting User",
  "notificationtrigger.referralout.defaultoff": "Defaults OFF — must be enabled explicitly.",
  "notificationtrigger.referralout.description": "Sent when a sample is referred to an external laboratory.",
  "notificationtrigger.referralout.firesoncenote": "Fires once per saved referral. If one order has referrals to two different labs, two notifications are sent.",
  "notificationtrigger.referralout.name": "Referral Out",
  "notificationtrigger.sentmessages.action.resend": "Resend",
  "notificationtrigger.sentmessages.action.viewlog": "View Log",
  "notificationtrigger.sentmessages.channel.failed": "failed",
  "notificationtrigger.sentmessages.channel.sent": "sent",
  "notificationtrigger.sentmessages.column.actions": "Действия",
  "notificationtrigger.sentmessages.column.channels": "Channels",
  "notificationtrigger.sentmessages.column.datetime": "Date / Time",
  "notificationtrigger.sentmessages.column.recipient": "Recipient",
  "notificationtrigger.sentmessages.column.reference": "Reference",
  "notificationtrigger.sentmessages.column.status": "Статус",
  "notificationtrigger.sentmessages.column.type": "Тип",
  "notificationtrigger.sentmessages.count": "{count} of {total} messages",
  "notificationtrigger.sentmessages.empty.heading": "No notifications have been sent yet.",
  "notificationtrigger.sentmessages.filter.status.all": "Всички статуси",
  "notificationtrigger.sentmessages.filter.status.failed": "Неуспешно",
  "notificationtrigger.sentmessages.filter.status.label": "Статус",
  "notificationtrigger.sentmessages.filter.status.sent": "Sent",
  "notificationtrigger.sentmessages.filter.type.all": "Всички типове",
  "notificationtrigger.sentmessages.filter.type.label": "Тип",
  "notificationtrigger.sentmessages.heading": "Sent Messages",
  "notificationtrigger.sentmessages.resend.disclaimer": "Resending replays the original message bytes and recipient address. To send to a different address, edit the patient record and trigger a new event.",
  "notificationtrigger.sentmessages.resend.failure": "Resend failed. See server logs for details.",
  "notificationtrigger.sentmessages.resend.success": "Notification resent.",
  "notificationtrigger.sentmessages.status.failed": "Неуспешно",
  "notificationtrigger.sentmessages.status.sent": "Sent",
  "notificationtrigger.sentmessages.subtitle": "All outbound notifications dispatched by OpenELIS, across all trigger types and channels.",
  "notificationtrigger.sentmessages.viewlog.channels": "Channel Outcomes",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Attempts",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Channel",
  "notificationtrigger.sentmessages.viewlog.column.error": "Грешка",
  "notificationtrigger.sentmessages.viewlog.column.status": "Статус",
  "notificationtrigger.sentmessages.viewlog.heading": "Notification Log",
  "notificationtrigger.sentmessages.viewlog.message": "Message Body",
  "notificationtrigger.sentmessages.viewlog.subject": "Тема",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Sent when a sample has been physically dispatched to the receiving laboratory.",
  "notificationtrigger.subcontractdispatched.name": "Subcontract Dispatched",
  "notificationtrigger.tabs.sentmessages": "Sent Messages",
  "notificationtrigger.tabs.sentmessages.placeholder": "Sent messages — coming in a future milestone.",
  "notificationtrigger.tabs.templates": "Templates",
  "notificationtrigger.tabs.templates.placeholder": "Template editor — coming in a future milestone.",
  "notificationtrigger.tabs.triggers": "Triggers",
  "notificationtrigger.templates.body.help": "Free text with merge fields. This template is not managed by i18n — edit it directly.",
  "notificationtrigger.templates.body.label": "Message Body",
  "notificationtrigger.templates.button.reset": "Reset to Default",
  "notificationtrigger.templates.button.save": "Save Template",
  "notificationtrigger.templates.channel.help": "Each channel has its own template fields. Switch channels to edit separately.",
  "notificationtrigger.templates.channel.label": "Channel",
  "notificationtrigger.templates.heading": "Notification Template Configuration",
  "notificationtrigger.templates.mergefields.heading": "Available Merge Fields",
  "notificationtrigger.templates.mergefields.help": "Fields below are specific to the {eventCode} event. Click a field to insert it at the cursor position.",
  "notificationtrigger.templates.mergefields.optionalnote": "If [expectedReturn] is not set on the referral, it renders blank — no error.",
  "notificationtrigger.templates.preview.label": "Rendered Preview",
  "notificationtrigger.templates.referralout.description": "Sent to the customer contact (Ordering Provider) and/or internal staff (Submitting User) when a referral is saved.",
  "notificationtrigger.templates.subcontractdispatched.description": "Sent to the receiving lab's CoC contact and the customer when a sample is physically dispatched to the receiving laboratory.",
  "notificationtrigger.templates.subject.label": "Тема",
  "notificationtrigger.templates.subtitle": "Compose message templates for each notification event type. Templates are free text with merge fields.",
  "order.clinicalInfo.helper": "Optional context to guide test selection and reporting — not recorded as a confirmed diagnosis.",
  "order.complete.processing.description": "{labNumber} is now in {status} status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.description.plain": "{labNumber} is now in Processing status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.title": "Order Complete — Processing",
  "order.context.poolOf": "Pool of {count} {animal}",
  "order.paymentStatus.helper": "How payment will be handled for this order.",
  "order.priority.helper": "ROUTINE: standard turnaround. STAT: process immediately.",
  "order.referral.sampleType.ambiguous": "This referred order requested {items}, but the sample type could not be determined automatically. Please select a sample type below and choose the requested test(s).",
  "order.requester.section.helper": "Select the facility that ordered the tests and the responsible provider.",
  "panel.domain.clinical": "Clinical",
  "panel.domain.environmental": "Environmental",
  "panel.domain.eqa": "EQA",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Flea",
  "panel.organism.fly": "Fly",
  "panel.organism.mosquito": "Mosquito",
  "panel.organism.rodent": "Rodent",
  "panel.organism.selectPlaceholder": "Select Organism Group",
  "panel.organism.tick": "Tick",
  "patient.search.section.helper": "Search by any combination of fields — partial matches accepted. 'External Search' queries the Client Registry and requires at minimum a name and date of birth.",
  "placeholder.validation.qc.justification": "Required (max 500 chars)",
  "provider.add.new": "+ Add new provider \"{name}\"",
  "providerTitle.abbreviation": "Abbreviation",
  "providerTitle.add": "Add Title",
  "providerTitle.confirm.activate": "Activate \"{title}\"?",
  "providerTitle.confirm.activate.body": "It will be offered again when choosing a provider's title.",
  "providerTitle.confirm.deactivate": "Deactivate \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "It will no longer be offered for new selections. The {count} provider(s) already carrying it keep it.",
  "providerTitle.duplicate": "\"{value}\" is already in the list",
  "providerTitle.edit": "Edit Title",
  "providerTitle.edit.warning": "Changing a title changes how it displays on every provider using it.",
  "providerTitle.empty": "No provider titles are configured yet.",
  "providerTitle.filter.status": "Статус",
  "providerTitle.filter.status.active": "Активен",
  "providerTitle.filter.status.all": "Всички",
  "providerTitle.filter.status.inactive": "Неактивен",
  "providerTitle.inUse": "In use",
  "providerTitle.search": "Search titles",
  "providerTitle.sortOrder": "Sort order",
  "providerTitle.summary": "{total} title(s): {active} active, {inactive} inactive.",
  "providerTitle.title": "Заглавие",
  "providerTitle.titles": "Provider Titles",
  "provider.email.field": "Имейл на доставчика",
  "provider.fax.field": "Provider Fax",
  "provider.title.field": "Заглавие",
  "provider.title.inName": "That looks like a title. Consider moving it to the Title field so lists sort by surname.",
  "provider.title.filter": "Filter by title",
  "provider.title.filter.all": "All titles",
  "provider.title.placeholder": "Select a title...",
  "provider.firstName.field": "Име",
  "provider.lastName.field": "Фамилия",
  "provider.new.helper": "Will be created as a new provider when this order is saved.",
  "provider.new.tag": "New",
  "provider.no.match": "No matching provider found.",
  "provider.phone.field": "Телефон",
  "qc.add.blank": "+ Blank QC",
  "qc.add.control": "+ Control QC",
  "qc.add.duplicate": "+ Duplicate QC",
  "qc.collect.inheritsFromParent": "Collection details inherited from parent sample",
  "qc.expectedValue.placeholder": "e.g. 50.0",
  "qc.samples.label": "QC samples:",
  "qc.samples.numericOnly": "QC is currently supported only for tests with numeric results. The selected tests are coded — pick a numeric test to attach QC.",
  "qc.samples.thresholdsMissing": "Configure QC thresholds for {tests} in Administration → Test Configuration before adding QC samples.",
  "qc.status.current": "Current QC Status",
  "qc.status.failed.warning.message": "Lots that fail QC are excluded from testing and from stock available for use.",
  "qc.status.failed.warning.title": "This lot will not be usable",
  "qc.status.new": "New QC Status",
  "qc.status.notes": "QC бележки",
  "qc.status.notes.placeholder": "Reason for the QC result, test performed, or reference",
  "qc.type.blank": "QC: Blank",
  "qc.type.control": "QC: Control",
  "qc.type.duplicate": "QC: Duplicate",
  "referral.accept.error": "Could not accept the result. Please try again.",
  "referral.action.accept": "Приеми",
  "referral.action.acceptToAnalysis": "Accept to Analysis",
  "referral.action.clearFilters": "Clear filters",
  "referral.action.enterResult": "Въведете резултат",
  "referral.action.markLost": "Mark Lost",
  "referral.action.notifyReferenceLab": "Notify reference lab",
  "referral.action.openResultEntry": "Open in Result Entry",
  "referral.action.reject": "Отхвърли",
  "referral.banner.filterToStuck": "Filter to stuck only",
  "referral.banner.stuckReferralsSubtitle": "{count} referral(s) have been at a reference lab for more than {threshold} day(s).",
  "referral.banner.stuckReferralsTitle": "Stuck referrals detected",
  "referral.box.cannotReconcileMessage": "Cannot reconcile box — {count} samples still awaiting result reconciliation. See Reference Lab Results.",
  "referral.box.viewBlockedReferrals": "View in Reference Lab Results",
  "referral.breadcrumb.referenceLabResults": "Reference Lab Results",
  "referral.chip.ariaLabel": "Reference lab results view",
  "referral.chip.history": "History",
  "referral.chip.outstanding": "Outstanding",
  "referral.chip.returned": "Returned — needs action",
  "referral.column.actions": "Действия",
  "referral.column.boxId": "Box ID",
  "referral.column.closedDate": "Closed date",
  "referral.column.daysOutstanding": "Days outstanding",
  "referral.column.daysTotal": "Days total",
  "referral.column.labNumber": "Лабораторен номер",
  "referral.column.outcome": "Outcome",
  "referral.column.patient": "Пациент",
  "referral.column.priority": "Приоритет",
  "referral.column.referenceLab": "Референтна лаборатория",
  "referral.column.requestor": "Original requestor",
  "referral.column.resultSummary": "Result summary",
  "referral.column.returnedDate": "Returned Date",
  "referral.column.sentDate": "Дата на изпращане",
  "referral.column.status": "Статус",
  "referral.column.tests": "Тест(ове)",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "Box ID",
  "referral.expand.detail.boxReceivedDate": "Received at reference lab",
  "referral.expand.detail.collected": "Collected",
  "referral.expand.detail.currentStatus": "Current status",
  "referral.expand.detail.daysOutstanding": "Days outstanding",
  "referral.expand.detail.dispatched": "Dispatched",
  "referral.expand.detail.fhirTask": "FHIR Task",
  "referral.expand.detail.labNumber": "Лабораторен номер",
  "referral.expand.detail.patient": "Пациент",
  "referral.expand.detail.priority": "Приоритет",
  "referral.expand.detail.referenceLab": "Референтна лаборатория",
  "referral.expand.detail.requestor": "Original requestor",
  "referral.expand.detail.sampleType": "Sample type",
  "referral.expand.detail.tests": "Тестове",
  "referral.expand.noResultPayload": "No structured result was returned by the reference lab.",
  "referral.expand.originalOrderContext": "Original order context",
  "referral.expand.outcomeDetail": "Outcome detail",
  "referral.expand.receptionAction": "Reception action",
  "referral.expand.receptionHint": "Review the returned result below, then Accept it to post to the patient record, or Reject it if the result cannot be used.",
  "referral.expand.referenceLabTransit": "Reference lab transit",
  "referral.expand.result": "Резултат",
  "referral.expand.statusDetail": "Status detail",
  "referral.filter.allPriorities": "All priorities",
  "referral.filter.allRefLabs": "All reference labs",
  "referral.filter.dateRange": "Date range",
  "referral.filter.daysOutstandingBucket": "Days outstanding",
  "referral.filter.daysOutstandingBucket.stuck": "Stuck (> {threshold} days)",
  "referral.filter.priority": "Приоритет",
  "referral.filter.referenceLab": "Референтна лаборатория",
  "referral.markLost.cancelButton": "Отказ",
  "referral.markLost.confirmButton": "Mark as lost",
  "referral.markLost.description": "This marks the referral as lost in transit and removes it from Outstanding. The clinical team will need to re-collect and re-refer the sample.",
  "referral.markLost.modalTitle": "Mark referral as lost",
  "referral.markLost.reasonLabel": "Reason",
  "referral.markLost.reasonPlaceholder": "e.g. Courier confirmed loss. Box never arrived at the reference lab.",
  "referral.markLost.reasonRequired": "Reason is required.",
  "referral.metric.outstanding": "Outstanding",
  "referral.metric.reconciledToday": "Reconciled today",
  "referral.metric.rejectedThisWeek": "Rejected this week",
  "referral.metric.returned": "Returned — needs action",
  "referral.notification.accepted": "Result accepted to the patient record.",
  "referral.notification.rejected": "Result rejected. The clinician has been notified to re-collect.",
  "referral.notify.errorRetry": "Failed to notify reference lab. Try again.",
  "referral.notify.toast": "Reference lab notified.",
  "referral.page.title": "Reference Lab Results",
  "referral.reject.cancelButton": "Отказ",
  "referral.reject.confirmButton": "Reject and notify clinician",
  "referral.reject.description": "Rejecting closes the originating test terminally and notifies the clinician to re-collect and re-refer the sample.",
  "referral.reject.error": "Could not reject the result. Please try again.",
  "referral.reject.modalTitle": "Reject returned result",
  "referral.reject.reason.clotted": "Clotted",
  "referral.reject.reason.damagedContainer": "Damaged container",
  "referral.reject.reason.hemolyzed": "Hemolyzed",
  "referral.reject.reason.insufficientVolume": "Insufficient volume",
  "referral.reject.reason.mislabeled": "Mislabeled",
  "referral.reject.reason.other": "Друг",
  "referral.reject.reason.temperatureDeviation": "Temperature deviation",
  "referral.reject.reason.wrongSampleType": "Wrong sample type",
  "referral.reject.reasonLabel": "Reason",
  "referral.reject.reasonTextLabel": "Details",
  "referral.reject.reasonTextPlaceholder": "Describe why this returned result cannot be used.",
  "referral.reject.reasonTextRequired": "Details are required.",
  "referral.reject.warningTitle": "This action cannot be undone",
  "referral.result.interp.Abnormal": "Abnormal",
  "referral.result.interp.Critical": "Критична",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Анулиран",
  "referral.status.completed": "Result returned",
  "referral.status.draft": "Чернова",
  "referral.status.inProgress": "In progress at reference lab",
  "referral.status.received": "At reference lab",
  "referral.status.reconciled": "Reconciled",
  "referral.status.rejected": "Rejected by reference lab",
  "referral.status.requested": "Sent — awaiting acceptance",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "History",
  "referral.table.outstanding.title": "Outstanding referrals",
  "referral.table.returned.title": "Returned — needs action",
  "referral.tag.manuallyEntered": "Manually entered",
  "reports.tat.title": "Turn Around Time Report",
  "reports.tat.description": "Analyze laboratory turnaround times across workflow milestones",
  "reports.tat.generateReport": "Генерирай отчет",
  "reports.tat.clearFilters": "Изчисти филтрите",
  "reports.tat.segment.orderToCollection": "Order to Collection",
  "reports.tat.segment.collectionToReceipt": "Collection to Receipt",
  "reports.tat.segment.receiptToTesting": "Receipt to Testing Started",
  "reports.tat.segment.receiptToResult": "Receipt to Result Entry",
  "reports.tat.segment.receiptToValidation": "Receipt to Validation",
  "reports.tat.segment.resultToValidation": "Result Entry to Validation",
  "reports.tat.segment.overall": "Overall TAT",
  "reports.tat.calendarTime": "Calendar Time",
  "reports.tat.workingTime": "Working Time",
  "reports.tat.workingTimeInfo": "Working Time mode: Excluding {weekendDays} and {holidayCount} public holidays in the selected date range",
  "reports.tat.configuredWeekends": "configured weekends",
  "reports.tat.noHolidaysWarning": "No public holidays configured. Configure holidays in Admin > Calendar Management.",
  "reports.tat.manageCalendar": "Manage Calendar",
  "reports.tat.totalResults": "Общо резултати",
  "reports.tat.meanTat": "Mean TAT",
  "reports.tat.medianTat": "Median TAT",
  "reports.tat.percentile90": "90th Percentile",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Max TAT",
  "reports.tat.stdDeviation": "Std Deviation",
  "reports.tat.distribution": "TAT Distribution",
  "reports.tat.breakdownBy": "Breakdown by",
  "reports.tat.clickRowHint": "Click a row to view individual results",
  "reports.tat.summary": "Summary",
  "reports.tat.detailList": "Detail List",
  "reports.tat.trends": "Трендове",
  "reports.tat.noResults": "No results found for the selected filters. Try adjusting the date range or filter criteria.",
  "reports.tat.insufficientData": "Insufficient data",
  "reports.tat.loadError": "Error loading report data",
  "reports.tat.dateRange": "Период",
  "reports.tat.labUnit": "Lab Unit",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "Всички",
  "reports.tat.priority.routine": "Рутинни",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Тип проба",
  "reports.tat.orderingSite": "Ordering Site",
  "reports.tat.priority": "Приоритет",
  "reports.tat.includeCancelled": "Include cancelled/rejected",
  "reports.tat.export": "Експорт",
  "reports.tat.exportCsv": "Export CSV",
  "reports.tat.exportPdf": "Export PDF",
  "reports.tat.labNumber": "Лабораторен номер",
  "reports.tat.patient": "Пациент",
  "reports.tat.test": "Тест",
  "reports.tat.orderCreated": "Order Created",
  "reports.tat.collected": "Collected",
  "reports.tat.received": "Received",
  "reports.tat.testingStarted": "Testing Started",
  "reports.tat.resultEntered": "Result Entered",
  "reports.tat.validated": "Validated",
  "reports.tat.selectedTat": "Selected TAT",
  "reports.tat.overallTat": "Overall TAT",
  "reports.tat.columns": "Columns",
  "reports.tat.rowsPerPage": "Rows per page",
  "reports.tat.showing": "Showing {from}-{to} of {total} results",
  "reports.tat.trend": "Trend",
  "reports.tat.aggregation": "Aggregation",
  "reports.tat.daily": "Daily",
  "reports.tat.weekly": "Weekly",
  "reports.tat.monthly": "Monthly",
  "reports.tat.compareBy": "Compare by",
  "reports.tat.showVolume": "Show order volume",
  "reports.tat.mean": "Mean",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "Няма информация",
  "reports.tat.dateRangeFrom": "Date Range (From)",
  "reports.tat.dateRangeTo": "Date Range (To)",
  "reports.tat.tatSegment": "TAT Segment",
  "reports.tat.metrics": "Metrics",
  "reports.tat.compareNone": "Няма",
  "reports.tat.comparePriority": "Приоритет",
  "reports.tat.column.labNumber": "Лабораторен номер",
  "reports.tat.column.test": "Тест",
  "reports.tat.column.labUnit": "Lab Unit",
  "reports.tat.column.priority": "Приоритет",
  "reports.tat.column.ordered": "Поръчан",
  "reports.tat.column.collected": "Collected",
  "reports.tat.column.received": "Received",
  "reports.tat.column.started": "Started",
  "reports.tat.column.resulted": "Resulted",
  "reports.tat.column.validated": "Validated",
  "reports.tat.column.selectedTat": "Selected TAT",
  "reports.tat.column.overallTat": "Overall TAT",
  "reports.tat.column.name": "Име",
  "reports.tat.column.count": "Count",
  "reports.tat.column.mean": "Mean",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "90th %ile",
  "reports.tat.column.max": "Max",
  "reports.tat.home": "Начало",
  "reports.tat.all": "Всички",
  "reports.tat.preset.today": "Today",
  "reports.tat.preset.7days": "Last 7 Days",
  "reports.tat.preset.30days": "Last 30 Days",
  "reports.tat.preset.90days": "Last 90 Days",
  "reports.tat.preset.thisMonth": "This Month",
  "reports.tat.preset.lastMonth": "Last Month",
  "reports.tat.preset.thisQuarter": "This Quarter",
  "button.cancel": "Отказ",
  "button.activate": "Активирай",
  "button.adjust": "Коригирай",
  "button.deactivate": "Деактивирай",
  "button.dispose": "Бракувай",
  "button.edit": "Редактирай",
  "button.generate": "Генерирай",
  "button.label.genarateReport": "Генерирай отчет",
  "button.label.loadnext": "Зареди следващ пакет",
  "button.label.loadprevious": "Зареди предишен пакет",
  "button.label.showHidePram": "Покажи/Скрий параметър на отчета",
  "button.record": "Запиши",
  "button.save": "Запази",
  "button.save.draft": "Запази чернова",
  "button.save.next": "Save & Next",
  "button.save.stay": "Запази",
  "button.send": "Изпрати",
  "button.update": "Update",
  "calculatedTests": "Изчислени тестове",
  "catalog.item.activate.success": "Каталожният елемент е активиран успешно",
  "catalog.item.category": "Категория",
  "catalog.item.code": "Код",
  "catalog.item.code.hint": "Stable identifier used by integrations. Leave blank and we'll generate one from the name, like PAR-500MG-001.",
  "catalog.item.code.locked": "Code is locked once saved so integrations and existing references keep working.",
  "catalog.item.code.placeholder": "Leave blank to auto-generate from name",
  "catalog.item.code.preview": "Will be saved as {code}",
  "catalog.item.compatibleAnalyzers": "Съвместими анализатори",
  "catalog.item.deactivate.confirm.button": "Деактивирай",
  "catalog.item.deactivate.confirm.message": "Сигурни ли сте, че искате да деактивирате {itemName}?",
  "catalog.item.deactivate.confirm.title": "Потвърждение на деактивиране",
  "catalog.item.deactivate.implications.1": "Този елемент повече няма да се появява в списъците с активни елементи",
  "catalog.item.deactivate.implications.2": "Съществуващите партиди за този елемент ще останат достъпни",
  "catalog.item.deactivate.implications.3": "Можете да активирате отново този елемент по-късно, ако е необходимо",
  "catalog.item.deactivate.implications.title": "Последствия:",
  "catalog.item.deactivate.label": "Деактивирай елемент",
  "catalog.item.deactivate.success": "Елементът е деактивиран успешно",
  "catalog.item.error.saveGeneric": "Грешка при запазване на каталожния елемент",
  "catalog.item.error.stabilityRequired": "Stability after opening is required for reagents",
  "catalog.item.form.title.add": "Добавяне на нов каталожен елемент",
  "catalog.item.form.title.edit": "Редактиране на каталожен елемент",
  "catalog.item.lowStockThreshold": "Праг за ниска наличност",
  "catalog.item.manufacturer": "Производител",
  "catalog.item.minimumStock": "Минимално ниво на склад",
  "catalog.item.name": "Име на елемента",
  "catalog.item.reorderLevel": "Ниво за поръчка",
  "catalog.item.reorderQuantity": "Количество за поръчка",
  "catalog.item.save.error": "Грешка при запазване на каталожния елемент",
  "catalog.item.save.success": "Каталожният елемент е запазен успешно",
  "catalog.item.stabilityAfterOpening": "Стабилност след отваряне (дни)",
  "catalog.item.status": "Статус",
  "catalog.item.storageRequirements": "Изисквания за съхранение",
  "catalog.item.testTypes": "Типове тестове",
  "catalog.item.testsPerCartridge": "Тестове на касета",
  "catalog.item.testsPerKit": "Тестове на кит",
  "catalog.item.type": "Тип на елемента",
  "catalog.item.units": "Единици",
  "catalog.search.placeholder": "Търсене по име на елемент",
  "choose.availablepanel": "Изберете наличен панел",
  "coldStorage.action.createSuccess": "Коригиращото действие е създадено успешно",
  "coldStorage.action.retractSuccess": "Коригиращото действие е оттеглено успешно",
  "coldStorage.action.updateSuccess": "Коригиращото действие е актуализирано успешно",
  "coldStorage.actions": "Действия",
  "coldStorage.activated": "активиран",
  "coldStorage.addDevicesMessage": "Моля, добавете устройства в Управление на устройства, за да конфигурирате температурни прагове.",
  "coldStorage.addNewDevice": "Добави ново устройство",
  "coldStorage.alert.acknowledged": "Alert acknowledged successfully",
  "coldStorage.alert.actionFailed": "Unable to {action} alert {alertId}",
  "coldStorage.alert.equipment": "Повреда на оборудването",
  "coldStorage.alert.equipment.description": "Сигнали за неизправност или проблеми с връзката",
  "coldStorage.alert.inventory": "Сигнали за инвентар",
  "coldStorage.alert.inventory.description": "Сигнали за ниска наличност или управление на склад",
  "coldStorage.alert.resolved": "Alert resolved successfully",
  "coldStorage.alert.saveFailed": "Неуспешно запазване на предпочитанията за известяване: ",
  "coldStorage.alert.saveSuccess": "Предпочитанията за известяване са запазени успешно.",
  "coldStorage.alert.temperature": "Температурни сигнали",
  "coldStorage.alert.temperature.description": "Сигнали при превишаване на температурните прагове във фризера",
  "coldStorage.alert.type": "Тип сигнал",
  "coldStorage.alertConfiguration": "Конфигурация на сигналите",
  "coldStorage.autoEscalate": "Автоматична ескалация на неразрешени сигнали",
  "coldStorage.button.delete": "Изтрий",
  "coldStorage.configuredDevices": "Конфигурирани устройства",
  "coldStorage.correctiveAction.column.actionId": "Action ID",
  "coldStorage.correctiveAction.column.created": "Създадено",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Last Updated By",
  "coldStorage.correctiveAction.column.performedBy": "Performed By",
  "coldStorage.correctiveAction.edited": "Edited",
  "coldStorage.correctiveAction.status.cancelled": "Анулиран",
  "coldStorage.correctiveAction.status.completed": "Завършен",
  "coldStorage.correctiveAction.status.inProgress": "В ход",
  "coldStorage.correctiveAction.status.pending": "Pending",
  "coldStorage.correctiveAction.status.retracted": "Retracted",
  "coldStorage.correctiveAction.type.calibration": "Calibration",
  "coldStorage.correctiveAction.type.calibration.description": "Calibrating equipment or sensors",
  "coldStorage.correctiveAction.type.equipmentRepair": "Equipment Repair",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Repairing or replacing equipment",
  "coldStorage.correctiveAction.type.itemReorder": "Item Reorder",
  "coldStorage.correctiveAction.type.itemReorder.description": "Reordering inventory items",
  "coldStorage.correctiveAction.type.maintenance": "Maintenance",
  "coldStorage.correctiveAction.type.maintenance.description": "Performing maintenance tasks",
  "coldStorage.correctiveAction.type.other": "Друг",
  "coldStorage.correctiveAction.type.other.description": "Other or custom corrective actions",
  "coldStorage.correctiveAction.type.sampleRelocation": "Sample Relocation",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Moving samples to another location",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Temperature Adjustment",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Adjusting temperature settings",
  "coldStorage.criticalThreshold": "Критичен праг (°C)",
  "coldStorage.dashboard.acknowledge": "Потвърди",
  "coldStorage.dashboard.activeAlerts": "Active Alerts ({count})",
  "coldStorage.dashboard.column.currentTemp": "Current Temp",
  "coldStorage.dashboard.column.currentTemp2": "Probe 2 Temp",
  "coldStorage.dashboard.column.device": "Устройство",
  "coldStorage.dashboard.column.duration": "Duration",
  "coldStorage.dashboard.column.humidity": "Humidity",
  "coldStorage.dashboard.column.lastReading": "Last Reading",
  "coldStorage.dashboard.column.location": "Местоположение",
  "coldStorage.dashboard.column.severity": "Сериозност",
  "coldStorage.dashboard.column.started": "Started",
  "coldStorage.dashboard.column.targetTemp": "Target Temp",
  "coldStorage.dashboard.column.temperature": "Temperature",
  "coldStorage.dashboard.column.unitId": "Unit ID",
  "coldStorage.dashboard.column.unitName": "Unit Name",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} storage unit(s) experiencing critical temperature excursions",
  "coldStorage.dashboard.criticalAlertTitle": "CRITICAL ALERT",
  "coldStorage.dashboard.deviceTypeFilter": "Device Type",
  "coldStorage.dashboard.kpi.critical": "Critical Alerts",
  "coldStorage.dashboard.kpi.normal": "Normal Status",
  "coldStorage.dashboard.kpi.totalUnits": "Total Storage Units",
  "coldStorage.dashboard.kpi.warnings": "Предупреждения",
  "coldStorage.dashboard.lastUpdate": "Last update: {time}",
  "coldStorage.dashboard.loadingUnits": "Loading storage units…",
  "coldStorage.dashboard.noActiveAlerts": "No active alerts",
  "coldStorage.dashboard.noUnitsFound": "No storage units found.",
  "coldStorage.dashboard.online": "Online",
  "coldStorage.dashboard.refresh": "Refresh",
  "coldStorage.dashboard.refreshing": "Refreshing",
  "coldStorage.dashboard.refreshingEllipsis": "Refreshing...",
  "coldStorage.dashboard.searchLabel": "Search by Unit ID or Name",
  "coldStorage.dashboard.statusFilter": "Статус",
  "coldStorage.dashboard.storageUnitsTitle": "Storage Units",
  "coldStorage.dashboard.subtitle": "Real-time temperature monitoring & compliance",
  "coldStorage.dashboard.systemStatus": "System Status: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Коригиращи действия",
  "coldStorage.dashboard.tab.dashboard": "Табло",
  "coldStorage.dashboard.tab.historicalTrends": "Исторически трендове",
  "coldStorage.dashboard.tab.reports": "Отчети",
  "coldStorage.dashboard.tab.settings": "Настройки",
  "coldStorage.dashboard.viewAlertDetails": "View alert details",
  "coldStorage.deactivated": "деактивиран",
  "coldStorage.description": "Описание",
  "coldStorage.device.activate": "Активирай устройство",
  "coldStorage.device.activateMessage": "Активирането ще включи мониторинга и събирането на данни.",
  "coldStorage.device.changeStatus": "Промени статуса на устройството",
  "coldStorage.device.changeStatusOf": "Промени статуса на {name}:",
  "coldStorage.device.created": "Устройството е създадено успешно",
  "coldStorage.device.createdSuccess": "Устройството „{name}“ е създадено успешно",
  "coldStorage.device.deactivate": "Деактивирай устройство",
  "coldStorage.device.deactivateMessage": "Деактивирането ще спре мониторинга. Историческите данни ще бъдат запазени.",
  "coldStorage.device.delete": "Изтрий устройство",
  "coldStorage.device.deleteConfirm": "Сигурни ли сте, че искате да изтриете {name}?",
  "coldStorage.device.deleteWarning": "Това ще маркира устройството като неактивно. Историческите данни ще бъдат запазени.",
  "coldStorage.device.deleted": "Устройството „{name}“ е изтрито успешно",
  "coldStorage.device.deviceStatus": "Статус на устройството",
  "coldStorage.device.edit": "Редактирай устройство",
  "coldStorage.device.id": "ID на устройство",
  "coldStorage.device.ipAddress": "IP адрес",
  "coldStorage.device.port": "Порт",
  "coldStorage.device.protocol": "Протокол",
  "coldStorage.device.registerCount": "Registers Per Value",
  "coldStorage.device.registerCount.help": "1 for a 16-bit value, 2 for a 32-bit value spanning two registers",
  "coldStorage.device.roomFacility": "Стая/Обект",
  "coldStorage.device.rs485": "RS-485 Half-Duplex (Optional)",
  "coldStorage.device.rs485.delayAfter": "Delay After Transmit (ms)",
  "coldStorage.device.rs485.delayBefore": "Delay Before Transmit (ms)",
  "coldStorage.device.rs485.mode": "Enable RS-485 driver-enable timing",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS active high during transmit",
  "coldStorage.device.rs485.rxDuringTx": "Keep receiver enabled while transmitting",
  "coldStorage.device.rs485.termination": "Bus termination enabled",
  "coldStorage.device.secondProbe": "Second Temperature Probe (Optional)",
  "coldStorage.device.secondProbe.offset": "Base Temperature 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Base offset for the second probe",
  "coldStorage.device.secondProbe.register": "Temperature Register 2",
  "coldStorage.device.secondProbe.registerHelp": "Modbus register address for a second, independent temperature probe. Its readings are recorded and charted; threshold alerts are raised from the first probe.",
  "coldStorage.device.secondProbe.scale": "Temperature Scale 2",
  "coldStorage.device.secondProbe.scaleHelp": "Scaling factor (e.g., 0.1 to divide by 10)",
  "coldStorage.device.statusChanged": "Статусът на устройството „{name}“ е променен на {status} успешно",
  "coldStorage.device.type": "Тип",
  "coldStorage.device.updated": "Устройството е актуализирано успешно",
  "coldStorage.device.wordOrder": "Word Order",
  "coldStorage.device.wordOrder.bigEndian": "Big endian (most significant word first)",
  "coldStorage.device.wordOrder.help": "Order of the two registers in a 32-bit value; ignored when reading one register",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (least significant word first)",
  "coldStorage.deviceHistory.averageMetric": "Average {metric}",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Acknowledged / Performed By",
  "coldStorage.deviceHistory.column.date": "Дата",
  "coldStorage.deviceHistory.column.eventId": "Event ID",
  "coldStorage.deviceHistory.column.eventType": "Event Type",
  "coldStorage.deviceHistory.column.summaryTitle": "Summary / Title",
  "coldStorage.deviceHistory.column.time": "Време",
  "coldStorage.deviceHistory.correctiveActions": "Коригиращи действия",
  "coldStorage.deviceHistory.dataPoints": "Data Points",
  "coldStorage.deviceHistory.exportCsv": "Export CSV",
  "coldStorage.deviceHistory.loadingEvents": "Loading event history...",
  "coldStorage.deviceHistory.loadingTemperature": "Loading temperature data...",
  "coldStorage.deviceHistory.maxMetric": "Max {metric}",
  "coldStorage.deviceHistory.metric": "Metric:",
  "coldStorage.deviceHistory.minMetric": "Min {metric}",
  "coldStorage.deviceHistory.noEventsFound": "No events found.",
  "coldStorage.deviceHistory.noTemperatureData": "No temperature data available for the selected time range.",
  "coldStorage.deviceHistory.searchEvents": "Search events",
  "coldStorage.deviceHistory.searchPlaceholder": "Search by event ID, summary, or user...",
  "coldStorage.deviceHistory.tab.eventHistory": "Event History",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Temperature Trends",
  "coldStorage.deviceHistory.timeRange": "Time Range:",
  "coldStorage.deviceHistory.title": "Device History - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Total Alerts",
  "coldStorage.deviceHistory.totalEvents": "Total Events",
  "coldStorage.email": "Имейл",
  "coldStorage.emailSmsNotifications": "Имейл и SMS известия",
  "coldStorage.error.createAction": "Неуспешно създаване на коригиращо действие. Моля, опитайте отново.",
  "coldStorage.error.createDevice": "Неуспешно създаване на устройство: ",
  "coldStorage.error.createRoom": "Неуспешно създаване на стая: ",
  "coldStorage.error.deleteDevice": "Неуспешно изтриване на устройство: ",
  "coldStorage.error.loadActions": "Неуспешно зареждане на коригиращи действия.",
  "coldStorage.error.loadAuditTrail": "Unable to load audit trail",
  "coldStorage.error.loadAuditTrailDetail": "Unexpected error while loading audit records.",
  "coldStorage.error.loadDevices": "Неуспешно зареждане на устройства: ",
  "coldStorage.error.loadExcursions": "Unable to load excursion history",
  "coldStorage.error.loadExcursionsDetail": "Unexpected error while loading excursions.",
  "coldStorage.error.loadFailed": "Unable to load cold storage monitoring data.",
  "coldStorage.error.loadLocations": "Неуспешно зареждане на местоположения: ",
  "coldStorage.error.loadUsers": "Неуспешно зареждане на списъка с потребители.",
  "coldStorage.error.noCurrentUser": "Unable to identify the current user. Please sign in again.",
  "coldStorage.error.retractAction": "Неуспешно оттегляне на коригиращо действие.",
  "coldStorage.error.saveThreshold": "Неуспешно запазване на конфигурацията на праговете: ",
  "coldStorage.error.toggleStatus": "Неуспешна промяна на статуса на устройството: ",
  "coldStorage.error.updateAction": "Неуспешна актуализация на коригиращо действие.",
  "coldStorage.error.updateDevice": "Неуспешна актуализация на устройство: ",
  "coldStorage.error.updateFailed": "Unable to update cold storage data",
  "coldStorage.escalationDelay": "Забавяне на ескалацията (минути)",
  "coldStorage.escalationDelayHelper": "Време за изчакване преди ескалиране на неразрешен сигнал",
  "coldStorage.escalationRules": "Правила за ескалация",
  "coldStorage.filter.activeOnly": "Само активни",
  "coldStorage.filter.all": "Всички устройства",
  "coldStorage.filter.inactiveOnly": "Само неактивни",
  "coldStorage.footer": "Cold Storage Monitoring v2.1.0 | Compliant with CAP, CLIA, FDA, and WHO guidelines | HIPAA Compliant Data Handling",
  "coldStorage.granularNotificationControl": "Групиран контрол на известията",
  "coldStorage.granularNotificationControlDesc": "Конфигурирайте имейл и SMS известия за всеки тип сигнал независимо.",
  "coldStorage.howNotificationsWork": "Как работят известията",
  "coldStorage.howNotificationsWorkDesc": "Когато се задейства сигнал (нарушение на прага, повреда и т.н.), системата ще:",
  "coldStorage.loadingDevices": "Зареждане на устройства...",
  "coldStorage.loadingPrefs": "Зареждане на предпочитания за известяване...",
  "coldStorage.name": "Име",
  "coldStorage.noConfigFound": "Няма намерена конфигурация",
  "coldStorage.noDevicesConfigured": "Няма конфигурирани устройства",
  "coldStorage.notification.createRecord": "Създава запис за сигнал в системата (видим в таблото)",
  "coldStorage.notification.logAttempt": "Записва опита за известяване в одитната следа",
  "coldStorage.notification.sendEmail": "Изпраща ИМЕЙЛ известия, ако са разрешени",
  "coldStorage.notification.sendSms": "Изпраща SMS известия, ако са разрешени",
  "coldStorage.pollInterval": "Интервал на допитване (секунди)",
  "coldStorage.reports.column.action": "Действие",
  "coldStorage.reports.column.details": "Details",
  "coldStorage.reports.column.excursionId": "Excursion ID",
  "coldStorage.reports.column.freezer": "Freezer",
  "coldStorage.reports.column.freezerId": "Freezer ID",
  "coldStorage.reports.column.startTime": "Start Time",
  "coldStorage.reports.column.temperatureRange": "Temperature Range",
  "coldStorage.reports.column.timestamp": "Времево клеймо",
  "coldStorage.reports.column.user": "Потребител",
  "coldStorage.reports.downloadReport": "Download {format} Report",
  "coldStorage.reports.endDate": "End date",
  "coldStorage.reports.excursionHistory": "Temperature Excursion History",
  "coldStorage.reports.exportFormat": "Формат на експорта",
  "coldStorage.reports.footer": "Cold Storage Monitoring v2.1.0 | CAP, CLIA, FDA & WHO compliant | HIPAA-ready data handling",
  "coldStorage.reports.freezer": "Freezer",
  "coldStorage.reports.generateReport": "Генерирай отчет",
  "coldStorage.reports.loadingAudit": "Loading audit entries…",
  "coldStorage.reports.loadingExcursions": "Loading excursions…",
  "coldStorage.reports.noAuditActivity": "No audit activity for the selected filters.",
  "coldStorage.reports.noAuditMatch": "No audit entries match your search.",
  "coldStorage.reports.noExcursions": "No excursions available for the selected filters.",
  "coldStorage.reports.regulatoryCompliance": "Regulatory Compliance",
  "coldStorage.reports.regulatoryComplianceDesc": "Reports follow CAP (College of American Pathologists), CLIA (Clinical Laboratory Improvement Amendments), FDA (Food and Drug Administration), and WHO (World Health Organization) guidance for temperature-controlled storage.",
  "coldStorage.reports.reportType": "Тип отчет",
  "coldStorage.reports.searchAuditTrail": "Search audit trail...",
  "coldStorage.reports.startDate": "Start date",
  "coldStorage.reports.tab.auditTrail": "Одитна следа",
  "coldStorage.reports.tab.excursions": "Temperature Excursions",
  "coldStorage.reports.title": "Regulatory Reports",
  "coldStorage.room.addNew": "Добави нова стая",
  "coldStorage.room.create": "Създай стая",
  "coldStorage.room.created": "Стаята е създадена успешно",
  "coldStorage.room.description": "Описание",
  "coldStorage.room.descriptionPlaceholder": "Въведете описание на стаята (опционално)",
  "coldStorage.room.name": "Име на стая *",
  "coldStorage.room.namePlaceholder": "Въведете име на стая (напр. Лабораторен склад A)",
  "coldStorage.saveNotificationPrefs": "Запази предпочитанията за известяване",
  "coldStorage.saveThresholdConfig": "Запази конфигурацията на праговете",
  "coldStorage.saving": "Запазване...",
  "coldStorage.search.placeholder": "Търсене по ID или име на устройство",
  "coldStorage.selectType": "Select type",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Статус",
  "coldStorage.status.active": "АКТИВЕН",
  "coldStorage.status.inactive": "НЕАКТИВЕН",
  "coldStorage.status.noData": "No data",
  "coldStorage.status.offline": "Офлайн",
  "coldStorage.status.unknown": "Неизвестен",
  "coldStorage.supervisorEmail": "Имейл на супервайзор",
  "coldStorage.supervisorEmailHelper": "Имейл адрес за изпращане на ескалирани сигнали",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Целева температура (°C)",
  "coldStorage.threshold.saveSuccess": "Конфигурацията на праговете е запазена успешно",
  "coldStorage.thresholdConfiguration": "Конфигурация на температурните прагове",
  "coldStorage.trends.averageMetric": "Average {metric}",
  "coldStorage.trends.axis.humidity": "Humidity (%)",
  "coldStorage.trends.axis.temperature": "Temperature (°C)",
  "coldStorage.trends.axis.temperature2": "Temperature - Probe 2 (°C)",
  "coldStorage.trends.maxMetric": "Max {metric}",
  "coldStorage.trends.metric": "Metric",
  "coldStorage.trends.metric.humidity": "Humidity",
  "coldStorage.trends.metric.temperature": "Temperature",
  "coldStorage.trends.metric.temperature2": "Temperature (Probe 2)",
  "coldStorage.trends.minMetric": "Min {metric}",
  "coldStorage.usingDefaults": "Използват се настройки по подразбиране. Запазете за създаване на конфигурация.",
  "coldStorage.validation.error": "Грешка при валидация",
  "coldStorage.validation.retractionReason": "Моля, посочете причина за оттеглянето",
  "coldStorage.validation.selectActionType": "Моля, изберете тип действие",
  "coldStorage.validation.selectDevice": "Моля, изберете устройство",
  "coldStorage.validation.selectRoom": "Моля, изберете стая/местоположение за устройството",
  "coldStorage.warningThreshold": "Предупредителен праг (°C)",
  "collect.addSample.button": "Добавяне на проба",
  "collect.assign.addToSample": "Add to existing sample",
  "collect.assign.button": "Assign Tests",
  "collect.assign.description": "Assign requested tests to sample tubes",
  "collect.assign.newSample": "Create new sample",
  "collect.assign.newSampleHelp": "Select sample type for the new tube",
  "collect.assign.noExisting": "No existing samples available",
  "collect.assign.title": "Задаване на тестове",
  "collect.multiSampleExample.description": "When multiple sample types are needed",
  "collect.multiSampleExample.result": "Creates separate tubes for each type",
  "collect.multiSampleExample.title": "Multi-Sample Collection Example",
  "collect.noSampleYet": "No samples collected yet",
  "collect.noTestsOrdered": "No tests have been ordered",
  "collect.noTestsWarning.subtitle": "Add samples with tests in Step 1 before proceeding",
  "collect.noTestsWarning.title": "No tests to collect",
  "collect.printMoreLabels.button": "Print More Labels",
  "collect.printMoreLabels.helper": "Print additional labels for this sample",
  "collect.requestedTests.info": "Tests requested for this order",
  "collect.requestedTests.title": "Requested Tests",
  "collect.sample.assignedTests": "Assigned Tests",
  "collect.sample.collectionConditions": "Collection Conditions",
  "collect.sample.collectionConditions.placeholder": "Note any special conditions...",
  "collect.sample.collectionDate": "Дата на вземане",
  "collect.sample.collectionMethod": "Collection Method",
  "collect.addTests.title": "Add Tests or Panels",
  "collect.addTests.helper": "Add a test the clinician asked for after the order was entered, or one that only becomes appropriate with the specimen in hand.",
  "collect.consentRequired.title": "Informed consent is required",
  "collect.consentRequired.subtitle": "This laboratory requires consent to be recorded before a collection can proceed.",
  "sample.holdingLimit": "Holding time: {limit}",
  "sample.holdingLimit.testBy": "test by {deadline}",
  "env.sample.receivedAtLab": "Received at Lab",
  "collect.sample.specimenOrigin": "Specimen Origin",
  "collect.sample.temperature": "Sample Temperature",
  "collect.sample.temperature.placeholder": "e.g. 4 C",
  "collect.sample.collectionDate.helper": "Defaults to today — correct it if the sample was collected earlier",
  "collect.sample.collectionDateBeforeAdmission": "Collection date cannot be before date of admission.",
  "collect.sample.collectionTime": "Време на вземане",
  "collect.sample.collector": "Вземащ пробата",
  "collect.sample.header": "Sample {number}",
  "collect.sample.labPerformedSampling": "Lab performed sampling",
  "collect.sample.nce.link": "Докладване на несъответствие",
  "collect.sample.noTests": "No tests assigned to this sample",
  "collect.sample.printLabels": "Print Labels",
  "collect.sample.quantity": "Количество",
  "collect.sample.receivedAtLab": "Received at Lab",
  "collect.sample.receivedAtLab.helper": "Check if sample has been received at the laboratory",
  "collect.sample.receivedDate": "Дата на получаване",
  "collect.sample.receivedTime": "Received Time",
  "collect.sample.remove": "Премахване на проба",
  "collect.samples.title": "Проби",
  "collect.table.compatibleTypes": "Compatible Sample Types",
  "collect.table.sampleAssignments": "Sample Assignments",
  "collect.table.testPanel": "Test/Panel",
  "heading.informedConsent.sectionTitle": "Informed Consent",
  "heading.informedConsent.auditRecord": "Consent Audit Record",
  "label.informedConsent.consentGiven": "Patient has provided signed consent",
  "label.informedConsent.formReference": "Consent Form Reference No.",
  "label.informedConsent.recordedBy": "Recorded by",
  "label.informedConsent.recordedAt": "Recorded on",
  "label.informedConsent.statusTag": "Consent Recorded",
  "label.informedConsent.notRecorded": "Не е записано",
  "placeholder.informedConsent.formReference": "e.g. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "e.g. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Consent form reference must be 100 characters or fewer",
  "error.informedConsent.formReferenceInvalidChars": "Only letters, numbers, hyphens, and spaces are allowed",
  "coldstorage.label.dashboard": "Табло за хладилно съхранение",
  "collection.date": "Дата на вземане",
  "collector": "Вземащ пробата",
  "collector.label": "Вземащ пробата",
  "column.actions": "Действия",
  "column.name.accept": "Приеми",
  "column.name.analyzerResult": "Резултат от анализатор",
  "column.name.currentResult": "Текущ резултат",
  "column.name.ignore": "Игнорирай",
  "column.name.normalRange": "Нормални граници",
  "column.name.notes": "Бележки",
  "column.name.pastNotes": "Минали бележки",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "QC статус",
  "column.name.reject": "Отхвърли",
  "column.name.result": "Резултат",
  "column.name.retest": "Повторен тест",
  "column.name.sampleInfo": "Инфо за пробата",
  "column.name.sampleKind": "Sample Kind",
  "column.name.save": "Запази",
  "column.name.statusPerRegulation": "Status — Per Regulation",
  "column.name.testDate": "Дата на теста",
  "column.name.testId": "ID на тест",
  "column.name.testName": "Име на тест",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Code must contain at least one letter, digit, or underscore.",
  "common.properties.title": "Common Properties",
  "configuration.batch.test.reassignment": "Групово пренасочване и анулиране на тестове",
  "configuration.method": "Управление на методи",
  "configuration.method.create": "Създаване на нов метод",
  "configuration.method.explain": "Използва се за създаване, активиране или деактивиране на метод",
  "configuration.method.rename": "Преименуване на съществуващи методи",
  "configuration.method.rename.explain": "Използва се за коригиране имената на съществуващи методи",
  "configuration.panel.assign": "Задаване на тестове",
  "configuration.panel.assign.explain": "Изберете тестове за пренасочване към друг панел.",
  "configuration.panel.confirmation.explain": "Този панел няма да бъде активен, докато към него не бъде зачислен поне един тест.",
  "configuration.panel.create": "Създаване на нов панел",
  "configuration.panel.create.duplicate": "Намерен е съществуващ панел със същото име. Моля, откажете или използвайте друго име.",
  "configuration.panel.manage": "Управление на панели",
  "configuration.panel.manage.explain": "Използва се за създаване, подредба или зачисляване на тестове към панели",
  "configuration.panel.order": "Задаване на подредба на панелите",
  "configuration.panel.order.explain": "Сортирайте панелите чрез влачене и пускане.",
  "configuration.panel.order.explain.limits": "Само панели със зачислени тестове могат да бъдат подреждани.",
  "configuration.panel.rename": "Преименуване на съществуващи панели",
  "configuration.panel.rename.explain": "Използва се за корекция на имената на съществуващи панели.",
  "configuration.sampleType.assign.explain": "Изберете тестове за пренасочване към друг тип проба.",
  "configuration.sampleType.assign.new.type": "Зачисли към тип проба",
  "configuration.sampleType.confirmation.explain": "Този тип проба няма да бъде активен, докато към него не бъде зачислен поне един тест.",
  "configuration.sampleType.create": "Създаване на нов тип проба",
  "configuration.sampleType.create.duplicate": "Намерен е съществуващ тип проба със същото име.",
  "configuration.sampleType.manage": "Управление на типове проби",
  "configuration.sampleType.manage.explain": "Използва се за създаване, подредба или зачисляване на тестове към типове проби",
  "configuration.sampleType.order": "Задаване подредба на типовете проби",
  "configuration.sampleType.order.explain": "Сортирайте чрез влачене.",
  "configuration.sampleType.order.explain.limits": "Само типове проби със зачислени тестове могат да бъдат подреждани.",
  "configuration.selectList.add": "Добави списък за избор на резултати",
  "configuration.selectList.add.alert": "За промяна на правописа използвайте Преименуване на съществуващи опции",
  "configuration.selectList.add.explain": "Използва се за създаване на списък с опции за избор за резултати от тестове",
  "configuration.selectList.assign.description": "Новият запис може да бъде зачислен към тестове или запазен без зачисляване.",
  "configuration.selectList.assign.header": "Зачисляване на нова опция към тест",
  "configuration.selectList.assign.new": "Нова опция в списъка за избор",
  "configuration.selectList.confirmChange": "Нормалната стойност ще бъде променена от %oldvalue% на %newvalue%, сигурни ли сте?",
  "configuration.selectList.description": "Въведете на английски и френски за новата опция.",
  "configuration.selectList.header": "Създаване на нова опция за избор на резултат",
  "configuration.selectList.rename": "Преименуване на опции от списъка",
  "configuration.selectList.rename.explain": "Преименуване на съществуващи опции за избор на резултати",
  "configuration.test.activate": "Активиране/Деактивиране на тестове",
  "configuration.test.activate.explain": "Използва се за активиране или деактивиране на съществуващ тест.",
  "configuration.test.add": "Добавяне на нови тестове",
  "configuration.test.add.explain": "Използва се за добавяне на нови тестове в системата.",
  "configuration.test.catalog": "Виж каталога на тестовете",
  "configuration.test.catalog.explain": "Преглед на текущия каталог на тестовете",
  "configuration.test.management.ocl": "Импорт на OCL концепции",
  "configuration.test.management.organization": "Организация на тестовете",
  "configuration.test.management.spelling": "Корекции на правописа",
  "configuration.test.modify": "Промяна на тестове",
  "configuration.test.modify.explain": "Използва се за промяна на съществуващи тестове в системата.",
  "configuration.test.modify.tab.configuration": "Configuration",
  "configuration.test.modify.tab.compliance": "Compliance Thresholds",
  "configuration.test.modify.filter.instruction": "Изберете тип проба или тестова секция, за да видите тестовете.",
  "configuration.test.modify.filter.noTestsFound": "Няма намерени тестове, съответстващи на критериите.",
  "configuration.test.modify.filter.selectToBegin": "Моля, изберете тип проба или секция, за да започнете.",
  "configuration.test.orderable": "Разрешаване/забраняване поръчката на тестове",
  "configuration.test.orderable.explain": "Тестове, които могат да се поръчват при приемане.",
  "configuration.test.rename": "Преименуване на съществуващи тестове",
  "configuration.test.rename.explain": "Използва се за преименуване на съществуващи тестове.",
  "configuration.testSection.rename": "Преименуване на съществуващи тестови секции",
  "configuration.testSection.rename.explain": "Използва се за корекция на имената на съществуващи тестови секции.",
  "configuration.testUnit.assign.new.unit": "Зачисли към тестова секция",
  "configuration.testUnit.confirmation.explain": "Тази тестова единица няма да бъде активна, докато към нея не бъде зачислен поне един тест.",
  "configuration.testUnit.create": "Създаване на нова тестова единица",
  "configuration.testUnit.create.duplicate": "Намерена е съществуваща тестова единица със същото име.",
  "configuration.testUnit.manage": "Управление на тестови единици",
  "configuration.testUnit.manage.explain": "Използва се за създаване, подредба или зачисляване на тестове",
  "configuration.testUnit.order": "Задаване на подредба на тестовите единици",
  "configuration.testUnit.order.explain": "Сортирайте лабораторните единици чрез влачене.",
  "configuration.testUnit.order.explain.limits": "Само секции със зачислени тестове могат да бъдат подреждани.",
  "configuration.type.rename": "Преименуване на съществуващи типове проби",
  "configuration.type.rename.explain": "Използва се за корекция на имената на съществуващи панели.",
  "heading.sampleType.management": "Sample Type Editor",
  "heading.sampleType.subtitle": "Configure sample types, display order, test associations, and domain classification.",
  "heading.sampleType.editing": "Editing: {name}",
  "label.sampleType.domain": "Sample Domain",
  "label.domain.CLINICAL": "Clinical",
  "label.domain.ENVIRONMENTAL": "Environmental",
  "label.domain.VECTOR": "Vector",
  "label.sampleType.domain.clinical": "Clinical",
  "label.sampleType.domain.environmental": "Environmental",
  "label.sampleType.domain.helper": "Determines which workflow mode (Clinical or Environmental) this sample type appears in.",
  "label.sampleType.filterDomain": "Filter by domain",
  "label.sampleType.testCount": "Тестове",
  "label.sampleType.actions": "Действия",
  "label.sampleType.status": "Статус",
  "placeholder.sampleType.search": "Search sample types...",
  "placeholder.sampleType.filter.domain": "All domains",
  "button.sampleType.add": "Add Sample Type",
  "configuration.uom.create": "Създаване на нови мерни единици",
  "configuration.uom.manage": "Управление на мерни единици",
  "configuration.uom.manage.explain": "Използва се за създаване на мерни единици",
  "configuration.uom.rename": "Преименуване на съществуващи мерни единици",
  "configuration.uom.rename.explain": "Използва се за корекция на имената на съществуващи мерни единици.",
  "configure.labNumber.title": "Управление на лабораторни номера",
  "confirmation.rename": "Потвърдете промените, които направихте по-горе.",
  "currentests.title": "Текущи тестове",
  "cytology.label.cellabnomality": "Епителна клетъчна аномалия",
  "cytology.label.confirmSelect": "Ако изберете тази опция, цялата текуща информация за диагнозата ще бъде премахната",
  "cytology.label.dashboard": "Табло на цитология",
  "cytology.label.glandular": "Жлезисти",
  "cytology.label.negative": "Отрицателно за интраепителна лезия или злокачествено заболяване",
  "cytology.label.neoplastic": "Не-неопластични клетъчни вариации",
  "cytology.label.organisms": "Организми",
  "cytology.label.other": "Други злокачествени неоплазми",
  "cytology.label.otherResult": " Друг резултат от диагнозата",
  "cytology.label.reactive": "Реактивни клетъчни промени",
  "cytology.label.review": "Очаква преглед от цитопатолог",
  "cytology.label.specimen": "Адекватност на пробата",
  "cytology.label.squamous": "Сквамозни",
  "cytology.label.title": "Цитология",
  "dashboard.avg.turn.around.label": "Средно време за обработка",
  "dashboard.avg.turn.around.reception.to.result.label": "Reception To Result Average Time",
  "dashboard.avg.turn.around.reception.to.validation.label": "Reception To Validation Average Time",
  "dashboard.avg.turn.around.result.to.validation.label": "Result To Validation Average Time",
  "dashboard.avg.turn.around.subtitle.label": "Приемане до Валидация",
  "dashboard.complete.orders.label": "Завършени поръчки днес",
  "dashboard.in.progress.label": "В ход",
  "dashboard.in.progress.subtitle.label": "Очаква въвеждане на резултати",
  "dashboard.metrics.loadFailed": "Dashboard counts could not be loaded.",
  "dashboard.partially.completed.label": "Частично завършени днес",
  "dashboard.partially.completed.subtitle.label": "Awaiting Remaining Tests",
  "dashboard.rejected.orders": "Отхвърлени поръчки",
  "dashboard.turn.around.label": "Забавена обработка",
  "dashboard.turn.around.subtitle.label": "Повече от 96 часа",
  "dashboard.unprints.results.label": "Неразпечатани резултати",
  "dashboard.user.orders.label": "Поръчки, въведени от потребители",
  "dashboard.user.orders.today.label": "Поръчки, въведени от потребител днес",
  "dashboard.validation.ready.label": "Готови за валидация",
  "dashboard.validation.ready.subtitle.label": "Очаква преглед",
  "dataexport.status.actions": "Действия",
  "dataexport.status.attempt.duration": "Duration",
  "dataexport.status.attempt.endTime": "End Time",
  "dataexport.status.attempt.startTime": "Start Time",
  "dataexport.status.attempt.status": "Статус",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Failed / Total (24h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Retry Interval",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Last Attempt",
  "dataexport.status.lastRefreshed": "Last refreshed",
  "dataexport.status.lastStatus": "Last Status",
  "dataexport.status.lastSuccess": "Last Success",
  "dataexport.status.loadingAttempts": "Loading attempt history…",
  "dataexport.status.never": "Never",
  "dataexport.status.noAttempts": "No attempts yet",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Retry now",
  "dataexport.status.retryInFlight": "Triggering…",
  "dataexport.status.title": "FHIR Data Export Status",
  "datasubmission.siteid": "ID на обекта",
  "database.clean": "Database Cleaning",
  "database.clean.button": "Clean Database",
  "database.clean.confirm.message": "Are you sure you want to clean the database? This will remove all patient and test data.",
  "database.clean.confirm.title": "Confirm Database Cleaning",
  "database.clean.confirm.warning": "This action cannot be undone!",
  "database.clean.error": "Failed to clean the database.",
  "database.clean.not.training": "Database cleaning is only available on training installations.",
  "database.clean.success": "Database cleaned successfully.",
  "database.clean.warning": "This will permanently delete all patient data, sample data, and results from the database.",
  "date.created": "Дата на създаване",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Грешка при изтриване",
  "delete.success.msg": "Успешно изтрито",
  "description.active": "Ако тестът е активен, той може да бъде поръчан. Ако не е активен, не може.",
  "description.ageRange": "Указва дали възрастовият диапазон (в месеци) е важен.",
  "description.name": "Името на теста, както се появява в OpenELIS.",
  "description.normalRange": "Числов диапазон, очакван при здрав човек.",
  "description.note": "n/a означава неприложимо.",
  "description.orderable": "Ако е активен и поръчваем, той се появява във формата за поръчка.",
  "description.panel": "Ако тестът е част от панел, името му е тук.",
  "description.referenceValue": "Стойност за здрав човек за резултати от списъци.",
  "description.reportName": "Името на теста, както ще се появява в отчетите.",
  "description.resultLimits": "Граници за нормални и валидни резултати за числови тестове.",
  "description.resultType": "Вид на резултата за този тест:",
  "description.resultType.alphanumeric": "A - Алфанумеричен:",
  "description.resultType.alphanumericDesc": " Приема числа или текст.",
  "description.resultType.cascadingMultiSelectList": "C - Каскаден списък с множествен избор:",
  "description.resultType.cascadingMultiSelectListDesc": " Подобен на множествен избор, но с групи.",
  "description.resultType.kind": "Вид на резултата за този тест:",
  "description.resultType.multiSelectList": "M - Списък с множествен избор:",
  "description.resultType.multiSelectListDesc": " Потребителят избира една или повече стойности.",
  "description.resultType.numeric": "N - Числов:",
  "description.resultType.numericDesc": " Приема само числови резултати.",
  "description.resultType.selectList": "D - Списък за избор:",
  "description.resultType.selectListDesc": " Избор от падащо меню.",
  "description.resultType.textArea": "R - Свободен текст:",
  "description.resultType.textAreaDesc": " Приема до 200 символа.",
  "description.sampleType": "Тип проба, за която може да се направи теста.",
  "description.selectValues": "Наличните опции за избор.",
  "description.sex": "Указва дали полът на пациента е важен за стойностите.",
  "description.significantDigits": "Брой значими цифри за числови резултати.",
  "description.testUnit": "Секцията в лабораторията, която извършва теста.",
  "description.uom": "Мерна единица.",
  "description.validRange": "Резултат извън тези граници подсказва, че тестът може да е извършен неправилно.",
  "dictionary.category.isActive": "Е активен",
  "dictionary.category.label": "Dictionary Category",
  "dictionary.category.localAbbreviation": "Местно съкращение",
  "dictionary.category.name": "Категория",
  "dictionary.dictEntry": "Запис в речника",
  "dictionary.label.modify": "Меню на речника",
  "dictionary.loincCode": "LOINC код",
  "dictionary.loincCode.help": "Въведете стандартен LOINC идентификатор",
  "dictionary.loincCode.helpText": "Стандартен лабораторен идентификатор",
  "dictionary.loincCode.invalid": "Невалиден формат (очакван: 12345-6)",
  "dictionary.loincCode.placeholder": "напр. 12345-6",
  "dictionary.menu.deactivate.fail": "Деактивирането на менюто на речника е неуспешно",
  "dictionary.menu.deactivate.success": "Менюто на речника е деактивирано успешно",
  "dictionary.modal.add.heading": "Add Dictionary",
  "dictionary.modal.edit.heading": "Edit Dictionary",
  "dictionary.number.label": "Dictionary Number",
  "disposal.button": "Бракуване на партида",
  "disposal.notes": "Бележки по бракуването",
  "disposal.notes.placeholder": "Подробности (метод на изхвърляне, свидетел и др.)",
  "disposal.reason": "Причина за бракуване",
  "disposal.reason.select": "Изберете причина",
  "disposal.success": "Партидата е бракувана успешно",
  "disposal.title": "Бракуване на партида",
  "disposal.warning.message": "Това действие е необратимо. Партидата ще бъде премахната от активния инвентар.",
  "disposal.warning.title": "Предупреждение",
  "emergencyContactInfo.title": "Контакт при спешни случаи",
  "english.current": "Текущ АНГЛИЙСКИ",
  "english.label": "Английски",
  "enterText.label": "Въведете останалия текст",
  "eorder.allInfo": "Цялата информация",
  "eorder.button.editOrder": "Редактирай поръчка",
  "eorder.button.enterOrder": "Въведи поръчка",
  "eorder.buttons": " ",
  "eorder.date.end": "Крайна дата",
  "eorder.date.start": "Начална дата",
  "eorder.facility.requesting": "Заявяващо заведение",
  "eorder.header": "Търсене на входящи заявки за тестове",
  "eorder.id.national": "Национален ID",
  "eorder.id.subjectNumber": "Номер на субект",
  "eorder.instructions.enter1": "Заявки, съответстващи на търсенето - В ",
  "eorder.instructions.enter2": " менюто, добавете лаб. номер и изберете ",
  "eorder.instructions.enter3": " за приемане на поръчката както е, или изберете ",
  "eorder.instructions.enter4": " за промени ",
  "eorder.labNumber": "Лабораторен номер",
  "eorder.labnumber.referring": "Референтен лаб. номер",
  "eorder.name.first": "Име",
  "eorder.name.last": "Фамилия",
  "eorder.passport.number": "Номер на паспорт",
  "eorder.priority": "Приоритет",
  "eorder.requestDate": "Дата на заявка",
  "eorder.search.noresults": "Няма електронни поръчки",
  "eorder.search1.text": "Търсене по фамилия, национален ID, референтен лаб. номер или номер на паспорт",
  "eorder.search2.text": "Търсене по дата и статус.",
  "eorder.searchValue": "Стойност за търсене",
  "eorder.status": "Статус",
  "eorder.test.name": "Име на тест",
  "eqa.action.deactivate": "Деактивирай",
  "eqa.action.edit": "Редактиране",
  "eqa.action.enterResults": "Въвеждане на резултати",
  "eqa.action.enterViewResults": "Enter/View Results",
  "eqa.action.reactivate": "Reactivate",
  "eqa.action.viewOrder": "View Order",
  "eqa.action.viewResults": "View Results",
  "eqa.admin.addProgram": "Add Program",
  "eqa.admin.col.actions": "Действия",
  "eqa.admin.col.category": "Категория",
  "eqa.admin.col.frequency": "Frequency",
  "eqa.admin.col.participants": "Enrolled Participants",
  "eqa.admin.col.programName": "Име на програмата",
  "eqa.admin.col.provider": "Доставчик",
  "eqa.admin.delete": "Изтрий",
  "eqa.admin.form.addHeading": "Add New EQA Program",
  "eqa.admin.form.category.placeholder": "Select category",
  "eqa.admin.form.description.placeholder": "Program description and objectives...",
  "eqa.admin.form.editHeading": "Edit EQA Program",
  "eqa.admin.form.frequency.placeholder": "Select frequency",
  "eqa.admin.form.name.placeholder": "e.g., TB Culture & Sensitivity",
  "eqa.admin.form.provider.placeholder": "Select provider",
  "eqa.admin.form.subtitle": "Enroll in a new external quality assessment program",
  "eqa.admin.programs.subtitle": "Manage enrolled EQA programs and providers",
  "eqa.admin.programs.title": "EQA Programs",
  "eqa.admin.provider.placeholder": "e.g., WHO, CDC, CAP",
  "eqa.admin.subtitle": "Manage EQA programs, users, and system settings",
  "eqa.admin.systemSettings.placeholder": "System settings coming soon.",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.programs": "EQA Programs",
  "eqa.admin.tab.systemSettings": "System Settings",
  "eqa.admin.tab.userManagement": "Управление на потребители",
  "eqa.admin.tile.acrossAllPrograms": "Across all programs",
  "eqa.admin.tile.activePrograms": "Active Programs",
  "eqa.admin.tile.canManageEqa": "Can manage EQA",
  "eqa.admin.tile.enrolledParticipants": "Enrolled Participants",
  "eqa.admin.tile.systemUsers": "System Users",
  "eqa.admin.tile.totalParticipants": "Total Participants",
  "eqa.admin.tile.totalPrograms": "{count} total programs",
  "eqa.admin.title": "Program Administration",
  "eqa.admin.userManagement.placeholder": "User management coming soon.",
  "eqa.column.actions": "Действия",
  "eqa.deadline.label": "Testing Deadline",
  "eqa.distribution.action.continue": "Continue",
  "eqa.distribution.action.ship": "Ship",
  "eqa.distribution.action.track": "Track",
  "eqa.distribution.action.viewReport": "Виж отчета",
  "eqa.distribution.advance": "Advance Status",
  "eqa.distribution.backToDashboard": "Back to Distributions",
  "eqa.distribution.barcodes": "Generate Barcodes",
  "eqa.distribution.col.actions": "Действия",
  "eqa.distribution.col.deadline": "Deadline",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Програма",
  "eqa.distribution.col.responses": "Responses",
  "eqa.distribution.col.round": "Round",
  "eqa.distribution.col.samples": "Проби",
  "eqa.distribution.col.shipmentId": "Shipment ID",
  "eqa.distribution.col.status": "Статус",
  "eqa.distribution.create": "Create Distribution",
  "eqa.distribution.createError": "Failed to create distribution.",
  "eqa.distribution.createShipment": "Create New Shipment",
  "eqa.distribution.createSuccess": "Distribution created successfully.",
  "eqa.distribution.dashboard.subtitle": "Distribute EQA samples to participating laboratories",
  "eqa.distribution.dashboard.title": "EQA Distribution",
  "eqa.distribution.deadline": "Submission Deadline",
  "eqa.distribution.detail.title": "Distribution Details",
  "eqa.distribution.empty": "No distributions found",
  "eqa.distribution.filter.allShipments": "All Shipments",
  "eqa.distribution.filter.program": "Filter by Program",
  "eqa.distribution.filter.status": "Филтриране по статус",
  "eqa.distribution.list.title": "EQA Distributions",
  "eqa.distribution.manageParticipants": "Manage Participants",
  "eqa.distribution.name": "Distribution Name",
  "eqa.distribution.name.placeholder": "e.g., Round 1 - Chemistry 2026",
  "eqa.distribution.network.active": "Active Participants",
  "eqa.distribution.network.active.sub": "Currently enrolled",
  "eqa.distribution.network.responseRate": "Average Response Rate",
  "eqa.distribution.network.responseRate.sub": "Last 4 quarters",
  "eqa.distribution.network.subtitle": "Overview of enrolled participating laboratories",
  "eqa.distribution.network.title": "Participant Network",
  "eqa.distribution.network.total": "Total Participants",
  "eqa.distribution.network.total.sub": "Across all countries",
  "eqa.distribution.participants": "Participant Organizations",
  "eqa.distribution.participants.min": "At least 2 participant organizations are required",
  "eqa.distribution.participants.none": "No organizations are currently enrolled in the selected programme. Enrol participants before creating a distribution.",
  "eqa.distribution.participants.select": "Select organizations",
  "eqa.distribution.program": "EQA Program",
  "eqa.distribution.program.select": "Select a program",
  "eqa.distribution.responseRate": "response rate",
  "eqa.distribution.shipments.subtitle": "Track distributed EQA samples and participant responses",
  "eqa.distribution.shipments.title": "EQA Shipments",
  "eqa.distribution.shipped": "Shipped",
  "eqa.distribution.status.completed": "Завършен",
  "eqa.distribution.status.draft": "Чернова",
  "eqa.distribution.status.prepared": "Prepared",
  "eqa.distribution.status.shipped": "Shipped",
  "eqa.distribution.step.confirmation": "Потвърждение",
  "eqa.distribution.step.details": "Program & Details",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Завършен",
  "eqa.distribution.summary.completed.sub": "All responses received",
  "eqa.distribution.summary.draft": "Draft Shipments",
  "eqa.distribution.summary.draft.sub": "Being prepared",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Enrolled",
  "eqa.distribution.summary.shipped": "Shipped",
  "eqa.distribution.summary.shipped.sub": "Awaiting responses",
  "eqa.enrollment.allStatuses": "Всички статуси",
  "eqa.enrollment.alreadyEnrolled": "Already Enrolled",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organization(s) already enrolled",
  "eqa.enrollment.confirmWithdraw": "Confirm Withdrawal",
  "eqa.enrollment.created.success": "Program enrollment created successfully",
  "eqa.enrollment.deactivated": "Program enrollment deactivated",
  "eqa.enrollment.description": "Описание",
  "eqa.enrollment.district": "Здравен район",
  "eqa.enrollment.editing": "Editing: {name}",
  "eqa.enrollment.empty": "No enrollments found for this program",
  "eqa.enrollment.enroll": "Enroll",
  "eqa.enrollment.enrollParticipant": "Enroll Participant",
  "eqa.enrollment.enrollSelected": "Enroll Selected",
  "eqa.enrollment.enrollmentDate": "Enrollment Date",
  "eqa.enrollment.error": "The enrollment was not saved. Try again.",
  "eqa.enrollment.labUnits": "Тестови единици",
  "eqa.enrollment.new": "New EQA Program Enrollment",
  "eqa.enrollment.organizationCode": "Organization Code",
  "eqa.enrollment.organizationName": "Organization Name",
  "eqa.enrollment.panels": "Панели",
  "eqa.enrollment.programName": "Име на програмата",
  "eqa.enrollment.programName.placeholder": "Enter program name",
  "eqa.enrollment.provider": "Доставчик",
  "eqa.enrollment.provider.placeholder": "Enter provider name",
  "eqa.enrollment.reactivate": "Reactivate",
  "eqa.enrollment.reactivated": "Program enrollment reactivated",
  "eqa.enrollment.save": "Save Enrollment",
  "eqa.enrollment.saveChanges": "Запази промените",
  "eqa.enrollment.searchOrgs": "Search organizations...",
  "eqa.enrollment.searchPlaceholder": "Search by organization name or code...",
  "eqa.enrollment.selectLabUnits": "Select lab units...",
  "eqa.enrollment.selectOrg": "Select an organization...",
  "eqa.enrollment.selectOrgsPrompt": "Select organizations to enroll",
  "eqa.enrollment.selectPanels": "Select panels...",
  "eqa.enrollment.selectProgram": "Select Program",
  "eqa.enrollment.selectProgramPrompt": "Select a program to view enrollments",
  "eqa.enrollment.selectTests": "Select tests...",
  "eqa.enrollment.selected": "selected",
  "eqa.enrollment.status": "Статус",
  "eqa.enrollment.status.active": "Активен",
  "eqa.enrollment.status.suspended": "Suspended",
  "eqa.enrollment.status.withdrawn": "Withdrawn",
  "eqa.enrollment.success": "Enrollment successful",
  "eqa.enrollment.suspend": "Suspend",
  "eqa.enrollment.tests": "Тестове",
  "eqa.enrollment.thisLab": "This Lab",
  "eqa.enrollment.updated.success": "Program enrollment updated successfully",
  "eqa.enrollment.withdraw": "Withdraw",
  "eqa.enrollment.withdrawReason": "Reason for Withdrawal",
  "eqa.enrollment.withdrawReasonPlaceholder": "Provide a reason for withdrawing this participant...",
  "eqa.filter.allPriorities": "All Priorities",
  "eqa.filter.allPrograms": "All Programs",
  "eqa.filter.allStatuses": "Всички статуси",
  "eqa.filter.eqaOnly": "EQA Samples Only",
  "eqa.filter.priority": "Приоритет",
  "eqa.filter.program": "Програма",
  "eqa.filter.status": "Статус",
  "eqa.management.action.enterResults": "Въвеждане на резултати",
  "eqa.management.action.submit": "Изпрати",
  "eqa.management.bulkUpload": "Bulk Upload Results",
  "eqa.management.col.accession": "Accession #",
  "eqa.management.col.actions": "Действия",
  "eqa.management.col.deadline": "Deadline",
  "eqa.management.col.progress": "Прогрес",
  "eqa.management.col.provider": "Provider/Program",
  "eqa.management.col.sampleId": "ID на проба",
  "eqa.management.col.status": "Статус",
  "eqa.management.daysLeft": "days left",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "All Samples",
  "eqa.management.overdue": "Overdue",
  "eqa.management.participants.subtitle": "Manage organization enrollment in EQA programs",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "On-Time Submission",
  "eqa.management.performance.participation": "Participation Rate",
  "eqa.management.performance.participation.sub": "All programs enrolled",
  "eqa.management.performance.subtitle": "Your laboratory's EQA performance metrics",
  "eqa.management.performance.title": "Performance Summary",
  "eqa.management.performance.zScore": "Average Z-Score",
  "eqa.management.performance.zScore.sub": "Within acceptable range",
  "eqa.management.programs.subtitle": "Manage programs distributed by this laboratory",
  "eqa.management.programs.title": "EQA Programs",
  "eqa.management.results.title": "Results & Analysis",
  "eqa.management.samples.empty": "No EQA samples found",
  "eqa.management.samples.subtitle": "Manage received EQA samples and submit results",
  "eqa.management.samples.title": "EQA Samples",
  "eqa.management.status.completed": "Завършен",
  "eqa.management.status.completed.sub": "Ready to submit",
  "eqa.management.status.inProgress": "В ход",
  "eqa.management.status.inProgress.sub": "Testing in progress",
  "eqa.management.status.in_progress": "В ход",
  "eqa.management.status.overdue": "Overdue",
  "eqa.management.status.pending": "Pending",
  "eqa.management.status.pending.sub": "Not started",
  "eqa.management.status.submitted": "Изпратено",
  "eqa.management.status.submitted.sub": "Results sent",
  "eqa.management.subtitle": "Receive and manage EQA samples from external providers",
  "eqa.management.title": "EQA Management",
  "eqa.management.viewPerformance": "View Performance",
  "eqa.myProgram.helperText": "Selecting an enrollment pre-populates tests and panels",
  "eqa.myProgram.label": "My Program Enrollment",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests and {panels} panels pre-selected from enrollment",
  "eqa.myProgram.prePopulated.title": "Tests/panels pre-populated",
  "eqa.myProgram.select": "Select enrollment to pre-populate tests...",
  "eqa.myPrograms.action.deactivate": "Деактивирай",
  "eqa.myPrograms.action.edit": "Редактиране",
  "eqa.myPrograms.action.reactivate": "Reactivate",
  "eqa.myPrograms.description": "Описание",
  "eqa.myPrograms.enrollButton": "Enroll in Program",
  "eqa.myPrograms.enrollInProgram": "Enroll in Program",
  "eqa.myPrograms.labUnits": "Lab Unit(s)",
  "eqa.myPrograms.panels": "Панели",
  "eqa.myPrograms.programName": "Име на програмата",
  "eqa.myPrograms.provider": "Доставчик",
  "eqa.myPrograms.search.placeholder": "Search programs...",
  "eqa.myPrograms.status": "Статус",
  "eqa.myPrograms.status.active": "Активен",
  "eqa.myPrograms.status.inactive": "Неактивен",
  "eqa.myPrograms.subtitle": "Programs this laboratory participates in",
  "eqa.myPrograms.testMapping": "Test Mapping (Optional)",
  "eqa.myPrograms.testMappingHint": "Select tests and panels to pre-populate Order Entry when this program is selected",
  "eqa.myPrograms.tests": "Тестове",
  "eqa.myPrograms.title": "My EQA Programs",
  "eqa.order.deadline": "Result Deadline",
  "eqa.order.form.title": "EQA Sample Information",
  "eqa.order.participantId": "Participant ID",
  "eqa.order.priority": "EQA Priority",
  "eqa.order.programme": "Programme",
  "eqa.order.provider": "Доставчик",
  "eqa.order.providerSampleId": "Provider Sample ID",
  "eqa.orders.completedThisMonth": "Completed This Month",
  "eqa.orders.enterNewTest": "Enter New EQA Test",
  "eqa.orders.inProgress": "В ход",
  "eqa.orders.overdue": "Overdue",
  "eqa.orders.pending": "Pending",
  "eqa.orders.search.placeholder": "Search by lab number or program...",
  "eqa.participant.id": "Participant ID",
  "eqa.priority.critical": "Критична",
  "eqa.priority.label": "Приоритет",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgent",
  "eqa.program.activate": "Активирай",
  "eqa.program.active": "Активен",
  "eqa.program.addProgram": "Add Program",
  "eqa.program.cancel": "Отказ",
  "eqa.program.create": "Create Program",
  "eqa.program.createTitle": "Create EQA Program",
  "eqa.program.deactivate": "Деактивирай",
  "eqa.program.description": "Описание",
  "eqa.program.description.placeholder": "Describe the EQA program...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit EQA Program",
  "eqa.program.empty": "No EQA programs found",
  "eqa.program.inactive": "Неактивен",
  "eqa.program.label": "EQA Program",
  "eqa.program.management.title": "EQA Program Management",
  "eqa.program.name": "Име на програмата",
  "eqa.program.name.placeholder": "e.g., Chemistry Proficiency Testing",
  "eqa.program.name.required": "Program name is required",
  "eqa.program.provider.required": "Provider is required",
  "eqa.program.participantCount": "Enrolled Participants",
  "eqa.program.provider": "Доставчик",
  "eqa.program.required": "EQA Program is required when registering an EQA sample",
  "eqa.program.save": "Save Program",
  "eqa.program.select": "Select EQA Program",
  "eqa.program.status": "Статус",
  "eqa.program.tests": "Assigned Tests",
  "eqa.program.tests.assign": "Assign Tests",
  "eqa.program.tests.select": "Select tests to assign",
  "eqa.provider.label": "EQA Provider Organization",
  "eqa.provider.sampleId": "Provider Sample ID",
  "eqa.provider.select": "Select EQA Provider",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Batch Import",
  "eqa.results.col.deadline": "Deadline",
  "eqa.results.col.labNumber": "Лабораторен номер",
  "eqa.results.col.priority": "Приоритет",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Доставчик",
  "eqa.results.col.status": "Статус",
  "eqa.results.import.confirm": "Confirm Import",
  "eqa.results.import.errors": "{count} rows had errors",
  "eqa.results.import.success": "{count} results imported successfully",
  "eqa.results.import.upload": "Upload CSV File",
  "eqa.results.manual.entry": "Manual Result Entry",
  "eqa.results.mean": "Mean",
  "eqa.results.minimum.participants": "Minimum 5 participants required for statistical analysis",
  "eqa.results.noResults": "No EQA test results found.",
  "eqa.results.organization": "Organization",
  "eqa.results.organization.select": "Select organization",
  "eqa.results.participant.count": "Participant Count",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Questionable",
  "eqa.results.report.downloading": "Downloading report...",
  "eqa.results.report.generate": "Генерирай отчет",
  "eqa.results.search.placeholder": "Search by lab number, programme, or provider...",
  "eqa.results.standardDeviation": "Standard Deviation",
  "eqa.results.statistics": "Statistics",
  "eqa.results.submit": "Submit Result",
  "eqa.results.test": "Тест",
  "eqa.results.test.select": "Select test",
  "eqa.results.title": "EQA Results & Analysis",
  "eqa.results.unacceptable": "Unacceptable",
  "eqa.results.value": "Result Value",
  "eqa.results.zscore": "Z-Score",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "EQA Sample",
  "eqa.sample.checkbox.helper": "Check if this is an External Quality Assurance sample",
  "eqa.sample.demographics.disabled": "Demographics disabled for EQA samples",
  "eqa.sample.patient.readonly.body": "Patient demographic fields are automatically set for EQA samples and cannot be edited.",
  "eqa.sample.patient.readonly.title": "EQA Sample — Patient Info Locked",
  "eqa.section.title": "EQA Sample Details",
  "eqa.settings.integration.apiKey": "API Key",
  "eqa.settings.integration.apiUrl": "API Base URL",
  "eqa.settings.integration.fhir": "FHIR API Integration",
  "eqa.settings.integration.fhir.desc": "Enable FHIR R4 API for external EQA data exchange",
  "eqa.settings.integration.subtitle": "Configure external system integrations",
  "eqa.settings.integration.title": "Integration Settings",
  "eqa.settings.loading": "Loading settings...",
  "eqa.settings.notifications.email": "Email Notifications",
  "eqa.settings.notifications.email.desc": "Send email notifications for critical alerts and deadlines",
  "eqa.settings.notifications.eqaDeadline": "EQA Deadline Alerts",
  "eqa.settings.notifications.eqaDeadline.desc": "Receive alerts when EQA submission deadlines are approaching",
  "eqa.settings.notifications.stat": "STAT Order Alerts",
  "eqa.settings.notifications.stat.desc": "Alert when STAT orders are overdue",
  "eqa.settings.notifications.subtitle": "Configure alert and notification preferences",
  "eqa.settings.notifications.threshold": "Alert Threshold (days before deadline)",
  "eqa.settings.notifications.title": "Notification Settings",
  "eqa.settings.performance.autoZScore": "Automatic Z-Score Calculation",
  "eqa.settings.performance.autoZScore.desc": "Automatically calculate Z-Scores when results are submitted",
  "eqa.settings.performance.generateReports": "Generate Performance Reports",
  "eqa.settings.performance.generateReports.desc": "Automatically generate performance reports after each round",
  "eqa.settings.performance.subtitle": "Configure EQA performance analysis parameters",
  "eqa.settings.performance.title": "Performance Analysis",
  "eqa.settings.performance.zScoreMax": "Maximum Acceptable Z-Score",
  "eqa.settings.performance.zScoreMin": "Minimum Acceptable Z-Score",
  "eqa.settings.saveError": "Failed to save settings",
  "eqa.settings.saveSuccess": "Settings saved successfully",
  "eqa.settings.saving": "Запазване...",
  "eqa.status.active": "Активен",
  "eqa.status.completed": "Завършен",
  "eqa.status.inProgress": "В ход",
  "eqa.status.inactive": "Неактивен",
  "eqa.status.inprogress": "В ход",
  "eqa.status.overdue": "Overdue",
  "eqa.status.pending": "Pending",
  "eqa.submission.audit": "Submission Audit Trail",
  "eqa.submission.date": "Submission Date",
  "eqa.submission.error": "Submission failed",
  "eqa.submission.fhir": "Submit via FHIR",
  "eqa.submission.fhir.description": "Submit results to external EQA provider via FHIR R4",
  "eqa.submission.late.approve": "Approve Late Submission",
  "eqa.submission.late.justification": "Justification for Late Submission",
  "eqa.submission.late.justification.placeholder": "Provide reason for late submission...",
  "eqa.submission.late.supervisor": "Supervisor User ID",
  "eqa.submission.late.warning": "Submission deadline has passed. Supervisor approval is required.",
  "eqa.submission.method": "Submission Method",
  "eqa.submission.success": "Results submitted successfully",
  "eqa.submission.title": "Result Submission",
  "eqa.tests.action.enterResults": "Въвеждане на резултати",
  "eqa.tests.action.viewOrder": "View Order",
  "eqa.tests.action.viewResults": "View Results",
  "eqa.tests.dateEntered": "Date Entered",
  "eqa.tests.deadline": "Deadline",
  "eqa.tests.enterNew": "Enter New EQA Test",
  "eqa.tests.labNumber": "Лабораторен номер",
  "eqa.tests.orders.subtitle": "Proficiency testing orders for this laboratory",
  "eqa.tests.orders.title": "EQA Orders",
  "eqa.tests.priority": "Приоритет",
  "eqa.tests.program": "EQA Program",
  "eqa.tests.provider": "Доставчик",
  "eqa.tests.searchPlaceholder": "Search by accession #, program, or provider...",
  "eqa.tests.status": "Статус",
  "eqa.tests.status.completed": "Завършен",
  "eqa.tests.status.inProgress": "В ход",
  "eqa.tests.status.overdue": "Overdue",
  "eqa.tests.status.pending": "Pending",
  "eqa.tests.summary.completedThisMonth": "Completed This Month",
  "eqa.tests.summary.inProgress": "В ход",
  "eqa.tests.summary.overdue": "Overdue",
  "eqa.tests.summary.pending": "Pending",
  "eqa.validation.deadline.required": "Testing Deadline is required",
  "eqa.validation.program.required": "EQA Program is required",
  "eqa.validation.provider.required": "EQA Provider Organization is required",
  "error.add.edited.msg": "Грешка при Редактиране/Добавяне",
  "error.barcode.dimension.positive": "Label dimension must be a positive number",
  "error.barcode.labelcount.default.lte.max": "Default label count must not exceed maximum for this label type",
  "error.delete.msg": "Грешка при изтриване",
  "error.duplicate.calculationname": "Дублирано име на изчисление или грешка при запазване",
  "error.fetch.boxDetails": "Failed to fetch box details",
  "error.fetch.boxes": "Failed to fetch shipping boxes",
  "error.fetch.facilities": "Failed to fetch facilities",
  "error.fetch.unassignedSamples": "Failed to fetch unassigned samples",
  "error.field.required": "Това поле е задължително",
  "error.import.patient": "Грешка при импортиране на пациент в OpenELIS",
  "error.invalid.email": "Невалиден имейл",
  "error.invalidcredentials": "Потребителското име или паролата са грешни",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "Няма данни за пациент за импорт",
  "error.nonconform.report": "Моля, въведете стойност",
  "error.report.csv.date": "Моля, изберете тип дата.",
  "error.report.csv.study": "Моля, изберете тип проучване.",
  "error.report.status": "Грешка при генериране на отчета",
  "error.report.linkIncomplete": "The link does not say which {0} to open, so the report cannot be shown. Choose it from the report lists instead.",
  "error.report.linkIncomplete.title": "This report link is incomplete",
  "error.required.destination": "Destination facility is required",
  "error.results.loadFailed": "The results worklist could not be loaded",
  "error.results.loadFailed.detail": "This is not an empty worklist — the request failed, so any pending work here is not shown. Try again, and tell an administrator if it keeps failing.",
  "error.results.precision": "This test reports to {0} decimal place(s). Enter the value at that precision, or the record and the reported value will differ.",
  "error.results.staleSave": "This result was updated by {0} at {1} — refresh to see the latest value",
  "error.load.failed": "Could not load this list. Reload to try again.",
  "error.save.failed": "Failed to save",
  "error.save.msg": "Грешка при запазване",
  "error.save.order": "Error while saving order",
  "error.save.patient": "Грешка при запазване на пациент",
  "error.title": "Грешка",
  "errorBoundary.reload": "Презареди",
  "errorBoundary.route.patientResultsViewer.message": "Something went wrong while showing this patient's results. Reload to try again.",
  "errorBoundary.route.patientResultsViewer.title": "Patient results could not be loaded",
  "errorBoundary.route.resultsSearch.message": "Something went wrong on the results page. Reload to try again.",
  "errorBoundary.route.resultsSearch.title": "Results could not be loaded",
  "errorBoundary.route.orderEntry.message": "Something went wrong on the order entry page. Reload to try again.",
  "errorBoundary.route.orderEntry.title": "Order entry could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "Something went wrong on the sample entry page. Reload to try again.",
  "errorBoundary.route.samplePatientEntry.title": "Sample entry could not be loaded",
  "errorBoundary.route.storage.message": "Something went wrong on this page. Reload to try again, or use the menu to go elsewhere.",
  "errorBoundary.route.storage.title": "Storage could not be loaded",
  "errorBoundary.route.analyzers.message": "Something went wrong loading this page. Reload to try again.",
  "errorBoundary.route.analyzers.title": "Analyzer module could not be loaded",
  "errorBoundary.route.analyzerResults.message": "Something went wrong loading results. Reload to try again.",
  "errorBoundary.route.analyzerResults.title": "Analyzer results could not be loaded",
  "errors.no.sample": "Select the appropriate sample for each test.",
  "errors.requester.org.or.requestor.required": "Enter at least one of Requesting Organization or Requester contact.",
  "esig.button.certify": "Certify & Continue",
  "esig.button.reject": "Отхвърли",
  "esig.button.saveAndSign": "Запази",
  "esig.button.sign": "Sign",
  "esig.button.validate": "Валидирай",
  "esig.certification.acknowledge": "I have read and understand the above statement",
  "esig.certification.intro": "Before you can use electronic signatures, you must certify that your electronic signature is the legally binding equivalent of your handwritten signature.",
  "esig.error.disabled": "Electronic signatures are not enabled",
  "esig.error.generic": "An error occurred",
  "esig.error.invalidCredentials": "Invalid credentials",
  "esig.error.keycloakNotSupported": "Keycloak authentication is not yet supported for electronic signatures",
  "esig.error.loadingStatus": "Failed to load signature status",
  "esig.error.mustAcknowledge": "You must acknowledge the certification statement",
  "esig.error.passwordRequired": "Password is required",
  "esig.error.rejectionReasonRequired": "Rejection reason is required",
  "esig.error.title": "Грешка",
  "esig.error.usernameRequired": "Username is required",
  "esig.info.fullAuth": "This is your first signature in this session. Please enter your username and password to authenticate.",
  "esig.info.legalBinding": "By entering your credentials, you are creating a legally binding electronic signature per 21 CFR Part 11.",
  "esig.info.passwordOnly": "You have an active signing session. Enter your password to continue.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signature Meaning:",
  "esig.label.password": "Парола",
  "esig.label.rejectionReason": "Rejection Reason",
  "esig.label.signingAs": "Signing as: {userName}",
  "esig.label.username": "Потребителско име",
  "esig.meaning.authored": "Authored",
  "esig.meaning.modified": "Modified",
  "esig.meaning.rejected": "Rejected",
  "esig.meaning.validatedAndReleased": "Validated and Released",
  "esig.placeholder.password": "Enter your password to confirm",
  "esig.placeholder.rejectionReason": "Enter the reason for rejection",
  "esig.placeholder.username": "Enter your username",
  "esig.title.certification": "Electronic Signature Certification",
  "esig.title.signature": "Electronic Signature",
  "example": "Пример",
  "external.id": "Външен ID",
  "external.referrals.report": "Отчет за външни препращания",
  "externalReferredOutTests.title": "Отчет за външни препращания",
  "externalconnections.active": "Активен",
  "externalconnections.add.title": "Add External Connection",
  "externalconnections.authtype": "Authentication Type",
  "externalconnections.authtype.basic.password": "Парола",
  "externalconnections.authtype.basic.username": "Потребителско име",
  "externalconnections.browse.title": "External Connections",
  "externalconnections.deactivate.success": "External connection(s) deactivated successfully.",
  "externalconnections.description": "Описание",
  "externalconnections.edit.title": "Edit External Connection",
  "externalconnections.name": "Име",
  "externalconnections.name.placeholder": "Enter connection name",
  "externalconnections.programmedconnection": "Connection Type",
  "externalconnections.save.success": "External connection saved successfully.",
  "externalconnections.search": "Search external connections",
  "externalconnections.search.placeholder": "Search by name or type",
  "externalconnections.select": "Избор",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "e.g. https://server:port",
  "false.label": "Грешно",
  "field.active": "Активен/Неактивен",
  "field.ageRange": "Възрастов диапазон",
  "field.dictionaryValues": "Стойности в речника",
  "field.loinc": "Loinc",
  "field.name": "Име",
  "field.normalRange": "Нормални граници",
  "field.note": "Бележка",
  "field.orderable": "Поръчваем/Непоръчваем",
  "field.panel": "Панел",
  "field.referenceValue": "Референтна стойност",
  "field.reportName": "Име в отчета",
  "field.resultLimits": "Лимити на резултата",
  "field.resultType": "Тип резултат",
  "field.sampleType": "Тип проба",
  "field.select.testSection": "Избор на тестова секция",
  "field.selectValues": "Стойности за избор",
  "field.sex": "Пол",
  "field.significantDigits": "Значими цифри",
  "field.testSection": "Тестова секция",
  "field.testUnit": "Тестова единица",
  "field.uom": "Мерна единица",
  "field.validRange": "Валидни граници",
  "file.import.configuration.active": "Активен",
  "file.import.configuration.analyzer": "Анализатор",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Изберете анализатор",
  "file.import.configuration.cancel": "Отказ",
  "file.import.configuration.columnMappings": "Мапинги на колони",
  "file.import.configuration.columnMappings.helperText": "JSON мапинг на CSV колони към OpenELIS полета (напр. {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Разделител",
  "file.import.configuration.delimiter.helperText": "CSV разделител (по подразбиране: запетая)",
  "file.import.configuration.error.save": "Неуспешно запазване на конфигурацията за импорт",
  "file.import.configuration.error.unknown": "Възникна неизвестна грешка",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "Файлов шаблон",
  "file.import.configuration.filePattern.helperText": "Glob шаблон за намиране на файлове (напр. *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Има заглавен ред",
  "file.import.configuration.importDirectory": "Директория за импорт",
  "file.import.configuration.importDirectory.helperText": "Директория за наблюдение за нови файлове",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Запази",
  "file.import.configuration.success.created": "Конфигурацията за импорт на файлове е създадена успешно",
  "file.import.configuration.success.updated": "Конфигурацията за импорт на файлове е актуализирана успешно",
  "file.import.configuration.title.add": "Добавяне на конфигурация за импорт",
  "file.import.configuration.title.edit": "Редактиране на конфигурация за импорт",
  "file.import.configuration.validation.analyzerId.required": "Анализаторът е задължителен",
  "file.import.configuration.validation.columnMappings.invalid": "Невалиден JSON формат за мапинг на колони",
  "file.import.configuration.validation.importDirectory.required": "Директорията за импорт е задължителна",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Филтри",
  "freezer.alert.detail.acknowledge": "Потвърди",
  "freezer.alert.detail.acknowledgedAt": "Acknowledged At",
  "freezer.alert.detail.acknowledgedBy": "Acknowledged By",
  "freezer.alert.detail.acknowledgmentNotes": "Acknowledgment Notes",
  "freezer.alert.detail.actions": "Actions Taken",
  "freezer.alert.detail.close": "Затвори",
  "freezer.alert.detail.correctiveAction": "Corrective Action",
  "freezer.alert.detail.correctiveActionDescription": "Описание",
  "freezer.alert.detail.correctiveActionFailed": "Failed to log corrective action",
  "freezer.alert.detail.correctiveActionType": "Тип действие",
  "freezer.alert.detail.delete": "Delete Alert",
  "freezer.alert.detail.deleteConfirm": "Delete this alert permanently?",
  "freezer.alert.detail.deleteFailed": "Failed to delete alert",
  "freezer.alert.detail.deletePermanently": "Delete permanently",
  "freezer.alert.detail.deleteWarning": "The start time, severity, acknowledgment and notes are removed with no audit trail and cannot be recovered.",
  "freezer.alert.detail.freezer": "Freezer",
  "freezer.alert.detail.id": "Alert ID",
  "freezer.alert.detail.logCorrectiveAction": "Log corrective action",
  "freezer.alert.detail.message": "Съобщение",
  "freezer.alert.detail.method": "Method",
  "freezer.alert.detail.notes": "Бележки",
  "freezer.alert.detail.notesPlaceholder": "Add notes about this alert...",
  "freezer.alert.detail.notifications": "Notifications Sent",
  "freezer.alert.detail.overview": "Alert Overview",
  "freezer.alert.detail.recipient": "Recipient",
  "freezer.alert.detail.resolutionNotes": "Resolution Notes",
  "freezer.alert.detail.resolve": "Resolve",
  "freezer.alert.detail.resolvedAt": "Resolved At",
  "freezer.alert.detail.resolvedBy": "Resolved By",
  "freezer.alert.detail.sentAt": "Sent At",
  "freezer.alert.detail.severity": "Сериозност",
  "freezer.alert.detail.startTime": "Start Time",
  "freezer.alert.detail.status": "Статус",
  "freezer.alert.detail.summary": "Summary",
  "freezer.alert.detail.takenAt": "Taken At",
  "freezer.alert.detail.takenBy": "Taken By",
  "freezer.alert.detail.title": "Alert Details",
  "freezer.alert.severity.critical": "Критична",
  "freezer.alert.severity.warning": "Предупреждение",
  "freezer.alert.status.acknowledged": "Потвърдена",
  "freezer.alert.status.closed": "Closed",
  "freezer.alert.status.escalated": "Escalated",
  "freezer.alert.status.open": "Open",
  "freezer.alert.status.resolved": "Resolved",
  "freezer.nav.corrective": "Коригиращи действия",
  "freezer.nav.corrective.tooltip": "Управление на коригиращи действия",
  "freezer.nav.dashboard": "Табло",
  "freezer.nav.dashboard.tooltip": "Табло за мониторинг на хладилно съхранение",
  "freezer.nav.reports": "Отчети",
  "freezer.nav.reports.tooltip": "Генериране на отчети за хладилно съхранение",
  "freezer.nav.settings": "Настройки",
  "freezer.nav.settings.tooltip": "Конфигуриране на настройки за хладилно съхранение",
  "freezer.nav.trends": "Исторически трендове",
  "freezer.nav.trends.tooltip": "Преглед на температурните трендове във времето",
  "french.current": "Текущ ФРЕНСКИ",
  "french.label": "Френски",
  "from.title": "От",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.title": "Редактиране на проба",
  "genericSample.field.by": "От",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Дата",
  "genericSample.field.from": "От",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Получател в лаб.",
  "genericSample.field.project": "Проект",
  "genericSample.field.storageLocation": "Фризер и място за съхранение",
  "genericSample.field.type": "Тип",
  "genericSample.notebook.selection.title": "Избор на тетрадка (по избор)",
  "genericSample.order.error.labNoRequired": "Моля, генерирайте лабораторен номер преди запазване.",
  "genericSample.order.generateLabNo": "Генерирай лабораторен номер",
  "genericSample.order.labNo.placeholder": "Кликнете 'Генерирай лаб. номер'",
  "genericSample.order.success.details": "Подробности за пробата",
  "genericSample.order.success.message": "Поръчката е създадена успешно с номер: {accessionNumber}",
  "genericSample.order.title": "Приемане на проба",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Изчисти",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Запазване...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "ID",
  "header.assign": "Задай",
  "header.cancel.test": "Анулирай тест",
  "header.formname": "Име на форма",
  "header.icon.help": "Помощ",
  "header.icon.lang": "Language",
  "header.icon.menu.close": "Close menu",
  "header.icon.menu.open": "Open menu",
  "header.icon.menu.pin": "Pin menu",
  "header.icon.menu.unpin": "Unpin menu",
  "header.icon.notifications": "Notifications",
  "header.icon.search": "Търсене",
  "header.icon.user": "Потребител",
  "header.label.ARV": "ARV-начално",
  "header.label.EID": "Диагностика за деца с DBS-PCR",
  "header.label.changeLab": "Избор на лаборатория",
  "header.label.followup": "ARV-проследяване",
  "header.label.intialFollowup": "ARV --> Начално-Проследяване-VL",
  "header.label.logout": "Изход",
  "header.label.nonconformityByDate": "Отчет за несъответствия по дата",
  "header.label.selectLab": "Избор на лаборатория",
  "header.label.selectlocale": "Избор на локал",
  "header.label.specialRequest": "Специална заявка",
  "header.label.study.ciexport": "Експорт на CSV файл по дата",
  "header.label.study.vlloadtrends": "Отчет за експорт на данни за вирусен товар",
  "header.label.version": "Версия:",
  "header.reject": "Отхвърли",
  "header.rejection.reason": "Причина за отхвърляне",
  "header.results.recorded": "Записани резултати",
  "hide.aliquoting": "Скрий аликотирането",
  "holder.choose.availabletest": "Изберете наличен тест",
  "home.label": "Начало",
  "immunohistochemistry.label.addreport": "Добави отчет",
  "immunohistochemistry.label.averageChrom": "Средно Хромозома 17 сигнали на ядро",
  "immunohistochemistry.label.averageHer2": "Средно HER2 на ядро",
  "immunohistochemistry.label.cellIntensity": "интензитет. Allred резултат",
  "immunohistochemistry.label.cellPercent": "% клетки с ядрено оцветяване",
  "immunohistochemistry.label.dashboard": "Табло на имунохистохимия",
  "immunohistochemistry.label.her2Assesment": "Оценка на HER 2 протеин",
  "immunohistochemistry.label.her2Pattern": "CerbB2/HER 2 модел на оцветяване",
  "immunohistochemistry.label.her2ScoreOf": "с резултат",
  "immunohistochemistry.label.historicalDiagnosis": "Хистологична диагноза",
  "immunohistochemistry.label.ihcRatio": "Съотношение Her2/neu сигнали към Хромозома 17",
  "immunohistochemistry.label.ihcScore": "IHC (Cerb2 резултат)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Пролиферативен индекс): ",
  "immunohistochemistry.label.molecularType": " Молекулярен подтип",
  "immunohistochemistry.label.numberOfCancer": "Брой ракови ядра",
  "immunohistochemistry.label.outOf8": "от 8",
  "immunohistochemistry.label.report": "Отчет",
  "immunohistochemistry.label.reports": "Отчети",
  "immunohistochemistry.label.review": "Очаква преглед от имунохистохимия",
  "immunohistochemistry.label.title": "Имунохистохимия",
  "immunohistochemistry.label.tumorCells": "положителни туморни клетки (праг 20%)",
  "import.autoGenerated": "Автоматично генерирано",
  "import.created": "Създадено",
  "import.error.failed": "Импортът е неуспешен",
  "import.error.importFile": "Неуспешен импорт на файл",
  "import.error.selectFile": "Моля, първо изберете файл",
  "import.error.validateFile": "Неуспешна валидация на файл",
  "import.error.validateFirst": "Моля, първо валидирайте файла и коригирайте грешките",
  "import.error.validationFailed": "Валидацията е неуспешна. Вижте грешките по-долу.",
  "import.failed": "Импортът е неуспешен",
  "import.failedCount": "Неуспешни",
  "import.header.collectionDate": "Дата на вземане",
  "import.header.errorMessage": "Съобщение за грешка",
  "import.header.field": "Поле",
  "import.header.from": "От",
  "import.header.labNo": "Лаб. номер",
  "import.header.quantity": "Количество",
  "import.header.row": "Ред",
  "import.header.sampleType": "Тип проба",
  "import.header.samplesToCreate": "Проби за създаване",
  "import.importing": "Импортиране...",
  "import.invalidRows": "Невалидни редове",
  "import.selectFile": "Избор на файл",
  "import.status.invalid": "Невалиден",
  "import.status.valid": "Валиден",
  "import.success": "Импортът е успешен",
  "import.totalRows": "Общо редове",
  "import.totalSamplesToCreate": "Общо проби за създаване",
  "import.uploadFile": "Качи файл",
  "import.uploadFileDesc": "Качете CSV или Excel файл ({types})",
  "import.validRows": "Валидни редове",
  "import.validating": "Валидиране...",
  "import.validationStatus": "Статус на валидация",
  "input.error.same.panel.type": "Намерен е съществуващ панел със същото име.",
  "input.placeholder.labNo": "Въведете лабораторен номер",
  "input.placeholder.patientFirstName": "Въведете име на пациента",
  "input.placeholder.patientId": "Въведете ID на пациента",
  "input.placeholder.patientLastName": "Въведете фамилия на пациента",
  "input.placeholder.prevLabNumber": "Въведете предишен лаб. номер",
  "input.placeholder.providerEmail": "Въведете имейл на заявителя",
  "input.placeholder.providerFax": "Въведете факс на заявителя",
  "input.placeholder.providerWorkPhone": "Въведете телефон на заявителя",
  "input.placeholder.provisionalClinicalDiagnosis": "Въведете предварителна клинична диагноза",
  "input.placeholder.requesterFirstName": "Въведете име на заявителя",
  "input.placeholder.requesterLastName": "Въведете фамилия на заявителя",
  "input.placeholder.searchTestName": "Търсете име на тест тук",
  "input.placeholder.selectPanel": "Изберете тип панел",
  "input.placeholder.selectPriority": "Изберете приоритет",
  "input.placeholder.selectTest": "Изберете тип тест",
  "input.placeholder.selectTestSection": "Изберете тип звено",
  "instructions.copy.labnum": "Копирай лаб. номер",
  "instructions.order.entry.eqa.enabled": "When enabled, a checkbox will appear on the Order Entry screen allowing staff to mark a sample as an EQA (External Quality Assurance) sample. Patient demographics will be auto-populated with N/A and locked.",
  "instructions.order.entry.requester": "When enabled, Search Requester and Requester First Name and Requester Last Name become required fields on the Add Order screen. When disabled (default), all three fields are optional.",
  "instructions.test.activation": "Активни тестове: отметнатото квадратче показва вече активен тест.",
  "instructions.test.activation.confirm": "Проверете промените. Ако са правилни, запазете.",
  "instructions.test.activation.sort": "Подредба на дисплея: Сортирайте тестовете чрез влачене.",
  "instructions.test.order": "Тестовете с отметки могат да се поръчват.",
  "invalid.json": "JSON е невалиден",
  "inventory.add.button": "Добави нова партида",
  "inventory.addItem.button": "Добави каталожен елемент",
  "inventory.consume.error.noLots": "No stock available for {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "No QC-passed stock for {name} ({code}): {count} lot(s) with stock are awaiting QC. Mark QC as passed to use them.",
  "inventory.consume.error.noLotsQcFailed": "No usable stock for {name} ({code}): {count} lot(s) with stock failed QC",
  "inventory.consume.error.noLotsQuarantined": "No usable stock for {name} ({code}): {count} lot(s) with stock are quarantined",
  "inventory.dashboard.title": "Табло на инвентара",
  "inventory.export.button": "Експорт",
  "inventory.filter.all": "Всички",
  "inventory.filter.status": "Филтрирай по статус",
  "inventory.filter.type": "Филтрирай по тип",
  "inventory.itemType.CARTRIDGE": "Analyzer Cartridge",
  "inventory.itemType.HIV_KIT": "HIV Test Kit",
  "inventory.itemType.RDT": "RDT (Rapid Diagnostic Test)",
  "inventory.itemType.REAGENT": "Reagent",
  "inventory.itemType.SYPHILIS_KIT": "Syphilis Test Kit",
  "inventory.item.error.duplicateCode": "An inventory item with code \"{code}\" already exists.",
  "inventory.item.error.codeGenerationExhausted": "Could not find a free code for prefix \"{prefix}\". Enter a code manually.",
  "inventory.list.title": "Инвентарни елементи",
  "inventory.lot.error.duplicateBarcode": "Barcode \"{barcode}\" is already assigned to lot {lotNumber}",
  "inventory.lot.search.placeholder": "Search by item name, lot number or barcode",
  "inventory.metrics.expired": "С изтекъл срок",
  "inventory.metrics.expiringSoon": "Изтичащи скоро",
  "inventory.metrics.lowStock": "Ниска наличност",
  "inventory.metrics.totalLots": "Общо партиди",
  "inventory.tab.catalog": "Каталог",
  "inventory.tab.dashboard": "Табло",
  "inventory.tab.reports": "Отчети",
  "inventory.title": "Управление на инвентара",
  "label.action": "Действие",
  "labNumber.format.current": "Текущ формат",
  "labNumber.format.new": "Нов формат",
  "labNumber.prefix": "Префикс",
  "labNumber.type": "Тип лаб. номер",
  "labNumber.usePrefix": "Използвай префикс",
  "label.actions": "Действия",
  "label.active": "Активен",
  "label.actualTestName": "Действително име на теста",
  "label.add": "Добави",
  "label.add.notification": "Добави изскачащо известие за потребителя",
  "label.all": "Всички",
  "label.analysisNotStarted": "Анализът не е започнал",
  "label.any": "Всяко",
  "label.audittrail": "Лаб. номер",
  "label.audittrail.Reports": "Отчети за одитна следа",
  "label.audittrail.labNo.invalidaccessionnumber": "Невалиден номер на акцесия",
  "label.audittrail.labNo.missing": "Лаб. номер е задължителен!",
  "label.audittrailreport.nextvisitdate": "Следваща дата на посещение",
  "label.audittrailreport.priority": "Приоритет",
  "label.audittrailreport.program": "Програма",
  "label.audittrailreport.receiveddate": "Дата на получаване",
  "label.audittrailreport.requestdate": "Дата на заявка",
  "label.audittrailreport.requester": "Заявител",
  "label.audittrailreport.requester.firstname": "Име на заявителя",
  "label.audittrailreport.requester.lastname": "Фамилия на заявителя",
  "label.audittrailreport.sitename": "Име на обекта",
  "label.autoFilledFromServer": "Auto-filled from server",
  "label.barcode": "Баркод",
  "label.barcode.labelsets": "Брой комплекти етикети",
  "label.barcode.orderlabel": "Брой етикети за поръчка на комплект",
  "label.barcode.specimenlabel": "Брой етикети за проба на комплект",
  "label.barcode.totallabel": "Общо етикети за печат",
  "label.button.action": "Действие",
  "label.button.add": "Добави",
  "label.button.add.question": "Добави нов въпрос",
  "label.button.cancel": "Отказ",
  "label.button.close": "Затвори",
  "label.button.changepassword": "Промени парола",
  "label.button.clear": "Изчисти",
  "label.button.confirm": "Потвърди",
  "label.button.confirmAction": "Потвърди действие",
  "label.button.confirmDelete": "Потвърди изтриване",
  "label.button.confirmTitle": "Сигурни ли сте?",
  "label.button.delete": "Изтрий",
  "label.button.descritpion": "Описание",
  "label.button.edit": "Редактирай",
  "label.button.activate": "Активирай",
  "label.button.deactivate": "Деактивирай",
  "label.button.exit": "Изход",
  "label.button.externalsearch": "Външно търсене",
  "label.button.field": "Поле",
  "label.button.finish": "Край",
  "label.button.finished": "Завършено",
  "label.button.generatePrintableVersion": "Генерирай версия за печат",
  "label.button.import": "Импорт",
  "label.button.login": "Вход",
  "label.button.login.sso": "Единен вход (SSO)",
  "label.button.newEntry": "Нов запис",
  "label.button.ok": "Ок",
  "label.button.previous": "Предишен",
  "label.button.range": "Диапазон",
  "label.button.remove": "Премахни",
  "label.button.remove.block": "Премахни блок",
  "label.button.remove.report": "Премахни отчет",
  "label.button.remove.slide": "Премахни слайд",
  "label.button.reset": "Нулирай",
  "label.button.sample": "Проба",
  "label.button.save": "Запази",
  "label.button.saveconfig": "Save Configuration",
  "label.button.search": "Търсене",
  "label.button.select": "Избери",
  "label.button.select.pathologist": "Избери патолог",
  "label.button.select.status": "Избери статус",
  "label.button.select.technician": "Избери лаборант",
  "label.button.select.test": "Избери тест",
  "label.button.start": "Старт",
  "label.button.submit": "Изпрати",
  "label.button.update": "Update",
  "label.button.uploadfile": "Качи файл",
  "label.button.validate": "Валидирай",
  "label.button.viewReport": "Виж отчета",
  "label.cancel": "Отказ",
  "label.cancel.test.no.replace": "Анулирай теста за избраните лаб. номера, не задавай нов тест",
  "label.checkedWillBeModified": "Маркираните лаб. номера ще бъдат променени",
  "label.clear": "Изчисти филтрите",
  "label.content": "Label Content",
  "label.confirm": "Потвърди",
  "label.created.samples": "Създадени проби",
  "label.critical.range": "Критичен диапазон",
  "label.currentTest": "Текущ тест",
  "label.days": "days",
  "label.default.result": "Резултат по подразбиране",
  "label.delete": "Изтрий",
  "label.description": "Описание",
  "label.edit": "Редактиране",
  "label.electronic.orders": "Електронни поръчки",
  "label.equals": "равно на",
  "label.error": "Грешка",
  "label.existing.methods": "Съществуващи методи",
  "label.existing.test.sets": "Съществуващи комплекти тестове",
  "label.filters.mycases": "Моите случаи",
  "label.filters.status": "Статус",
  "label.field.required": "Това поле е задължително",
  "label.status": "Статус",
  "label.form.searchby": "Търсене по",
  "label.id": "ID",
  "label.import.errors": "Грешки при импорт",
  "label.inactive": "Неактивен",
  "label.inactive.methods": "Неактивни методи. Задайте тестове за активиране.",
  "label.includeInactiveTests": "Включи неактивни тестове",
  "label.inside.normalrange": "е в нормални граници",
  "label.lastPrinted": "Последно отпечатано: {date} {time} от {user}",
  "label.loading": "Зареждане...",
  "label.loinc": "LOINC",
  "label.management.title": "Управление на етикети",
  "label.no": "Не",
  "label.no.options.available": "No options available",
  "label.none": "None (no filter)",
  "label.notValidated": "Невалидиран",
  "label.notequals": "не е равно на",
  "label.order.labNrPrefix": "Lab Nr",
  "label.order.patientPrefix": "Пациент",
  "label.order.scan.text": "Сканирайте ИЛИ Въведете ръчно ИЛИ",
  "label.orderable": "Може да се поръчва",
  "label.outside.normalrange": "е извън нормални граници",
  "label.page.patientHistory": "История на пациента",
  "label.preview.data": "Преглед на данните",
  "label.print": "Печат на етикет",
  "label.print.error": "Грешка при генериране на етикет.",
  "label.print.error.popupBlocked": "Изскачащият прозорец е блокиран. Моля, разрешете изскачащи прозорци.",
  "label.print.openDirectly": "Open the labels in a new tab",
  "label.print.generating": "Генериране...",
  "label.print.success": "Етикетът е отпечатан успешно",
  "label.print.description": "Print labels for orders and samples",
  "label.print.helper": "Select the type and quantity of labels to print",
  "label.print.success.count": "{count} labels printed successfully",
  "label.print.title": "Print Labels",
  "label.printAll": "Print All Labels",
  "label.printAll.success": "All labels printed successfully",
  "label.printConfirmation.message": "Печат на етикет за {name}{code}?",
  "label.printConfirmation.title": "Печат на етикет",
  "label.printHistory": "История на печата",
  "label.printHistory.byUser": "От {user}",
  "label.printHistory.count": "{count} етикета",
  "label.printHistory.loading": "Зареждане на историята на печата...",
  "label.printHistory.never": "Никога не е печатан",
  "label.printHistory.unknownUser": "Неизвестен",
  "label.printHistory.viewAll": "Виж историята",
  "label.printLabel": "Печат на етикет",
  "label.program": "Програма",
  "label.qualifiers": "Квалификатори",
  "label.quantity": "Количество",
  "label.readonly": "Read Only",
  "label.reference.value": "Референтна стойност",
  "label.refertest.referencelab": "Препрати теста към референтна лаборатория",
  "label.rejectedByBiologist": "Отхвърлен от биолог",
  "label.rejectedByTechnician": "Отхвърлен от лаборант",
  "label.remove": "Премахни",
  "label.replaceWith": "Замени с",
  "label.report.byNationalId": "По национален ID / Уникален здравен номер",
  "label.reporting.range": "Диапазон за отчитане",
  "label.result.order": "Ред на резултата",
  "label.resultSelectList": "Списък за избор на резултат",
  "label.results.actions": "Действия",
  "label.results.anotherUser": "another user",
  "label.results.date": "Test date",
  "label.results.domain": "Clinical",
  "label.results.domain.env": "Water Quality",
  "label.results.domain.vector": "Vector Surveillance",
  "label.results.edit": "Редактиране",
  "label.results.inReviewBy": "In review by {0}",
  "label.results.labUnit": "Lab Unit",
  "label.results.load": "Load results",
  "label.results.loading": "Loading results...",
  "label.results.range": "Reference Range",
  "label.results.range.env": "Regulatory Limit",
  "label.results.range.vector": "Интерпретация",
  "label.results.reflexTriggered": "Reflex/calculated tests added for:",
  "label.results.refresh": "Refresh",
  "label.results.result": "Резултат",
  "label.results.resultFor": "Result for {0}",
  "label.results.retry": "Try again",
  "label.results.save": "Запази",
  "label.results.search": "Search by lab number",
  "label.results.searchByPatient": "Search by patient",
  "label.results.selectAnotherPatient": "Select another patient",
  "label.results.selectedPatient": "Selected patient",
  "label.results.selectedPatient.none": "Няма",
  "label.results.status": "Статус",
  "label.results.status.all": "Всички",
  "label.results.subject": "Sample / Patient",
  "label.results.subject.env": "Sample / Site",
  "label.results.subject.vector": "Sample / Trap",
  "label.results.table.caption": "Results worklist",
  "label.results.test": "Тест",
  "label.results.titer.placeholder": "e.g. 1:10",
  "label.results.method": "Method",
  "label.results.analyzer": "Анализатор",
  "label.results.analyzer.none": "Not from an instrument",
  "label.results.fromAnalyzer": "from analyzer",
  "label.results.methodAnalyzerHint": "Method is the analyzer type; Analyzer is the specific instrument.",
  "label.results.expandRow": "Expand row",
  "label.results.collapseRow": "Collapse row",
  "label.results.referredOut": "Referred out",
  "label.results.notes": "Бележки",
  "label.results.note.context": "Context",
  "label.results.note.context.entry": "Entry",
  "label.results.note.context.modification": "Modification",
  "label.results.note.context.auto": "Set automatically from what you are doing.",
  "label.results.note.visibility": "Visibility",
  "label.results.note.internal": "In lab only",
  "label.results.note.external": "Send with result",
  "label.results.note.analysisLevel": "Analysis-level",
  "label.results.note.externalWarning": "This note will appear on the patient report.",
  "label.results.note.placeholder": "Add a note…",
  "label.results.dilution.measured": "Measured value",
  "label.results.dilution.factor": "Dilution factor",
  "label.results.dilution.reported": "Reported value: {0}",
  "label.results.saveHint": "Saving records your e-signature. Critical acknowledgment never blocks Save.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Abnormal",
  "label.results.flag.critical": "Критична",
  "label.results.flag.invalid": "Невалиден",
  "label.results.sample": "Проба",
  "label.results.flag": "Flag",
  "label.results.order.clinician": "Ordering clinician",
  "label.results.order.phone": "Телефон",
  "label.results.order.site": "Requesting site",
  "label.results.order.priority": "Приоритет",
  "label.results.order.collection": "Collection",
  "label.results.section.program": "Program info",
  "label.results.program.name": "Програма",
  "label.results.program.eqa": "EQA",
  "label.results.program.readonly": "Program fields are read-only here — edit on the originating order.",
  "label.results.section.storage": "Storage & sample disposal",
  "label.results.storage.location": "Местоположение",
  "label.results.storage.position": "Позиция",
  "label.results.storage.notes": "Бележки",
  "label.results.storage.unassigned": "No storage assignment",
  "label.results.storage.assignLocation": "Задаване на местоположение",
  "label.results.storage.moveLocation": "Move to Location",
  "label.results.program.capturedData": "Programme data",
  "label.results.sampleStatus.title": "Sample status",
  "label.results.sampleStatus.volume": "Volume: {0} remaining of {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "available",
  "label.results.sampleStatus.usedUp": "used up (exhausted)",
  "label.results.sampleStatus.disposed": "disposed",
  "label.results.sampleStatus.recordUse": "Record amount used",
  "label.results.sampleStatus.markUsedUp": "Mark used up",
  "label.results.sampleStatus.startDisposal": "Start disposal",
  "label.results.sampleStatus.amountUsed": "Amount used this test",
  "label.results.sampleStatus.record": "Запиши",
  "label.results.sampleStatus.recordHint": "Decrements remaining volume — the sample is not disposed until exhausted or explicitly marked used up.",
  "label.results.sampleStatus.usedUpNote": "The sample is exhausted and queued for the disposal workflow. Disposal records who, when, and method.",
  "label.results.sampleStatus.disposalReason": "Disposal reason",
  "label.results.sampleStatus.disposalMethod": "Disposal method",
  "label.results.sampleStatus.disposalNotes": "Бележки",
  "label.results.sampleStatus.confirmDisposal": "Confirm disposal",
  "label.results.sampleStatus.reason.expired": "Изтекъл срок",
  "label.results.sampleStatus.reason.contaminated": "Contaminated",
  "label.results.sampleStatus.reason.patient_request": "Patient Request",
  "label.results.sampleStatus.reason.testing_complete": "Testing Complete",
  "label.results.sampleStatus.reason.other": "Друг",
  "label.results.sampleStatus.method.autoclave": "Biohazard Autoclave",
  "label.results.sampleStatus.method.neutralization": "Chemical Neutralization",
  "label.results.sampleStatus.method.incineration": "Incineration",
  "label.results.sampleStatus.method.other": "Друг",
  "label.results.sampleStatus.footnote": "Partial use records the amount consumed against the sample item's remaining volume; full exhaustion (or Mark used up) triggers disposal.",
  "label.results.section.reagents": "Reagents, QC & Controls",
  "label.results.reagents.summary.analyzer": "analyzer-reported lot",
  "label.results.reagents.summary.manual": "manual capture",
  "label.results.reagents.mode.analyzer": "capture mode: analyzer-reported",
  "label.results.reagents.mode.manual": "capture mode: manual (optional)",
  "label.results.reagents.analyzerNote": "Reported by {0} in its result payload — read-only.",
  "label.results.reagents.lotsUsed": "Reagent lots used",
  "label.results.reagents.noneLinked": "No reagents linked to this test — links are configured in the Test Catalog.",
  "label.results.reagents.noLots": "No available lots in inventory for this reagent.",
  "label.results.reagents.perTest": "{0} {1} per test",
  "label.results.reagents.fefo": "FEFO Suggested",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} remaining",
  "label.results.reagents.quantityUsed": "Quantity used",
  "label.results.reagents.recordUse": "Record use",
  "label.results.reagents.recorded": "Recorded {0} {1} — consumed FEFO across lots.",
  "label.results.reagents.recordFailed": "Could not record reagent use.",
  "label.results.reagents.amountInvalid": "Quantity used must be a positive number.",
  "label.results.reagents.consumeNote": "Recording use decrements inventory (FEFO) and writes a consumption transaction linked to this analysis.",
  "label.results.control.title": "Control result",
  "label.results.control.noneConfigured": "No control lots configured for this test and analyzer.",
  "label.results.control.viewResults": "View control results",
  "label.results.control.capture.controlLine": "Control line",
  "label.results.control.capture.valid": "Валиден",
  "label.results.control.capture.invalid": "Невалиден",
  "label.results.control.capture.kitLot": "Kit lot",
  "label.results.control.capture.outcome": "Outcome",
  "label.results.control.capture.lot": "Control lot",
  "label.results.control.capture.measured": "Measured value",
  "label.results.control.capture.expected": "Expected value",
  "label.results.control.capture.uncertainty": "Uncertainty (±)",
  "label.results.control.capture.record": "Record control result",
  "label.results.control.capture.recorded": "Control result recorded.",
  "label.results.control.capture.recordedBlocked": "Control result recorded. Reporting is blocked for covered results until a passing repeat is recorded.",
  "label.results.control.capture.blockedHint": "A failing control blocks reporting for covered results — a repeat run is expected.",
  "label.results.control.capture.noBenchLots": "No bench control lot is configured for this test — add one under QC → Control Lots before recording a quantitative control.",
  "label.results.control.capture.incomplete": "Complete the control result fields before recording.",
  "label.results.control.capture.failed": "Recording the control result failed.",
  "label.results.dilution.title": "Dilution",
  "label.results.section.attachments": "Прикачени файлове",
  "label.results.attachments.summary": "{0} file(s)",
  "label.results.attachments.none": "none",
  "label.results.attachments.empty": "No attachments on this order yet.",
  "label.results.attachments.add": "Add attachment",
  "label.results.attachments.tooLarge": "File exceeds the 10 MB limit.",
  "label.results.attachments.uploadFailed": "Upload failed — PDF, JPG, PNG, or TIFF up to 10 MB.",
  "label.results.attachments.resultsScope": "Резултати",
  "label.results.attachments.orderScope": "Order Entry",
  "label.results.attachments.view": "Преглед",
  "label.results.attachments.download": "Изтегли",
  "label.results.section.interpretation": "Интерпретация",
  "label.results.interpretation.summary": "enter via rule or free text",
  "label.results.interpretation.ruleFired": "rule fired ({0}) · auto-open",
  "label.results.interpretation.autoOpen": "rule fired · auto-open",
  "label.results.interpretation.ruleBanner": "Rule match (configured on the test): the entered value {0} falls in {1}. Pick a category to apply its interpretation text, then edit as needed.",
  "label.results.interpretation.match": "matches value",
  "label.results.interpretation.freeText": "Interpretation (free text)",
  "label.results.interpretation.footnote": "Interpretation can be set by a rule configured on the test (the categorical buckets, auto-matched to the value) or free text. Rule text is a non-binding suggestion until applied or edited. Saving sends it with the result to the report.",
  "label.results.nce.disposition": "Result disposition",
  "label.results.nce.disposition.hint": "Applied when the NCE is submitted. Refer-out is a separate row action, not a disposition.",
  "label.results.nce.disposition.none": "Няма",
  "label.results.nce.disposition.none.detail": "File the NCE without changing the result.",
  "label.results.nce.disposition.cancel": "Cancel result",
  "label.results.nce.disposition.cancel.detail": "Voided. No value reported. Common for pre-analytical NCEs.",
  "label.results.nce.disposition.reject": "Reject + reason",
  "label.results.nce.disposition.reject.detail": "Clears the value and records the reason. Applied by your e-signature Save.",
  "label.results.nce.disposition.retest": "Повторен тест",
  "label.results.nce.disposition.retest.detail": "Orders the same test again on this sample; the repeat appears as pending.",
  "label.results.nce.disposition.rejectArmed": "Rejection armed on the row — Save (e-signature) to apply it.",
  "label.results.nce.disposition.cancelled": "Result cancelled.",
  "label.results.nce.disposition.retested": "Retest ordered.",
  "label.results.critical.range": "Критична",
  "label.results.critical.banner.title": "Critical value — physician notification required",
  "label.results.critical.banner.body": "The responsible clinician must be notified. Acknowledgment is recorded on the Alerts dashboard and never blocks Save.",
  "label.results.critical.acknowledge": "I Acknowledge",
  "label.results.critical.acknowledged": "Потвърдена",
  "label.results.critical.comment": "Acknowledgment comment",
  "label.results.critical.comment.placeholder": "e.g. Physician notified by phone",
  "label.results.section.history": "History (this analysis)",
  "label.results.history.summary": "{0} events",
  "label.results.history.summary.unloaded": "revisions · status · retests",
  "label.results.history.when": "When",
  "label.results.history.event": "Event",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "От",
  "label.results.history.event.CREATED": "Създадено",
  "label.results.history.event.STATUS": "Статус",
  "label.results.history.event.RESULT": "Резултат",
  "label.results.history.event.NOTE": "Бележка",
  "label.results.history.event.RETEST": "Повторен тест",
  "label.results.history.event.REFLEX": "Reflex",
  "label.results.history.event.OTHER": "Event",
  "label.results.history.empty": "No recorded events yet for this analysis.",
  "label.results.history.footnote": "This analysis only — revisions, status transitions, retests, corrections, notes and audit entries. Patient trends live on the patient record; Westgard rules on the QC dashboard.",
  "label.results.nce.report": "Report Non-Conformity",
  "label.results.reject.result": "Reject result",
  "label.results.reject.reason": "Rejection reason",
  "label.results.reject.hint": "Saving with a rejection clears the value, records the reason, and marks the analysis Technical Rejected.",
  "label.results.referral.refer": "Refer this test",
  "label.results.referral.editing": "Referral pending — edit",
  "label.results.referral.organization": "Reference laboratory",
  "label.results.referral.reason": "Referral reason",
  "label.results.referral.date": "Referral date",
  "label.results.referral.reportDate": "Reference lab report date",
  "label.results.referral.reportDate.placeholder": "dd/mm/yyyy",
  "label.results.referral.hint": "The referral is recorded when you Save this row and hands off to the Referrals dashboard.",
  "label.results.referral.cancel": "Discard",
  "label.results.section.aliquots": "Аликоти",
  "label.results.aliquots.summary": "{0} aliquots",
  "label.results.aliquots.summary.unloaded": "list · create",
  "label.results.aliquots.labNo": "Лаб. номер",
  "label.results.aliquots.quantity": "Количество",
  "label.results.aliquots.createdDate": "Създадено",
  "label.results.aliquots.empty": "No aliquots yet for this sample item.",
  "label.results.aliquots.count": "Number of aliquots",
  "label.results.aliquots.totalQuantity": "Total quantity to transfer",
  "label.results.aliquots.notes": "Бележки",
  "label.results.aliquots.create": "Create aliquots",
  "label.results.aliquots.created": "Aliquots created.",
  "label.results.aliquots.failed": "Could not create aliquots.",
  "label.results.aliquots.remaining": "Parent remaining quantity",
  "label.results.history.event.REFERRAL": "Referred",
  "label.results.history.event.NCE": "Non-conformity",
  "label.results.referenceZone": "Reference & context",
  "label.results.layoutRemembered": "Layout remembered",
  "label.results.resetLayout": "Reset layout",
  "label.results.section.orderInfo": "Order info",
  "label.results.sampleType": "Sample type",
  "label.results.testDate": "Test date",
  "label.results.receivedDate": "Received",
  "label.results.technician": "Техник/Лаборант",
  "label.routine.Reports": "Рутинни отчети",
  "label.sample.types.activate": "Следните типове проби ще бъдат активирани:",
  "label.sample.types.deactivate": "Следните типове проби ще бъдат деактивирани, защото нямат тестове:",
  "label.save": "Запази",
  "label.saving": "Запазване...",
  "label.search.available.targetest": "Търсене на налични тестове",
  "label.search.availablepanel": "Търсене на наличен панел",
  "label.search.labno.family": "Търсене по лаб. номер или фамилия",
  "label.search.patient": "Търсене на пациент",
  "label.select": "Избор",
  "label.select.dateRange": "Изберете период за отчета",
  "label.select.list.options": "Опции на списъка за избор",
  "label.selectTestSectionCatalog": "Изберете тестова секция за преглед на каталога",
  "label.sex.dependent": "Зависи от пола",
  "label.shortCode": "Кратък код",
  "label.shortCode.error.invalidChars": "Краткият код може да съдържа само букви, цифри, тирета и долни черти",
  "label.shortCode.error.maxLength": "Краткият код трябва да е до 10 символа",
  "label.shortCode.error.network": "Неуспешна проверка за уникалност.",
  "label.shortCode.error.save": "Грешка при запазване на кратък код: {error}",
  "label.shortCode.error.startChar": "Краткият код трябва да започва с буква или цифра",
  "label.shortCode.helper": "Макс 10 символа, буквено-цифров, тире, долна черта",
  "label.shortCode.optional.helper": "Опционално (ще се използва кода, ако е ≤10 знака).",
  "label.shortCode.required.helper": "Задължително, когато кодът е > 10 символа.",
  "label.shortCode.update.success": "Краткият код е актуализиран успешно",
  "label.shortCodeRequired": "Краткият код е задължителен за печат на етикети. Моля, задайте го в формата за редактиране.",
  "label.shortCodeWarning": "Промяната на краткия код ще обезсили съществуващите етикети",
  "label.showChildren": "Покажи под-елементи",
  "label.study.Reports": "Отчети от проучвания",
  "label.test.activate": "Следните тестове ще бъдат активирани:",
  "label.test.add": "Добави тест към поръчка",
  "label.test.batch.cancel.finish": "Това е необратимо.",
  "label.test.batch.cancel.start": "Избрахте да анулирате теста",
  "label.test.batch.no.change.finish": "тестовете няма да бъдат променени.",
  "label.test.batch.replace.start": "Следните",
  "label.test.deactivate": "Следните тестове ще бъдат деактивирани:",
  "label.test.display.order": "Подредба на тестовете",
  "label.test.order.confirm": "Проверете: Разрешаване/забраняване поръчката на тестове",
  "label.test.orderable": "Следните тестове ще могат да се поръчват от формата.",
  "label.test.results": "Резултати от теста",
  "label.test.resultsData": "Данни от резултатите",
  "label.test.unorderable": "Следните тестове няма да могат да се поръчват от формата.",
  "label.testActivate": "Активиране на тест",
  "label.testName": "Имена на тестове",
  "label.text.generate": "генерирай",
  "label.total.tests": "Общо тестове",
  "label.type": "Label Type",
  "label.type.order": "Order Label",
  "label.type.pool": "Pool of {count} {animal}",
  "label.type.sample": "Sample Label",
  "label.unit": "Единица",
  "label.user.notestsection": "Текущият потребител няма зачислено звено. Свържете се с админ.",
  "label.validation.errors": "Грешки при валидация",
  "label.validation.results": "Резултати от валидация",
  "label.view": "Преглед",
  "label.viewtestCatalog": "Каталог на тестовете",
  "label.warning": "Предупреждение",
  "label.yes": "Да",
  "labno.alt.prefix.instruction": "Префикс за предварително отпечатани етикети (4 символа):",
  "labno.alt.prefix.note": "ЗАБЕЛЕЖКА: Ако този префикс е използван, номерацията ще продължи от последния генериран номер.",
  "labno.alt.prefix.use": "Използвай същия формат и набор от номера като при въвеждане на поръчка.",
  "language.select.label": "Български",
  "legend.search.availabletests": "Търсене в наличните тестове",
  "loading": "Зареждане...",
  "loading.boxes": "Loading boxes...",
  "loading.description": "Зареждане...",
  "location.collection.title": "Collection Location",
  "location.environmentalConditions": "Environmental Conditions",
  "location.environmentalConditions.placeholder": "e.g. 25°C, clear weather",
  "location.gps.error": "Unable to get location",
  "location.gps.getCurrent": "Get Current Location",
  "location.gps.getting": "Getting location...",
  "location.gps.latitude": "GPS Latitude",
  "location.gps.longitude": "GPS Longitude",
  "location.gps.notSupported": "Geolocation is not supported by your browser",
  "location.gps.permissionDenied": "Location permission denied",
  "location.gps.timeout": "Location request timed out",
  "location.gps.unavailable": "Location information unavailable",
  "location.helper": "Location hierarchy (Region / District / Town-Village) uses the existing system of Location structure. Environmental workflow profiles allow some rows to be unlabeled to provide simpler or shorter row sets for setup as required.",
  "location.requesterReference": "Requester Reference",
  "location.requesterReference.placeholder": "e.g. EPA Method 524.2",
  "location.select.placeholder": "Select {levelName}...",
  "location.siteDescription": "Collection Site Description",
  "location.siteDescription.placeholder": "e.g. Municipal water supply intake point",
  "locale.active": "Активен",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Display Name",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Статус",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Изпращане на данни за аликот:",
  "log.submitting.aliquot.data2": "Изпращане на данни за аликот (JSON):",
  "logging.management.apply": "Apply Log Level",
  "logging.management.description": "Change the backend logging level at runtime. This is useful for debugging issues without restarting the server. Changes take effect immediately but do not persist across server restarts.",
  "logging.management.label": "Logging Configuration",
  "logging.management.level": "Log Level",
  "logging.management.logger": "Logger Name",
  "logging.management.logger.helper": "e.g., org.openelisglobal, root",
  "logging.management.success": "Log level set to {level} for {logger}",
  "login.account.disabled": "Акаунтът е деактивиран",
  "login.account.locked": "Акаунтът е заключен",
  "login.complexity.message": "Паролата трябва: ",
  "login.complexity.message.1": "Да бъде поне 7 символа",
  "login.complexity.message.2": "Може да съдържа малки и големи букви или цифри",
  "login.complexity.message.3": "Трябва да съдържа поне един от следните символи: *, $, #, !",
  "login.complexity.message.4": "Не трябва да съдържа други символи",
  "login.complexity.new.message": "Новата парола трябва: ",
  "login.complexity.new.message.1": "Да не е същата като текущата",
  "login.error.account.disable": "Your account has been disabled. Please contact system administrator.",
  "login.error.password.current.incorrect": "The current password you entered is incorrect. Please try again.",
  "login.error.password.expired": "Your password has expired. Please contact system administrator.",
  "login.error.update.message": "Update password failed. Please try again.",
  "login.login.": "Повторете паролата",
  "login.login.current.password": "Текуща парола",
  "login.login.first": "Име",
  "login.login.last": "Фамилия",
  "login.login.name": "Потребителско име",
  "login.login.new.password": "Нова парола",
  "login.login.password": "Парола",
  "login.login.repeat.password": "Повторете паролата",
  "login.msg.password": "Парола",
  "login.msg.password.missing": "Паролата е задължителна",
  "login.msg.username": "Потребителско име",
  "login.msg.username.missing": "Потребителското име е задължително",
  "login.notice.message": "Забележка: Достъпът е само за оторизиран персонал.",
  "login.password.expired.date": "Дата на изтичане на паролата",
  "login.password.expired.date.placeholder": "(дд/мм/гггг)",
  "login.redirecting.sso": "Пренасочване към единен вход...",
  "login.subtitle": "Вход",
  "login.timeout": "Таймаут на потребителя (минути)",
  "login.timeout.placeholder": "Въведете в ms",
  "login.title": "Вход",
  "lot.barcode": "Баркод",
  "lot.barcode.assign": "This lot has no barcode yet. Enter one now; it is locked once saved.",
  "lot.barcode.hint": "Leave blank to generate one from the item code and lot number.",
  "lot.barcode.locked": "Barcode is locked once saved so printed labels keep working.",
  "lot.barcode.placeholder": "Leave blank to auto-generate",
  "lot.barcode.placeholder.assign": "Enter a barcode",
  "lot.calculatedExpiry": "Изчислено изтичане",
  "lot.currentQuantity": "Текущо количество",
  "lot.dateOpened": "Дата на отваряне",
  "lot.details.no.movements": "No movements recorded for this lot",
  "lot.details.no.transactions": "Няма записани транзакции за тази партида",
  "lot.details.no.usage": "Няма история на използване",
  "lot.details.section.basic": "Основна информация",
  "lot.details.section.dates": "Важни дати",
  "lot.details.section.movements": "Movement History",
  "lot.details.section.quantities": "Количества",
  "lot.details.section.storage": "Място за съхранение",
  "lot.details.section.transactions": "История на транзакциите",
  "lot.details.section.usage": "История на използване",
  "lot.details.tab.info": "Информация",
  "lot.details.tab.transactions": "Транзакции",
  "lot.details.tab.usage": "История на използване",
  "lot.details.title": "Подробности за партидата",
  "lot.details.view": "Виж подробности",
  "lot.expirationDate": "Дата на изтичане",
  "lot.form.title.add": "Приемане на нова инвентарна партида",
  "lot.form.title.edit": "Редактиране на инвентарна партида",
  "lot.initialQuantity": "Първоначално количество",
  "lot.label.print": "Print label",
  "lot.label.print.failed": "Could not generate the label. Please try again.",
  "lot.number": "Номер на партида",
  "lot.number.hint": "Stable identifier for this lot. Leave blank and we'll generate one from the item code and today's date.",
  "lot.number.placeholder": "Leave blank to auto-generate",
  "lot.qcStatus.FAILED": "Неуспешно",
  "lot.qcStatus.PASSED": "Успешно",
  "lot.qcStatus.PENDING": "Pending",
  "lot.qcStatus.QUARANTINED": "Quarantined",
  "lot.qcStatus.hint": "Lots stay unusable for testing until QC is marked Passed.",
  "lot.qcStatus": "QC статус",
  "lot.receiptDate": "Дата на получаване",
  "lot.save.error": "Грешка при запазване на партидата",
  "lot.save.error.locationAfterCreate": "The lot was created, but assigning its storage location failed. Press Save again to retry the assignment only, so the lot is not received twice. {reason}",
  "lot.save.success": "Партидата е запазена успешно",
  "lot.selectItem": "Избор на каталожен елемент",
  "lot.selectLocation": "Избор на място за съхранение",
  "lot.status": "Статус",
  "lot.status.ACTIVE": "Активен",
  "lot.status.CONSUMED": "Консумирана",
  "lot.status.DISPOSED": "Бракуван",
  "lot.status.EXPIRED": "Изтекъл срок",
  "lot.status.IN_USE": "В употреба",
  "lot.status.QUARANTINED": "Quarantined",
  "lot.storageLocation": "Място за съхранение",
  "manage.testing.algorithms.add.reflex.tests": "Управление на алгоритми и рефлексни тестове",
  "master.lists.page": "Страница с основни списъци",
  "master.lists.page.analyzer": "Меню Тест на анализатор",
  "master.lists.page.barcode": "Конфигурация на баркод",
  "master.lists.page.batchtest": "Групово пренасочване и анулиране",
  "master.lists.page.external.connections": "Меню Външни връзки",
  "master.lists.page.field": "Валидация на полета",
  "master.lists.page.list": "Списък плъгини",
  "master.lists.page.menu": "Конфигурация на меню",
  "master.lists.page.notification": "Известия за тестове",
  "master.lists.page.order.entry": "Конфигурация за поръчки",
  "master.lists.page.org": "Меню Организация",
  "master.lists.page.patient": "Конфигурация за пациенти",
  "master.lists.page.printed": "Печатни отчети",
  "master.lists.page.provider": "Доставчик",
  "master.lists.page.report.result": "Отчитане на резултати",
  "master.lists.page.result": "Въвеждане на резултати",
  "master.lists.page.site": "Информация за обекта",
  "master.lists.page.test.management": "Управление на тестове",
  "master.lists.page.user": "Управление на потребители",
  "master.lists.page.work.plan": "Конфигурация на работен план",
  "menu.accession.validation": "По поръчка",
  "menu.accession.validation.range": "По диапазон от номера",
  "menu.billing.active": "Меню Фактуриране активно",
  "menu.billing.address": "Фактуриране URL",
  "menu.billing.title": "Управление на меню Фактуриране",
  "menu.genericSample": "Обща проба",
  "menu.genericSample.edit": "Редактиране на поръчка",
  "menu.genericSample.import": "Импорт",
  "menu.genericSample.order": "Поръчка",
  "menu.global.title": "Глобално управление на менюта",
  "menu.label.filter": "Филтри: ",
  "menu.label.filter.active": "Само активни",
  "menu.label.filter.admin": "Само администратор",
  "menu.label.filter.role": "По роля в звено",
  "menu.nonconform.active": "Меню Несъответствия активно",
  "menu.nonconform.title": "Управление на меню Несъответствия",
  "menu.patient.active": "Меню Пациент активно",
  "menu.patient.title": "Управление на меню Пациент",
  "menu.results.range": "По диапазон номера",
  "menu.sidenav.active": "Странична навигация активна",
  "menu.study.active": "Меню Проучване активно",
  "menu.study.title": "Конфигурация на меню Проучване",
  "menu.validation.date": "По дата",
  "message.method.activation": "Този метод няма да бъде активен без зачислен тест.",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Секция за методи",
  "method.methodName": "Име на метода",
  "method.modal.add.heading": "Добави нов метод",
  "modal.add.method": "Добави нов метод",
  "move.back": "Премести назад",
  "move.to.aliquot": "Премести към аликот",
  "new.patient.label": "Нов пациент",
  "next.action.button": "Напред",
  "nextLabel.action.button": "Следващ етикет",
  "no.aliquots": "Няма налични аликоти",
  "no.analysis.found": "Няма намерени анализи",
  "no.data.found": "Няма намерени данни",
  "no.option": "Не",
  "noTestsFound.matching": "Няма намерени тестове за",
  "nonconform.add.new.date": "Добави нова дата",
  "nonconform.corrective.action": "Планирано или препоръчително коригиращо действие:",
  "nonconform.corrective.actionType": "Тип действие",
  "nonconform.corrective.comment": "Коментари",
  "nonconform.corrective.control": "Планирано коригиращо превантивно действие или паралелен контрол:",
  "nonconform.corrective.title": "Коригиращо действие при несъответствие",
  "nonconform.date.completed": "Дата на завършване",
  "nonconform.date.discussion.nce": "Дата на обсъждане със служители по NCE",
  "nonconform.date.event": "Дата на събитието",
  "nonconform.description.nce": "Описание на NCE",
  "nonconform.field.date": "NCE дата",
  "nonconform.field.reporting.data": "Дата на докладване",
  "nonconform.goToNceForm": "Към формуляр за докладване на NCE",
  "nonconform.lab.componenet.nce": "Лабораторен компонент, където е възникнал NCE",
  "nonconform.label.highseverity": "9 = много висока сериозност – изисква се незабавно действие",
  "nonconform.label.lowseverity": "1 = много ниска сериозност – не се изисква незабавно действие",
  "nonconform.label.prescibernamesite": "Име и обект на предписващия",
  "nonconform.label.proposed.action": "Предложено действие",
  "nonconform.label.reportingunit": "Докладващо звено",
  "nonconform.label.suspected.cause.nce": "Предполагаема причина за NCE",
  "nonconform.nce.concurrent.control.action": "едновременно контролно действие",
  "nonconform.nce.number": "NCE номер",
  "nonconform.nce.preventive.action": "превантивно действие",
  "nonconform.nce.resolution": "Резолюция на NCE",
  "nonconform.nce.resolution.description": "Ефективни ли бяха коригиращите действия и превантивните/едновременните контроли за решаване на несъответствието и предотвратяване на повторната му поява?",
  "nonconform.nce.turnaround.time": "Време за изпълнение",
  "nonconform.order.save.fail": "Запазването е неуспешно",
  "nonconform.order.save.success": "Запазването е успешно",
  "nonconform.person.reporting.different": "Име на лицето, докладващо NCE (ако е различно)",
  "nonconform.person.responsible": "Отговорно лице",
  "nonconform.report": "Докладване на несъответстващо събитие (NCE)",
  "nonconform.report.field.date": "Дата на доклада",
  "nonconform.severity.score": "Оценка на сериозността",
  "nonconform.view.comments": "Коментари",
  "nonconform.view.corrective.action.description": "Описание на коригиращото действие, което трябва да се предприеме",
  "nonconform.view.event.date": "Дата на събитието",
  "nonconform.view.event.description": "Описание на събитието",
  "nonconform.view.lab.component": "Лабораторен компонент",
  "nonconform.view.nce.category": "Категория на NCE",
  "nonconform.view.nce.likely.occur": "Колко вероятно е NCE да се повтори?",
  "nonconform.view.nce.severity": "Сериозност",
  "nonconform.view.nce.type": "Тип NCE",
  "nonconform.view.preventive.description": "Ако е приложимо, описание на превантивното или едновременното контролно действие",
  "nonconform.view.report": "Преглед на ново несъответстващо събитие",
  "nonconform.view.reporting.person": "Докладващо лице",
  "nonconform.view.severe.consequences": "Колко сериозни са последствията или въздействието на NCE?",
  "nonconform.view.specimen": "Проба(и)",
  "nce.attachment.dropzone": "Drag and drop files here or click to upload",
  "nce.attachment.error.maxFiles": "Maximum {maxFiles} files allowed",
  "nce.attachment.error.size": "File size exceeds maximum of {maxSize}",
  "nce.attachment.error.type": "File type not allowed. Accepted types: {types}",
  "nce.attachment.error.upload": "Error uploading file",
  "nce.attachment.files": "files",
  "nce.attachment.hint": "(Optional - max {maxFiles} files, 10MB each)",
  "nce.attachment.uploading": "Uploading...",
  "nce.category.administrative": "Administrative",
  "nce.category.analytical": "Analytical",
  "nce.category.postanalytical": "Post-analytical",
  "nce.category.preanalytical": "Pre-analytical",
  "nce.field.attachments": "Прикачени файлове",
  "nce.field.notes": "Бележки",
  "nce.field.description.placeholder": "Describe what happened, when it was detected, and any relevant context...",
  "nce.field.immediateAction": "Immediate Action Taken",
  "nce.field.immediateAction.placeholder": "What corrective steps were taken immediately...",
  "nce.field.linkedItems": "Linked Samples/Results",
  "nce.field.severity": "Сериозност",
  "nce.field.title": "Заглавие",
  "nce.field.title.placeholder": "Brief description of the event...",
  "nce.severity.critical": "Критична",
  "nce.severity.critical.description": "Patient safety risk, regulatory violation",
  "nce.severity.major": "Major",
  "nce.severity.major.description": "Significant quality or operational impact",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Limited impact, easily corrected",
  "nce.severity.low": "Low",
  "nce.severity.low.description": "Minimal impact, no corrective action required",
  "nce.status.open": "Open",
  "nce.status.underInvestigation": "Under Investigation",
  "nce.tree.empty": "No orders found. Search for a lab number to begin.",
  "nce.tree.loading": "Loading orders...",
  "nce.tree.order": "Поръчка",
  "nce.tree.search": "Filter by test or sample...",
  "nce.tree.selected": "{sampleCount} samples, {resultCount} results selected",
  "nce.trigger.order_cancellation": "Order cancellation may require NCE documentation",
  "nce.trigger.partial_sample_rejection": "Partial sample rejection requires NCE documentation",
  "nce.trigger.pathology_rejection": "Pathology case rejection may require NCE documentation",
  "nce.trigger.premature_disposal": "Premature disposal may require NCE documentation",
  "nce.trigger.qc_invalidation": "QC invalidation requires NCE documentation",
  "nce.trigger.referral_rejection": "Referral rejection requires NCE documentation",
  "nce.trigger.result_rejection_no_retest": "Result rejection without retest requires NCE documentation",
  "nce.trigger.result_rejection_retest": "Result rejection with retest may require NCE documentation",
  "nce.trigger.sample_rejection": "Sample rejection requires NCE documentation",
  "nce.trigger.test_cancel_no_results": "Test cancellation may require NCE documentation",
  "nce.trigger.test_cancel_with_results": "Test cancellation with results requires NCE documentation",
  "nce.type.calibration_failure": "Calibration failure",
  "nce.type.communication_failure": "Communication failure",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Documentation error",
  "nce.type.equipment_malfunction": "Equipment malfunction",
  "nce.type.labeling_error": "Labeling error",
  "nce.type.patient_id_mismatch": "Patient ID mismatch",
  "nce.type.policy_violation": "Policy violation",
  "nce.type.procedure_deviation": "Procedure deviation",
  "nce.type.qc_failure": "QC failure",
  "nce.type.reagent_issue": "Reagent issue",
  "nce.type.report_delay": "Report delay",
  "nce.type.report_distribution_error": "Report distribution error",
  "nce.type.requisition_incomplete": "Requisition incomplete",
  "nce.type.resource_shortage": "Resource shortage",
  "nce.type.result_interpretation_error": "Result interpretation error",
  "nce.type.sample_collection_error": "Sample collection error",
  "nce.type.staff_competency_issue": "Staff competency issue",
  "nce.type.storage_error": "Storage error",
  "nce.type.system_error": "System error",
  "nce.type.training_gap": "Training gap",
  "nce.type.transcription_error": "Transcription error",
  "nce.type.transport_issue": "Transport issue",
  "nce.type.request_form_error": "Request form error",
  "nce.type.equipment_failure": "Equipment failure",
  "nce.type.procedure_error": "Procedure error",
  "nce.type.calibration_error": "Calibration error",
  "nce.type.cross_contamination": "Cross-contamination",
  "nce.type.result_transcription_error": "Result transcription error",
  "nce.type.report_delivery_error": "Report delivery error",
  "nce.type.critical_value_not_reported": "Critical value not reported",
  "nce.type.delayed_result": "Delayed result",
  "nce.type.result_amendment": "Result amendment",
  "nce.type.training_issue": "Training issue",
  "nce.button.createNce": "Create NCE",
  "nce.button.skip": "Skip",
  "nce.creating": "Creating NCE...",
  "nce.description.placeholder": "Describe the non-conforming event...",
  "nce.error.create.failed": "Failed to create NCE",
  "nce.error.severity.required": "Severity is required",
  "nce.trigger.mandatory.message": "You must create an NCE before proceeding with this action.",
  "nce.trigger.mandatory.title": "NCE Required",
  "nce.trigger.order_cancellation.message": "Order cancellation may require documentation of a non-conforming event.",
  "nce.trigger.order_cancellation.title": "Order Cancellation - NCE",
  "nce.trigger.partial_sample_rejection.message": "Partial sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.partial_sample_rejection.title": "Partial Sample Rejection - NCE Required",
  "nce.trigger.pathology_rejection.message": "Pathology case rejection may require documentation of a non-conforming event.",
  "nce.trigger.pathology_rejection.title": "Pathology Rejection - NCE",
  "nce.trigger.premature_disposal.message": "Premature disposal may require documentation of a non-conforming event.",
  "nce.trigger.premature_disposal.title": "Premature Disposal - NCE",
  "nce.trigger.qc_invalidation.message": "QC invalidation requires documentation of a non-conforming event.",
  "nce.trigger.qc_invalidation.title": "QC Invalidation - NCE Required",
  "nce.trigger.referral_rejection.message": "Referral rejection requires documentation of a non-conforming event.",
  "nce.trigger.referral_rejection.title": "Referral Rejection - NCE Required",
  "nce.trigger.result_rejection_no_retest.message": "Result rejection without retest requires documentation of a non-conforming event.",
  "nce.trigger.result_rejection_no_retest.title": "Result Rejection - NCE Required",
  "nce.trigger.result_rejection_retest.message": "Result rejection with retest may require documentation of a non-conforming event.",
  "nce.trigger.result_rejection_retest.title": "Result Rejection - NCE",
  "nce.trigger.sample_rejection.message": "Sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.sample_rejection.title": "Sample Rejection - NCE Required",
  "nce.trigger.test_cancel_no_results.message": "Test cancellation may require documentation of a non-conforming event.",
  "nce.trigger.test_cancel_no_results.title": "Test Cancellation - NCE",
  "nce.trigger.test_cancel_with_results.message": "Test cancellation with existing results requires documentation of a non-conforming event.",
  "nce.trigger.test_cancel_with_results.title": "Test Cancellation - NCE Required",
  "nce.admin.trigger.config.title": "NCE Trigger Configuration",
  "nce.admin.trigger.config.description": "Configure when Non-Conforming Events are automatically created or prompted.",
  "nce.admin.trigger.behaviors.title": "Trigger Behaviors",
  "nce.admin.rejection.mappings.title": "Rejection Reason Mappings",
  "nce.admin.rejection.mappings.description": "Map rejection reasons to NCE categories for automatic population.",
  "nce.trigger.behavior.mandatory": "Mandatory",
  "nce.trigger.behavior.prompted": "Prompted",
  "nce.trigger.behavior.disabled": "Disabled",
  "nce.trigger.column.type": "Trigger Type",
  "nce.trigger.column.description": "Описание",
  "nce.trigger.column.behavior": "Behavior",
  "nce.trigger.column.active": "Активен",
  "nce.trigger.type.sampleRejection": "Sample Rejection",
  "nce.trigger.type.resultRejection": "Result Rejection",
  "nce.trigger.type.qaEvent": "QA Event",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Trigger configuration updated",
  "nce.trigger.update.error": "Failed to update trigger configuration",
  "nce.mapping.add": "Add Mapping",
  "nce.mapping.edit": "Edit Mapping",
  "nce.mapping.column.rejectionReason": "Rejection Reason",
  "nce.mapping.column.category": "Категория на NCE",
  "nce.mapping.column.type": "Тип NCE",
  "nce.mapping.column.severity": "Default Severity",
  "nce.mapping.column.active": "Активен",
  "nce.mapping.noData": "No rejection mappings configured",
  "nce.mapping.validation.error": "Rejection reason and category are required",
  "nce.mapping.save.success": "Mapping saved successfully",
  "nce.mapping.active": "Активен",
  "nce.field.category": "Категория",
  "nce.field.type": "Тип",
  "nce.select.category": "Select a category",
  "nce.select.type": "Select a type",
  "nce.error.dateOfEvent.required": "Date of event is required",
  "nce.error.reportingUnit.required": "Reporting unit is required",
  "nce.error.description.required": "Description is required",
  "nce.error.suspectedCauses.required": "Suspected causes are required",
  "nce.error.proposedAction.required": "Proposed action is required",
  "nce.error.category.required": "Category is required",
  "nce.attachment.saveFirst": "Save the NCE event to enable file attachments",
  "nce.attachment.error.noEvent": "Please save the NCE event first before uploading attachments",
  "nce.attachment.download": "Изтегли",
  "nce.attachment.delete": "Изтрий",
  "requester.add.new.restricted": "Adding a new organization has been disabled by your administrator.",
  "requester.add.new.restricted.organization.contact": "Entering contact info for a new organization has been disabled by your administrator. Search for an existing organization above.",
  "requester.add.new.restricted.provider": "Adding a new provider has been disabled by your administrator.",
  "requester.add.new.restricted.provider.contact": "Entering contact info for a new provider has been disabled by your administrator. Search for an existing provider above.",
  "requester.add.new.restricted.requestor": "Adding a new requestor has been disabled by your administrator. Search for an existing requestor above.",
  "requester.contact.search": "Requestor Search",
  "requester.contact.search.helper": "Search for the contact person requesting these tests, or enter a new one below. At least one of Requesting Organization or Requestor is required.",
  "requester.organization.add.new": "+ Add new organization \"{name}\"",
  "requester.organization.email": "Organization Email",
  "requester.organization.fax": "Organization Fax",
  "requester.organization.new.helper": "Will be created as a new organization when this order is saved.",
  "requester.organization.new.tag": "New",
  "requester.organization.no.match": "No matching organization found.",
  "requester.organization.phone": "Organization Phone",
  "requester.organization.search": "Requesting Organization Search",
  "requestor.add.new": "+ Add new requestor \"{name}\"",
  "requestor.add.new.restricted": "Adding a new requestor has been disabled by your administrator.",
  "requestor.department": "Department",
  "requestor.email": "Имейл",
  "requestor.fax": "Факс",
  "requestor.firstName": "Име",
  "requestor.lastName": "Фамилия",
  "requestor.name": "Requestor Name",
  "requestor.name.placeholder": "Enter requestor name",
  "requestor.new.helper": "Will be created as a new requestor when this order is saved.",
  "requestor.new.tag": "New",
  "requestor.no.match": "No matching requestor found.",
  "requestor.phone": "Телефон",
  "requestor.search.helper": "Type at least 2 characters to auto-search.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "All lots",
  "result.pool.filter.allPools": "All pools",
  "result.pool.filter.clear": "Clear filter",
  "result.pool.filter.count": "Showing {shown} of {total} results",
  "result.pool.filter.lot": "Filter by lot",
  "result.pool.filter.pool": "Filter by pool",
  "result.pool.intake": "Intake pool",
  "result.pool.subpool": "Sub-pool {n}",
  "result.vectorPool.label": "Pool of {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Uncertainty must be a non-negative number.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Проба",
  "sample.priority.ASAP": "ASAP",
  "sample.priority.FUTURE_STAT": "Future STAT",
  "sample.priority.ROUTINE": "Рутинни",
  "sample.priority.STAT": "STAT (Urgent)",
  "sample.priority.TIMED": "Timed",
  "sample.referToReferenceLab.helper": "Mark if this sample requires testing at an external reference laboratory.",
  "sampleAcceptance.action.moveDown": "Move down",
  "sampleAcceptance.action.moveUp": "Move up",
  "sampleAcceptance.banner.resampledFrom": "This is a replacement created by a resample of sample #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Replacement sample",
  "sampleAcceptance.banner.resampledTo": "This sample was rejected and resampled. Replacement order: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Resampled",
  "sampleAcceptance.button.addItem": "Add item",
  "sampleAcceptance.col.active": "Активен",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Поръчка",
  "sampleAcceptance.col.statusForDomain": "Status for this domain",
  "sampleAcceptance.domain.all": "All domains",
  "sampleAcceptance.domain.clinical": "Clinical",
  "sampleAcceptance.domain.environmental": "Environmental",
  "sampleAcceptance.domain.vector": "Vector",
  "sampleAcceptance.enforcement.help": "Enforcement is set per domain, not per lab unit — a reception clerk spans many lab units.",
  "sampleAcceptance.enforcement.label": "Checklist enforcement — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Mandatory — block Step 3 until complete",
  "sampleAcceptance.enforcement.off": "Off — hide the checklist",
  "sampleAcceptance.enforcement.optional": "Optional — record but don't block",
  "sampleAcceptance.gate.blocked": "Intake acceptance is mandatory for this domain — accept every specimen (or report an NCE / resample) before this order can proceed.",
  "sampleAcceptance.labWide.heading": "Lab-wide items (apply unless a domain overrides)",
  "sampleAcceptance.labWide.inherited": "Lab-wide items — inherited (active fallback)",
  "sampleAcceptance.labWide.superseded": "Lab-wide items — superseded here (edit from “All domains”)",
  "sampleAcceptance.notify.enforcementSaved": "Enforcement updated",
  "sampleAcceptance.notify.itemAdded": "Checklist item added",
  "sampleAcceptance.notify.itemSaved": "Checklist item saved",
  "sampleAcceptance.notify.recordFailed": "Failed to record acceptance",
  "sampleAcceptance.notify.rejectFailed": "Failed to reject",
  "sampleAcceptance.notify.resampleFailed": "Failed to resample",
  "sampleAcceptance.ownItems.empty": "No items yet — this domain falls back to the lab-wide list below.",
  "sampleAcceptance.ownItems.heading": "{domain} items",
  "sampleAcceptance.qa.accepted.success": "Acceptance recorded",
  "sampleAcceptance.qa.answer.fail": "Fail",
  "sampleAcceptance.qa.answer.na": "Няма информация",
  "sampleAcceptance.qa.answer.pass": "Pass",
  "sampleAcceptance.qa.button.accept": "Accept sample",
  "sampleAcceptance.qa.button.reject": "Отхвърли",
  "sampleAcceptance.qa.button.resample": "Resample",
  "sampleAcceptance.qa.context.collected": "Collected",
  "sampleAcceptance.qa.context.longTransit": "long transit — your call",
  "sampleAcceptance.qa.context.note": "Transit is shown for reference only — it does not auto-grade anything. Active list: {domain}.",
  "sampleAcceptance.qa.context.received": "Received",
  "sampleAcceptance.qa.context.transit": "Transit time",
  "sampleAcceptance.qa.empty": "No acceptance checklist is configured for this domain.",
  "sampleAcceptance.qa.failHint": "This sample has failed checks — report an NCE or resample instead of accepting.",
  "sampleAcceptance.qa.noSample": "Save collection to run intake acceptance for this specimen.",
  "sampleAcceptance.qa.note.label": "Note (optional)",
  "sampleAcceptance.qa.note.placeholder": "Optional — note any observed condition",
  "sampleAcceptance.qa.status.accepted": "Accepted",
  "sampleAcceptance.qa.status.pending": "Pending",
  "sampleAcceptance.qa.status.rejected": "Rejected",
  "sampleAcceptance.qa.status.review": "Review",
  "sampleAcceptance.qa.subtitle": "Complete the acceptance checklist for this sample",
  "sampleAcceptance.qa.subtitle.rejected": "This specimen was rejected and resampled — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "This catch was rejected — read-only.",
  "sampleAcceptance.qa.title": "Intake acceptance",
  "sampleAcceptance.reject.commit": "Commit reject",
  "sampleAcceptance.reject.info": "Reject this catch as unusable. This cannot be re-collected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.reject.reason.required": "A reason is required",
  "sampleAcceptance.reject.success": "Sample rejected.",
  "sampleAcceptance.reject.title": "Reject — {labNumber}",
  "sampleAcceptance.resample.commit": "Commit resample",
  "sampleAcceptance.resample.info": "Reject this sample and create a new collection order for re-collection. The requester will be notified.",
  "sampleAcceptance.resample.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.resample.reason.required": "A reason is required",
  "sampleAcceptance.resample.success": "Resample created — new order {accession}. Requester notified.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Eligibility",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Sample type",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "No collected specimens to review yet.",
  "sampleAcceptance.review.subtitle": "Select a sample to complete its acceptance checklist",
  "sampleAcceptance.review.title": "Intake Acceptance",
  "sampleAcceptance.status.active": "Активен",
  "sampleAcceptance.status.inactive": "Неактивен",
  "sampleAcceptance.status.inheritedActive": "Active (inherited)",
  "sampleAcceptance.status.superseded": "Superseded",
  "sampleAcceptance.title": "Sample Acceptance Checklist",
  "sidenav.label.admin.nceTriggerConfig": "Trigger Configuration",
  "sidenav.label.admin.nceCategoryType": "Categories & Types",
  "sidenav.label.admin.nceConfig": "NCE Configuration",
  "nce.admin.categorytype.title": "NCE Categories & Types Configuration",
  "nce.admin.categorytype.description": "Manage the categories and types available for Non-Conforming Events.",
  "nce.admin.tab.categories": "Categories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Add Category",
  "nce.admin.category.edit": "Edit Category",
  "nce.admin.category.name.required": "Category name is required",
  "nce.admin.category.save.success": "Category saved successfully",
  "nce.admin.category.save.error": "Failed to save category",
  "nce.admin.type.add": "Add Type",
  "nce.admin.type.edit": "Edit Type",
  "nce.admin.type.validation.error": "Type name and category are required",
  "nce.admin.type.save.success": "Type saved successfully",
  "nce.admin.type.save.error": "Failed to save type",
  "nce.admin.column.name": "Име",
  "nce.admin.column.displayKey": "Display Key",
  "nce.admin.column.typesCount": "Types Count",
  "nce.admin.column.category": "Категория",
  "nce.admin.column.actions": "Действия",
  "nce.admin.field.name": "Име",
  "nce.admin.field.displayKey": "Display Key (for i18n)",
  "nce.admin.field.displayKey.helper": "Optional. Used for translations.",
  "nce.admin.field.category": "Категория",
  "nce.admin.delete.confirm.title": "Потвърди изтриването",
  "nce.admin.delete.confirm.message": "Are you sure you want to delete '{name}'? This action cannot be undone.",
  "nce.admin.delete.success": "Deleted successfully",
  "nce.inline.title": "Report Non-Conformity Event",
  "nce.inline.context": "CONTEXT (Auto-populated)",
  "nce.dashboard.title": "All NCEs",
  "nce.dashboard.subtitle": "All open NCEs across the laboratory",
  "nce.button.reportNce": "Report NCE",
  "nce.search.placeholder": "Search NCEs...",
  "nce.filter.allStatus": "All Status",
  "nce.filter.allCategories": "All Categories",
  "nce.filter.allSeverities": "Всички нива",
  "nce.filter.clearAll": "Clear All",
  "nce.summary.critical": "Критична",
  "nce.summary.major": "Major",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Overdue",
  "nce.tag.overdue": "Overdue",
  "nce.tab.eventDetails": "Event Details",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "History",
  "nce.field.suspectedCauses": "Suspected Causes",
  "nce.field.proposedAction": "Предложено действие",
  "nce.field.trigger": "Trigger",
  "nce.capReason.time_24h": "{count} samples linked — capped at 24h window",
  "nce.capReason.count_50": "{count} samples linked — capped at 50 most recent",
  "nce.capa.noItems": "No corrective/preventive actions recorded yet.",
  "nce.capa.dueDate": "Due Date",
  "nce.history.noItems": "No history available.",
  "nce.history.system": "System",
  "nce.action.acknowledge": "Потвърди",
  "nce.action.assignTo": "Assign To",
  "nce.action.addNote": "Add Note",
  "nce.action.close": "Close NCE",
  "nce.action.startCorrectiveAction": "Start Corrective Action",
  "nce.link.duplicate.warning": "These specimens are already linked to this NCE",
  "nce.list.empty": "No NCEs found matching your criteria.",
  "nce.modal.addNote": "Add Note",
  "nce.modal.addNoteDescription": "Add a note to NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Enter your note...",
  "nce.modal.assign": "Assign NCE",
  "nce.modal.assignDescription": "Assign NCE {nceNumber} to a user",
  "nce.modal.selectUser": "Select User",
  "nce.modal.searchUser": "Search for a user...",
  "nce.assign.selectUser": "Please select a user to assign",
  "nce.assign.success": "NCE assigned successfully",
  "nce.assign.error": "Failed to assign NCE",
  "nce.acknowledge.success": "NCE acknowledged successfully",
  "nce.acknowledge.error": "Failed to acknowledge NCE",
  "nce.note.empty": "Please enter a note",
  "nce.note.success": "Note added successfully",
  "nce.note.error": "Failed to add note",
  "nce.attachment.downloadError": "Failed to download attachment",
  "nce.attachment.viewError": "Failed to view attachment",
  "not.available": "Няма информация",
  "not.specified": "Не е указано",
  "notAuthenticated": "Не е удостоверено",
  "notebook.attachments.title": "Прикачени файлове",
  "notebook.attachments.uploadPrompt": "кликнете за качване на файлове",
  "notebook.auditTrail.action.archived": "Архивирано",
  "notebook.auditTrail.action.created": "Създадено",
  "notebook.auditTrail.action.finalized": "Финализирано",
  "notebook.auditTrail.action.locked": "Заключено",
  "notebook.auditTrail.action.submitted": "Изпратено",
  "notebook.auditTrail.action.updated": "Актуализирано",
  "notebook.auditTrail.comingSoon": "Функционалността за одитна следа ще бъде налична скоро.",
  "notebook.auditTrail.none.subtitle": "Не са намерени записи в одитната следа за този бележник.",
  "notebook.auditTrail.none.title": "Няма налична одитна следа",
  "notebook.auditTrail.title": "Одитна следа",
  "notebook.button.edit": "Редактиране",
  "notebook.button.editResults": "Редактиране на резултати",
  "notebook.button.enterResults": "Въвеждане на резултати",
  "notebook.button.newLabNotebook": "Проект",
  "notebook.button.view": "Преглед",
  "notebook.comments.add.button": "Добавяне на коментар",
  "notebook.comments.add.label": "Добавете коментар",
  "notebook.comments.none.subtitle": "Все още не са добавени коментари.",
  "notebook.comments.none.title": "Няма коментари",
  "notebook.comments.title": "Коментари",
  "notebook.error.notAssigned": "Не сте зачислен към този проект",
  "notebook.heading.allEntries": "Всички записи",
  "notebook.heading.notebooks": "Проекти",
  "notebook.icon.edit": "Редактиране",
  "notebook.instruments.title": "Инструменти",
  "notebook.label.addpage": "Добавяне на страница",
  "notebook.label.author": "Автор",
  "notebook.label.basicinfo": "Основна информация",
  "notebook.label.content": "Основно съдържание",
  "notebook.label.dashboard": "Табло на бележника",
  "notebook.label.drafts": "Чернови",
  "notebook.label.entry": "Notebook Entry",
  "notebook.label.entryFiles": "Файлове към записа",
  "notebook.label.instanceEntry": "Notebook Instance Entry",
  "notebook.label.entryTags": "Тагове към записа",
  "notebook.label.experimentDoc": "Документация на експеримента",
  "notebook.label.experimentType": "Тип експеримент",
  "notebook.label.filter.types": "Типове експерименти",
  "notebook.label.finalized": "Финализирани тази седмица",
  "notebook.label.formEntry": "Въвеждане във формуляр на бележника",
  "notebook.label.objective": "Цел",
  "notebook.label.pages": "Страници на работния процес",
  "notebook.label.pending": "Очаква преглед",
  "notebook.label.project": "Проект",
  "notebook.label.project.title": "Заглавие на проекта",
  "notebook.label.projectFiles": "Файлове на проекта",
  "notebook.label.projectTags": "Тагове на проекта",
  "notebook.label.protocol": "Протокол ID",
  "notebook.label.questionnaire": "Въпросник",
  "notebook.label.sampleManagement": "Управление на проби",
  "notebook.label.status": "Статус",
  "notebook.label.technician": "Техник/Лаборант",
  "notebook.label.title": "Заглавие на записа",
  "notebook.label.total": "Общо записи",
  "notebook.page.completed": "Завършено",
  "notebook.page.content": "Съдържание:",
  "notebook.page.instructions": "Инструкции:",
  "notebook.page.markComplete": "Маркирай като завършено",
  "notebook.page.modal.add.errorRequired": "Заглавието и съдържанието са задължителни.",
  "notebook.page.modal.add.title": "Добавяне на нова страница",
  "notebook.page.modal.content.label": "Съдържание",
  "notebook.page.modal.edit.title": "Редактиране на страница",
  "notebook.page.modal.instructions.label": "Инструкции",
  "notebook.page.modal.title.label": "Заглавие",
  "notebook.page.title": "Бележник",
  "notebook.pages.none.subtitle": "Кликнете за добавяне на страници",
  "notebook.pages.none.title": "Няма добавени страници",
  "notebook.project.definition.form.title": "Формуляр за дефиниране на проект",
  "notebook.project.entry.form.title": "Формуляр за запис в проект",
  "notebook.results.modal.title": "Резултати за {accession}",
  "notebook.results.noAccession": "Няма наличен номер на акцесия за тази проба",
  "notebook.results.none.subtitle": "Не са намерени резултати за предоставения номер на акцесия.",
  "notebook.results.none.title": "Няма намерени резултати",
  "notebook.results.title": "Резултати",
  "notebook.sample.result.dateCreated": "Дата на създаване",
  "notebook.samples.available": "Налични проби",
  "notebook.samples.none.subtitle": "Търсене на проби по пациент или номер на акцесия",
  "notebook.samples.none.subtitle.selected": "Кликнете за добавяне на проби",
  "notebook.samples.none.title": "Няма налични проби",
  "notebook.samples.none.title.selected": "Няма избрани проби",
  "notebook.samples.resultsRecorded": "Записани резултати:",
  "notebook.samples.selected": "Избрани проби",
  "notebook.search.byAccession": "Търсене по акцесия",
  "notebook.search.byPatient": "Търсене по пациент",
  "notebook.select.label": "Избор на бележник",
  "notebook.status.archived": "Архивирай записа",
  "notebook.status.assignment.title": "Статус и зачисляване",
  "notebook.status.draft": "Запази чернова",
  "notebook.status.finalized": "Финализирай записа",
  "notebook.status.locked": "Заключи записа",
  "notebook.status.metadata.title": "Статус и метаданни",
  "notebook.status.submitted": "Изпрати за преглед",
  "notebook.tab.attachments": "Прикачени файлове",
  "notebook.tab.auditTrail": "Одитна следа",
  "notebook.tab.comments": "Коментари",
  "notebook.tab.content": "Съдържание",
  "notebook.tab.entryDetails": "Подробности за записа",
  "notebook.tab.metadata": "Метаданни",
  "notebook.tab.results": "Резултати",
  "notebook.tab.samples": "Проби",
  "notebook.tab.workflow": "Работен процес",
  "notebook.table.header.entries": "Записи",
  "notebook.tag.placeholder": "Въведете тагове",
  "notebook.tags.add": "Добавяне на таг",
  "notebook.tags.modal.add.errorRequired": "Тагът е задължителен.",
  "notebook.tags.modal.add.label": "Таг",
  "notebook.tags.modal.add.title": "Добавяне на нов таг",
  "notebook.tags.title": "Тагове",
  "notebook.validation.content.required": "Основното съдържание е задължително.",
  "notebook.validation.objective.required": "Целта е задължителна.",
  "notebook.validation.project.required": "Проектът е задължителен.",
  "notebook.validation.protocol.required": "ID на протокола е задължителен.",
  "notebook.validation.title.required": "Заглавието е задължително.",
  "notebook.validation.type.required": "Типът експеримент е задължителен.",
  "notification.error": "Грешка",
  "notification.info": "Информация",
  "notification.invalid.confirm.password": "Въведената парола не съвпада с горната парола.",
  "notification.invalid.loginName": "Моля, въвеждайте само буквено-цифрови стойности без интервали.",
  "notification.invalid.name": "Моля, въвеждайте само буквено-цифрови стойности.",
  "notification.invalid.password": "Моля, въведете парола според инструкциите.",
  "notification.login.generic.error": "Грешка при опит за влизане",
  "notification.login.syntax.error": "Грешка при опит за влизане – невъзможност за парсване на отговора към JSON",
  "notification.organization.post.delete.success": "Организацията е деактивирана успешно.",
  "notification.organization.post.internetAddress": "Въведете валиден URL адрес на организацията.",
  "notification.organization.post.save.success": "Информацията за организацията е добавена успешно.",
  "notification.organization.post.success": "Информацията за организацията е актуализирана успешно.",
  "notification.password.change.fail": "Промяната на паролата не бе успешна",
  "notification.password.change.success": "Паролата бе променена успешно",
  "notification.response.syntax.error": "Грешка – невъзможност за парсване на отговора към JSON",
  "notification.resultSelectList.post.save.success": "Result select list saved successfully.",
  "notification.resultSelectList.post.update.success": "Result select list updated successfully.",
  "notification.slideover.button.hideread": "Скрий прочетените",
  "notification.slideover.button.markallasread": "Маркирай всички като прочетени",
  "notification.slideover.button.markasread": "Маркирай като прочетено",
  "notification.slideover.button.reload": "Презареди",
  "notification.slideover.button.showread": "Покажи прочетените",
  "notification.slideover.button.subscribe": "Абонирай се на това устройство",
  "notification.slideover.button.subscribe.fail": "Абонирането не бе успешно",
  "notification.slideover.button.subscribe.success": "Абонирането бе успешно",
  "notification.slideover.button.unsubscribe": "Откажи абонамента",
  "notification.slideover.button.unsubscribe.fail": "Отказът от абонамент не бе успешен",
  "notification.slideover.button.unsubscribe.success": "Абонаментът бе отказан успешно",
  "notification.slideover.empty.header": "Всичко е прегледано",
  "notification.sliderover.empty.message": "В момента нямате нови известия.",
  "notification.success": "Успех",
  "notification.title": "Известие",
  "notification.user.add.success": "User information added successfully.",
  "notification.user.post.delete.success": "Потребителят е деактивиран успешно.",
  "notification.user.post.save.success": "Потребителската информация е добавена успешно.",
  "notification.user.update.success": "User information updated successfully.",
  "notify.error": "Потребителят и съобщението са задължителни",
  "notify.main.title": "Известяване на потребител",
  "notify.message": "Съобщение",
  "notify.user.by": "Потребител, който да бъде известен",
  "notify.user.success.notification": "Известието е изпратено успешно",
  "of": "от",
  "openreports.activity.title": "Отчети за дейността",
  "openreports.aggregate.title": "Обобщени отчети",
  "openreports.all.test.summary.title": "Обобщен отчет за тестове",
  "openreports.all.tests.aggregate": "Резюме на всички тестове",
  "openreports.hiv.aggregate": "Резюме на HIV тестове",
  "openreports.management.title": "Управленски отчети",
  "openreports.mgt.nonconformity.date": "Отчет за несъответствия по дата",
  "openreports.mgt.nonconformity.section": "Отчет за несъответствия по звено и причина",
  "openreports.mgt.rejection": "Отчет за отхвърляне",
  "openreports.patient.EID.version1": "EID Версия 1",
  "openreports.patient.EID.version2": "EID Версия 2",
  "openreports.patient.VL.version1": "VL Национална версия",
  "openreports.patientTestStatus": "Отчет за статус на пациент",
  "openreports.patientreports.title": "Отчет за статус на пациент",
  "openreports.stat.aggregate": "Статистически отчет",
  "order.accept": "Приеми",
  "order.accept.error": "Failed to accept order",
  "order.additionalInfo": "Допълнителна информация",
  "order.additionalInfo.helper": "Optional notes about this order",
  "order.clinicalInfo": "Clinical Information",
  "order.continue": "Continue",
  "order.current.time": "Текущо време (чч:мм)",
  "order.dashboard.empty": "No orders found",
  "order.dashboard.title": "Order Dashboard",
  "order.department.label": "отделение/сектор/звено:",
  "order.diagnosis.helper": "Working diagnosis — guides test selection. Not recorded as a confirmed diagnosis.",
  "order.diagnosis.placeholder": "Enter diagnosis or clinical notes",
  "order.entry.setup": "Настройка за групово въвеждане на поръчки",
  "order.external": "External",
  "order.facility": "Лечебно заведение",
  "order.filter.priority": "Filter by Priority",
  "order.filter.status": "Филтриране по статус",
  "order.fixIssue": "Fix Issue",
  "order.form.label": "Формуляр:",
  "order.form.select": "Избор на формуляр",
  "order.generate.barcode": "Генериране на баркод и запазване",
  "order.generate.barcode.history": "Предишно използван номер на акцесия",
  "order.if.other.label": "ако е друго, посочете:",
  "order.invalid.requester.name.label": "невалидно име на заявител",
  "order.invalid.site.name": "Невалидно име на обекта",
  "order.labNumber": "Лабораторен номер",
  "order.labNumber.generate": "Генерирай лабораторен номер",
  "order.labNumber.helper": "Unique identifier for this order",
  "order.attachment.action.delete": "Delete attachment",
  "order.attachment.action.download": "Download attachment",
  "order.attachment.action.view": "View attachment",
  "order.attachment.column.actions": "Действия",
  "order.attachment.column.fileName": "File name",
  "order.attachment.column.fileSize": "Size",
  "order.attachment.column.fileType": "Тип",
  "order.attachment.column.uploadedAt": "Uploaded at",
  "order.attachment.delete.confirm.body": "Are you sure you want to delete \"{fileName}\"? This cannot be undone.",
  "order.attachment.delete.confirm.title": "Delete attachment",
  "order.attachment.delete.failed": "Could not delete the attachment. Please try again.",
  "order.attachment.dropzone": "Drag and drop files here, or click to browse",
  "order.attachment.empty": "No attachments yet.",
  "order.attachment.error.maxFiles": "You can attach at most {maxFiles} files.",
  "order.attachment.error.size": "Each file must be {maxSize} or smaller.",
  "order.attachment.error.type": "Allowed file types: {types}",
  "order.attachment.heading": "Прикачени файлове",
  "order.attachment.hint": "Optional. Up to {maxFiles} files, 10MB each. Allowed: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "One or more attachments could not be uploaded.",
  "order.labNumber.placeholder": "Enter or generate lab number",
  "order.label.add": "Добавяне на поръчка",
  "order.label.modify": "Промяна на поръчка",
  "order.legend.EDTATube": "EDTA епруветка",
  "order.legend.commonFields": "Общи полета",
  "order.legend.configureBarcode": "Конфигуриране на въвеждане с баркод",
  "order.legend.dryBloodSpot": "Сухо кръвно петно (DBS)",
  "order.legend.dryTube": "Суха епруветка",
  "order.legend.facility": "Лечебно заведение",
  "order.legend.onDemand": "При поискване",
  "order.legend.optionalFields": "Незадължителни полета",
  "order.legend.patient": "Инфо за пациента",
  "order.legend.preDemand": "Предварително отпечатани",
  "order.legend.sample": "Проба",
  "order.legend.selectMethod": "Избор на метод",
  "order.legend.siteName": "Име на обекта",
  "order.legend.specimen.collected": "Взета проба",
  "order.legend.tests": "Тестове",
  "order.legend.viralLoadTest": "Тест за вирусен товар",
  "order.lastUpdated": "Last Updated",
  "order.load.error": "Failed to load order",
  "order.location": "Местоположение",
  "order.new": "New Order",
  "order.payment.status.label": "Платежен статус на пациента:",
  "order.paymentStatus": "Payment Status",
  "order.previousLabNumber": "Предишен лабораторен номер",
  "order.previousLabNumber.placeholder": "Enter previous lab number if applicable",
  "order.printLabels": "Print Labels",
  "order.printLabels.info": "Print barcodes for this order",
  "order.priority": "Приоритет",
  "order.progress": "Прогрес",
  "order.provisionalDiagnosis": "Provisional Diagnosis",
  "order.received.time": "Време на получаване (чч:мм)",
  "order.reception.time": "Време на приемане (чч:мм):",
  "order.remember.site.and.requester.label": "Remember site and requester",
  "order.readonly.message": "This order is in read-only mode",
  "order.requester": "Заявител",
  "order.requester.email.label": "Имейл на заявителя:",
  "order.requester.fax.label": "Факс на заявителя:",
  "order.requester.firstName.label": "Име на заявителя:",
  "order.requester.lastName.label": "Фамилия на заявителя:",
  "order.requester.phone.label": "Телефон на заявителя:",
  "order.requester.provisionalDiagnosis.label": "Предварителна клинична диагноза:",
  "order.result.reporting.heading": "ОТЧИТАНЕ НА РЕЗУЛТАТИ",
  "order.sampleCategory": "Sample Category",
  "order.sampleCategory.helper": "Select the category of sample to collect",
  "order.sampling.performed.label": "Вземане на проби, извършено за анализ:",
  "order.search.requester.label": "Търсене на заявител",
  "order.saveStatus.error": "Запазването е неуспешно",
  "order.saveStatus.saved": "Saved",
  "order.saveStatus.saving": "Запазване...",
  "order.saveStatus.unsaved": "Unsaved changes",
  "order.save.blocked": "The order was not saved",
  "order.save.notPersisted": "The server accepted the order but stored no samples for it. Check the order before continuing.",
  "order.save.incomplete": "Please add a patient (or sampling site) and at least one sample type before saving.",
  "order.save.incomplete.fields": "Add {fields} before saving.",
  "order.save.incomplete.and": "and",
  "order.save.requirement.labNumber": "a lab number",
  "order.save.requirement.patient": "a patient",
  "order.save.requirement.samplingSite": "a sampling site",
  "order.save.requirement.collectionSite": "a collection site",
  "order.save.requirement.sampleType": "at least one sample type",
  "order.save.requirement.site": "a requesting site",
  "order.requestDate": "Дата на поръчка",
  "order.nextVisitDate": "Следваща дата на посещение",
  "order.sampleHandling": "Sample Handling",
  "sampleAcceptance.qa.button.continueWithTesting": "Continue with testing",
  "sampleAcceptance.qa.continueWithTesting.reason": "Why is this sample being tested despite the failed check?",
  "sampleAcceptance.qa.continueWithTesting.record": "Record and continue",
  "order.eqaSample": "External quality assessment (EQA) sample",
  "order.noPatient": "This order has no patient",
  "order.noPatient.reason": "Reason for ordering without a patient",
  "order.noPatient.reason.eqa": "External quality assessment sample",
  "order.noPatient.warning.title": "Results will not be evaluated against a reference range",
  "order.noPatient.warning.subtitle": "Without a patient there is no age or sex to select a reference range from, so results on this order will not be flagged normal or abnormal.",
  "order.noPatient.butPatientChosen": "A patient is attached to this order, so the no-patient decision will not be recorded.",
  "order.eqa.program": "EQA Programme",
  "order.eqa.providerSampleId": "Provider Sample ID",
  "order.eqa.deadline": "Submission Deadline",
  "order.eqa.priority": "EQA Priority",
  "order.rememberSiteAndRequester": "Remember this site and requester for my next order",
  "order.testLocationCode": "Sampling Performed At",
  "order.testLocationCode.other": "Друг",
  "order.testLocationCode.otherLabel": "If other, specify",
  "provider.fax.invalid": "Enter a valid fax number, digits and + ( ) - only.",
  "provider.email.invalid": "Enter a valid email address, for example lab@example.org.",
  "order.save.requirement.provider": "a requesting provider",
  "order.save.requirement.testsPerSample": "at least one test or panel on every sample",
  "order.saved.draft": "Draft saved",
  "order.saved.title": "Order {labNumber} saved",
  "order.saved.next": "Next: {step}",
  "order.search.placeholder": "Search orders...",
  "order.search.site.name": "Търсене на име на обект",
  "order.send.toAnalyzer": "Send to analyzer",
  "order.send.modal.title": "Send order to analyzer",
  "order.send.modal.confirm": "Изпрати",
  "order.send.modal.cancel": "Отказ",
  "order.send.modal.analyzerLabel": "Target analyzer",
  "order.send.modal.accession": "Order accession: {accession}",
  "order.send.modal.noAnalyzers": "No analyzers are configured for LIS-initiated dispatch.",
  "order.send.success": "Order dispatched",
  "order.send.error": "Failed to dispatch order",
  "order.send.unknownError": "Unknown bridge error",
  "order.send.missingAccession": "Order has no accession number to correlate the result.",
  "order.site.name": "Име на обекта:",
  "order.step.collect": "Collect",
  "order.step.complete": "Завършено",
  "order.step.enter": "Въведи поръчка",
  "order.step.label": "Label & Store",
  "order.step.patient.info": "Инфо за пациента",
  "order.step.program.selection": "Избор на програма",
  "order.step.qa": "QA Review",
  "order.start.new": "Start New Order",
  "order.submit.labNumber": "Submit with Lab Number",
  "order.submit.success": "Order submitted successfully",
  "order.submitted.success.msg": "Order has been submitted successfully",
  "order.summary.accessionNumber": "Номер на акцесия",
  "order.summary.collectionDate": "Дата на вземане",
  "order.summary.patientName": "Име на пациента",
  "order.summary.sampleType": "Тип проба",
  "order.summary.title": "Order Summary",
  "order.test.request.heading": "Заявка за тест",
  "order.title": "ПОРЪЧКА",
  "ordertests.title": "Поръчване на тестове",
  "organization.add.placeholder": "Буквено-цифрови стойности",
  "organization.add.placeholder.active": "Y или N",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Организация майка",
  "organization.add.title": "Добавяне на организация",
  "organization.city": "Град",
  "organization.clia.number": "CLIA номер",
  "organization.edit.title": "Редактиране на организация",
  "organization.internetaddress": "Интернет адрес",
  "organization.isActive": "Е активна",
  "organization.main.title": "Управление на организации",
  "organization.next": "Следваща страница",
  "organization.organizationName": "Име на орг.",
  "organization.parent": "Орг. майка",
  "organization.previous": "Предишна страница",
  "organization.search.byorgname": "Търсене по име на орг.",
  "organization.search.parent.name": "Имена на организации майки",
  "organization.search.placeHolder": "Търсене по име на орг...",
  "organization.select": "Избор",
  "organization.short.CI": "Префикс на орг.",
  "organization.streetAddress": "Адрес (улица)",
  "organization.type.CI": "Тип дейност",
  "organization.type.CI.description": "Тип дейност: Описание",
  "organization.type.CI.name": "Тип дейност: Име",
  "organization.type.CI.select": "Тип дейност: Избор",
  "otherMalignant.placeholder": "Друго злокачествено",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Назад",
  "pagination.backward": "Предишна страница",
  "pagination.forward": "Следваща страница",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} от {total} елемента",
  "pagination.items-on-page": "{count} {count, plural, one {item} other {items}} on this page",
  "pagination.items-per-page": "Елемента на страница",
  "pagination.itemsPerPage": "Елемента на страница:",
  "pagination.nextPage": "Следваща страница",
  "pagination.page": "страница {page}",
  "pagination.page-number": "Номер на страница",
  "pagination.page-range": "от {total} {total, plural, one {страница} other {страници}}",
  "pagination.previousPage": "Предишна страница",
  "panel.existing": "Съществуващи панели",
  "panel.existing.inactive": "Неактивни панели (зачислете тестове за активиране)",
  "panel.new": "Нов панел",
  "panel.panelName": "Име на панела",
  "pathology.label.addblock": "Добавяне на блок(ове)",
  "pathology.label.addslide": "Добавяне на предметно стъкло(а)",
  "pathology.label.block": "Блок",
  "pathology.label.block.add.number": "Брой блокове за добавяне",
  "pathology.label.block.number": "Номер на блока",
  "pathology.label.blocks": "Блокове",
  "pathology.label.casesInProgress": "Случаи в ход",
  "pathology.label.complete": "Завършено",
  "pathology.label.conclusion": "Заключение",
  "pathology.label.dashboard": "Табло на патологията",
  "pathology.label.grossexam": "Макроскопско изследване",
  "pathology.label.location": "Местоположение",
  "pathology.label.microexam": "Микроскопско изследване",
  "pathology.label.printlabel": "Печат на етикет",
  "pathology.label.refer": "Препращане към имунохистохимия",
  "pathology.label.release": "Готово за издаване",
  "pathology.label.report": "Патологоанатомичен отчет",
  "pathology.label.request": "Заявки",
  "pathology.label.requests": "Допълнителни патологоанатомични заявки",
  "pathology.label.review": "Очаква патологоанатомичен преглед",
  "pathology.label.slide": "Предметно стъкло",
  "pathology.label.slide.add.number": "Брой стъкла за добавяне",
  "pathology.label.slide.number": "номер на стъкло",
  "pathology.label.slides": "Предметни стъкла",
  "pathology.label.stage": "Етап",
  "pathology.label.techniques": "Използвани техники",
  "pathology.label.textconclusion": "Текстово заключение",
  "pathology.label.title": "Патология",
  "pathology.label.view": "Преглед на файл",
  "pathology.stage.accessioned": "Accessioned",
  "pathology.stage.completed": "Завършен",
  "pathology.stage.coverslipping": "Coverslipping & QC",
  "pathology.stage.decalcification": "Decalcification",
  "pathology.stage.embedding": "Embedding",
  "pathology.stage.grossing": "Grossing",
  "pathology.stage.microtomy": "Microtomy",
  "pathology.stage.processing": "Processing",
  "pathology.stage.readyPathologist": "Ready for Pathologist",
  "pathology.stage.staining": "Staining",
  "pathology.stage.underReview": "Under Pathologist Review",
  "patient.address.camp": "Лагер/Община",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "Здравен район",
  "patient.address.healthregion": "Здравен регион",
  "patient.address.province": "Province",
  "patient.address.street": "Улица",
  "patient.address.town": "Град/Населено място",
  "patient.age.days": "Дни",
  "patient.age.months": "Месеци",
  "patient.age.years": "Възраст/Години",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Име на източника на данни",
  "patient.dob": "Дата на раждане",
  "patient.eduction": "Образование",
  "patient.emergency.additional.camp": "Въведете лагер/община",
  "patient.emergency.additional.district": "Въведете район",
  "patient.emergency.additional.education": "Въведете образование",
  "patient.emergency.additional.maritalstatus": "Въведете семейно положение",
  "patient.emergency.additional.nationnality": "Въведете националност",
  "patient.emergency.additional.othernationality": "Въведете друга националност",
  "patient.emergency.additional.region": "Въведете регион",
  "patient.emergency.additional.street": "Въведете улица",
  "patient.emergency.additional.town": "Въведете град",
  "patient.emergency.email": "Въведете имейл на лице за контакт при спешни случаи",
  "patient.emergency.firstname": "Въведете име на лице за контакт при спешни случаи",
  "patient.emergency.lastname": "Въведете фамилия на лице за контакт при спешни случаи",
  "patient.emergency.phone": "Въведете телефон на лице за контакт при спешни случаи",
  "patient.externalId": "Външен ID",
  "patient.female": "Жена",
  "patient.first.name": "Име",
  "patient.gender": "Пол",
  "patient.gps.latitude": "GPS Latitude",
  "patient.gps.latitude.placeholder": "e.g., -18.879190 (range -90 to 90)",
  "patient.gps.longitude": "GPS Longitude",
  "patient.gps.longitude.placeholder": "e.g., 47.507905 (range -180 to 180)",
  "patient.id": "ID на пациент",
  "patient.information.age": "Въведете възраст",
  "patient.information.days": "Въведете дни",
  "patient.information.email": "Enter Patient Email",
  "patient.information.firstname": "Въведете име на пациента",
  "patient.information.healthid": "Въведете уникален здравен идентификатор",
  "patient.information.lastname": "Въведете фамилия на пациента",
  "patient.information.months": "Въведете месеци",
  "patient.information.nationalid": "Въведете национален идентификатор",
  "patient.information.primaryphone": "Въведете основен телефон на пациента",
  "patient.label": "Пациент",
  "patient.label.additionalInfo": "Допълнителна информация",
  "patient.label.age": "Възраст",
  "patient.label.customNotes": "Custom Notes",
  "patient.label.diseaseProgramme": "Target Disease Programme",
  "patient.label.occupation": "Occupation",
  "patient.label.contactphone": "Телефон за контакт: {PHONE_FORMAT}",
  "patient.label.email": "Имейл",
  "patient.label.info": "Информация за пациента",
  "patient.label.modify": "Добавяне или промяна на пациент",
  "patient.label.name": "Име",
  "patient.label.nopatientid": "Няма налична информация за пациента",
  "patient.label.primaryphone": "Основен телефон: {PHONE_FORMAT}",
  "patient.label.sex": "Пол",
  "patient.last.name": "Фамилия",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Мъж",
  "patient.maritalstatus": "Семейно положение",
  "patient.merge.activeOrders": "Активни поръчки",
  "patient.merge.address": "Адрес",
  "patient.merge.addressesDiffer": "Адресът е различен: {primary} срещу {secondary}",
  "patient.merge.auditEntries": "Одитни записи (ще запазят оригиналния пациент)",
  "patient.merge.back": "Назад",
  "patient.merge.cancelButton": "Отказ",
  "patient.merge.clinicalSummary": "Клинично резюме",
  "patient.merge.confirmButton": "Потвърди обединяването",
  "patient.merge.confirmCheckbox": "Разбирам, че това действие е необратимо и потвърждавам, че избраните пациенти са правилни",
  "patient.merge.confirmMerge": "Потвърждение на обединяване на пациенти",
  "patient.merge.conflictNote": "(Ще се използват демографските данни на основния пациент)",
  "patient.merge.conflictingInfo": "Засечена е противоречива информация",
  "patient.merge.contactInfo": "Информация за контакт",
  "patient.merge.county": "Окръг/Област",
  "patient.merge.dataToConsolidate": "Данни за консолидиране",
  "patient.merge.demographics": "Демографски данни",
  "patient.merge.dob": "Дата на раждане",
  "patient.merge.email": "Имейл",
  "patient.merge.emailsDiffer": "Имейлът е различен: {primary} срещу {secondary}",
  "patient.merge.error.alreadyMerged": "Пациентът вече е обединен",
  "patient.merge.error.executionFailed": "Изпълнението на обединяването не бе успешно",
  "patient.merge.error.noPermission": "Само глобални администратори могат да обединяват пациенти",
  "patient.merge.error.patientNotFound": "Пациентът не е намерен",
  "patient.merge.error.samePatient": "Не може да обедините пациент със самия него",
  "patient.merge.error.selectBoth": "Моля, изберете и двамата пациенти, за да продължите",
  "patient.merge.error.selectPrimary": "Моля, изберете кой пациент да бъде основният запис",
  "patient.merge.error.validationFailed": "Валидацията за обединяване не бе успешна",
  "patient.merge.externalIds": "Външни ID",
  "patient.merge.gender": "Пол",
  "patient.merge.identifiers": "Идентификатори",
  "patient.merge.identifiersToPreserve": "Идентификатори за запазване (и за двамата пациенти)",
  "patient.merge.mergeSummary": "Резюме на обединяването",
  "patient.merge.mergingFrom": "Обединяване от",
  "patient.merge.mergingLabel": "Обединяване",
  "patient.merge.name": "Име",
  "patient.merge.nationalId": "Национален ID",
  "patient.merge.nationalIds": "Национални ID",
  "patient.merge.nextStep": "Следваща стъпка",
  "patient.merge.noIdentifiers": "Няма записани идентификатори",
  "patient.merge.noPatientSelected": "Няма избран пациент",
  "patient.merge.notRecorded": "Не е записано",
  "patient.merge.orders": "Поръчки",
  "patient.merge.ordersCount": "{count} ({active} активни)",
  "patient.merge.patientId": "ID на пациент",
  "patient.merge.patientIds": "ID-та на пациенти",
  "patient.merge.patientResults": "Резултати на пациента",
  "patient.merge.phone": "Телефон",
  "patient.merge.phonesDiffer": "Телефонните номера са различни: {primary} срещу {secondary}",
  "patient.merge.postalCode": "Пощенски код",
  "patient.merge.primaryLabel": "Основен",
  "patient.merge.primaryPatient": "Основен пациент",
  "patient.merge.reason": "Причина за обединяване (задължително)",
  "patient.merge.reasonPlaceholder": "Въведете причина за обединяването на тези записи...",
  "patient.merge.recordsReassigned": "{count} записа са прехвърлени",
  "patient.merge.samples": "Проби",
  "patient.merge.searchDifferent": "Търсене на друг пациент",
  "patient.merge.selectFirstPatient": "Избор на първи пациент",
  "patient.merge.selectPrimaryDescription": "Кой пациент трябва да стане основният запис?",
  "patient.merge.selectPrimaryRecord": "Избор на основен пациентски запис",
  "patient.merge.selectSecondPatient": "Избор на втори пациент",
  "patient.merge.step.compare": "Избор на основен",
  "patient.merge.step.confirm": "Потвърди обединяването",
  "patient.merge.step.select": "Избор на пациенти",
  "patient.merge.streetAddress": "Адрес (улица)",
  "patient.merge.success": "Обединяването на пациентите приключи успешно",
  "patient.merge.successMessage": "Пациент {mergedId} бе обединен в пациент {primaryId}. Одит ID: {auditId}",
  "patient.merge.testResults": "Резултати от тестове",
  "patient.merge.title": "Обединяване на пациентски записи",
  "patient.merge.totalContacts": "Контакти",
  "patient.merge.totalRelations": "Връзки",
  "patient.merge.totalResults": "Общо резултати",
  "patient.merge.totalSamples": "Проби",
  "patient.merge.town": "Град",
  "patient.merge.tryDifferentSearch": "Опитайте да коригирате критериите за търсене или използвайте други идентификатори.",
  "patient.merge.warning.dataLink": "Всички бъдещи данни ще бъдат свързани с основния пациент. Неизбраният пациент ще бъде маркиран като обединен и неактивен.",
  "patient.merge.warning.irreversible": "Това действие НЕ МОЖЕ да бъде отменено. Всички данни ще бъдат окончателно консолидирани.",
  "patient.merge.warning.samePatient": "Избран е един и същ пациент",
  "patient.merge.warning.samePatientDescription": "Избрали сте един и същ пациент за двата записа. Моля, изберете двама различни пациенти.",
  "patient.natioanalid": "Национален ID",
  "patient.nationalid": "Национален ID",
  "patient.nationality": "Националност",
  "patient.nationality.other": "Посочете друга националност",
  "patient.photo.active.camera": "Кликнете за активиране на камерата",
  "patient.photo.add": "Добавяне на снимка",
  "patient.photo.browse": "Кликнете за преглед на файлове",
  "patient.photo.camera.permission.denied": "Разрешението за камерата е отказано. Проверете настройките на браузъра.",
  "patient.photo.cancel": "Отказ",
  "patient.photo.capture": "Заснемане на снимка",
  "patient.photo.captured": "Заснета снимка:",
  "patient.photo.change": "Промяна на изображението",
  "patient.photo.confirm": "Потвърди",
  "patient.photo.dragndrop": "Плъзнете и пуснете изображение тук",
  "patient.photo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "patient.photo.formats": "Формати: JPG, PNG (макс. 1MB)",
  "patient.photo.import": "Импорт",
  "patient.photo.label": "Снимка на пациента",
  "patient.photo.modal.heading": "Избор на снимка на пациента",
  "patient.photo.modal.options": "Опции за избор на изображение",
  "patient.photo.preview": "Предварителен преглед:",
  "patient.photo.preview.alt": "Преглед на снимката на пациента",
  "patient.photo.preview.captured.alt": "Заснета снимка на пациента",
  "patient.photo.retake": "Повторно заснемане",
  "patient.photo.start.camera": "Стартиране на камерата",
  "patient.photo.take": "Снимай",
  "patient.photo.view": "View Photo",
  "patient.idDoc.title": "Identification Documents",
  "patient.idDoc.addDocument": "Add Document",
  "patient.idDoc.selectImage": "Select Image",
  "patient.idDoc.documentType": "Document Type",
  "patient.idDoc.description": "Описание",
  "patient.idDoc.description.placeholder": "Enter document description",
  "patient.idDoc.category.nationalId": "Външен ID",
  "patient.idDoc.category.insuranceCard": "Insurance Card",
  "patient.idDoc.category.other": "Друг",
  "patient.idDoc.view": "Преглед",
  "patient.idDoc.edit": "Редактиране",
  "patient.idDoc.delete": "Изтрий",
  "patient.idDoc.remove": "Премахни",
  "patient.idDoc.pending": "Unsaved",
  "patient.idDoc.empty": "No identification documents uploaded",
  "patient.idDoc.viewDocument": "View Document",
  "patient.idDoc.editDocument": "Edit Document",
  "patient.idDoc.confirmDelete": "Delete Document",
  "patient.idDoc.deleteWarning": "Are you sure you want to delete this document? This action cannot be undone.",
  "patient.idDoc.upload": "Upload",
  "patient.idDoc.dragndrop": "Drag and drop a file here",
  "patient.idDoc.browse": "or click to browse files",
  "patient.idDoc.formats": "Formats: JPEG, PNG, PDF (max 10MB)",
  "patient.idDoc.useCamera": "Use Camera",
  "patient.idDoc.pdfSelected": "PDF document selected",
  "patient.idDoc.error.invalidFormat": "Invalid file format. Accepted formats: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File is too large. Maximum size is 10MB.",
  "patient.prev.lab.no": "Предишен лабораторен номер",
  "patient.report.associated.name": "Свързан отчет за пациент",
  "patient.report.collection.name": "Взет ARV отчет за пациент",
  "patient.search.nopatient": "Не са намерени пациенти, отговарящи на условията",
  "patient.st.number": "ST номер",
  "patient.subject.number": "Уникален здравен ID номер",
  "patient.yrs": "г.",
  "patientcontact.person.email": "Имейл за контакт",
  "patientcontact.person.firstname": "Име на лице за контакт",
  "patientcontact.person.lastname": "Фамилия на лице за контакт",
  "placeholder.accession.number": "Въведете номер на акцесия",
  "print.barcode": "Печат на баркод",
  "process.testAdd.pressNext.ageRangeSelectiong": "Натиснете бутона Напред, стъпката за избор на възрастов диапазон не е задължителна!",
  "process.testAdd.pressNext.selectGroupDictionary": "Натиснете бутона Напред, стъпката за избор на речник на групи не е задължителна!",
  "program.name.label": "Име на програмата",
  "project.ARVFollowupStudy.name": "Проследяване ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "Първоначално ARV",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Неопределено",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Тестване за давност",
  "project.SequencingStudy.name": "Секвениране",
  "project.SpecialRequestStudy.name": "Специална заявка",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Добавяне на проект",
  "project.add.title": "Добавяне на проект",
  "project.browse.title": "Проект",
  "project.completedDate": "Дата на завършване",
  "project.desc.short": "Опис. на проекта",
  "project.description": "Описание на проекта",
  "project.edit.subtitle": "Редактиране на проект",
  "project.edit.title": "Редактиране на проект",
  "project.external.reference": "Външна референция",
  "provider.browse.title": "Управление на доставчици/лекари",
  "provider.email": "Имейл",
  "provider.fax": "Факс",
  "provider.isActive": "Е активен",
  "provider.modal.add.heading": "Add Provider",
  "provider.modal.update.heading": "Update Provider",
  "provider.providerFirstName": "Име на доставчика",
  "provider.providerLastName": "Фамилия на доставчика",
  "provider.search": "Търсене на доставчик",
  "provider.search.placeholder": "Търсене на име на доставчик...",
  "provider.select": "Избор на доставчик",
  "provider.telephone": "Телефон",
  "qa.checklist.incomplete": "QA checklist is incomplete",
  "qa.checklist.instructions": "Complete all required checks before submitting",
  "qa.checklist.samplingSiteCorrect": "Sampling site information is correct",
  "qa.checklist.title": "QA Checklist",
  "qa.summary.noSamples": "No samples to review",
  "qa.summary.noTests": "Няма избрани тестове",
  "qa.summary.order": "Order Details",
  "qa.summary.panel": "Панел",
  "qa.summary.patient": "Информация за пациента",
  "qa.summary.poolOf": "Pool of {count} {animal}",
  "qa.summary.samples": "Sample Summary",
  "qa.summary.samplingSite": "Sampling Site",
  "qa.summary.siteCode": "Site Code",
  "qa.summary.siteName": "Име на обекта",
  "qc.comments.add": "Добавяне на коментар",
  "qc.comments.empty": "No comments yet",
  "qc.comments.placeholder": "Enter QC comment...",
  "qc.comments.title": "QC Comments",
  "qc.expectedValue": "Expected Value",
  "qc.frequency.compliance": "Compliance Metrics",
  "qc.frequency.config": "QC Frequency Configuration",
  "qc.frequency.daily": "Daily Startup",
  "qc.frequency.everyHours": "Every N Hours",
  "qc.frequency.everySamples": "Every N Samples",
  "qc.frequency.manual": "Manual Trigger Only",
  "qc.frequency.notConfigured": "Not configured",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "Save Configuration",
  "qc.frequency.type": "Frequency Type",
  "qc.frequency.value": "Frequency Value",
  "qc.leveyJennings.mean": "Mean",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "No QC data available",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Levey-Jennings Control Chart",
  "qc.notes": "QC бележки",
  "qc.notes.placeholder": "Въведете QC бележки и наблюдения",
  "qc.parentSample": "Родителска проба",
  "qc.signature.comment": "Comment (optional)",
  "qc.signature.comment.placeholder": "Add a comment...",
  "qc.signature.ipAddress": "IP адрес",
  "qc.signature.noSignatures": "No signatures yet",
  "qc.signature.sign": "Sign Report",
  "qc.signature.signedAt": "Signed At",
  "qc.signature.success": "Report signed successfully",
  "qc.signature.title": "Electronic Signatures",
  "qc.signature.userId": "User ID",
  "qc.status": "QC статус",
  "qc.status.failed": "Неуспешно",
  "qc.status.notRequired": "Не се изисква",
  "qc.status.passed": "Успешно",
  "qc.status.pending": "Очаква QC",
  "qc.status.select": "Избор на QC статус",
  "qc.status.update.button": "Актуализирай QC статус",
  "qc.status.update.success": "QC статусът е актуализиран успешно",
  "qc.status.update.title": "Актуализиране на QC статус",
  "qc.status.warning.message": "Маркирането на тази партида като „Неуспешна“ ще предотврати използването ѝ до актуализиране на статуса.",
  "qc.status.warning.title": "Предупреждение за неуспешен QC",
  "qc.westgard.noViolations": "No violations detected",
  "qc.westgard.rule.disabled": "Disabled",
  "qc.westgard.rule.enabled": "Enabled",
  "qc.westgard.rules": "Westgard Rules",
  "qc.westgard.rules.description": "Configure Westgard multi-rule QC evaluation",
  "qc.westgard.violations": "Violations",
  "quantity": "Количество",
  "quantity.balanced": "Количеството е балансирано",
  "quantity.not.balanced": "Количеството не е балансирано",
  "quick.entry.accession.number": "Номер на акцесия",
  "referTest.referralLabel": "Препрати теста към референтна лаборатория",
  "referral.button.labSearch": "Търсене на препращания по лаб. номер",
  "referral.button.patientSearch": "Търсене на пациент",
  "referral.button.unitTestSearch": "Търсене на препращания по звено и тест",
  "referral.date.end": "Крайна дата (дд/мм/гггг)",
  "referral.date.start": "Начална дата (дд/мм/гггг)",
  "referral.emptyState": "No referrals found for the selected filters.",
  "referral.error": "Няма препращания, отговарящи на критериите",
  "referral.input": "Сканирайте ИЛИ Въведете ръчно",
  "referral.label.institute": "Институт",
  "referral.label.reason": "Причина за препращане",
  "referral.label.referredOutTests": "Препратени навън тестове",
  "referral.label.sentdate": "Дата на изпращане",
  "referral.label.testmethod": "Методи",
  "referral.label.testtoperform": "Тест за изпълнение",
  "referral.main.button": "Търсене на препращания по пациент",
  "referral.matching.search": "Препратени тестове, съответстващи на търсенето",
  "referral.out.head": "Препращания",
  "referral.out.note": "Забележка: при търсене по дата на резултат ще се появят само тестове с резултати.",
  "referral.out.request": "Резултати по дата / Тест / Звено Тип дата:",
  "referral.print.selected.patient.reports": "Печат на избраните отчети за пациенти",
  "referral.print.selected.patient.reports.selectall.button": "Избери всички",
  "referral.print.selected.patient.reports.selectnone.button": "Никой",
  "referral.result.labNumber": "Резултати по лабораторен номер",
  "referral.result.referenceRange": "Reference range",
  "referral.search": "Търсене",
  "referral.search.column.analysisId": "AnalysisId",
  "referral.search.column.referenceLab": "Референтна лаборатория",
  "referral.search.column.resultDate": "Дата на резултат",
  "referral.search.column.sentDate": "Дата на изпращане",
  "referral.test": "Тест(ове)",
  "referral.testresult.pastnote": "Минали бележки",
  "referral.units": "Звено(а)",
  "referrer.label": "препращащ",
  "reflexTests": "Рефлексни тестове",
  "reject.action.button": "Отхвърли",
  "reject.order.sample.notification": "Вие отхвърляте проба. Тази проба ще бъде отхвърлена и няма да се появява в работните планове след запазване; за тази поръчка не могат да се въвеждат резултати.",
  "remaining.quantity": "Оставащо количество:",
  "remove.aliquot": "Премахване на аликот",
  "report.enter.labNumber.headline": "Генериране на отчет или диапазон от отчети по номер на поръчка / лабораторен номер",
  "report.enter.patient.headline": "Генериране на всички отчети за клиент",
  "report.enter.patient.headline.description": "Търсене на пациента чрез предишен лаб. номер, ID на пациента (уникален здравен ID или национален ID) или други полета.",
  "report.enter.site.headline": "Генериране на отчети по обект",
  "report.labe.byLabNumber": "Отчет по лабораторен номер",
  "report.labe.byPatient": "Отчет по пациент",
  "report.labe.date": "Отчет по дата",
  "report.labe.site": "Отчет по обект",
  "report.label.site.dateType": "Тип дата",
  "report.label.site.onlyResults": "Само отчети с резултати",
  "report.patient.site.description": "Генерирайте отчети по дата на резултат или дата на поръчка. Датата на резултат ще покаже само отчети с резултати. Ако изберете „Само отчети с резултати“, отчети, при които всички тестове са в ход, няма да бъдат генерирани.",
  "report.select.site": "Избор на обект",
  "report.select.studttype": "Избор на тип проучване",
  "reporting.label.testName": "Име на теста за отчитане",
  "reports.auditTrail": "Одитна следа",
  "reports.systemAuditTrail": "System Audit Trail",
  "reports.button": "Генерирай отчет",
  "reports.dateRange": "Период",
  "reports.endDate": "Крайна дата",
  "reports.error.dateRangeRequired": "Периодът е задължителен за този тип отчет",
  "reports.error.generationFailed": "Генерирането на отчета не бе успешно. Опитайте отново.",
  "reports.error.invalidDate": "Invalid date",
  "reports.error.invalidDateRange": "Крайната дата трябва да е след началната",
  "reports.error.unknownExportFormat": "Unknown export format",
  "reports.error.unknownReportType": "Unknown report type",
  "reports.export": "Експорт",
  "reports.export.byDate": "Експорт по дата",
  "reports.export.byDate_routine": "Рутинен CSV отчет",
  "reports.export.general": "Общ експорт",
  "reports.export.specific": "Експорт на данни за вирусен товар",
  "reports.export.valid": "Валиден",
  "reports.export.whonet": "WHONET отчет",
  "reports.followupRequired.byLocation": "Изисква се проследяване",
  "reports.format": "Формат на експорта",
  "reports.format.select": "Избор на формат",
  "reports.generate.title": "Генериране на инвентарен отчет",
  "reports.generating": "Генериране...",
  "reports.generation.success": "Отчетът бе генериран и изтеглен успешно",
  "reports.groupByLocation": "Групиране по място на съхранение",
  "reports.groupByType": "Групиране по тип елемент",
  "reports.grouping": "Опции за групиране",
  "reports.help.description": "Използвайте тези отчети за анализ на вашите инвентарни данни:",
  "reports.help.tip1": "Използвайте периоди за анализ на трендове",
  "reports.help.tip2": "Групирайте по тип или местоположение за по-добра видимост",
  "reports.help.tip3": "Експортирайте в Excel за допълнителен анализ",
  "reports.help.title": "Съвети за отчети",
  "reports.includeExpired": "Включи партиди с изтекъл срок",
  "reports.includeInactive": "Включи неактивни елементи",
  "reports.info.message": "Изберете тип отчет и опции по-долу. Генерирането може да отнеме няколко моменти.",
  "reports.info.title": "Генериране на отчет",
  "reports.label.cistudyexport": "Общ отчет",
  "reports.label.indicator": "Индикатор",
  "reports.label.indicator.performance": "Производителност на секцията",
  "reports.label.referred.out": "Отчет за препратени тестове",
  "reports.label.trends": "Трендове",
  "reports.menu.covid": "Covid отчет",
  "reports.nonConformity.byDate.report": "По дата",
  "reports.nonConformity.byLabno.report": "По лаб. номер",
  "reports.nonConformity.bySectionReason.report": "По звено и причина",
  "reports.nonConformity.bySectionReason.title": "Отчет за несъответствия по звено и причина",
  "reports.nonConformity.menu": "Отчети за несъответствия",
  "reports.nonConformity.notification.report": "Известие за несъответствие",
  "reports.nonConformity.notification.report.instructions": "Ако е избрана услуга, ще бъдат отпечатани всички известия за несъответствия, които още не са отпечатани. Въвеждането на лабораторен номер ще отпечата известие, дори ако вече е било отпечатвано.",
  "reports.options": "Опции за филтриране",
  "reports.patient.ARV.version1": "ARV версия",
  "reports.patient.ARV.version1 ": "ARV версия 1",
  "reports.patient.ARVFollowup.version1": "ARV проследяване версия 1",
  "reports.patient.ARVFollowup.version2": "ARV проследяване версия 2",
  "reports.patient.ARVInitial.version1": "ARV начално версия 1",
  "reports.patient.ARVInitial.version2": "ARV начално версия 2",
  "reports.patient.Indeterminate.location": "Неопределено по услуга",
  "reports.patient.Indeterminate.version1": "Неопределено версия 1",
  "reports.patient.Indeterminate.version2": "Неопределено версия 2",
  "reports.startDate": "Начална дата",
  "reports.type": "Тип отчет",
  "reports.type.expirationForecast": "Прогноза за изтичане на срок",
  "reports.type.expirationForecast.description": "Елементи, чийто срок изтича в посочения период",
  "reports.type.lotTraceability": "Проследяемост на партида",
  "reports.type.lotTraceability.description": "Пълна проследяемост на движенията и използването на партидата",
  "reports.type.lowStock": "Сигнал за ниска наличност",
  "reports.type.lowStock.description": "Елементи, които са под минималното ниво на склад",
  "reports.type.select": "Избор на тип отчет",
  "reports.type.stockLevels": "Отчет за нива на наличности",
  "reports.type.stockLevels.description": "Текущи нива на склад за всички инвентарни елементи",
  "reports.type.transactionHistory": "История на транзакциите",
  "reports.type.transactionHistory.description": "Всички транзакции в рамките на периода",
  "reports.type.usageTrends": "Трендове на използване",
  "reports.type.usageTrends.description": "Модели на използване и трендове на потребление във времето",
  "request.samesite.order": "Направи поръчка за същия обект",
  "requester.label": "Заявител",
  "required.invalidtext": "Това поле е задължително",
  "result.acceptasis.warning": "Маркирането на това поле показва, че приемате резултатите безусловно. В случай на промяна, оставете бележка с обяснение.",
  "result.acceptasis.trigger": "Приеми",
  "result.acceptasis.reason.label": "Reason for unconditional acceptance",
  "result.acceptasis.reason.placeholder": "Required — e.g. retested twice with same result, or no result available",
  "result.acceptasis.confirm": "Confirm acceptance",
  "result.acceptasis.cancel": "Отказ",
  "result.acceptasis.committed": "Accepted",
  "result.acceptasis.undo": "Undo",
  "result.entry.error.accessionRequired": "Моля, въведете номер на акцесия",
  "result.entry.error.title": "Грешка",
  "result.entry.info.title": "Информация",
  "result.entry.label": "Въвеждане на резултат",
  "result.entry.noResults": "Не е намерена проба за номер на акцесия {accessionNumber}",
  "result.entry.noTestsFound": "Не са намерени тестове с чакащи резултати за номер на акцесия {accessionNumber}",
  "result.entry.results.accessionNumber": "Номер на акцесия",
  "result.entry.results.sampleCount": "Проби",
  "result.entry.results.testCount": "Тестове",
  "result.entry.results.title": "Тестове с чакащи резултати",
  "result.entry.saveSuccess": "Резултатът за {testName} е запазен",
  "result.entry.search.accessionLabel": "Номер на акцесия",
  "result.entry.search.accessionPlaceholder": "Въведете номер на акцесия...",
  "result.entry.search.button": "Търсене",
  "result.entry.search.searching": "Търсене...",
  "result.entry.search.title": "Търсене по номер на акцесия",
  "result.entry.success.title": "Успех",
  "result.entry.table.action": "Действие",
  "result.entry.table.header.sampleId": "ID на проба",
  "result.entry.table.header.sampleType": "Тип проба",
  "result.entry.table.header.testCount": "Тестове",
  "result.entry.table.noSamples": "Не са намерени проби с тестове",
  "result.entry.table.noTests": "Няма тестове за тази проба",
  "result.entry.table.result": "Резултат",
  "result.entry.table.resultPlaceholder": "Въведете резултат",
  "result.entry.table.save": "Запази",
  "result.entry.table.saving": "Запазване...",
  "result.entry.table.status": "Статус",
  "result.entry.table.testName": "Име на тест",
  "result.entry.table.testsTitle": "Тестове ({count})",
  "result.entry.title": "Въвеждане на резултат",
  "result.noTestsFound": "Не бяха намерени подходящи тестове.",
  "result.nonconforming.item": "Пробата или поръчката не съответстват ИЛИ тестът е отхвърлен",
  "result.outOfValidRange.msg": "Стойността, която въведохте (червено поле), е извън допустимия диапазон. Проверете стойността",
  "result.notNumeric.msg": "{test}: \"{value}\" is not a number. Enter a plain decimal or scientific notation such as 1.5e5 or 1.5 x 10^5, then save again.",
  "result.reject.warning": "Отхвърлянето на резултата трайно ще изтрие резултатите от теста. Те повече няма да са налични.",
  "result.report.queue.size": "Размер на опашката:",
  "result.search.noresult": "Няма намерени резултати",
  "resultreporting.browse.title": "Конфигурация на отчитане на резултати",
  "resultreporting.config.url": "URL адрес на обекта, към който ще се изпращат резултатите. Например http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Препрати теста към референтна лаборатория",
  "routine.reports": "Рутинни отчети",
  "rulebuilder.error.invalidNumeric": "Невалидна числова стойност",
  "rulebuilder.error.invalidTest": "Невалиден тест",
  "rulebuilder.label.add.externaltrigger": "Добави външно съобщение за задействане",
  "rulebuilder.label.add.internaltrigger": "Добави вътрешно съобщение за задействане",
  "rulebuilder.label.addAction": "Добави действие",
  "rulebuilder.label.addCondition": "Добави условие",
  "rulebuilder.label.addExternalNote": "Добави външна бележка",
  "rulebuilder.label.addInternalNote": "Добави вътрешна бележка",
  "rulebuilder.label.addPopup": "Добави изскачащ прозорец",
  "rulebuilder.label.addRule": "Добави правило",
  "rulebuilder.label.addRuleConditions": "Добави условия за рефлексно правило",
  "rulebuilder.label.confirmDelete": "Сигурни ли сте, че искате да деактивирате това правило?",
  "rulebuilder.label.dictValue": "Стойност от речник",
  "rulebuilder.label.noSuggestions": "Няма налични предложения",
  "rulebuilder.label.numericValue": "Числова стойност",
  "rulebuilder.label.numericValue2": "Числова стойност 2",
  "rulebuilder.label.overallOptions": "Общи опции",
  "rulebuilder.label.perfomActions": "Изпълни следните действия",
  "rulebuilder.label.relation": "Отношение",
  "rulebuilder.label.removeAction": "Премахни действие",
  "rulebuilder.label.removeCondition": "Премахни условие",
  "rulebuilder.label.removeRule": "Деактивирай правило",
  "rulebuilder.label.rule": "Правило",
  "rulebuilder.label.ruleDetails": "View Rule",
  "rulebuilder.label.ruleName": "Име на правило",
  "rulebuilder.label.searchTest": "Търсене на тест",
  "rulebuilder.label.selectSample": "Избор на проба",
  "rulebuilder.label.textValue": "Текстова стойност",
  "rulebuilder.label.toggleRule": "Превключи правило",
  "sample.accession.number": "Акцесия на проба",
  "sample.add.action": "Добавяне на проба",
  "sample.collection.date": "Дата на вземане",
  "sample.collection.method": "Collection Method",
  "sample.collection.method.placeholder": "e.g., venipuncture, capillary, tubing",
  "sample.collection.time": "Време на вземане",
  "sample.currentDate": "Текуща дата",
  "sample.requiredBy": "Required By",
  "sample.specimen.origin": "Specimen Origin (referent lab)",
  "sample.specimen.origin.placeholder": "Referring laboratory name",
  "sample.temperature": "Sample Temperature",
  "sample.temperature.placeholder": "e.g., room temp, iced, refrigerated",
  "sample.entry.available.tests": "Налични тестове",
  "sample.entry.nextVisit.date": "Дата на следващо посещение",
  "sample.entry.panels": "Панели",
  "sample.entry.project.patient.and.testName": "Име/Код на пациента {br} Име на тест",
  "sample.entry.project.testName": "Име на тест",
  "sample.entry.search.barcode": "Печат на баркодове за съществуващи поръчки",
  "sample.id": "ID на проба",
  "sample.item.info": "Информация за пробата",
  "sample.items.for.accession": "Елементи на пробата за номер на акцесия:",
  "sample.label.accessionNumber": "Номер на акцесия",
  "sample.label.collectionDate": "Дата на вземане",
  "sample.label.dept": "Отделение/Сектор/Звено",
  "sample.label.facility": "Препращащо заведение",
  "sample.label.labnumber": "Лабораторен номер",
  "sample.label.labnumber.generate": "Генерирай",
  "sample.label.labnumber.new": "Нов лабораторен номер",
  "sample.labnumber.reassign.button": "Reassign Lab Number",
  "sample.labnumber.reassign.confirm": "Reassign",
  "sample.labnumber.reassign.current": "Current Lab Number",
  "sample.labnumber.reassign.heading": "Reassign Lab Number",
  "sample.labnumber.reassign.pending": "This specimen will be reassigned to {number} when you save.",
  "sample.labnumber.reassign.pending.title": "Pending Lab Number reassignment",
  "sample.labnumber.reassign.undo": "Undo",
  "sample.labnumber.reassign.warning": "Reassigning permanently changes this specimen's Lab Number. Existing labels, reports, and references to the current number will no longer match it. Do this only to correct a mislabelled specimen.",
  "sample.label.noorder": "Поръчката не съществува",
  "sample.label.orderdate": "Дата на поръчка",
  "sample.label.orderpanel": "Поръчване на панели",
  "sample.label.requester": "Заявител",
  "sample.label.search.Order": "Търсене на поръчка",
  "sample.label.search.labnumber": "Търсене по номер на акцесия",
  "sample.label.search.patient": "Търсене по пациент",
  "sample.label.typeOfSample": "Тип проба",
  "sample.label.types": "Sample Types",
  "sample.management.action.clearSelection": "Изчисти избраното",
  "sample.management.action.createAliquot": "Създай аликот",
  "sample.management.action.selectAllAliquots": "Избери всички аликоти",
  "sample.management.action.selectAllParents": "Избери всички родителски проби",
  "sample.management.addTests.button": "Добавяне на тестове",
  "sample.management.addTests.error.addFailed": "Неуспешно добавяне на тестове. Опитайте отново.",
  "sample.management.addTests.error.loadSampleTypes": "Грешка при зареждане на типове проби",
  "sample.management.addTests.error.loadTests": "Грешка при зареждане на налични тестове",
  "sample.management.addTests.error.noEligibleSamples": "Не могат да се добавят тестове: всички избрани проби са напълно разходвани",
  "sample.management.addTests.error.noTests": "Моля, изберете поне един тест",
  "sample.management.addTests.modal.add": "Добавяне на тестове",
  "sample.management.addTests.modal.addCount": "Добави {count} тест(а)",
  "sample.management.addTests.modal.adding": "Добавяне...",
  "sample.management.addTests.modal.aliquotsIncluded": "включен(и) аликот(и)",
  "sample.management.addTests.modal.bulkAliquotNote": "Тестовете ще бъдат добавени към всички избрани проби, включително аликотите.",
  "sample.management.addTests.modal.cancel": "Отказ",
  "sample.management.addTests.modal.noEligibleSamples": "Няма подходящи проби",
  "sample.management.addTests.modal.noTestsAvailable": "Няма налични тестове за този тип проба.",
  "sample.management.addTests.modal.noTestsSelected": "Няма избрани тестове",
  "sample.management.addTests.modal.panels": "Панели",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Търсене на тестове...",
  "sample.management.addTests.modal.selectSampleType": "Тип проба",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Моля, първо изберете тип проба, за да видите наличните панели и тестове.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Избор на тип проба...",
  "sample.management.addTests.modal.selectTests": "Избор на тестове",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Търсене и избор на тестове...",
  "sample.management.addTests.modal.selectedTests": "Избрани тестове",
  "sample.management.addTests.modal.subtitle": "Добавяне на тестове към {count} избрана(и) проба(и)",
  "sample.management.addTests.modal.tests": "Тестове",
  "sample.management.addTests.modal.title": "Добавяне на тестове към проба",
  "sample.management.addTests.resultItem": "{sampleId}: {added} добавени",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} добавени, {skipped} пропуснати",
  "sample.management.addTests.success": "Успешно добавени {count} тест(а)",
  "sample.management.addTests.successDetailed": "Добавени {count} тест(а) към {samples} проба(и): {details}",
  "sample.management.addTests.successDetailedWithSkipped": "Добавени {added} тест(а) към {samples} проба(и), {skipped} пропуснати: {details}",
  "sample.management.addTests.successWithSkipped": "Добавени {added} тест(а), {skipped} пропуснати (вече поръчани)",
  "sample.management.addTests.title": "Добавяне на тестове",
  "sample.management.addTests.warning.dispensedSamples": "{count} проба(и) нямат оставащ обем и ще бъдат пропуснати. Тестовете ще бъдат добавени към {eligible} подходящи проби.",
  "sample.management.addTests.warning.dispensedSamples.title": "Разходваните проби са изключени",
  "sample.management.aliquot.error.createFailed": "Неуспешно създаване на аликот. Опитайте отново.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Броят на аликотите трябва да е между 1 и 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Заявеното количество ({requested}) надвишава оставащото количество ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Количеството на аликот ({quantityPerAliquot}) би било по-малко от минимума (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Количеството трябва да е по-голямо от 0",
  "sample.management.aliquot.error.quantityRequired": "Количеството е задължително",
  "sample.management.aliquot.error.title": "Грешка",
  "sample.management.aliquot.modal.cancel": "Отказ",
  "sample.management.aliquot.modal.create": "Създай аликот",
  "sample.management.aliquot.modal.createMultiple": "Създай {count} аликота",
  "sample.management.aliquot.modal.creating": "Създаване...",
  "sample.management.aliquot.modal.notesLabel": "Бележки (незадължително)",
  "sample.management.aliquot.modal.notesPlaceholder": "Добавете бележки за този аликот...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Въведете колко аликота с еднакъв обем да създадете (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Брой аликоти",
  "sample.management.aliquot.modal.parentInfo": "Информация за родителската проба",
  "sample.management.aliquot.modal.preview": "Предварителен преглед",
  "sample.management.aliquot.modal.previewText": "Създаване на {count} аликота с по {quantityEach} {unit} всеки",
  "sample.management.aliquot.modal.quantityHelper": "Въведете количеството за прехвърляне в {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Количество за прехвърляне",
  "sample.management.aliquot.modal.quantityPlaceholder": "Въведете количество",
  "sample.management.aliquot.modal.subtitle": "Създаване на аликот от проба {externalId}",
  "sample.management.aliquot.modal.title": "Създаване на аликот",
  "sample.management.aliquot.modal.totalQuantityHelper": "Въведете общото количество, което да бъде разделено между всички аликоти в {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Общо количество за прехвърляне",
  "sample.management.aliquot.success": "Аликот {externalId} бе създаден успешно. Търсете отново за опресняване.",
  "sample.management.aliquot.successMultiple": "Успешно създадени {count} аликота ({externalIds}). Търсете отново за опресняване.",
  "sample.management.breadcrumb.title": "Управление на проби",
  "sample.management.cancelTest.error": "Неуспешно анулиране на тест. Опитайте отново.",
  "sample.management.cancelTest.success": "Тестът „{testName}“ бе анулиран успешно",
  "sample.management.description": "Търсете и управлявайте проби, създавайте аликоти и добавяйте тестове",
  "sample.management.error.title": "Грешка",
  "sample.management.hierarchy.aliquotOf": "Аликот от {parent}",
  "sample.management.hierarchy.aliquots": "аликоти",
  "sample.management.noResults.subtitle": "Не са намерени елементи за номер на акцесия: {accessionNumber}",
  "sample.management.noResults.title": "Няма намерени резултати",
  "sample.management.results.accessionNumber": "Номер на акцесия",
  "sample.management.results.aliquots": "аликоти",
  "sample.management.results.aliquotsSelected": "аликоти",
  "sample.management.results.item": "елемент",
  "sample.management.results.items": "елементи",
  "sample.management.results.selected": "Избрани",
  "sample.management.results.title": "Елементи на пробата",
  "sample.management.results.totalCount": "Общо проби",
  "sample.management.search.error.general": "Грешка при зареждане на резултатите за пробата. Опитайте отново.",
  "sample.management.search.label": "Търсене на проби",
  "sample.management.search.loading": "Търсене...",
  "sample.management.search.placeholder": "Въведете номер на акцесия за търсене...",
  "sample.management.search.title": "Търсене на проби",
  "sample.management.status.allVolumeDispensed": "Целият обем е разходван",
  "sample.management.status.available": "Налична",
  "sample.management.status.consumed": "Консумирана",
  "sample.management.status.inUse": "В употреба",
  "sample.management.status.unknown": "Неизвестен",
  "sample.management.success.title": "Успех",
  "sample.management.table.cancelTest": "Анулирай тест",
  "sample.management.table.cancelling": "Анулиране...",
  "sample.management.table.header.externalId": "ID на проба",
  "sample.management.table.header.hierarchy": "Йерархия",
  "sample.management.table.header.originalQuantity": "Първоначално количество",
  "sample.management.table.header.quantity": "Първоначално количество",
  "sample.management.table.header.remainingQuantity": "Оставащо количество",
  "sample.management.table.header.sampleType": "Тип проба",
  "sample.management.table.header.status": "Статус",
  "sample.management.table.header.tests": "Тестове",
  "sample.management.table.noResults": "Няма елементи за показване. Използвайте търсенето по-горе.",
  "sample.management.table.noTests": "Няма поръчани тестове за тази проба",
  "sample.management.table.orderedDate": "Поръчано на",
  "sample.management.table.orderedTests": "Поръчани тестове ({count})",
  "sample.management.title": "Управление на проби",
  "sample.panel.label.text": "Търсене на наличен панел",
  "sample.panel.placeholder": "Изберете наличен панел",
  "sample.panel.search.error.msg": "Няма намерен панел, отговарящ на условията",
  "sample.quantity.label": "Количество",
  "sample.receivedDate": "Дата на получаване",
  "sample.reject.label": "Отхвърляне на проба",
  "sample.remove.action": "Премахване на проба",
  "sample.requestDate": "Дата на заявка",
  "sample.search.nosample": "Не е намерена проба за предоставения номер на акцесия.",
  "sample.search.panel.legend.text": "Търсене в наличните панели",
  "sample.search.scanner.instructions": "Сканирайте ИЛИ Въведете ръчно. За единичен отчет оставете полето вдясно празно",
  "sample.search.scanner.instructions.highaccession": "За единичен отчет оставете полето вдясно празно",
  "sample.search.scanner.instructions2": "Сканирайте ИЛИ Въведете ръчно.",
  "sample.search.title": "Търсене на проба",
  "sample.select.type": "Избор на тип проба",
  "sample.type": "Тип проба",
  "sample.type.and.test.sort.order": "Ред на сортиране на тип проба и тест",
  "sample.type.helper": "Select a specimen type — available panels and tests update after selection.",
  "sample.uom.label": "Мерна единица на пробата",
  "sample.voided.title": "Пробата е анулирана",
  "sampleManagement.actions": "Действия",
  "sampleManagement.addTests.button": "Добавяне на тестове",
  "sampleManagement.addTests.cancel": "Отказ",
  "sampleManagement.addTests.duplicate": "Тестът вече е поръчан за {sampleId}",
  "sampleManagement.addTests.error": "Грешка при добавяне на тестове",
  "sampleManagement.addTests.incompatible": "Тестът не е съвместим с типа проба ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Изберете проба(и) за добавяне на тестове",
  "sampleManagement.addTests.selectTests": "Изберете тест(ове) за добавяне",
  "sampleManagement.addTests.skipped": "Пропуснати са {count} дубликата",
  "sampleManagement.addTests.submit": "Добави тестове",
  "sampleManagement.addTests.success": "Успешно добавени {count} тест(а)",
  "sampleManagement.addTests.title": "Добавяне на тестове към проби",
  "sampleManagement.aliquot.button": "Създай аликот",
  "sampleManagement.aliquot.cancel": "Отказ",
  "sampleManagement.aliquot.error": "Грешка при създаване на аликот",
  "sampleManagement.aliquot.error.concurrentModification": "Друг потребител е променил тази проба. Моля, опреснете.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Невъзможност за аликотиране: заявеното количество {requested} надвишава наличното {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Целият обем е разходван: няма налично количество за аликотиране",
  "sampleManagement.aliquot.notes": "Бележки (незадължително)",
  "sampleManagement.aliquot.notesPlaceholder": "Добавете бележки за този аликот...",
  "sampleManagement.aliquot.parentExternalId": "Родителски външен ID",
  "sampleManagement.aliquot.parentLabel": "Родителска проба",
  "sampleManagement.aliquot.quantityPlaceholder": "Въведете количество...",
  "sampleManagement.aliquot.quantityToTransfer": "Количество за прехвърляне",
  "sampleManagement.aliquot.remainingQuantity": "Оставащо количество",
  "sampleManagement.aliquot.submit": "Създай аликот",
  "sampleManagement.aliquot.success": "Аликот {externalId} бе създаден успешно",
  "sampleManagement.aliquot.title": "Създаване на аликот",
  "sampleManagement.aliquot.unit": "Единица",
  "sampleManagement.aliquot.validation.exceeds": "Количеството надвишава оставащото",
  "sampleManagement.aliquot.validation.min": "Количеството трябва да е поне 0.001",
  "sampleManagement.aliquot.validation.required": "Количеството за прехвърляне е задължително",
  "sampleManagement.clearSelection": "Изчисти избраното",
  "sampleManagement.hierarchy.children": "Аликоти:",
  "sampleManagement.hierarchy.collapse": "Свий йерархията",
  "sampleManagement.hierarchy.expand": "Разшири йерархията",
  "sampleManagement.hierarchy.level": "Ниво {level}",
  "sampleManagement.hierarchy.parent": "Родител:",
  "sampleManagement.notification.refreshResults": "Резултатите бяха опреснени",
  "sampleManagement.results.children": "Аликоти",
  "sampleManagement.results.collectionDate": "Дата на вземане",
  "sampleManagement.results.count": "Намерени са {count} проба(и)",
  "sampleManagement.results.externalId": "Външен ID",
  "sampleManagement.results.originalQuantity": "Първоначално количество",
  "sampleManagement.results.parent": "Родител",
  "sampleManagement.results.remainingQuantity": "Оставащо количество",
  "sampleManagement.results.sampleType": "Тип проба",
  "sampleManagement.results.status": "Статус",
  "sampleManagement.results.tests": "Тестове",
  "sampleManagement.results.title": "Резултати от търсенето",
  "sampleManagement.search.button": "Търсене",
  "sampleManagement.search.error": "Грешка при търсене на проби",
  "sampleManagement.search.label": "Търсене по номер на акцесия",
  "sampleManagement.search.loading": "Търсене...",
  "sampleManagement.search.noResults": "Не са намерени проби с този номер на акцесия",
  "sampleManagement.search.placeholder": "Въведете номер на акцесия...",
  "sampleManagement.selectSamples": "Изберете проба(и)",
  "sampleManagement.selectedCount": "Избрани: {count}",
  "sampleManagement.test.name": "Име на тест",
  "sampleManagement.test.orderedDate": "Дата на поръчка",
  "sampleManagement.test.status": "Статус",
  "sampleManagement.test.status.CANCELLED": "Анулиран",
  "sampleManagement.test.status.COMPLETED": "Завършен",
  "sampleManagement.test.status.IN_PROGRESS": "В ход",
  "sampleManagement.test.status.ORDERED": "Поръчан",
  "sampleManagement.title": "Управление на проби",
  "sampleManagement.validation.accessionNumberRequired": "Номерът на акцесия е задължителен",
  "sampleManagement.validation.parentSampleRequired": "Родителският елемент на пробата е задължителен",
  "sampleManagement.validation.samplesRequired": "Трябва да бъде избрана поне една проба",
  "sampleManagement.validation.testsRequired": "Трябва да бъде избран поне един тест",
  "sampleType.existing": "Съществуващи типове проби",
  "sampleType.existing.inactive": "Неактивни типове проби. Зачислете тестове за активиране.",
  "sampleType.new": "Нов тип проба",
  "sampleType.typeName": "Име на типа проба",
  "save.aliquot.changes": "Запази промените по аликота",
  "save.config.success.msg": "Конфигурацията бе актуализирана успешно",
  "save.order.success.msg": "Въвеждането на поръчката на пробата бе запазено успешно",
  "save.success": "Успешно запазено",
  "saving": "Запазване...",
  "search.by.dictionary.entry": "Търсене по запис в речника",
  "search.label": "Търсене",
  "search.label.accession": "Въведете номер на акцесия",
  "search.label.analysis": "Избор на статус на анализ",
  "search.label.collectiondate": "Въведете дата на вземане",
  "search.label.fromaccession": "От номер на акцесия",
  "search.label.loadnext": "Зареди следващите 99 записа, започвайки от лаб. номер",
  "search.label.receiveddate": "Въведете дата на получаване",
  "search.label.sample": "Избор на статус на проба",
  "search.label.test": "Избор на име на тест",
  "search.label.testdate": "Въведете дата на теста",
  "search.label.testunit": "Избор на тестова единица",
  "search.label.toaccession": "До номер на акцесия",
  "search.patient.label": "Търсене на пациент",
  "search.placeholder": "Search...",
  "searchTests.label": "Търсене на наличен тест",
  "searchTests.legend": "Търсене в наличните тестове",
  "searchindexmanagement.description": "Индексът за търсене се актуализира автоматично. Ако трябва ръчно да го опресните, кликнете върху бутона „Стартиране на реиндексиране“.",
  "searchindexmanagement.label": "Управление на индекса за търсене",
  "searchindexmanagement.reindex": "Стартиране на реиндексиране",
  "searchindexmanagement.reindex.error": "Реиндексирането не бе успешно",
  "searchindexmanagement.reindex.success": "Реиндексирането приключи успешно",
  "select.aliquot": "Избор на аликот",
  "select.datarange.label": "Периодът се отнася за времето, когато са направени препращанията",
  "select.dateRange": "Изберете периода за обобщения отчет за тестове",
  "select.default.option.label": "Изберете опция",
  "select.end.date.referredTests": "Крайна дата (дд/мм/гггг)",
  "select.labUnits": "Изберете лабораторното звено(а), за което искате да създадете теста",
  "select.label.analyser": "Избор на анализатор",
  "select.priority.tests": "Изберете приоритета на тестовете, които искате да покажете",
  "select.program": "Програма",
  "select.referral.centre": "Център за препращане или лаборатория",
  "select.referral.centre.is.required": "Центърът за препращане или лабораторията е задължителен",
  "select.start.date.referredTests": "Начална дата (дд/мм/гггг)",
  "select.timeFrame": "Изберете времеви рамки за генериране на отчетите",
  "select.timeFrame.Note": "ЗАБЕЛЕЖКА: всички дати и часове са базирани на времето на приемане.",
  "select.year.report": "Изберете годината, за която искате да генерирате отчетите",
  "selectListRenameEntry.selectList": "Запис за преименуване на списък за избор",
  "selectListRenameEntry.selectListEdit": "Редактиране на запис за преименуване на списък за избор",
  "selectReportValues.title": "Избор на стойности за отчет",
  "selectResult.title": "Избор на резултат",
  "serial.config.active.label": "Активен",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Свързване",
  "serial.config.connect.error": "Грешка при свързване със серийния порт",
  "serial.config.connect.success": "Серийният порт бе свързан успешно",
  "serial.config.create.title": "Създаване на конфигурация на сериен порт",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Прекъсване на връзката",
  "serial.config.disconnect.error": "Грешка при прекъсване на връзката със серийния порт",
  "serial.config.disconnect.success": "Връзката със серийния порт бе прекъсната успешно",
  "serial.config.edit.title": "Редактиране на конфигурация на сериен порт",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "Няма",
  "serial.config.form.legend": "Настройки на сериен порт",
  "serial.config.parity.even": "Четно",
  "serial.config.parity.label": "Паритет",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "Няма",
  "serial.config.parity.odd": "Нечетно",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Име на порта",
  "serial.config.save.error": "Грешка при запазване на конфигурацията на серийния порт",
  "serial.config.save.success": "Конфигурацията на серийния порт бе запазена успешно",
  "serial.config.status.label": "Статус на връзката",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "ID на анализатора е задължителен",
  "serial.config.validation.baudRate.invalid": "Baud rate трябва да е между 9600 и 115200",
  "serial.config.validation.dataBits.invalid": "Data bits трябва да са 7 или 8",
  "serial.config.validation.portName.required": "Името на порта е задължително",
  "server.error.msg": "Упс, сървърна грешка. Свържете се с администратора",
  "common.retry": "Retry",
  "show.aliquoting": "Покажи аликотирането",
  "showing": "Показване на",
  "breadcrumb.label.addOrder": "Добавяне на поръчка",
  "sidenav.label.admin": "Админ",
  "sidenav.label.admin.backToMainMenu": "Back to main menu",
  "sidenav.label.admin.barcodeconfiguration": "Конфигурация на баркод",
  "sidenav.label.admin.labelPresets": "Label Presets",
  "sidenav.label.admin.commonproperties": "Свойства на приложението",
  "sidenav.label.admin.eqaProgram": "EQA Program Management",
  "sidenav.label.admin.formEntry.menustatementconfig": "Конфигурация на меню изрази",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Конфигурация на несъответствия",
  "sidenav.label.admin.formEntry.patientconfig": "Конфигурация на въвеждане на пациенти",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Конфигурация на отпечатани отчети",
  "sidenav.label.admin.formEntry.resultConfig": "Конфигурация на въвеждане на резултати",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Конфигурация на въвеждане на поръчки",
  "sidenav.label.admin.formEntry.siteBranding": "Брандиране на сайта",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Информация за обекта",
  "sidenav.label.admin.formEntry.validationconfig": "Конфигурация на валидация",
  "sidenav.label.admin.formEntry.Workplanconfig": "Конфигурация на работен план",
  "sidenav.label.admin.labNumber": "Управление на лабораторни номера",
  "sidenav.label.admin.localization": "Localization",
  "sidenav.label.admin.menu": "Конфигурация на меню",
  "sidenav.label.admin.menu.billing": "Конфигурация на меню Фактуриране",
  "sidenav.label.admin.menu.global": "Глобална конфигурация на меню",
  "sidenav.label.admin.menu.nonconform": "Конфигурация на меню Несъответствия",
  "sidenav.label.admin.menu.patient": "Конфигурация на меню Пациент",
  "sidenav.label.admin.menu.study": "Конфигурация на меню Проучване",
  "sidenav.label.admin.organizationmgt": "Управление на организации",
  "sidenav.label.admin.testmgt": "Конфигурация на рефлексни тестове",
  "sidenav.label.admin.testmgt.calculated": "Управление на тестове с изчислени стойности",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Test Catalogue Editor",
  "sidenav.label.admin.testCatalog": "Test Catalogue Management",
  "sidenav.label.admin.testCatalog.backToList": "← All Tests",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Click a test to edit its sections",
  "sidenav.label.admin.testCatalog.editing": "Editing: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Editing test",
  "label.testCatalog.editor": "Test Catalogue Editor",
  "label.testCatalog.editor.empty": "Click a test to edit its sections",
  "label.testCatalog.editor.empty.helper": "Open a test from the Test Catalogue list to edit it.",
  "label.testCatalog.editor.loadError": "Unable to load this test. Please try again.",
  "label.testCatalog.editor.saveAsNew": "Save as new test…",
  "label.testCatalog.editor.save.pending": "Saving is available once the section editors ship.",
  "label.testCatalog.editor.clone.pending": "Save as new test is available once the editor sections ship.",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Basic Info",
  "label.testCatalog.section.sample-results": "Sample & Results",
  "label.testCatalog.section.methods": "Методи",
  "label.testCatalog.section.ranges": "Ranges",
  "label.testCatalog.section.qc-targets": "QC Targets",
  "label.testCatalog.section.storage": "Sample Storage",
  "label.testCatalog.section.panels": "Панели",
  "label.testCatalog.entity.panels": "Панели",
  "note.panel.domainUpgrade": "A panel's domain is set on the panel itself, not worked out from the sample types its tests use.",
  "note.panel.domainLaterPhase": "A panel whose tests reach sample types from another domain is marked Mixed domain.",
  "label.panel.list.description": "Ordered bundles of tests; sample types derive from the member tests",
  "label.panel.list.empty": "No panels match the current filters.",
  "label.panel.search": "Search by name or LOINC",
  "button.panel.add": "Add Panel",
  "label.panel.col.name": "Име на панела",
  "label.panel.col.tests": "Тестове",
  "label.panel.col.domain": "Domain",
  "label.panel.list.mixedDomain": "Mixed domain",
  "label.panel.list.mixedDomain.detail": "Sample types outside this panel's domain: {sampleTypes}",
  "label.panel.col.sampleTypes": "Sample Types (derived)",
  "label.panel.col.status": "Статус",
  "label.panel.backToList": "Back to list",
  "title.panel.new": "New panel",
  "label.panel.name": "Panel name",
  "placeholder.panel.name": "e.g. Anemia Workup",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Only {domain}-domain tests can be added to this panel.",
  "helper.panel.loincIsIdentifier": "The panel's LOINC serves as its identifier.",
  "note.panel.sampleTypesDerived": "Sample types are derived from the tests in this panel.",
  "label.panel.description": "Описание",
  "label.panel.active": "Активен",
  "helper.panel.needsTest": "Add at least one test before this panel can be activated.",
  "error.panel.save": "The panel could not be saved. Check the fields and try again.",
  "error.panel.nameRequired": "A panel name is required.",
  "error.panel.nameTooLong": "A panel name has at most 20 characters.",
  "error.panel.descriptionTooLong": "A description has at most 60 characters.",
  "error.panel.nameDuplicate": "Another panel already uses this name. Enter a different name.",
  "error.panel.domainConflict": "This panel cannot be filed under {domain}: {count, plural, one {# of its tests belongs} other {# of its tests belong}} to another domain ({tests}).",
  "helper.panel.domainConflict.remedy": "Change the domain of those tests in the Test Catalog, or remove them from this panel, then save again.",
  "error.panel.tests.domainConflict": "Not saved: {tests} {count, plural, one {is} other {are}} not in this panel's domain ({domain}). Only {domain}-domain tests can be added.",
  "error.testCatalog.panels.domainConflict": "This test cannot join {panelName}: the panel is filed under {panelDomain} and the test under {testDomain}.",
  "success.panel.created": "Panel created. It stays inactive until at least one test is assigned to it.",
  "error.panel.create.invalid": "The panel could not be created. Fill in every required field, including a LOINC code.",
  "label.panel.section.basic-info": "Basic Info",
  "label.panel.section.tests": "Тестове",
  "label.panel.section.terminology": "Terminology",
  "label.panel.section.localization": "Localization",
  "label.panel.localization.intro": "Edit per-language translations for this panel's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.panel.localization.empty": "This panel has no localizable name fields.",
  "label.panel.localization.loadError": "Unable to load translations for this panel.",
  "label.panel.localization.field.name": "Име на панела",
  "sidenav.label.admin.panel.editing": "Editing panel: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Click a panel to edit its sections",
  "sidenav.label.admin.panel.addingNew": "Adding a new panel",
  "label.panel.testsCount": "tests",
  "label.panel.addTest": "Add a test",
  "label.panel.tests.filterBySampleType": "Filter by sample type",
  "label.panel.tests.filterBySampleType.all": "All sample types",
  "placeholder.panel.addTest": "Search by name or code…",
  "helper.panel.membershipSync": "Membership writes keep order entry's panel list in sync.",
  "label.panel.col.order": "Поръчка",
  "label.panel.col.testName": "Име на тест",
  "label.panel.col.code": "Код",
  "label.panel.moveUp": "Move up",
  "label.panel.moveDown": "Move down",
  "empty.panel.tests": "No tests yet — search above to add the first one.",
  "helper.panel.loincRouting": "It is also a live routing key — FHIR e-orders match panels by this code at intake. The primary LOINC stays on the panel for list display and order entry.",
  "label.panel.terminology.primary": "Основен",
  "label.panel.terminology.empty": "No terminology mappings yet. The LOINC mapping is the panel's identifier.",
  "label.panel.terminology.saved": "Terminology mappings saved.",
  "label.panel.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.panel.terminology.saveError": "Could not save terminology mappings.",
  "note.panel.positionShared": "Position writes panel_item.sort_order — the same field the test-side Panels section edits.",
  "label.testCatalog.section.labels": "Labels",
  "label.testCatalog.section.terminology": "Terminology",
  "label.testCatalog.labels.col.preset": "Preset",
  "label.testCatalog.labels.col.defaultQty": "Default Qty",
  "label.testCatalog.labels.col.maxQty": "Max Qty",
  "label.testCatalog.labels.col.allowOverride": "Allow Override",
  "label.testCatalog.labels.col.actions": "Действия",
  "label.testCatalog.labels.addLabelType": "Add Label Type",
  "label.testCatalog.labels.addLabelType.placeholder": "Select a label preset…",
  "label.testCatalog.labels.empty": "No label types configured. Add label presets to automatically suggest labels when this test is ordered.",
  "label.testCatalog.labels.loadError": "Unable to load label configuration for this test.",
  "label.testCatalog.labels.saved": "Label configuration saved",
  "label.testCatalog.labels.saveError": "Could not save label configuration.",
  "label.testCatalog.labels.unsaved": "You have unsaved label changes. Click Save to apply them.",
  "label.testCatalog.labels.maxLtDefault": "Max Qty must be greater than or equal to Default Qty.",
  "label.testCatalog.labels.allowOverride.label": "Allow override at order entry",
  "label.testCatalog.labels.generationSettings": "Label Generation Settings",
  "label.testCatalog.labels.remove.action": "Премахни",
  "label.testCatalog.labels.remove.title": "Remove Label Type",
  "label.testCatalog.labels.remove.confirm": "Премахни",
  "label.testCatalog.labels.remove.body": "Remove {name} from this test's label configuration?",
  "label.testCatalog.section.reagents": "Reagents",
  "label.testCatalog.section.analyzers": "Анализатори",
  "label.testCatalog.section.alerts": "Alerts",
  "label.testCatalog.section.accreditation": "Accreditation",
  "label.testCatalog.accreditation.add": "Add accreditation",
  "label.testCatalog.accreditation.added": "Accreditation added",
  "label.testCatalog.accreditation.removed": "Accreditation removed",
  "label.testCatalog.accreditation.empty": "This test is not accredited by any body.",
  "label.testCatalog.accreditation.selectBody": "Choose an accrediting body",
  "label.testCatalog.accreditation.remove": "Remove accreditation",
  "label.testCatalog.accreditation.remove.body": "Remove this test from {body}? Its logo will stop appearing on reports that contain only this test.",
  "label.testCatalog.accreditation.manageLink": "Manage accrediting bodies and expiry dates",
  "label.testCatalog.accreditation.loadError": "Accreditation could not be loaded.",
  "label.testCatalog.accreditation.saveError": "The accreditation could not be added.",
  "label.testCatalog.accreditation.deleteError": "The accreditation could not be removed.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Localization",
  "label.testCatalog.section.display-order": "Display Order",
  "label.sampleType.section.basic-info": "Basic Info",
  "label.sampleType.section.associated-tests": "Associated Tests",
  "label.sampleType.section.terminology": "Terminology",
  "label.sampleType.section.localization": "Localization",
  "label.sampleType.localization.intro": "Edit per-language translations for this sample type's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.sampleType.localization.empty": "This sample type has no localizable name fields.",
  "label.sampleType.localization.loadError": "Unable to load translations for this sample type.",
  "label.sampleType.localization.field.name": "Име на типа проба",
  "label.sampleType.terminology.intro": "Map this sample type to standard terminology codes for interoperability.",
  "label.sampleType.terminology.empty": "No terminology mappings yet.",
  "label.sampleType.terminology.saved": "Terminology mappings saved.",
  "label.sampleType.terminology.saveError": "Could not save terminology mappings.",
  "label.sampleType.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.sampleType.terminology.addHint": "Save this sample type first, then add terminology mappings.",
  "label.sampleType.localization.addHint": "Save this sample type first, then edit its translations.",
  "label.sampleType.name": "Име",
  "label.sampleType.section.display-order": "Display Order",
  "label.sampleType.section.disposal": "Disposal",
  "label.sampleType.displayOrder": "Position in the Sample Type menu",
  "label.sampleType.displayOrder.intro": "Positions this sample type in the order-entry Sample Type menu. Type a position or use the arrows, then save — every sample type is renumbered.",
  "label.sampleType.displayOrder.current": "This sample type",
  "label.sampleType.displayOrder.loading": "Loading sample types...",
  "label.sampleType.displayOrder.saved": "Display order updated.",
  "label.sampleType.displayOrder.saveError": "Could not update display order.",
  "label.sampleType.displayOrder.addHint": "Save this sample type first, then set its menu position.",
  "label.sampleType.disposalInstructions": "Disposal instructions",
  "label.sampleType.disposal.intro": "Free-text reference guidance for disposing of this specimen type. The authoritative, structured handling stays on each test's Storage section and the specimen disposal workflow.",
  "label.sampleType.disposal.placeholder": "e.g. Autoclave before disposal via biohazard waste",
  "label.sampleType.disposal.loading": "Loading disposal instructions...",
  "label.sampleType.disposal.saved": "Disposal instructions saved.",
  "label.sampleType.disposal.saveError": "Could not save disposal instructions.",
  "label.sampleType.disposal.addHint": "Save this sample type first, then add disposal instructions.",
  "label.sampleType.tests.manageIntro": "Tests linked to this sample type. Search the catalog to add more, or remove existing links. The same link can also be managed from a test's Basic Info in the Test Catalog.",
  "label.sampleType.tests.search": "Search tests",
  "label.sampleType.tests.searchPlaceholder": "Search by test name...",
  "label.sampleType.tests.filterBySampleType": "Filter by sample type",
  "label.sampleType.tests.filterBySampleType.all": "Any sample type",
  "label.sampleType.tests.pick": "Test to add",
  "label.sampleType.tests.pickPlaceholder": "Select a test...",
  "label.sampleType.tests.add": "Add test",
  "label.sampleType.tests.addError": "Could not link the test to this sample type.",
  "label.sampleType.tests.remove": "Remove test",
  "label.sampleType.tests.removeError": "Could not unlink the test.",
  "label.sampleType.tests.loading": "Loading associated tests...",
  "label.sampleType.tests.none": "No tests are associated with this sample type.",
  "message.sampleType.add.success": "Sample type saved successfully.",
  "message.sampleType.edit.success": "Sample type updated successfully.",
  "error.sampleType.create.invalidName": "This name contains characters that are not allowed, such as HTML tags. Remove them and try again.",
  "error.sampleType.create.invalid": "The sample type was not created. Check the fields and try again.",
  "error.sampleType.create.duplicateName": "A sample type with this name already exists.",
  "error.sampleType.update.description.409": "Another sample type in this domain already has this description.",
  "error.sampleType.update.abbreviation.409": "Another sample type in this domain already uses this abbreviation.",
  "error.sampleType.update.abbreviation.400": "The abbreviation has at most 10 characters.",
  "error.sampleType.update.whonetCode.400": "The WHONET code has at most 5 characters.",
  "label.sampleType.loading": "Loading sample type...",
  "stock.status.pendingQc": "Очаква QC",
  "stock.status.qcFailed": "Failed QC",
  "stock.status.quarantined": "Quarantined",
  "label.sampleType.whonetCode": "WHONET specimen code",
  "helper.sampleType.whonetCode": "Code written to the WHONET SPECIMEN_TYPE field (maximum 5 characters).",
  "label.sampleType.whonetReturn": "Return to WHONET preview",
  "warning.sampleType.deactivateInUse": "{count} active tests use this type; they won't be orderable while it's inactive.",
  "note.sampleType.associatedTests.viewOnly": "View only — a test's specimen is part of its identity. To run a test on this sample type, create a specimen variant in the Test Catalog.",
  "sidenav.label.admin.sampleType.backToList": "← All Sample Types",
  "sidenav.label.admin.sampleType.editing": "Editing: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Editing sample type",
  "sidenav.label.admin.sampleType.sectionsHelper": "Click a sample type to edit its sections",
  "sidenav.label.admin.sampleType.addingNew": "Adding new sample type",
  "label.testCatalog.localization.locale": "Locale",
  "label.testCatalog.localization.intro": "Edit per-language translations for this test's name and reporting name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.testCatalog.localization.unsaved": "You have unsaved translation changes. Click Save to apply them.",
  "label.testCatalog.localization.loadError": "Unable to load translations for this test.",
  "label.testCatalog.localization.empty": "This test has no localizable name fields.",
  "label.testCatalog.localization.saved": "Translation saved",
  "label.testCatalog.localization.saveError": "Could not save the translation.",
  "label.testCatalog.localization.field.name": "Име на тест",
  "label.testCatalog.localization.field.reportingName": "Reporting Name",
  "label.testCatalog.localization.fallback.en": "Fallback (en)",
  "label.testCatalog.localization.fallback.tooltip": "Showing the English value because no translation is configured for {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Unable to load reflex and calculation cross-links for this test.",
  "label.testCatalog.reflexCalc.reflex.heading": "Рефлексни тестове",
  "label.testCatalog.reflexCalc.reflex.helper": "Rules that automatically order additional tests based on this test's results. Manage in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Име на правило",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Trigger Condition",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Reflex Test(s) Ordered",
  "label.testCatalog.reflexCalc.reflex.empty": "No reflex rules configured. Reflex rules are managed in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.manage": "Manage Reflex Rules",
  "label.testCatalog.reflexCalc.calc.heading": "Calculated Results",
  "label.testCatalog.reflexCalc.calc.helper": "Formulas that use this test's results or that produce this test as output. Manage in Master Lists → Calculated Results.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "This test feeds into",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "This test is calculated by",
  "label.testCatalog.reflexCalc.calc.col.name": "Formula Name",
  "label.testCatalog.reflexCalc.calc.col.formula": "Formula",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Test",
  "label.testCatalog.reflexCalc.calc.empty": "Няма",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "This test does not feed into any calculated result. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "This test is not calculated from other tests. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.manage": "Manage Calculated Results",
  "label.testCatalog.alerts.addRule": "Добави правило",
  "label.testCatalog.alerts.empty": "No alert rules configured. Add a rule to notify recipients when results match a condition.",
  "label.testCatalog.alerts.loadError": "Unable to load alert rules for this test.",
  "label.testCatalog.alerts.saved": "Alert rule saved",
  "label.testCatalog.alerts.saveError": "Could not save the alert rule.",
  "label.testCatalog.alerts.deleted": "Alert rule deleted",
  "label.testCatalog.alerts.deleteError": "Could not delete the alert rule.",
  "label.testCatalog.alerts.nameRequired": "Rule name is required.",
  "label.testCatalog.alerts.valueRequired": "A specific value is required for the Specific Value trigger.",
  "label.testCatalog.alerts.col.name": "Име",
  "label.testCatalog.alerts.col.trigger": "Trigger",
  "label.testCatalog.alerts.col.channels": "Channels",
  "label.testCatalog.alerts.col.ack": "Ack Required",
  "label.testCatalog.alerts.col.enabled": "Enabled",
  "label.testCatalog.alerts.col.actions": "Действия",
  "label.testCatalog.alerts.trigger.ALL": "All Results",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Abnormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Критична",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Specific Value",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Compliance Breach",
  "label.testCatalog.alerts.edit.action": "Редактиране",
  "label.testCatalog.alerts.delete.action": "Изтрий",
  "label.testCatalog.alerts.delete.title": "Delete Alert Rule",
  "label.testCatalog.alerts.delete.confirm": "Изтрий",
  "label.testCatalog.alerts.delete.body": "Delete alert rule {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Add Alert Rule",
  "label.testCatalog.alerts.modal.editTitle": "Edit Alert Rule",
  "label.testCatalog.alerts.field.name": "Име на правило",
  "label.testCatalog.alerts.field.trigger": "Alert when result is:",
  "label.testCatalog.alerts.field.specificValue": "Specific value",
  "label.testCatalog.alerts.field.channels": "Notification channels",
  "label.testCatalog.alerts.field.recipients": "Recipients",
  "label.testCatalog.alerts.field.ackRequired": "Require acknowledgment",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Имейл",
  "label.testCatalog.alerts.recipient.physician": "Ordering Physician",
  "label.testCatalog.alerts.recipient.patient": "Пациент",
  "label.testCatalog.alerts.recipient.facility": "Препращащо заведение",
  "label.testCatalog.alerts.recipient.customPhone": "Custom phone",
  "label.testCatalog.alerts.recipient.customEmail": "Custom email",
  "label.testCatalog.alerts.recipient.roleId": "Notify users with role",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Select a role",
  "label.testCatalog.reagents.col.name": "Reagent Name",
  "label.testCatalog.reagents.col.usage": "Usage Type",
  "label.testCatalog.reagents.col.qty": "Quantity per Test",
  "label.testCatalog.reagents.col.stock": "Ниво на склад",
  "label.testCatalog.reagents.col.actions": "Действия",
  "label.testCatalog.reagents.empty": "No reagents linked. Link reagents from inventory to track consumption per test.",
  "label.testCatalog.reagents.loadError": "Unable to load reagents for this test.",
  "label.testCatalog.reagents.linkButton": "Link Reagent",
  "label.testCatalog.reagents.linkError": "Unable to link one or more reagents. Please try again.",
  "label.testCatalog.reagents.modal.title": "Link Reagents",
  "label.testCatalog.reagents.modal.linkSelected": "Link Selected",
  "label.testCatalog.reagents.modal.select.label": "Reagents",
  "label.testCatalog.reagents.modal.select.placeholder": "Select reagents to link",
  "label.testCatalog.reagents.modal.allLinked": "All available reagents are already linked to this test.",
  "label.testCatalog.reagents.unitPlaceholder": "Единица",
  "label.testCatalog.reagents.updated": "Reagent updated",
  "label.testCatalog.reagents.saveError": "Could not save changes.",
  "label.testCatalog.reagents.unsaved": "You have unsaved reagent changes. Click Save to apply them.",
  "label.testCatalog.reagents.retry": "Retry",
  "label.testCatalog.reagents.unlink.action": "Unlink",
  "label.testCatalog.reagents.unlink.title": "Unlink Reagent",
  "label.testCatalog.reagents.unlink.confirm": "Unlink",
  "label.testCatalog.reagents.unlink.body": "Unlink {name} from this test? Existing results linked to this reagent are unaffected.",
  "label.testCatalog.reagents.unlinked": "Reagent unlinked",
  "label.testCatalog.reagents.unlinkError": "Could not unlink the reagent. Please try again.",
  "label.testCatalog.basicInfo.name": "Име",
  "label.testCatalog.basicInfo.name.helper": "The display name is translated — edit it in the Localization section.",
  "label.testCatalog.basicInfo.reportingName": "Reporting name",
  "label.testCatalog.basicInfo.labUnit": "Lab Unit",
  "label.testCatalog.basicInfo.createInactiveHint": "The test is created Inactive. Configure its sections, then activate it to make it orderable.",
  "sidenav.label.environmental.compliance.tooltip": "Environmental Compliance Dashboard",
  "site.search.helper": "Type at least 2 characters to auto-search. Required for routing results back to the requesting site.",
  "storage.skipped.title": "Storage skipped for {count} sample(s)",
  "test.qc.blankThreshold": "Blank Threshold",
  "test.qc.recoveryWindowPct": "Recovery Window (%)",
  "test.qc.rpdThreshold": "RPD Threshold (%)",
  "test.qc.thresholds.description": "Optional thresholds for environmental/vector QC evaluation. Leave blank if not applicable.",
  "test.qc.thresholds.heading": "QC Acceptance Thresholds",
  "title.testCatalog.createTest": "Create new test",
  "label.testCatalog.testName": "Test name",
  "label.testCatalog.testCode": "Test code",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Sample type",
  "label.testCatalog.basicInfo.sampleTypes": "Sample types",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Select every specimen this test runs on. Configuration is shared across them.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Select at least one sample type.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "This sample type's domain doesn't match the test's domain.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Проба",
  "label.testCatalog.override.shared": "All specimens (shared)",
  "notice.testCatalog.intake.awaitingSpecimen": "Awaiting specimen — this test runs on several specimens; resolve at collection.",
  "tag.testCatalog.finding.noSampleTypeLink": "No sample-type link",
  "error.testCatalog.codeExists": "A test with this code already exists.",
  "error.testCatalog.description.inUse": "Another test already uses this description. Descriptions must be unique — change it and save again.",
  "notification.testCatalog.testCreated": "Test '{name}' created. Complete its configuration in the sections at left.",
  "label.testCatalog.basicInfo.code": "Код",
  "label.testCatalog.basicInfo.description": "Описание",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinical",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environmental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "Change test domain?",
  "label.testCatalog.basicInfo.domainModal.body": "Change this test's domain to {domain}? This affects how the test is categorized in the catalog.",
  "label.testCatalog.basicInfo.amr": "AMR surveillance test",
  "label.testCatalog.basicInfo.cultureWorkflowType": "Culture workflow",
  "label.testCatalog.basicInfo.cultureWorkflowType.none": "Not a culture workflow",
  "label.testCatalog.basicInfo.cultureWorkflowType.BACTERIOLOGY": "Bacteriology",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOBACTERIOLOGY_TB": "Mycobacteriology/TB",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOLOGY": "Микология",
  "label.testCatalog.basicInfo.active": "Активен",
  "label.testCatalog.basicInfo.status": "Статус",
  "label.testCatalog.basicInfo.orderable": "Може да се поръчва",
  "label.testCatalog.basicInfo.saved": "Basic info saved.",
  "label.testCatalog.sampleResults.saved": "Sample & results saved.",
  "label.testCatalog.sampleResults.empty": "No result components yet. Add one to define how this test's results are captured.",
  "label.testCatalog.sampleResults.newComponent": "(new component)",
  "label.testCatalog.sampleResults.code": "Component code",
  "label.testCatalog.sampleResults.isPrimary": "Primary component",
  "label.testCatalog.sampleResults.showOnReport": "Show on patient report",
  "label.testCatalog.sampleResults.label": "Component label",
  "label.testCatalog.sampleResults.resultType": "Тип резултат",
  "label.testCatalog.sampleResults.resultType.N": "Числово",
  "label.testCatalog.sampleResults.resultType.none": "No result type selected",
  "label.testCatalog.sampleResults.preview.noType": "Select a result type above to see how technicians will enter this result.",
  "label.testCatalog.sampleResults.resultType.D": "Single-select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.resultType.M": "Multi-select list",
  "label.testCatalog.sampleResults.resultType.C": "Cascading multi-select",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (validated text)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Common",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Hide advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "A measured number with a unit (e.g. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "One value chosen from a fixed set (e.g. Detected / Not detected).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "A typed comment or description.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "One or more values from a list; no single reference value.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Grouped options; select multiple groups.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "A dilution ratio such as 1:10 or 1:20 (common in serology).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Validated alphanumeric text (a code or short coded value).",
  "label.testCatalog.sampleResults.preview": "Result entry preview",
  "label.testCatalog.sampleResults.previewHelper": "This is what a technician will see when entering this result.",
  "label.testCatalog.sampleResults.purpose": "Define what a technician records for this test and how results are interpreted.",
  "label.testCatalog.sampleResults.labelRequired": "Each result component needs a label before it can be saved.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Select a result type for \"{component}\" before saving.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Most tests record one result. Add a component only if this test produces several values (e.g. a differential).",
  "label.testCatalog.sampleResults.displayOrder": "Display order",
  "label.testCatalog.sampleResults.uom": "Мерна единица",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Add new unit…",
  "label.testCatalog.sampleResults.uom.newName": "Display name",
  "label.testCatalog.sampleResults.uom.newCode": "Код",
  "label.testCatalog.sampleResults.uom.newUcum": "UCUM code",
  "label.testCatalog.sampleResults.uom.newDescription": "Описание",
  "label.testCatalog.sampleResults.uom.saveNew": "Create unit",
  "label.testCatalog.sampleResults.significantDigits": "Значими цифри",
  "label.testCatalog.sampleResults.significantDigits.helper": "Number of digits to keep after the decimal point when a numeric result is entered. Leave blank for no rounding.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Limit of detection (optional)",
  "admin.testCatalog.sampleResults.loq.helper": "Limit of quantification (optional)",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD cannot be greater than LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Detection limits must be zero or more.",
  "admin.testCatalog.qcTargets.section.label": "QC Targets",
  "admin.testCatalog.qcTargets.intro": "The control targets Results Entry judges each QC run against. Enter them once here so technicians only enter the measured value.",
  "admin.testCatalog.qcTargets.column.level": "Control level",
  "admin.testCatalog.qcTargets.column.expected": "Expected value",
  "admin.testCatalog.qcTargets.column.uncertainty": "Uncertainty (±)",
  "admin.testCatalog.qcTargets.column.unit": "Единица",
  "admin.testCatalog.qcTargets.column.overrides": "Lot overrides",
  "admin.testCatalog.qcTargets.column.status": "Статус",
  "admin.testCatalog.qcTargets.column.actions": "Действия",
  "admin.testCatalog.qcTargets.level.low": "Low",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "High",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Expected outcome",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Choose the expected outcome",
  "admin.testCatalog.qcTargets.addTarget": "Add target",
  "admin.testCatalog.qcTargets.addOverride": "Add lot override",
  "admin.testCatalog.qcTargets.lot.label": "Control lot",
  "admin.testCatalog.qcTargets.lot.placeholder": "Search control lots…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "No lots found — manage lots in QC Lot Management",
  "admin.testCatalog.qcTargets.overrides.none": "No lot overrides",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# lot override} other {# lot overrides}}",
  "admin.testCatalog.qcTargets.empty.level": "No target configured — techs enter values at capture",
  "admin.testCatalog.qcTargets.helper.precedence": "At results entry, the control form prefills from the lot override if one exists, otherwise the level default.",
  "admin.testCatalog.qcTargets.showDeactivated": "Show deactivated",
  "admin.testCatalog.qcTargets.deactivate": "Деактивирай",
  "admin.testCatalog.qcTargets.reactivate": "Reactivate",
  "admin.testCatalog.qcTargets.edit": "Edit target",
  "admin.testCatalog.qcTargets.done": "Done",
  "admin.testCatalog.qcTargets.saved": "QC targets saved.",
  "admin.testCatalog.qcTargets.loadError": "The QC targets could not be loaded.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "Uncertainty must be a non-negative number.",
  "error.testCatalog.qcTargets.required": "Every active target needs an expected value and an uncertainty, or an expected outcome.",
  "label.testCatalog.sampleResults.defaultResult": "Резултат по подразбиране",
  "label.testCatalog.sampleResults.allowMultiple": "Allow multiple readings",
  "label.testCatalog.sampleResults.options": "Select-list options",
  "label.testCatalog.sampleResults.options.empty": "No options defined yet. Add at least one option so this result can be entered.",
  "label.testCatalog.sampleResults.option.value": "Стойност",
  "label.testCatalog.sampleResults.option.sortOrder": "Sort order",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Options are shown to technicians in ascending sort order — lower numbers appear first.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Add option",
  "label.testCatalog.sampleResults.addCustomOption": "Add custom option",
  "label.testCatalog.sampleResults.searchDictionary": "Search dictionary values…",
  "label.testCatalog.sampleResults.removeOption": "Remove option",
  "label.testCatalog.sampleResults.interpretations": "Interpretations",
  "label.testCatalog.sampleResults.interpretations.empty": "No interpretations defined. Add one to attach guidance or a severity flag to a result.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Value match",
  "label.testCatalog.sampleResults.interp.selectValue": "Choose a value…",
  "label.testCatalog.sampleResults.interp.numericHint": "e.g. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Интерпретация",
  "label.testCatalog.sampleResults.interp.severity": "Сериозност",
  "label.testCatalog.sampleResults.addInterpretation": "Add interpretation",
  "label.testCatalog.sampleResults.removeInterpretation": "Remove interpretation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Критична",
  "label.testCatalog.sampleResults.actions": "Действия",
  "label.testCatalog.sampleResults.addComponent": "Add component",
  "label.testCatalog.sampleResults.removeComponent": "Remove component",
  "label.testCatalog.sampleResults.moveUp": "Move component up",
  "label.testCatalog.sampleResults.moveDown": "Move component down",
  "label.testCatalog.sampleResults.copyFrom": "Copy configuration from test",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Select a test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copy from test",
  "label.testCatalog.sampleResults.copyConfirm.title": "Replace this test's result configuration?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Every result component, select-list option and interpretation of this test will be replaced with those of {source}. Nothing changes until you click Save. Once saved, the replacement cannot be undone.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Replace configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copied from {source}, not saved yet",
  "label.testCatalog.sampleResults.copyStaged.helper": "Click Save to replace this test's configuration with it, or discard it to keep the current one.",
  "label.testCatalog.sampleResults.copyDiscard": "Discard copied configuration",
  "label.testCatalog.sampleResults.copyEmpty": "{source} has no result configuration to copy.",
  "label.testCatalog.sampleResults.copyLoadError": "The configuration of {source} could not be loaded.",
  "label.testCatalog.sampleResults.copied": "Configuration copied.",
  "label.testCatalog.ranges.activated": "Test activated.",
  "label.testCatalog.ranges.ackModal.title": "Activate with coverage gaps?",
  "label.testCatalog.ranges.ackModal.confirm": "Acknowledge and activate",
  "label.testCatalog.ranges.ackModal.warning": "This test has reference-range coverage gaps.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Мъж",
  "label.testCatalog.ranges.female": "Жена",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "days",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.noUpperLimit": "no upper limit",
  "label.testCatalog.ranges.noLowerLimit": "no lower limit",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.component": "Component",
  "label.testCatalog.ranges.allComponents": "All components",
  "label.testCatalog.ranges.col.sex": "Пол",
  "label.testCatalog.ranges.col.age": "Възрастов диапазон",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Критична",
  "label.testCatalog.ranges.col.valid": "Валиден",
  "label.testCatalog.ranges.col.actions": "Действия",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.component": "Result component",
  "label.testCatalog.ranges.modal.component.all": "All components",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.lowValid": "Valid low",
  "label.testCatalog.ranges.modal.highValid": "Valid high",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.ranges.modal.boundsError": "Bounds must nest outward: valid low ≤ critical low ≤ normal low ≤ normal high ≤ critical high ≤ valid high.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.history.view": "View change history",
  "label.testCatalog.storage.history.title": "Sample Storage — Change History",
  "label.testCatalog.storage.history.loadError": "Unable to load change history.",
  "label.testCatalog.storage.history.empty": "No changes recorded.",
  "label.testCatalog.storage.history.filter": "Filter by field",
  "label.testCatalog.storage.history.col.changedAt": "Changed At",
  "label.testCatalog.storage.history.col.changedBy": "Changed By",
  "label.testCatalog.storage.history.col.field": "Поле",
  "label.testCatalog.storage.history.col.old": "Стара стойност",
  "label.testCatalog.storage.history.col.new": "Нова стойност",
  "label.testCatalog.storage.storageHeading": "Съхранение",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Controlled room temperature (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Cool room (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Cold room (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Ultra-low freezer (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Warm incubator (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Chemical disinfection",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Sharps container",
  "label.testCatalog.storage.disposal.SEWER": "Sewer / drain disposal",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Return to sender",
  "label.testCatalog.storage.disposal.ARCHIVE": "Long-term archive",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "days",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Анализатор",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Sample type",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Could not load the display order.",
  "label.testCatalog.displayOrder.saved": "Display order saved.",
  "label.testCatalog.displayOrder.moveUp": "Move up",
  "label.testCatalog.displayOrder.moveDown": "Move down",
  "label.testCatalog.displayOrder.col.position": "Позиция",
  "label.testCatalog.displayOrder.col.test": "Тест",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "vector.collectedVolume.helper": "Number of organisms in this pool, e.g., number of mosquitoes.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Отказ",
  "vector.complete.details.collectionDate": "Дата на вземане",
  "vector.complete.details.collectionSite": "Collection Site",
  "vector.complete.details.collector": "Вземащ пробата",
  "vector.complete.details.lifecycleStage": "Етап на жизнения цикъл",
  "vector.complete.details.tests": "Тестове",
  "vector.complete.details.title": "Order Details",
  "vector.complete.details.trapType": "Trap Type",
  "vector.complete.labNumber": "Лабораторен номер",
  "vector.complete.newOrder": "New Vector Order",
  "vector.complete.quantity": "Количество",
  "vector.complete.quantity.value": "{count} organisms",
  "vector.complete.status": "Статус",
  "vector.complete.status.processing": "Processing",
  "vector.lifecycleStage.helper": "Developmental stage of the collected organism.",
  "vector.order.collectionContext.helper": "Optional — records ecological conditions at time of collection (bionomics).",
  "vector.order.collectionDate.heading": "Дата на вземане",
  "vector.order.collectionDate.helper": "Date the lot was physically collected from the field. Applies to every sample on this order.",
  "vector.order.site.add.new": "+ Add new site \"{name}\"",
  "vector.order.site.add.new.restricted": "Adding a new sampling site has been disabled by your administrator.",
  "vector.order.site.new.helper": "Will be created as a new sampling site when this order is saved.",
  "vector.order.site.new.tag": "New",
  "vector.order.site.no.match": "No matching site found.",
  "vector.pool.noTests": "No tests recorded",
  "vector.pool.summary": "Pool of {count} {animal}",
  "vector.trapCount.helper": "Number of traps deployed — used with nights to compute density per trap-night.",
  "vector.trapNights.helper": "Number of nights the traps were active. Leave blank if effort was not recorded.",
  "vector.trapType.helper": "Capture method or device used — select a sample type first.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} assigned · {pools} pools",
  "vectorDec.button.back": "Назад",
  "vectorDec.button.discard": "Discard",
  "vectorDec.button.previewGrouping": "Preview Grouping",
  "vectorDec.button.savePools": "Save Pools",
  "vectorDec.button.splitIndividuals": "Split to individuals →",
  "vectorDec.button.splitIndividuals.tooltip": "Quick set: one specimen per pool",
  "vectorDec.button.view": "Преглед",
  "vectorDec.col.children": "Child Specimens",
  "vectorDec.col.positiveTest": "Positive Test",
  "vectorDec.col.results": "Резултати",
  "vectorDec.col.status": "Статус",
  "vectorDec.empty": "No deconvolution tasks.",
  "vectorDec.error.initiateFailed": "Could not initiate deconvolution.",
  "vectorDec.error.loadWorklist": "Could not load deconvolution worklist.",
  "vectorDec.error.minPoolCount": "Number of pools must be at least 2.",
  "vectorDec.error.noAssignedSpecimens": "Drag at least one specimen into a pool before saving.",
  "vectorDec.error.noParent": "No parent SampleItem available to split.",
  "vectorDec.error.poolFloorByType": "Lot has {types} sample types ({names}) — minimum {types} pools required for Random distribution.",
  "vectorDec.error.unassignedSpecimens": "{count} specimens are still unassigned. Assign all specimens before saving.",
  "vectorDec.field.howManyPools": "How many pools?",
  "vectorDec.field.notes": "Бележки",
  "vectorDec.field.organismsPerPool": "Organisms per pool",
  "vectorDec.field.poolCount": "Number of pools",
  "vectorDec.field.strategy": "Assignment method",
  "vectorDec.filter.all": "Всички",
  "vectorDec.filter.status": "Filter by status",
  "vectorDec.heading.preview": "Proposed Pool Grouping",
  "vectorDec.heading.split": "Split into Sub-pools",
  "vectorDec.heading.worklist": "Pool Deconvolution",
  "vectorDec.individualMode.badge": "Individual mode",
  "vectorDec.locationOverride.help": "Override the inherited intake collection site for individual sub-pools. Use this when a single lot was collected from multiple sites.",
  "vectorDec.locationOverride.inherit": "Inherit from lot (default)",
  "vectorDec.locationOverride.notes": "Aliquot notes",
  "vectorDec.locationOverride.site": "Collection site",
  "vectorDec.locationOverride.title": "Per sub-pool collection location (optional)",
  "vectorDec.message.success": "{count} sub-pools created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress.",
  "vectorDec.message.successIndividual": "{count} individual aliquots created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress. VR-07 Sporozoite Confirmation will fire on confirmed positives.",
  "vectorDec.parent.label": "Родител",
  "vectorDec.parent.quantity": "Quantity: {qty}",
  "vectorDec.preview.body": "{count} pools using {strategy}. Drag specimens between pools to adjust before saving.",
  "vectorDec.preview.empty": "No specimens",
  "vectorDec.preview.organisms": "organisms",
  "vectorDec.preview.poolN": "Pool {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "Proposed grouping",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} unassigned — these stay in the original pool.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Reflex rules will fire on save",
  "vectorDec.reflexPreview.parentTests": "Parent test orders ({test}) — re-run on each child",
  "vectorDec.reflexPreview.screeningPanel": "screening panel",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tip: Split to individual specimens to also fire {rules} — these rules only apply to pools with a single organism.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "Decon Complete",
  "vectorDec.status.confirmed": "Confirmed",
  "vectorDec.status.inProgress": "В ход",
  "vectorDec.status.pending": "Review Needed",
  "vectorDec.strategy.manual": "Assign manually — drag and drop specimens into pools",
  "vectorDec.strategy.manual.hint": "Drag and drop specimens into pools yourself",
  "vectorDec.strategy.manual.title": "Assign manually",
  "vectorDec.strategy.random": "Assign randomly — distribute specimens evenly across pools",
  "vectorDec.strategy.random.hint": "Evenly distribute specimens across pools",
  "vectorDec.strategy.random.title": "Assign randomly",
  "vectorDec.strategy.species": "Auto sub-pool by species — group matching specimens together",
  "vectorDec.strategy.species.hint": "Group specimens by species — requires species ID on specimens",
  "vectorDec.strategy.species.title": "Auto sub-pool by species",
  "vectorDec.totalOrganisms": "Total organisms",
  "vectorDec.warning.exceedsParent.body": "{total} organisms requested across child pools, but parent has {parent}. The system will still create {total} children.",
  "vectorDec.warning.exceedsParent.title": "Total exceeds parent quantity",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "Add Panel to Order",
  "vectorId.bloodMeal.added": "Blood-Meal Identification Panel added to specimen test orders.",
  "vectorId.bloodMeal.addedSub": "Provenance: manual (lab tech accepted suggestion). Per BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Blood-meal panel already attached ({skipped} tests).",
  "vectorId.bloodMeal.body": "Order the Mosquito Blood-Meal Identification Panel to identify the host species this specimen fed on.",
  "vectorId.bloodMeal.bulkAdd": "Add Panel to All ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Blood-meal panel processed for {count} specimens.",
  "vectorId.bloodMeal.bulkBody": "Add the Mosquito Blood-Meal Identification Panel to every selected specimen so the lab can identify which vertebrate host the mosquitoes fed on.",
  "vectorId.bloodMeal.bulkSummary": "Blood-meal panel: {added} added, {skipped} already attached, {rejected} rejected.",
  "vectorId.bloodMeal.bulkTitle": "Blood-fed females detected ({count} specimens)",
  "vectorId.bloodMeal.dismiss": "Dismiss",
  "vectorId.bloodMeal.error.add": "Could not add the Mosquito Blood-Meal Identification Panel.",
  "vectorId.bloodMeal.error.dismiss": "Could not record the dismissal.",
  "vectorId.bloodMeal.title": "Blood-fed female detected",
  "vectorId.bulk.applyToCount": "Apply to {count} specimens",
  "vectorId.bulk.heading": "Bulk Apply Species ID",
  "vectorId.bulk.notice.body": "Molecular detail fields (target gene, assay, accession) are not bulk-copied — record those per specimen.",
  "vectorId.bulk.notice.title": "Specimen-specific fields not copied",
  "vectorId.button.bulkApply": "🔖 Bulk Apply ({count})",
  "vectorId.button.cancel": "Отказ",
  "vectorId.button.close": "▲ Close",
  "vectorId.button.confirm": "Потвърди",
  "vectorId.button.confirmAll": "✓ Confirm for all vectors",
  "vectorId.button.confirmResult": "✓ Confirm: {test}",
  "vectorId.button.hideResults": "Hide results",
  "vectorId.button.identify": "▼ Identify",
  "vectorId.button.reviewResults": "Review results ({n})",
  "vectorId.button.save": "Save Identification",
  "vectorId.button.splitPool": "↗ Split",
  "vectorId.col.collectionDate": "Дата на вземане",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "Deconvolution status — whether pool results have been entered and sub-pools are awaiting review.",
  "vectorId.col.idStatus": "ID Status",
  "vectorId.col.lotId": "Lot ID",
  "vectorId.col.organismGroup": "Group",
  "vectorId.col.progress": "Прогрес",
  "vectorId.col.site": "Sampling Site",
  "vectorId.completion.body": "{positive} of {total} sub-pools confirmed ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vectors confirmed",
  "vectorId.completion.body.partial": "Confirmed for all vectors in this pool:",
  "vectorId.completion.heading": "Deconvolution Complete",
  "vectorId.completion.heading.confirmed": "Result Confirmed",
  "vectorId.completion.heading.partial": "Results Partially Confirmed",
  "vectorId.completion.tag": "Decon Complete",
  "vectorId.completion.tag.confirmed": "Confirmed",
  "vectorId.completion.tag.partial": "Partially Confirmed",
  "vectorId.confidence.confirmed": "Confirmed",
  "vectorId.confidence.presumptive": "Presumptive",
  "vectorId.distribution.confirmed": "{count} Confirmed",
  "vectorId.distribution.heading": "Species Distribution",
  "vectorId.distribution.notIdentified": "{count} Not Identified",
  "vectorId.distribution.notYet": "Not yet identified",
  "vectorId.distribution.presumptive": "{count} Presumptive",
  "vectorId.empty": "No lots in this queue.",
  "vectorId.error.accessionFormat": "GenBank accession format: 1–2 letters followed by 5–8 digits (e.g. MW123456).",
  "vectorId.error.confidenceRequired": "Confidence is required.",
  "vectorId.error.loadSpecimens": "Could not load specimens for this lot.",
  "vectorId.error.loadWorklist": "Could not load worklist.",
  "vectorId.error.methodRequired": "Identification method is required.",
  "vectorId.error.notesTooLong": "Notes must be 500 characters or less.",
  "vectorId.error.requiredFields": "Species, method, and confidence are required.",
  "vectorId.error.saveFailed": "Could not save identification.",
  "vectorId.error.speciesRequired": "Species is required.",
  "vectorId.filter.complete": "Завършено",
  "vectorId.filter.complete.sub": "All specimens identified.",
  "vectorId.filter.decon": "Deconvolution",
  "vectorId.filter.decon.sub": "Pool results entered, awaiting technician decision to split or confirm.",
  "vectorId.filter.label": "Статус",
  "vectorId.filter.notstarted": "Not Started",
  "vectorId.filter.notstarted.sub": "Received, 0 specimens identified.",
  "vectorId.filter.partialid": "Partial ID",
  "vectorId.filter.partialid.sub": "Identification in progress.",
  "vectorId.filter.pending": "Pending",
  "vectorId.filter.pending.sub": "All not-complete lots, including pools with results awaiting technician review.",
  "vectorId.form.assayName": "Assay Name",
  "vectorId.form.assayName.placeholder": "Multiplex RT-PCR",
  "vectorId.form.confidence": "Confidence",
  "vectorId.form.genbankAccession": "GenBank Accession",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Етап на жизнения цикъл",
  "vectorId.form.linkedResult": "Link to Pathogen Result",
  "vectorId.form.linkedResultPlaceholder": "Select a result on this lot…",
  "vectorId.form.method": "Method",
  "vectorId.form.molecularDetails": "🔬 Molecular Details",
  "vectorId.form.notes": "Бележки",
  "vectorId.form.physState": "Physiological State",
  "vectorId.form.select": "Select…",
  "vectorId.form.species": "Species",
  "vectorId.form.speciesPlaceholder": "Search genus or species…",
  "vectorId.form.targetGene": "Target Gene",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, 28S rDNA",
  "vectorId.heading.worklist": "Vector Identification Worklist",
  "vectorId.loading": "Loading…",
  "vectorId.message.bulkSuccess": "Identification applied to {count} specimens.",
  "vectorId.message.saveSuccess": "Identification saved.",
  "vectorId.method.both": "Morphological + Molecular",
  "vectorId.method.molecular": "Molecular",
  "vectorId.method.morphological": "Morphological",
  "vectorId.notif.confirmAll.error": "Could not confirm result. Please try again.",
  "vectorId.notif.confirmAll.success": "Result confirmed for all vectors in this pool.",
  "vectorId.notif.deconNeeded.body": "A result has been entered for this pool. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.bodyWithTest": "One of the tests has a result. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.title": "Pool Result Awaiting Review",
  "vectorId.physState.blood_fed": "Blood-fed",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "Half-gravid",
  "vectorId.physState.unfed": "Unfed",
  "vectorId.physState.unknown": "Unknown / not assessed",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Search lots…",
  "vectorId.specimen.col.confidence": "Confidence",
  "vectorId.specimen.col.idStatus": "ID Status",
  "vectorId.specimen.col.label": "Проба",
  "vectorId.specimen.col.labNo": "Лабораторен номер",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Specimen",
  "vectorId.specimen.col.species": "Species",
  "vectorId.specimen.confirmed": "Confirmed",
  "vectorId.specimen.count": "specimens",
  "vectorId.specimen.empty": "No specimens for this lot.",
  "vectorId.specimen.label": "Specimen #{n}",
  "vectorId.specimen.notIdentified": "Not Identified",
  "vectorId.specimen.presumptive": "Presumptive",
  "vectorId.status.complete": "Завършено",
  "vectorId.status.inProgress": "В ход",
  "vectorId.status.notStarted": "Not Started",
  "vectorId.tag.deconComplete": "Завършено",
  "vectorId.tag.deconInProgress": "Decon in progress",
  "vectorId.tag.deconNeeded": "⚠ Review Result",
  "vectorId.tag.subPoolPending": "{count} sub-pool with results",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "Density by site and period",
  "vectorReport.density.effortNotRecorded": "Effort not recorded",
  "vectorReport.density.period": "Period",
  "vectorReport.density.perTrapNight": "Density (per trap-night)",
  "vectorReport.density.pools": "Pools",
  "vectorReport.density.site": "Site",
  "vectorReport.density.specimens": "Specimens",
  "vectorReport.density.title": "Specimen counts by site",
  "vectorReport.density.trapNights": "Trap-nights",
  "vectorReport.description": "Surveillance indices computed from recorded vector collections, species identifications, and pathogen results",
  "vectorReport.empty": "No data for the selected scope.",
  "vectorReport.exportPdf": "Export PDF",
  "vectorReport.fieldMap.description": "Reorder, hide, relabel, or portal-tag the metrics shown in the Manual Entry Helper.",
  "vectorReport.fieldMap.hidden": "Hidden",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metric",
  "vectorReport.fieldMap.order": "Поръчка",
  "vectorReport.fieldMap.portalTag": "Portal tag",
  "vectorReport.fieldMap.title": "Manual Entry Field Map",
  "vectorReport.fieldMap.visibility": "Visibility",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Visible in the Manual Entry Helper",
  "vectorReport.filter.allSites": "All sites",
  "vectorReport.filter.apply": "Приложи",
  "vectorReport.filter.dateRange": "Date range",
  "vectorReport.filter.from": "От",
  "vectorReport.filter.site": "Sampling site",
  "vectorReport.filter.to": "До",
  "vectorReport.freshness": "Data freshness",
  "vectorReport.freshness.as": "Figures as of {time}",
  "vectorReport.freshness.unknown": "unknown",
  "vectorReport.generated": "Generated:",
  "vectorReport.home": "Начало",
  "vectorReport.loadError": "Failed to load surveillance indices. Please try again.",
  "vectorReport.manualEntry.confirmBody": "Record an audit snapshot of this week's figures ({periodStart} – {periodEnd})? Re-submitting a week is recorded as a separate entry.",
  "vectorReport.manualEntry.confirmSubmit": "Потвърди",
  "vectorReport.manualEntry.copied": "Copied to clipboard",
  "vectorReport.manualEntry.copy": "Copy value",
  "vectorReport.manualEntry.empty": "No metrics configured for this period",
  "vectorReport.manualEntry.loading": "Loading week's numbers...",
  "vectorReport.manualEntry.lowConfidence": "Confidence reduced (pool deconvolution below 95%)",
  "vectorReport.manualEntry.markSubmitted": "Mark week submitted",
  "vectorReport.manualEntry.submitError": "Could not record submission",
  "vectorReport.manualEntry.submitted": "Week marked submitted",
  "vectorReport.manualEntry.title": "Manual Entry Helper",
  "vectorReport.manualEntry.week": "Reporting week",
  "vectorReport.mir.classic": "MIR (classical)",
  "vectorReport.mir.observed": "Infection rate (observed)",
  "vectorReport.mir.pathogen": "Pathogen",
  "vectorReport.mir.positivePools": "Positive pools",
  "vectorReport.mir.resolution": "Positive resolution",
  "vectorReport.mir.species": "Species",
  "vectorReport.mir.sporozoite": "Sporozoite rate",
  "vectorReport.mir.sporozoiteNote": "Confidence is reduced when pool deconvolution resolution is below 95%.",
  "vectorReport.mir.title": "Minimum Infection Rate by species",
  "vectorReport.mir.totalSpecimens": "Total specimens",
  "vectorReport.mir.withheld": "Withheld",
  "vectorReport.positivity.notConfigured": "Positivity classification is not configured for this deployment, so infection-rate, positivity, and sporozoite figures are unavailable. Configure result significance in the test catalog to enable them.",
  "vectorReport.positivity.pathogen": "Pathogen",
  "vectorReport.positivity.pct": "Positivity",
  "vectorReport.positivity.poolsPositive": "Pools positive",
  "vectorReport.positivity.poolsTested": "Pools tested",
  "vectorReport.positivity.title": "Pathogen positivity",
  "vectorReport.positivity.unrecognized": "Some results carry a significance value that is not a recognized classification (POSITIVE, NEGATIVE, or INDETERMINATE) and are excluded from positivity counts. Review the test catalog so these results can be counted.",
  "vectorReport.prompt": "Select a date range and site, then choose Apply to view surveillance indices.",
  "vectorReport.qc.detail": "{passed} of {total} analyses passed",
  "vectorReport.qc.passed": "Analyses passed",
  "vectorReport.qc.passRate": "Pass rate",
  "vectorReport.qc.title": "QC pass-rate",
  "vectorReport.qc.total": "Analyses total",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Share",
  "vectorReport.species.species": "Species",
  "vectorReport.species.specimens": "Specimens",
  "vectorReport.species.title": "Species distribution",
  "vectorReport.sporozoite.title": "Sporozoite rate (Anopheles)",
  "vectorReport.title": "Vector Surveillance",
  "vfs.abj": "ABJ (Larva-Free Rate)",
  "vfs.abj.target.below": "✗ ABJ below the 95% Kemenkes target",
  "vfs.abj.target.met": "✓ ABJ meets the 95% Kemenkes target",
  "vfs.bi": "Breteau Index (per 100 houses)",
  "vfs.ci": "Container Index (CI)",
  "vfs.containersExamined": "Containers examined",
  "vfs.containersPositive": "Containers positive",
  "vfs.err.containersExceeded": "Cannot exceed containers examined.",
  "vfs.err.examinedMin": "Must be ≥ 1 when larval data is entered.",
  "vfs.err.housesExceeded": "Cannot exceed houses examined.",
  "vfs.err.negative": "Cannot be negative.",
  "vfs.err.populationMin": "Must be ≥ 1 when pupal data is entered.",
  "vfs.hi": "House Index (HI)",
  "vfs.housesExamined": "Houses examined",
  "vfs.housesPositive": "Houses positive",
  "vfs.indices.title": "Computed indices (preview)",
  "vfs.larval.title": "Larval Survey — Mode C",
  "vfs.populationAtRisk": "Population at risk",
  "vfs.ppi": "Pupae Per Person (PPI)",
  "vfs.pupaeCount": "Pupae count",
  "vfs.pupal.title": "Pupal Survey — Mode D",
  "vfs.surveyMethod": "Survey method",
  "vfs.surveyMethod.placeholder": "Изберете опция",
  "warning.testCatalog.noLoinc": "This test has no LOINC. Analyzer and electronic-order results cannot be imported to it.",
  "warning.testCatalog.duplicateLoinc": "LOINC {code} is also used by {testName}. Incoming results for this code route to only one test (first match) — results may be sent to the wrong test.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Код",
  "label.testCatalog.terminology.col.displayName": "Display name",
  "label.testCatalog.terminology.displayName.placeholder": "e.g. Glucose [Mass/volume] in Serum or Plasma",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.appliesTo": "Applies to",
  "label.testCatalog.terminology.appliesTo.test": "Whole test",
  "label.testCatalog.terminology.col.actions": "Действия",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.code": "Код",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "error.testCatalog.terminology.duplicate": "Duplicate {source} code {code} — this mapping already exists for this test.",
  "error.testCatalog.terminology.invalid": "The mappings could not be saved — check for a duplicate code, an unknown source, or an invalid relationship.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Панел",
  "label.testCatalog.panels.col.position": "Позиция",
  "label.testCatalog.panels.col.actions": "Действия",
  "label.testCatalog.panels.position": "Позиция",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.remove.confirm.heading": "Remove test from panel?",
  "label.testCatalog.panels.remove.confirm.body": "This test will be removed from {panel}. It stays in the catalog and any other panels. You can re-add it later.",
  "label.testCatalog.panels.moveUp": "Move earlier",
  "label.testCatalog.panels.moveDown": "Move later",
  "label.testCatalog.panels.viewOrder": "View this panel's test order",
  "label.testCatalog.panels.orderContext": "Tests in this panel (in order):",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "Enter a name to create a panel and add this test to it. Its sample type, ordering modules and other settings are configured later in the Panel Editor.",
  "notification.testCatalog.panels.created": "Panel '{name}' created and this test added. Configure it further in the Panel Editor.",
  "label.search": "Търсене",
  "label.testCatalog.list": "Каталог на тестовете",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Статус",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Неактивен",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Всяко",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Тип проба",
  "label.testCatalog.list.filter.allSampleTypes": "All sample types",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "No LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Only tests with issues",
  "label.testCatalog.list.health.banner": "{count} tests have configuration issues ({errors} errors · {warnings} warnings)",
  "label.testCatalog.list.health.show": "Show",
  "label.testCatalog.activation.incomplete.heading": "Test cannot be activated yet",
  "label.testCatalog.activation.incomplete.body": "Resolve the following before this test can be activated:",
  "label.testCatalog.list.col.sampleType": "Тип проба",
  "button.testCatalog.newTest": "New test",
  "button.testCatalog.editRelated": "Edit related tests together",
  "button.testCatalog.editRelatedFromEditor": "Edit related tests…",
  "label.testCatalog.editor.noRelated": "No related tests share this test's name.",
  "label.testCatalog.editor.createSaveFirst.title": "Save the test first",
  "label.testCatalog.editor.createSaveFirst": "Complete Basic Info and save. This section becomes available once the test is created.",
  "label.testCatalog.editingNTests": "Editing {count} tests",
  "label.testCatalog.perTestIdentity": "Identity & LOINC (per test)",
  "state.testCatalog.differsAcrossTests": "Differs across tests",
  "button.testCatalog.setAllTo": "Set all to these values",
  "label.testCatalog.group.rangesSaved": "Reference ranges saved to {count} tests.",
  "label.testCatalog.group.storageIntro": "Edit storage & handling once; saving applies it to every selected test.",
  "button.testCatalog.removeFromSet": "Remove from this set",
  "label.testCatalog.group.rangesIntro": "Edit the reference ranges once; saving applies them to every selected test. Identity and LOINC stay per test.",
  "label.testCatalog.group.rangesDiffer": "The selected tests' current ranges are not identical. Saving will set all of them to the values below.",
  "label.testCatalog.ranges.table.sex": "Applies to",
  "label.testCatalog.ranges.table.age": "Възрастов диапазон",
  "label.testCatalog.ranges.table.normal": "Normal (low / high)",
  "label.testCatalog.list.filters": "Филтри",
  "label.testCatalog.list.filters.count": "Filters ({count})",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Управление на методи",
  "sidenav.label.admin.testmgt.reflex": "Управление на рефлексни тестове",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Преглед на каталога с тестове",
  "sidenav.label.admin.usermgt": "Управление на потребители",
  "sideNav.label.arvfollowup1": "ARV проследяване версия 1",
  "sideNav.label.arvfollowup2": "ARV проследяване версия 2",
  "sideNav.label.arvreports1": "ARV начално версия 1",
  "sideNav.label.arvreports2": "ARV начално версия 2",
  "sideNav.label.arvversion1": "ARV версия 1",
  "sideNav.label.associatedpatientreport": "Свързан отчет за пациент",
  "sideNav.label.audittrail": "Одитна следа",
  "sidenav.label.barcode": "Баркод",
  "sidenav.label.batchorder": "Групово въвеждане на поръчки",
  "sideNav.label.bypaneltype": "По тип панел",
  "sideNav.label.bytesttype": "По тип тест",
  "sideNav.label.byunit": "По звено",
  "sideNav.label.collectedarvpatientreports": "Взети ARV отчети за пациенти",
  "sidenav.label.cytology": "Цитология",
  "sidenav.label.cytology.dashboard": "Табло",
  "sideNav.label.delayedvalidation": "Забавена валидация",
  "sidenav.label.editorder": "Редактиране на поръчка",
  "sideNav.label.eidreports1": "EID версия 1",
  "sideNav.label.eidreports2": "EID версия 2",
  "sideNav.label.exportcsvfile": "Експорт на рутинен CSV файл",
  "sideNav.label.followuprequired": "Изисква се проследяване",
  "sideNav.label.generalreport": "Общ отчет",
  "sideNav.label.hivtestsummary": "Резюме на HIV тест",
  "sidenav.label.immunochem": "Имунохистохимия",
  "sidenav.label.immunochem.dashboard": "Табло",
  "sidenav.label.incomingorder": "Електронни поръчки",
  "sideNav.label.intermediatebyservice": "Междинен по услуга",
  "sideNav.label.intermediatereport1": "Междинна версия 1",
  "sideNav.label.intermediatereport2": "Междинна версия 2",
  "sidenav.label.inventory": "Инвентар",
  "sidenav.label.inventory.management": "Управление на инвентар",
  "sidenav.label.inventory.management.tooltip": "Управление на артикули, партиди и нива на склад",
  "sidenav.label.inventory.tooltip": "Управление на инвентар за реагенти, китове и консумативи",
  "sideNav.label.laporanHasil": "Compliance Report",
  "sideNav.label.noncomformitynotification": "Известие за несъответствие",
  "sideNav.label.noncomformityreportsbydate": "По дата",
  "sideNav.label.noncomformityreportsbylabno": "По лаб. номер",
  "sideNav.label.noncomformityreportsbyunit": "По звено и причина",
  "sidenav.label.notebook": "Бележник",
  "sidenav.label.add.order": "Добавяне на поръчка",
  "sidenav.label.clinical.order": "Add Clinical Order",
  "sidenav.label.environmental.compliance": "Compliance Dashboard",
  "sidenav.label.environmental.order": "Add Environmental Order",
  "sidenav.label.vector.order": "Add Vector Order",
  "sidenav.label.order": "Поръчка",
  "sidenav.label.order.collect": "Collect Sample",
  "sidenav.label.order.dashboard": "Табло",
  "sidenav.label.order.enter": "Въведи поръчка",
  "sidenav.label.order.label": "Label & Store",
  "sidenav.label.order.qa": "QA Review",
  "sidenav.label.pathology": "Патология",
  "sidenav.label.pathology.dashboard": "Табло",
  "sideNav.label.referredtestreport": "Отчет за препратени тестове",
  "sideNav.label.rejectionreport": "Отчет за отхвърляне",
  "sidenav.label.reports": "Отчети",
  "sidenav.label.reports.routine": "Рутинни",
  "sidenav.label.reports.study": "Проучване",
  "sidenav.label.results": "Резултати",
  "sidenav.label.results.byrange": "По диапазон лаб. номера",
  "sidenav.label.results.order": "По поръчка",
  "sidenav.label.results.patient": "По пациент",
  "sidenav.label.results.testdate": "По дата на теста",
  "sidenav.label.results.unit": "По звено",
  "sideNav.label.sectionperformance": "Производителност на секцията",
  "sideNav.label.specialrequest": "Специална заявка",
  "sidenav.label.statisticsreport": "Статистически отчет",
  "sidenav.label.statusreport": "Отчет за статус на пациент",
  "sidenav.label.storage.coldstorage": "Мониторинг на хладилно съхранение",
  "sidenav.label.storage.coldstorage.tooltip": "Мониторинг на температура и влажност във фризери и хладилници",
  "sidenav.label.storage.management": "Управление на съхранението",
  "sidenav.label.storage.management.tooltip": "Управление на места за съхранение и устройства",
  "sidenav.label.testsummary": "Резюме на всички тестове",
  "sidenav.label.validation": "Валидация",
  "sidenav.label.validation.order": "Търсене по поръчка",
  "sidenav.label.validation.routine": "Рутинна",
  "sidenav.label.validation.study": "Проучване",
  "sidenav.label.validation.testdate": "Търсене по дата на теста",
  "sideNav.label.viralloaddataexport": "Експорт на данни за вирусен товар",
  "sideNav.label.vlversionnational": "VL национална версия",
  "sidenav.label.workplan": "Работен план",
  "sidenav.label.workplan.panel": "По тип панел",
  "sidenav.label.workplan.priority": "По приоритет",
  "sidenav.label.workplan.test": "По тип тест",
  "sidenav.label.workplan.unit": "По звено",
  "sideNav.title.activityreport": "Отчет за дейността",
  "sidenav.title.aggregatereport": "Обобщени отчети",
  "sideNav.title.arvreports": "ARV отчети",
  "sideNav.title.associatedpatientreport": "Свързан отчет за пациент",
  "sideNav.title.audittrail": "Одитна следа",
  "sideNav.title.collectedarvpatientreports": "Взети ARV отчети за пациенти",
  "sideNav.title.delayedvalidation": "Забавена валидация",
  "sideNav.title.eidreports": "EID отчети",
  "sideNav.title.environmentalReports": "Environmental Reports",
  "sideNav.title.exportbydate": "Експорт по дата",
  "sideNav.title.exportcsvfile": "Експорт на рутинен CSV файл",
  "sideNav.title.indicator": "Индикатор",
  "sideNav.title.intermediatereport": "Междинен отчет",
  "sideNav.title.noncomformityreports": "Отчети за несъответствия",
  "sideNav.title.referredtestreport": "Отчет за препратени тестове",
  "sideNav.title.rejectionreport": "Отчет за отхвърляне",
  "sideNav.title.specialrequest": "Специална заявка",
  "sideNav.title.tatreport": "Turn Around Time",
  "sideNav.title.vectorIdentification": "Vector Identification",
  "sideNav.title.vlreport": "VL отчет",
  "sideNav.label.audittrail.orderEvents": "Order Events",
  "sideNav.label.audittrail.systemEvents": "System Events",
  "sidenav.label.addorder": "Добавяне на поръчка",
  "sidenav.label.admin.sampleTypeManagement": "Sample Type Editor",
  "sideNav.label.qa": "Quality Assurance",
  "sideNav.label.qa.overview": "QA Overview",
  "sideNav.label.qa.qc": "Statistical QC",
  "sideNav.label.qa.qc.dashboard": "QC Dashboard",
  "sideNav.label.qa.qc.alerts": "QC Alerts",
  "sideNav.label.qa.qc.controlLots": "QC Lot Management",
  "sideNav.label.qa.qc.ruleConfig": "Rule Configuration",
  "sideNav.label.qa.qc.reagentQc": "Reagent QC",
  "sideNav.label.qa.qc.manualQc": "Analyzer Manual QC",
  "sideNav.label.qa.qi": "Quality Indicators",
  "sideNav.label.qa.qi.dashboard": "QI Dashboard",
  "sideNav.label.qa.qi.config": "QI Configuration",
  "qa.qiConfig.subtitle": "Set per-indicator target and action thresholds, enable or disable indicators, and override thresholds for specific test sections.",
  "qa.qiConfig.column.overrides": "Overrides",
  "qa.qiConfig.field.enabled": "Track this indicator",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Action threshold",
  "qa.qiConfig.field.category": "Test section",
  "qa.qiConfig.editor.title": "Edit {indicator}",
  "qa.qiConfig.editor.defaults": "Default thresholds",
  "qa.qiConfig.editor.overrides": "Per-section overrides",
  "qa.qiConfig.editor.usesDefault": "Test sections without an override use the indicator default.",
  "qa.qiConfig.editor.noOverrides": "No overrides — every test section uses the default.",
  "qa.qiConfig.editor.addOverride": "Add section override",
  "qa.qiConfig.editor.autoNce": "When the month-to-date value breaches the action threshold, a non-conforming event is created automatically (one per indicator per month).",
  "qa.qiConfig.indicator.tat": "Average Turnaround Time",
  "qa.qiConfig.indicator.rejection": "Rejection Rate",
  "qa.qiConfig.indicator.amendment": "Amendment Rate",
  "qa.qiConfig.indicator.nce": "NCE Pulse",
  "qa.qiConfig.indicator.callback": "Critical Callback Compliance",
  "qa.qiConfig.validation.required": "Both target and action thresholds are required.",
  "qa.qiConfig.validation.range": "Thresholds must be between 0 and 100.",
  "qa.qiConfig.validation.direction": "Target and action threshold are in the wrong order for this indicator.",
  "qa.qiConfig.validation.category": "Choose a test section for each override.",
  "qa.qiConfig.validation.duplicateCategory": "A test section can only be overridden once.",
  "qa.qiConfig.confirmDisableTitle": "Disable this indicator?",
  "qa.qiConfig.confirmDisableBody": "This will hide the dashboard tile, suppress new alerts, and stop auto-generated NCEs for this indicator. Historical data is preserved. Continue?",
  "qa.qiConfig.saveFailed": "Could not save QI configuration.",
  "sideNav.label.qa.qms": "QMS & Improvement",
  "sideNav.label.qa.qms.esigLog": "Electronic Signature Log",
  "sideNav.label.qa.qms.capaRegister": "CAPA Register",
  "sideNav.label.qa.qms.accreditation": "Accreditation",
  "qa.qms.capaRegister.subtitle": "Every corrective and preventive action across all non-conforming events, with due dates and status.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Due This Week",
  "qa.qms.capaRegister.tile.completed": "Completed (90d)",
  "qa.qms.capaRegister.filter.assignee": "Assignee",
  "qa.qms.capaRegister.filter.from": "Due Date (From)",
  "qa.qms.capaRegister.filter.to": "Due Date (To)",
  "qa.qms.capaRegister.column.correctiveAction": "Corrective / Preventive Action",
  "qa.qms.capaRegister.column.assignee": "Person Responsible",
  "qa.qms.capaRegister.status.open": "Open",
  "qa.qms.capaRegister.status.overdue": "Overdue",
  "qa.qms.capaRegister.status.completed": "Завършен",
  "qa.qms.capaRegister.error": "The CAPA register could not be loaded.",
  "qa.qms.accreditation.title": "Test Accreditation",
  "qa.qms.accreditation.subtitle": "Accrediting bodies and per-test enrollment. Drives the accreditation logos on patient reports and the inspector-readiness answer.",
  "qa.qms.accreditation.error": "Accreditation data could not be loaded.",
  "qa.qms.accreditation.actionError": "The change could not be saved.",
  "qa.qms.accreditation.tile.total": "Bodies",
  "qa.qms.accreditation.inForce": "In force: {names}",
  "qa.qms.accreditation.bodies.title": "Accrediting Bodies",
  "qa.qms.accreditation.bodies.add": "Add body",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expires",
  "qa.qms.accreditation.status.ACTIVE": "Активен",
  "qa.qms.accreditation.status.EXPIRING": "Expiring soon",
  "qa.qms.accreditation.status.EXPIRED": "Изтекъл срок",
  "qa.qms.accreditation.status.INACTIVE": "Неактивен",
  "qa.qms.accreditation.body.modal.addTitle": "Add Accrediting Body",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Accrediting Body",
  "qa.qms.accreditation.body.edit": "Edit body",
  "qa.qms.accreditation.body.delete": "Delete body",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 characters: capitals, digits and hyphens. Cannot be changed later.",
  "qa.qms.accreditation.body.field.expiresOn": "Accreditation expires",
  "qa.qms.accreditation.body.field.visibilityMode": "Show the logo on a report when",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Any accredited test is on the report",
  "qa.qms.accreditation.visibility.PERCENTAGE": "A percentage of the report's tests are accredited",
  "qa.qms.accreditation.body.field.thresholdPct": "Threshold (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG or JPEG, at least 64×64 pixels, up to 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Remove logo",
  "qa.qms.accreditation.body.required": "Code, name and expiry date are required.",
  "qa.qms.accreditation.body.saveError": "The accrediting body could not be saved.",
  "qa.qms.accreditation.body.logoError": "The logo could not be uploaded. Use a PNG or JPEG of at least 64×64 pixels and no more than 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Delete Accrediting Body",
  "qa.qms.accreditation.body.delete.body": "Delete {name}? This cannot be undone.",
  "qa.qms.accreditation.body.delete.blocked": "Cannot delete — {count} test accreditations reference this body. Remove them first.",
  "qa.qms.accreditation.enrollments.title": "Enrolled Tests",
  "qa.qms.accreditation.enrollments.add": "Enroll tests",
  "qa.qms.accreditation.enrollment.column.body": "Accrediting Body",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Effective From",
  "qa.qms.accreditation.enrollment.column.expires": "Body Expires",
  "qa.qms.accreditation.enrollment.remove": "Remove enrollment",
  "qa.qms.accreditation.eqa.title": "EQA Coverage of Accredited Scope",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 asks whether every test you claim as accredited takes part in external quality assessment. This compares accredited scope against active EQA enrollments.",
  "qa.qms.accreditation.eqa.column.scope": "Tests in Scope",
  "qa.qms.accreditation.eqa.column.covered": "Covered by EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Gaps",
  "qa.qms.accreditation.eqa.noGaps": "Full coverage",
  "qa.qms.accreditation.eqa.gapsMore": "{names} and {count} more",
  "qa.qms.accreditation.eqa.error": "EQA coverage could not be loaded.",
  "qa.qms.accreditation.filter.body": "Accrediting body",
  "qa.qms.accreditation.filter.test": "Test: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Enroll Tests",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Effective from (optional)",
  "qa.qms.accreditation.enroll.required": "Select an accrediting body and at least one test.",
  "qa.qms.accreditation.enroll.failed": "The enrollment was rejected.",
  "qa.qms.accreditation.enrollment.delete.title": "Remove Enrollment",
  "qa.qms.accreditation.enrollment.delete.body": "Remove {test} from {body}?",
  "qa.qms.esigLog.subtitle": "Every electronic signature recorded in the system — who signed what, when, and why.",
  "qa.qms.esigLog.column.signer": "Signer",
  "qa.qms.esigLog.column.subject": "Тема",
  "qa.qms.esigLog.filter.subjectType": "Subject Type",
  "qa.qms.esigLog.filter.apply": "Apply Filters",
  "qa.qms.esigLog.export.confirm.title": "Export without filters?",
  "qa.qms.esigLog.export.confirm.body": "No filters are applied, so this exports every signature in the selected date range (up to 10,000 rows).",
  "qa.qms.esigLog.meaning.AUTHORED": "Authored",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validated & Released",
  "qa.qms.esigLog.meaning.REJECTED": "Rejected",
  "qa.qms.esigLog.error": "Unable to load the signature log. Please try again.",
  "qa.qi.dashboard.subtitle": "Five quality indicators including the optional Critical Callback Compliance opt-in.",
  "qa.qi.dashboard.window.label": "Reporting window",
  "qa.qi.dashboard.window.7d": "Rolling 7 days",
  "qa.qi.dashboard.window.30d": "Rolling 30 days",
  "qa.qi.dashboard.window.90d": "Rolling 90 days",
  "qa.qi.dashboard.window.ytd": "Year to date",
  "qa.qi.dashboard.lastRecomputed": "Last recomputed: {time}",
  "qa.qi.dashboard.viewDetail": "View detail",
  "qa.qi.dashboard.tileInfo": "What does this tile measure?",
  "qa.qi.disabled.toast.title": "Indicator disabled",
  "qa.qi.disabled.toast.message": "This quality indicator is disabled in QI Configuration; its detail page is unavailable.",
  "qa.qi.dashboard.tile.tat.label": "Average TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Average turnaround time from sample receipt to result validation, across all completed test orders in the reporting window.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.tat.secondary": "Across {count, plural, one {# lab unit} other {# lab units}} · Slowest: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "No completed test orders in this window.",
  "qa.qi.dashboard.tile.tat.error": "Turnaround data is unavailable.",
  "qa.qi.dashboard.tile.rejection.label": "Rejection Rate",
  "qa.qi.dashboard.tile.amendment.label": "Amendment Rate",
  "qa.qi.dashboard.tile.ncePulse.label": "NCE Pulse",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Critical non-conforming events not yet acknowledged, as of now. A current count, not a trend.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critical pending",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.qi.dashboard.tile.ncePulse.error": "NCE data is unavailable.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Results corrected after their patient report went out, as a share of results released in the reporting window.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} amended of {released} released",
  "qa.qi.dashboard.tile.amendment.empty": "No results released in this window.",
  "qa.qi.dashboard.tile.amendment.error": "Amendment data is unavailable.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Tests rejected at results entry or validation, as a share of tests started in the reporting window.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejected of {total} started",
  "qa.qi.dashboard.tile.rejection.empty": "No tests started in this window.",
  "qa.qi.dashboard.tile.rejection.error": "Rejection data is unavailable.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · action {action}",
  "qa.qi.amendment.title": "Amendment Rate — Detail",
  "qa.qi.amendment.subtitle": "Results corrected after their patient report went out.",
  "qa.qi.amendment.column.amendedAt": "Amended at",
  "qa.qi.amendment.column.priorValue": "Prior value",
  "qa.qi.amendment.column.currentValue": "Current value",
  "qa.qi.amendment.column.amendedBy": "Amended by",
  "qa.qi.amendment.column.releasedAt": "Released at",
  "qa.qi.amendment.column.timeToAmend": "Time to amend",
  "qa.qi.amendment.rate.label": "Amendment rate",
  "qa.qi.amendment.trend.empty": "No trend data in this window.",
  "qa.qi.amendment.breakdown.title": "By test",
  "qa.qi.amendment.breakdown.column.rate": "Rate",
  "qa.qi.rejection.title": "Rejection Rate — Detail",
  "qa.qi.rejection.subtitle": "Tests rejected at results entry, with the recorded rejection reason.",
  "qa.qi.rejection.column.rejectedAt": "Rejected at",
  "qa.qi.rejection.column.rejectedBy": "Rejected by",
  "qa.qi.rejection.heatmap.title": "Heatmap: ordering location × test section",
  "qa.qi.rejection.heatmap.section": "Test section",
  "qa.qi.rejection.heatmap.unknown": "Unknown location",
  "qa.qi.rejection.heatmap.unknownSection": "Unknown section",
  "qa.qi.rejection.heatmap.legend": "Cells colored by rate against the lab's thresholds: green ≤ {target}%, amber in between, red ≥ {action}%. Hover a cell for rejected / started counts.",
  "qa.qi.rejection.rate.label": "Rejection rate",
  "qa.qi.rejection.reasons.title": "By reason (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% of rejections",
  "qa.qi.rejection.reasons.column.cumulative": "Cumulative %",
  "qa.qi.rejection.reasons.donut.label": "Rejections",
  "qa.qi.rejection.reasons.insight": "Top {count} of {total} reasons account for {percent}% of rejections — addressing {reason} first has the biggest impact.",
  "qa.qi.rejection.breakdown.other": "Other ({count} tests)",
  "qa.qi.rejection.list.title": "Individual rejections",
  "qa.qi.amendment.list.title": "Individual amendments",
  "qa.qi.callback.button": "Log callback",
  "qa.qi.callback.banner.title": "Critical results need a clinician callback",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# saved critical result on this page has no callback logged — read-back required (TJC NPSG.02.03.01).} other {# saved critical results on this page have no callback logged — read-back required (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Log critical callback",
  "qa.qi.callback.field.recipientName": "Person notified",
  "qa.qi.callback.field.recipientName.placeholder": "Name of clinician or ward contacted",
  "qa.qi.callback.field.status": "Callback outcome",
  "qa.qi.callback.status.CONFIRMED": "Confirmed with read-back",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Reached, no read-back",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Unable to reach",
  "qa.qi.callback.save.success": "Callback logged",
  "qa.qi.callback.save.fail": "Failed to log callback",
  "qa.qi.callback.title": "Critical Callback Compliance — Detail",
  "qa.qi.callback.subtitle": "Released critical results and whether each was phoned to a clinician with read-back inside the callback target window.",
  "qa.qi.callback.distribution.title": "Time-to-acknowledge distribution",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "No ack",
  "qa.qi.callback.failures.title": "Failures ({count}) by reason",
  "qa.qi.callback.failures.overTarget": "Over target",
  "qa.qi.callback.failures.unableToReach": "Unable to reach",
  "qa.qi.callback.failures.noReadback": "No read-back recorded",
  "qa.qi.callback.failures.noCallback": "No callback recorded",
  "qa.qi.callback.list.title": "Critical results in window",
  "qa.qi.callback.rate.label": "Callback compliance (read-back within {minutes} min)",
  "qa.qi.callback.status.notLogged": "Not logged",
  "qa.qi.callback.column.status": "Callback status",
  "qa.qi.callback.column.timeToCallback": "Time to callback",
  "qa.qi.callback.column.loggedBy": "Logged by",
  "qa.qi.dashboard.tile.callback.label": "Critical Callback Compliance",
  "qa.qi.dashboard.tile.callback.tooltip": "Released critical results with a confirmed read-back callback within the lab's callback target window. Opt-in — enable in QI Configuration. Compliance is recomputed from current critical ranges.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} of {critical} critical results acknowledged within target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.callback.empty": "No critical results in this window.",
  "qa.qi.dashboard.tile.callback.error": "Callback data is unavailable.",
  "qa.qi.dashboard.tile.callback.disabled": "Not enabled — turn on in QI Configuration.",
  "qa.empty.callback.title": "No critical results in this window",
  "qa.empty.callback.subhead": "Released critical results appear here with their callback documentation status.",
  "qa.overview.rejection.caption": "rejected at results entry (30d)",
  "qa.overview.rejection.ofStarted": "{rejected} of {total} started",
  "qa.overview.callback.caption": "critical read-back compliance (30d)",
  "qa.overview.callback.ofCritical": "{confirmed} of {critical} confirmed",
  "qa.overview.callback.none": "no critical results in window",
  "qa.overview.week.confirmedCount": "{count} confirmed",
  "qa.overview.amendment.caption": "amended after report (30d)",
  "qa.overview.amendment.ofReleased": "{amended} of {released} released",
  "qa.future.subtitle": "Future feature — design exists; build not yet scheduled.",
  "qa.future.questionLabel": "The question this feature answers",
  "qa.future.whyLabel": "Why it matters",
  "qa.future.readDesignDoc": "Read design doc on GitHub",
  "qa.future.reagentQc.question": "Has this reagent lot been verified before we use it on patients?",
  "qa.future.reagentQc.summary": "Per-lot QC frequency tracking. Before a new reagent lot is used clinically, the system requires documented verification samples comparing the new lot against the old lot or a peer-comparison reference.",
  "qa.future.reagentQc.why": "Without lot verification, a bad reagent lot can ruin a week of patient results before anyone notices. Most labs do this informally today; shipping it as a system feature catches the cases where the informal process fails.",
  "qa.future.manualQc.question": "Did the technician run a daily control on this instrument today, and did it pass?",
  "qa.future.manualQc.summary": "Daily PASS/FAIL log per instrument. Different instruments have different daily checks; the system holds them all to one shape: a daily PASS/FAIL log with a signer, a timestamp, and a block on instrument use if FAIL.",
  "qa.future.manualQc.why": "The first thing an inspector asks when they walk into a lab is 'show me your daily QC log for this instrument.' A signed log per instrument per day, every day. Forgetting it is what fails inspections.",
  "qa.overview.subtitle": "Daily snapshot for the QA Officer",
  "qa.overview.comingSoon": "Coming soon",
  "qa.overview.section.attention": "Attention Required",
  "qa.overview.section.thisWeek": "This Week",
  "qa.overview.section.pillars": "Pillar Status",
  "qa.overview.section.activity": "Recent Activity",
  "qa.overview.section.inspector": "Inspector readiness — five ISO 15189 quality questions",
  "qa.overview.attention.criticalNce": "Critical NCEs pending acknowledgment",
  "qa.overview.attention.criticalResults": "Critical results in last 24 hours",
  "qa.overview.attention.overdueCapas": "Overdue CAPAs",
  "qa.overview.attention.qcViolations": "QC violations in last 24 hours",
  "qa.overview.attention.effectivenessReview": "CAPA effectiveness reviews due",
  "qa.overview.attention.eqaDue": "EQA submissions due in next 14 days",
  "qa.overview.attention.nceSla": "NCEs nearing acknowledgment SLA",
  "qa.overview.tile.criticalCallback": "Critical Callback",
  "qa.overview.week.newNces": "New NCEs",
  "qa.overview.week.ncesResolved": "NCEs resolved",
  "qa.overview.week.capasCompleted": "CAPAs completed",
  "qa.overview.week.qcViolations": "QC violations",
  "qa.overview.week.criticalResults": "Critical results",
  "qa.overview.week.eqaSubmissions": "EQA submissions",
  "qa.overview.week.auditEntries": "Audit log entries",
  "qa.overview.week.signatureEvents": "Signature events",
  "qa.overview.inspector.q1": "Are runs in control?",
  "qa.overview.inspector.q2": "How did EQA perform last cycle?",
  "qa.overview.inspector.q3": "Are QIs on target?",
  "qa.overview.inspector.q4": "Open critical NCEs?",
  "qa.overview.inspector.q5": "Accreditation status?",
  "qa.overview.inspector.q1.answer": "{inControl} of {total} instruments in control (30d)",
  "qa.overview.inspector.q3.answer": "Avg TAT {tat} vs prior 30d",
  "qa.overview.inspector.q4.answer": "{count} critical NCEs pending acknowledgment",
  "qa.overview.inspector.q5.answer": "{active} of {total} in force, {expiring} expiring, {expired} expired",
  "qa.overview.inspector.q5.noData": "No accrediting bodies configured",
  "qa.overview.week.severityBreakdown": "{critical} critical · {major} major · {minor} minor",
  "qa.overview.week.overdueCount": "{count} overdue",
  "qa.overview.week.currentlyOpen": "currently open",
  "qa.overview.pillar.qc.text": "{inControl} of {total} instruments in control",
  "qa.overview.pillar.qc.noData": "No QC data yet",
  "qa.overview.pillar.qi.text": "Avg TAT {tat}",
  "qa.overview.pillar.qi.noData": "No TAT data yet",
  "qa.overview.pillar.qi.disabled": "Not currently tracked",
  "qa.overview.pillar.qms.text": "{critical} critical pending · {capa} in corrective action",
  "qa.overview.activity.viewAudit": "View full audit trail",
  "qa.overview.activity.empty": "No activity in the last 24 hours",
  "qa.empty.activity.subhead": "Attested actions across all pillars appear here as they happen.",
  "qa.empty.attention.title": "Nothing needs attention right now",
  "qa.empty.attention.subhead": "Critical NCEs, overdue CAPAs, and QC violations surface here when they occur.",
  "qa.empty.amendment.title": "No amendments in this window",
  "qa.empty.amendment.subhead": "Amendments appear here when a released result is corrected.",
  "qa.empty.rejection.title": "No rejections in this window",
  "qa.empty.rejection.subhead": "Rejections appear here when a test is rejected at results entry or validation.",
  "qa.empty.capaRegister.title": "No CAPAs match these filters",
  "qa.empty.capaRegister.subhead": "Corrective and preventive actions appear here as they are recorded against non-conforming events.",
  "qa.empty.accreditation.bodies.title": "No accrediting bodies yet",
  "qa.empty.accreditation.bodies.subhead": "Add the bodies that accredit this laboratory to start tracking per-test accreditation.",
  "qa.empty.accreditation.enrollments.title": "No enrollments match these filters",
  "qa.empty.accreditation.enrollments.subhead": "Enroll tests under an accrediting body to show its logo on patient reports.",
  "qa.empty.accreditation.eqa.title": "Nothing to compare yet",
  "qa.empty.accreditation.eqa.subhead": "Once tests are enrolled under an accrediting body, their EQA coverage is compared here.",
  "qa.empty.esigLog.title": "No signatures in this window",
  "qa.empty.esigLog.subhead": "Signatures appear here as results are authored and validated. Try a wider date range or fewer filters.",
  "qa.empty.tat.title": "No results in this window",
  "qa.empty.tat.subhead": "Turnaround times appear here as test orders are completed and validated. Try a different date range.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# lab unit} other {# lab units}} this period",
  "qa.overview.activity.yesterday": "Yesterday {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "authored results for",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "validated & released",
  "qa.overview.activity.meaning.REJECTED": "rejected",
  "qa.overview.activity.qc": "QC alert: {rule} ({severity}) on {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} reported {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} acknowledged {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} assigned {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} added a note to {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} updated the status of {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} updated corrective action on {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} resolved {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} updated {nce}",
  "sidenav.title.statusreport": "Отчет за статус на пациент",
  "systemAudit.filter.startDate": "Начална дата",
  "systemAudit.filter.endDate": "Крайна дата",
  "systemAudit.filter.entityType": "Тип обект (Entity Type)",
  "systemAudit.filter.action": "Действие",
  "systemAudit.filter.search": "Търсене",
  "systemAudit.filter.export": "Export CSV",
  "systemAudit.table.heading.time": "Време",
  "systemAudit.table.heading.entityType": "Тип обект (Entity Type)",
  "systemAudit.table.heading.entityId": "Entity ID",
  "systemAudit.table.heading.action": "Действие",
  "systemAudit.table.heading.user": "Потребител",
  "systemAudit.table.heading.changes": "Changes",
  "systemAudit.noResults": "No system events found for the given filters.",
  "systemAudit.filter.all": "Всички",
  "systemAudit.filter.user": "Потребител",
  "systemAudit.filter.searchText": "Търсене",
  "systemAudit.filter.searchText.placeholder": "Search by entity ID...",
  "systemAudit.filter.exportPdf": "Export PDF",
  "systemAudit.filter.selectedPatient": "Selected Patient",
  "systemAudit.filter.selectedPatient.none": "Няма",
  "systemAudit.filter.selectPatient": "Select Patient",
  "systemAudit.filter.selectAnotherPatient": "Select Another Patient",
  "systemAudit.action.insert": "Insert",
  "systemAudit.action.update": "Update",
  "systemAudit.action.delete": "Изтрий",
  "site.branding.cancel": "Отказ",
  "site.branding.color.format.error": "Невалиден формат на цвета. Използвайте валиден CSS цвят (напр. #0f62fe)",
  "site.branding.color.hex.label": "Hex код на цвят",
  "site.branding.colorPicker.helperText": "Въведете всеки CSS цвят (напр. #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe или blue",
  "site.branding.confirm.remove": "Премахване на лого",
  "site.branding.confirm.remove.message": "Сигурни ли сте, че искате да премахнете това лого и да се върнете към логото по подразбиране на OpenELIS?",
  "site.branding.current.logo": "Текущо лого",
  "site.branding.description": "Персонализирайте визуалния брандинг на вашата организация, включително лога и цветове",
  "site.branding.error.remove": "Грешка при премахване на файла с логото.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Икона, показвана в разделите на браузъра и отметките",
  "site.branding.file.format.error": "Неподдържан файлов формат. Използвайте PNG, SVG или JPG/JPEG",
  "site.branding.file.pending": "Файлът е избран – кликнете върху „Запази промените“, за да го качите",
  "site.branding.file.size.error": "Размерът на файла надвишава лимита от 2MB",
  "site.branding.formats": "Formats: PNG, SVG, JPG (max 2MB)",
  "site.branding.header.color": "Цвят на хедъра",
  "site.branding.header.color.description": "Фонов цвят за горната лента (хедъра) на приложението",
  "site.branding.header.logo": "Лого на хедъра",
  "site.branding.header.logo.description": "Лого, показвана в горния ляв ъгъл на приложението",
  "site.branding.login.logo": "Лого на страницата за вход",
  "site.branding.login.logo.description": "Лого, показвано на страницата за влизане в системата",
  "site.branding.login.using.header.logo": "Използване на логото от хедъра за страницата за вход",
  "site.branding.logo.upload.success": "Логото бе качено успешно",
  "site.branding.no.logo": "Няма персонализирано лого (използва се това по подразбиране)",
  "site.branding.preview": "Предварителен преглед",
  "site.branding.primary.color": "Основен цвят",
  "site.branding.primary.color.description": "Цвят за основните бутони, активните елементи от менюто и връзките",
  "site.branding.remove.favicon": "Премахване на Favicon",
  "site.branding.remove.header.logo": "Премахване на логото на хедъра",
  "site.branding.remove.login.logo": "Премахване на логото за вход",
  "site.branding.remove.logo": "Премахване на лого",
  "site.branding.reset.confirmation": "Сигурни ли сте, че искате да нулирате всички брандинг настройки към тези по подразбиране? Това ще премахне всички персонализирани лога и цветове.",
  "site.branding.reset.error": "Грешка при нулиране на брандинга.",
  "site.branding.reset.success": "Брандингът бе нулиран успешно до стойностите по подразбиране.",
  "site.branding.reset.to.defaults": "Нулиране към брандинг по подразбиране",
  "site.branding.save": "Запази промените",
  "site.branding.save.error": "Грешка при запазване на брандинг конфигурацията",
  "site.branding.save.success": "Брандинг конфигурацията бе запазена успешно",
  "site.branding.secondary.color": "Вторичен цвят",
  "site.branding.secondary.color.description": "Цвят за вторичните бутони, граници и неактивни състояния",
  "site.branding.section.colors": "Цветове",
  "site.branding.section.logos": "Лога",
  "site.branding.title": "Брандиране на сайта",
  "site.branding.unsaved.changes": "Имате незапазени промени. Искате ли да ги запазите, отхвърлите или да откажете операцията?",
  "site.branding.unsaved.changes.warning": "Имате незапазени промени. Кликнете върху „Запази“, за да ги приложите.",
  "site.branding.upload.favicon": "Качване на Favicon",
  "site.branding.upload.header.logo": "Качване на лого за хедъра",
  "site.branding.upload.login.logo": "Качване на лого за вход",
  "site.branding.upload.logo": "Качване на лого",
  "site.branding.use.header.logo.for.login": "Използвай същото лого като в хедъра",
  "siteInfo.description.default.barcode": "Посочете броя баркод етикети по подразбиране, които трябва да се печатат с всяка поръчка и проба.",
  "siteInfo.description.dimensions": "Посочете размерите, на които трябва да отговарят баркод етикетите при печат.",
  "siteInfo.description.elements": "Маркирайте незадължителните елементи, които да се появяват на етикетите.",
  "siteInfo.description.max.barcode": "Посочете максималния брой баркод етикети, които могат да бъдат отпечатани за всяка поръчка или проба.",
  "siteInfo.elements.mandatory": "Задължителни елементи",
  "siteInfo.elements.optional": "Незадължителни елементи",
  "siteInfo.section.altAccession": "Предварително отпечатан номер на акцесия на баркода",
  "siteInfo.section.elements": "Елементи на баркод етикета",
  "siteInfo.section.number": "Номер на баркод етикета",
  "siteInfo.section.size": "Размери на баркод етикета",
  "siteInfo.title.default.barcode": "Баркод етикети по подразбиране",
  "siteInfo.title.default.barcode.block": "Блок",
  "siteInfo.title.default.barcode.height": "Височина",
  "siteInfo.title.default.barcode.order": "Поръчка",
  "siteInfo.title.default.barcode.order.none": "Няма",
  "siteInfo.title.default.barcode.slide": "Предметно стъкло",
  "siteInfo.title.default.barcode.specimen": "Проба",
  "siteInfo.title.default.barcode.freezer": "Freezer",
  "siteInfo.title.default.barcode.width": "Ширина",
  "siteInfo.title.max.barcode": "Максимум баркод етикети",
  "started.date": "Дата на започване",
  "status": "Статус",
  "status.in.progress": "В ход",
  "status.unknown": "Неизвестен",
  "stillThere.message": "Потребителската сесия ще изтече скоро. Кликнете някъде, за да останете в системата.",
  "stillThere.title": "Още ли сте тук?",
  "stock.available": "Налично",
  "stock.level": "Ниво на склад",
  "stock.status": "Статус на склада",
  "stock.status.expired": "Изтекъл срок",
  "stock.status.expiring": "Изтичащ срок",
  "stock.status.expiringIn": "Expiring ({days}d)",
  "stock.status.inStock": "В наличност",
  "stock.status.lowStock": "Ниска наличност",
  "stock.status.outOfStock": "Няма наличност",
  "storage.active": "Активен",
  "storage.add.device": "Добавяне на устройство",
  "storage.add.location": "Местоположение",
  "storage.add.location.option": "Добавяне на местоположение...",
  "storage.add.new.device": "Добавяне на ново устройство",
  "storage.add.rack": "Добавяне на стелаж",
  "storage.add.box": "Add Box",
  "storage.add.room": "Добавяне на стая",
  "storage.add.shelf": "Добавяне на рафт",
  "storage.allAssigned.title": "All Samples Assigned",
  "storage.assign.button": "Задаване на местоположение",
  "storage.assign.title": "Assign Storage Location",
  "storage.assigned": "Assigned",
  "storage.assigned.by": "Зададено от",
  "storage.assigned.date": "Дата на зачисляване",
  "storage.barcode.scan.placeholder": "Сканирайте баркод или въведете ръчно",
  "storage.bulk.move.auto.assigned": "Автоматично зачислени позиции (могат да се редактират)",
  "storage.bulk.move.preview": "Преглед на групово преместване",
  "storage.cannotDelete.hasAssignments": "Невъзможност за изтриване на {entityType} „{name}“: има {count} зачислена(и) проба(и)",
  "storage.cannotDelete.hasChildren": "Невъзможност за изтриване на {entityType} „{name}“: съдържа {count} {childType}(а)",
  "storage.capacity.calculated": "Изчислен",
  "storage.capacity.manual": "Ръчен лимит",
  "storage.capacity.undetermined.tooltip": "Капацитетът не може да бъде изчислен: някои под-местоположения нямат дефиниран капацитет",
  "storage.capacity.warning": "{location} е запълнен на {percentage}%. Помислете за алтернативно съхранение.",
  "storage.code.change.acknowledge": "Разбирам и искам да продължа с промяната на кода",
  "storage.code.change.warning": "Предупреждение",
  "storage.code.change.warning.message": "Промяната на кода ще направи невалидни всички предварително отпечатани етикети за това местоположение.",
  "storage.confirm.add.device": "Искате ли да създадете ново устройство „{name}“?",
  "storage.conditionNotes": "Condition Notes",
  "storage.conditionNotes.placeholder": "Enter any notes about storage conditions...",
  "storage.confirm.delete": "Потвърди изтриването",
  "storage.create.room.error": "Неуспешно създаване на стая: {error}",
  "storage.create.room.success": "Стаята „{name}“ бе създадена успешно",
  "storage.current.location": "Текущо местоположение",
  "storage.currentLocation": "Текущо местоположение",
  "storage.delete.admin.only": "Само глобални администратори могат да изтриват местоположения",
  "storage.delete.are.you.sure": "Сигурни ли сте, че искате да изтриете",
  "storage.delete.cannot.be.undone": "Това действие не може да бъде отменено.",
  "storage.delete.cascade.confirm": "Потвърди каскадно изтриване",
  "storage.delete.cascade.confirmation.checkbox": "Потвърждавам, че искам да изтрия това местоположение и всички негови под-местоположения. Всички проби ще останат без зачислено място. Действието е необратимо.",
  "storage.delete.cascade.summary": "Това ще изтрие {childCount} {childType}(а) и ще отмени зачисляването на {sampleCount} проба(и). Продължавате ли?",
  "storage.delete.cascade.warning": "Предупреждение за каскадно изтриване",
  "storage.delete.checking": "Проверка на ограниченията...",
  "storage.delete.confirmation.checkbox": "Потвърждавам, че искам да изтрия това местоположение. Действието е необратимо.",
  "storage.delete.constraints.title": "Невъзможност за изтриване",
  "storage.delete.device": "Изтриване на устройство",
  "storage.delete.error": "Неуспешно изтриване на местоположение",
  "storage.delete.location": "Изтриване на местоположение",
  "storage.delete.rack": "Изтриване на стелаж",
  "storage.delete.room": "Изтриване на стая",
  "storage.delete.shelf": "Изтриване на рафт",
  "storage.device.code": "Код",
  "storage.device.communicationProtocol": "Комуникационен протокол",
  "storage.device.communicationProtocol.helper": "Протокол за комуникация с устройството (напр. BACnet)",
  "storage.device.ipAddress": "IP адрес",
  "storage.device.ipAddress.helper": "IPv4 или IPv6 адрес за оборудване, свързано към мрежата",
  "storage.device.label": "Устройство",
  "storage.device.name": "Име",
  "storage.device.placeholder": "Изберете или напишете, за да създадете устройство...",
  "storage.device.port": "Порт",
  "storage.device.port.helper": "Номер на порт (1-65535) за комуникация",
  "storage.device.room": "Стая",
  "storage.device.type": "Тип",
  "storage.edit.device": "Редактиране на устройство",
  "storage.edit.error.loadLocation": "Failed to load location",
  "storage.edit.error.saveFailed": "Запазването е неуспешно",
  "storage.edit.error.saveHttp": "Save failed (HTTP {status})",
  "storage.edit.rack": "Редактиране на стелаж",
  "storage.edit.room": "Редактиране на стая",
  "storage.edit.shelf": "Редактиране на рафт",
  "storage.edit.selectParent": "Select {parent}",
  "storage.editbox.error.loadBox": "Failed to load box",
  "storage.editbox.selectRack": "Select rack",
  "storage.box.capacity": "Capacity",
  "storage.box.gridSize": "Grid size",
  "storage.box.rows": "Rows",
  "storage.box.columns": "Columns",
  "storage.box.preset": "Dimension preset",
  "storage.box.preset.select": "Select dimensions",
  "storage.error.location.inactive": "Не може да се зачислява към неактивно местоположение",
  "storage.error.name.duplicate": "{entityType} с това име вече съществува в избраното местоположение",
  "storage.error.position.occupied": "Позицията вече е заета",
  "storage.expanded.capacityLimit": "Лимит на капацитета",
  "storage.expanded.createdBy": "Създадено от",
  "storage.expanded.createdDate": "Дата на създаване",
  "storage.expanded.description": "Описание",
  "storage.expanded.lastModifiedBy": "Последно променено от",
  "storage.expanded.lastModifiedDate": "Дата на последна промяна",
  "storage.expanded.notAvailable": "Няма информация",
  "storage.expanded.positionSchemaHint": "Подсказка за схема на позициониране",
  "storage.expanded.temperatureSetting": "Температурна настройка",
  "storage.filter.by.locations": "Филтриране по местоположение",
  "storage.filter.by.locations.placeholder": "Филтриране по местоположение...",
  "storage.filter.device": "Филтриране по устройство",
  "storage.filter.room": "Филтриране по стая",
  "storage.filter.status": "Филтриране по статус",
  "storage.hierarchical.path": "Път до местоположението",
  "storage.inline.add.device": "Добавяне на ново устройство",
  "storage.inline.add.rack": "Добавяне на нов стелаж",
  "storage.inline.add.room": "Добавяне на нова стая",
  "storage.inline.add.shelf": "Добавяне на нов рафт",
  "storage.location": "Местоположение",
  "storage.location.active": "Активен",
  "storage.location.add.button": "Add Location",
  "storage.location.add.title": "Add Storage Location",
  "storage.location.current": "Storage location",
  "storage.location.code": "Код",
  "storage.location.code.helper": "Макс. 10 символа, буквено-цифрови с тирета/долни черти",
  "storage.location.description": "Описание",
  "storage.location.label": "Място за съхранение",
  "storage.location.name": "Име на местоположението",
  "storage.location.skipped": "Storage Skipped",
  "storage.location.tempMax": "Max Temperature",
  "storage.location.tempMin": "Min Temperature",
  "storage.location.type": "Location Type",
  "storage.location.unassigned": "Unassigned",
  "storage.location.notAssigned": "Not assigned",
  "storage.location.move": "Move storage location",
  "storage.location.assign": "Assign storage location",
  "storage.manageLocation.error.saveFailed": "Запазването е неуспешно",
  "storage.manageLocation.error.selectTarget": "Select a device, shelf, rack, or box before saving",
  "storage.nav.box": "Box",
  "storage.nav.device": "Устройство",
  "storage.nav.room": "Стая",
  "storage.nav.shelf": "Рафт",
  "storage.picker.currentLocation": "Current location",
  "storage.picker.heading.assignLocation": "Assign Storage Location",
  "storage.picker.heading.move": "Move Item",
  "storage.picker.newLocation": "New location",
  "storage.picker.notes": "Бележки",
  "storage.picker.orBrowse": "Or pick level by level",
  "storage.picker.position.optional": "Position (optional)",
  "storage.picker.select": "Select {level}",
  "storage.picker.selectDeviceType": "Select device type",
  "storage.picker.addNewLevel": "Add new {level}",
  "storage.picker.inlineCreate.heading": "Create new {level}",
  "storage.picker.inlineCreate.error.title": "Could not create location",
  "storage.picker.inlineCreate.error": "Failed to create location",
  "storage.picker.occupant.identifier": "Идентификатор",
  "storage.picker.occupant.heading": "Елемент",
  "storage.picker.occupant.status": "Статус",
  "storage.picker.occupant.type": "Тип",
  "storage.picker.storageLocation": "Storage location",
  "storage.metrics.active": "Активни",
  "storage.metrics.disposed": "Бракувани",
  "storage.metrics.total.samples": "Общо елементи на проби",
  "storage.mode.autocomplete": "Търсене с автоматично довършване",
  "storage.mode.barcode": "Сканиране на баркод",
  "storage.mode.cascading": "Каскадни падащи менюта",
  "storage.move.button": "Преместване на проба",
  "storage.move.reason.label": "Причина за преместване",
  "storage.nav.boxes": "Кутии",
  "storage.nav.boxes.tooltip": "Управление на кутии за съхранение",
  "storage.nav.dashboard": "Табло на съхранението",
  "storage.nav.devices": "Устройства",
  "storage.nav.devices.tooltip": "Управление на устройства за съхранение",
  "storage.nav.locations": "Местоположения",
  "storage.nav.locations.tooltip": "Управление на места за съхранение",
  "storage.nav.racks": "Стелажи",
  "storage.nav.racks.tooltip": "Управление на стелажи за съхранение",
  "storage.nav.rooms": "Стаи",
  "storage.nav.rooms.tooltip": "Управление на стаи за съхранение",
  "storage.nav.sample.items": "Елементи на проби",
  "storage.nav.sample.items.tooltip": "Преглед и управление на съхранявани проби",
  "storage.nav.samples": "Елементи на проби",
  "storage.nav.samples.tooltip": "Преглед и управление на съхранявани проби",
  "storage.nav.shelves": "Рафтове",
  "storage.nav.shelves.tooltip": "Управление на рафтове за съхранение",
  "storage.no.data": "Няма налични данни",
  "storage.occupancy": "Заетост",
  "storage.position.label": "Позиция",
  "storage.rack.device": "Устройство",
  "storage.rack.dimensions": "Размери",
  "storage.rack.label": "Стелаж",
  "storage.rack.placeholder": "Изберете или напишете, за да създадете стелаж...",
  "storage.rack.room": "Стая",
  "storage.rack.shelf": "Рафт",
  "storage.room.code": "Код",
  "storage.room.devices": "Устройства",
  "storage.room.label": "Стая",
  "storage.room.name": "Име",
  "storage.room.placeholder": "Изберете или напишете, за да създадете стая...",
  "storage.room.samples": "Проби",
  "storage.sampleitem.id": "ID на SampleItem",
  "storage.search.boxes.placeholder": "Search boxes by label or code...",
  "storage.search.devices.placeholder": "Търсене по име или код на устройство...",
  "storage.search.location.minLength": "Keep typing, at least 2 characters",
  "storage.search.location.searching": "Търсене...",
  "storage.search.location.error": "Could not search locations. Please try again.",
  "storage.search.location.noResults": "No storage locations match \"{query}\"",
  "storage.search.placeholder": "Търсене по ID на проба или местоположение...",
  "storage.search.racks.placeholder": "Търсене по етикет на стелаж...",
  "storage.search.rooms.placeholder": "Търсене по име или код на стая...",
  "storage.search.lots.placeholder": "Search by lot number, barcode, item or location...",
  "storage.search.samples.placeholder": "Търсене по ID на проба или местоположение...",
  "storage.search.shelves.placeholder": "Търсене по етикет на рафт...",
  "storage.select.location": "Избор на местоположение",
  "storage.selectSample": "Избор на проба",
  "storage.shelf.device": "Устройство",
  "storage.shelf.label": "Рафт",
  "storage.shelf.placeholder": "Изберете или напишете, за да създадете рафт...",
  "storage.shelf.room": "Стая",
  "storage.status": "Статус",
  "storage.status.disposed": "Бракуван",
  "storage.success.assigned": "Пробата бе зачислена успешно към мястото за съхранение",
  "storage.success.moved": "Пробата бе преместена успешно на ново местоположение",
  "storage.tab.ariaLabel": "Storage management tabs",
  "storage.tab.dashboard": "Табло",
  "storage.tab.inventoryLots": "Inventory Lots",
  "storage.tab.samples": "Елементи на проби",
  "storage.target.location": "Целево местоположение",
  "storage.unassigned.title": "Unassigned Samples",
  "storage.skipAssignment": "No storage required - samples will be processed immediately",
  "success.add.edited.msg": "Успешно добавено/редактирано",
  "success.delete.msg": "Успешно изтрито",
  "success.import.patient": "Пациентът е импортиран успешно",
  "success.report.status": "Отчетът бе генериран успешно",
  "success.save.msg": "Успешно запазено",
  "success.save.patient": "Пациентът бе запазен успешно",
  "systemuser.firstName": "Собствено име на системния потребител",
  "systemuser.isActive": "Е активен",
  "systemuser.lastName": "Фамилно име на системния потребител",
  "systemuser.loginName": "Потребителско име за вход",
  "systemuser.role": "Роли",
  "systemuserrole.apply": "Приложи",
  "systemuserrole.allLabUnits.confirm.body": "Switching this row to All Lab Units removes these lab unit permissions. The All Lab Units row starts with no permissions ticked.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "no permissions ticked",
  "systemuserrole.allLabUnits.confirm.primary": "Replace permissions",
  "systemuserrole.allLabUnits.confirm.title": "Replace lab unit permissions?",
  "systemuserrole.allLabUnits.exclusive.error": "All Lab Units cannot be combined with individual lab units. Nothing was saved.",
  "systemuserrole.allLabUnits.exclusive.info": "All Lab Units cannot be combined with individual lab units: selecting it replaces every lab-unit-specific permission.",
  "systemuserrole.copypermissions": "Копиране на права от потребител",
  "systemuserrole.copypermissions.placeholder": "Копиране на потребителски права",
  "systemuserrole.instruction.1": "Има два типа роли. Глобални роли, зададени за цялото приложение, и роли за лабораторни звена.",
  "systemuserrole.instruction.2": "Глобалните роли включват: Глобален администратор, Одитна следа, Администратор на потребителски акаунти.",
  "systemuserrole.instruction.3": "Ролите за звена включват: Регистрация (Reception), Резултати (Results), Валидация (Validation), Отчети (Reports).",
  "systemuserrole.instruction.4": "За да зачислите роли за звена, изберете звената от падащото меню и посочете съответните роли.",
  "systemuserrole.instruction.5": "Можете да използвате функцията за копиране на права от съществуващ потребител.",
  "systemuserrole.newpermissions": "Добавяне на ново право",
  "systemuserrole.rmpermissions": "Премахване на право",
  "systemuserrole.roles.global": "Глобални роли",
  "systemuserrole.roles.labunit": "Роли за лабораторно звено",
  "test.add.copy.name": "Копиране от името на теста",
  "test.antimicrobialResistance": "Антимикробна резистентност",
  "test.description.active": "Ако тестът е активен, той може да се поръчва или да бъде част от алгоритъм.",
  "test.description.name": "Името на теста, както се появява в OpenELIS. Изискват се и английски, и френски.",
  "test.description.orderable": "Ако е поръчваем, той може да се поръчва директно от формуляра.",
  "test.description.panel": "Ако е част от панел, той може да бъде добавен тук.",
  "test.description.reportName": "Името на теста, както ще се появява в отчетите.",
  "test.description.testSection": "Секцията, в която ще се извършва тестът.",
  "test.description.uom": "Мерна единица за теста. Приложимо предимно за числови резултати.",
  "test.field.active": "Активен",
  "test.field.orderable": "Може да се поръчва",
  "test.inLabOnly": "Само в лабораторията",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Моля, изберете тест за промяна!",
  "test.modify.header.test": "Тест",
  "test.name": "Име на тест",
  "test.notifyResults": "Известяване на пациента за резултатите",
  "test.section": "Тестова секция",
  "test.section.label": "Тестова секция",
  "test.show.guide": "Покажи ръководство",
  "testcalculation.label.calculation": "Изчисление",
  "testcalculation.label.finalresult": "Краен резултат",
  "testcalculation.label.insertOperation": "Вмъкване на операция",
  "testcalculation.label.integer": "Цяло число",
  "testcalculation.label.mathFucntion": "Математическа функция",
  "testcalculation.label.name": "Име на изчислението",
  "testcalculation.label.patientAttribute": "Атрибут на пациента",
  "testcalculation.label.searchNumericTest": "Търсене на числов тест",
  "testcalculation.label.selectDictionaryValue": "Избор на стойност от речник",
  "testcalculation.label.testResult": "Резултат от тест",
  "testcalculation.label.textValue": "Текстова стойност",
  "testCatalog.header.ageRange": "Age Range",
  "testCatalog.header.criticalRange": "Critical Range",
  "testCatalog.header.field": "Поле",
  "testCatalog.header.gender": "Пол",
  "testCatalog.header.normalRange": "Нормални граници",
  "testCatalog.header.reportingRange": "Reporting Range",
  "testCatalog.header.validRange": "Valid Range",
  "testCatalog.header.value": "Стойност",
  "admin.testCatalog.methods.title": "Методи",
  "admin.testCatalog.methods.column.name": "Име на метода",
  "admin.testCatalog.methods.column.code": "Код",
  "admin.testCatalog.methods.column.default": "По подразбиране",
  "admin.testCatalog.methods.column.effectiveDate": "Effective Date",
  "admin.testCatalog.methods.column.actions": "Действия",
  "admin.testCatalog.methods.action.edit": "Редактиране",
  "admin.testCatalog.methods.action.remove": "Премахни",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Effective Date",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.error.duplicateCode": "A method with this code already exists. Enter a different code.",
  "admin.testCatalog.methods.error.invalidRequest": "The request was refused. Check the fields and try again.",
  "admin.testCatalog.methods.error.server": "The server could not complete the request. Try again.",
  "admin.testCatalog.methods.linked": "Method linked.",
  "admin.testCatalog.methods.created": "Method created and linked.",
  "admin.testCatalog.methods.copied": "From {source}: {count, plural, one {# method} other {# methods}} copied.",
  "admin.testCatalog.methods.copyNothing": "No methods copied: {source} has no methods that are not already linked to this test.",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "Скрито копие (BCC)",
  "testnotification.instructionis.variables.body": "[testName] : Име на теста",
  "testnotification.instructionis.variables.body.0": "[testResult] : Резултат от теста",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Име на пациента",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Инициал на фамилията на пациента",
  "testnotification.instructionis.variables.header": "Списък с променливи:",
  "testnotification.instructions.body": "При създаване на известие се проверява за дефиниран шаблон за получателя.",
  "testnotification.instructions.body.0": "Ако няма такъв, се използва стандартното съобщение за теста.",
  "testnotification.instructions.body.1": "Ако и то липсва, се използва системното съобщение по подразбиране.",
  "testnotification.instructions.body.2": "Променливите ще бъдат заменени с техните стойности в тялото и темата.",
  "testnotification.instructions.body.3": "Променливите трябва винаги да включват квадратните скоби и да нямат интервали.",
  "testnotification.instructions.header": "Инструкции:",
  "testnotification.messagetemplate": "Съобщение",
  "testnotification.options": "Индивидуални съобщения",
  "testnotification.patient.email": "Имейл на пациента",
  "testnotification.patient.sms": "SMS на пациента",
  "testnotification.patiententry.header": "Отчитане на резултати",
  "testnotification.patiententry.info": "Ако OpenELIS не може да се свърже с получателя, резултатите ще бъдат поставени в опашка.",
  "testnotification.provider.email": "Имейл на доставчика",
  "testnotification.provider.sms": "SMS на доставчика",
  "testnotification.subjecttemplate": "Тема",
  "testnotification.systemdefault.template": "Системно съобщение по подразбиране",
  "testnotification.testdefault.editIcon": "Редактиране на известие за тест",
  "testnotification.testdefault.template": "Съобщение по подразбиране за теста",
  "testnotificationconfig.browse.title": "Конфигурация на известия за тестове",
  "tests.not.assigned": "Незачислени тестове",
  "testsection.testSectionName": "Име на тестовата секция",
  "testUnit.existing": "Съществуващи тестови единици",
  "testUnit.existing.inactive": "Неактивни тестови единици. Зачислете тестове за активиране.",
  "testUnit.new": "Нова тестова единица",
  "text.length.max": "Дължината на текста не трябва да надвишава 200 символа",
  "title.notestfoundmatching": "Няма намерен тест, отговарящ на условията",
  "to.title": "До",
  "tooltip.banner.menu.generic.sample.results": "Въвеждане на резултати за общи проби",
  "tooltip.banner.menu.workplan.batch": "Batch Workplan",
  "total.quantity": "Общо количество",
  "transaction.date": "Дата",
  "transaction.quantity": "Количество",
  "transaction.type": "Тип",
  "transaction.user": "Потребител",
  "true.label": "Вярно",
  "unifiedSystemUser.add.user": "Добавяне на потребител",
  "unifiedSystemUser.browser.button.add": "Добавяне на нов потребител",
  "unifiedSystemUser.browser.search": "Търсене по потребителски имена",
  "unifiedSystemUser.browser.search.placeholder": "Търсене по потребителски имена...",
  "unifiedSystemUser.browser.title": "Управление на потребители",
  "unifiedSystemUser.edit.user": "Промяна на потребител",
  "unifiedSystemUser.select": "Избор",
  "unknown.section": "Неизвестна секция",
  "unknown.test": "Неизвестен тест",
  "uom.browse.title": "Мерна единица",
  "uom.create.heading.confirmation": "Потвърждение",
  "uom.existing": "Текуща мерна единица",
  "uom.existing.inactive": "Неактивна мерна единица. Зачислете тестове за активиране.",
  "uom.new": "Създаване на нова мерна единица",
  "uom.new.added": "Ще бъде добавена нова мерна единица",
  "uom.notification.duplicate": "Мерната единица вече съществува",
  "uom.notification.save": "Новата мерна единица бе запазена.",
  "uom.uomName": "Име на мерната единица",
  "training.installation.message": "Training Installation",
  "translation.edit.title": "Edit Translations",
  "translation.export": "Export CSV",
  "translation.export.success": "Translations exported successfully",
  "translation.fallback": "Fallback (English)",
  "translation.management.description": "View and edit translations for metadata.",
  "translation.management.title": "Translation Management",
  "translation.missing": "Missing",
  "translation.search": "Search translations...",
  "translation.selectLocale": "Select Language",
  "translation.showMissing": "Show Missing Only",
  "translation.stats.title": "Translation Progress",
  "translation.stats.total": "Total entries: {count}",
  "translation.update.error": "Failed to update translation",
  "translation.update.success": "Translation updated successfully",
  "translation.value": "Translation",
  "usage.analysisId": "ID на анализа",
  "usage.date": "Дата на използване",
  "usage.error.quantityPositive": "Количеството трябва да е по-голямо от 0",
  "usage.fefo.note": "The quantity is deducted from this item's earliest-expiring QC-passed lot (FEFO), which may not be the lot you opened this from.",
  "usage.item": "Елемент",
  "usage.notes": "Бележки",
  "usage.notes.placeholder": "Добавете бележки за това използване",
  "usage.quantityUsed": "Използвано количество",
  "usage.quantityUsed.helper": "Въведете броя на консумираните единици",
  "usage.record.button": "Запиши използването",
  "usage.record.error": "Error recording usage",
  "usage.record.success": "Използването бе записано успешно",
  "usage.record.title": "Записване на използване на инвентар",
  "usage.testResultId": "ID на резултат от тест (незадължително)",
  "usage.testResultId.placeholder": "Свързване с резултат за проследяемост",
  "user.select.instruction": "Изберете потребител за промяна или деактивиране.",
  "validation.accept.all": "Запази всички резултати",
  "validation.accept.normal": "Запази всички нормални",
  "validation.field.required": "Това поле е задължително",
  "validation.ignore.all": "Игнорирай всички резултати",
  "validation.label.nonconform": "= Пробата/поръчката не съответства или тестът е отхвърлен",
  "validation.legend.qcHold": "= A quality control covering this result failed; the non-conformity is still open",
  "validation.qcHold.tooltip": "A control run for this test in this lab unit failed. Review the non-conformity before releasing this result.",
  "validation.password.match": "Паролите трябва да съвпадат",
  "validation.password.minLength": "Паролата трябва да бъде поне 7 символа",
  "validation.password.notSameAsOld": "Новата парола не трябва да е същата като старата",
  "validation.password.specialChar": "Паролата трябва да съдържа поне един специален символ (*$#!) и една главна буква",
  "validation.no.records.display": "There are no records to display",
  "validation.reject.all": "Повтори всички тестове",
  "validation.save.error": "Грешка при валидиране на резултатите",
  "validation.save.success": "Резултатите бяха валидирани успешно",
  "validation.search.noresult": "Не бяха намерени резултати за валидиране",
  "validation.search.noresult.analyser": "Не бяха намерени резултати от: ",
  "vl.arvRegimen": "ARV Regimen",
  "vl.durationOnARV": "Duration on ARV (months)",
  "vl.durationOnARV.placeholder": "Enter months on treatment",
  "vl.indication": "Indication for VL Test",
  "vl.lastVLDate": "Date of Last VL Result",
  "vl.lastVLResult": "Last VL Result (copies/mL)",
  "vl.lastVLResult.placeholder": "e.g., 150",
  "vl.pregnancyStatus": "Pregnancy / Breastfeeding Status",
  "workplan.batch.action.activate": "Активирай",
  "workplan.batch.action.archive": "Archive",
  "workplan.batch.action.complete": "Завършено",
  "workplan.batch.batches": "Batches",
  "workplan.batch.batches.empty": "No batches found",
  "workplan.batch.column.actions": "Действия",
  "workplan.batch.column.count": "Тестове",
  "workplan.batch.column.created": "Създадено",
  "workplan.batch.column.method": "Method",
  "workplan.batch.column.name": "Batch",
  "workplan.batch.column.sampleType": "Sample type",
  "workplan.batch.column.status": "Статус",
  "workplan.batch.column.test": "Тест",
  "workplan.batch.column.unit": "Единица",
  "workplan.batch.create": "Create batch ({count})",
  "workplan.batch.create.error": "Batch could not be created",
  "workplan.batch.create.success": "Batch created",
  "workplan.batch.pending.empty": "No pending tests found",
  "workplan.batch.pendingTests": "Pending Tests",
  "workplan.batch.refresh": "Refresh",
  "workplan.batch.selectPage": "Select page",
  "workplan.batch.selectTest": "Select {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Активен",
  "workplan.batch.status.ARCHIVED": "Архивирано",
  "workplan.batch.status.COMPLETED": "Завършен",
  "workplan.batch.status.DRAFT": "Чернова",
  "workplan.batch.status.error": "Batch status could not be updated",
  "workplan.batch.status.success": "Batch status updated",
  "workplan.batch.tabs": "Batch workplan tabs",
  "workplan.batch.title": "Batch Workplan",
  "workplan.page.title": "Работен план {0}",
  "workplan.panel.selection.error.msg": "Това е невалидно съобщение за грешка.",
  "workplan.panel.title": "Работен план по панел",
  "workplan.panel.types": "Тип панел",
  "workplan.print": "Печат на работния план",
  "workplan.priority.list": "Приоритет",
  "workplan.priority.title": "Работен план по приоритет",
  "workplan.run": "Извлечи работния план",
  "workplan.test.title": "Работен план по тест",
  "workplan.test.types": "Тип тест",
  "workplan.title": "Работен план",
  "workplan.unit.title": "Работен план по звено",
  "workplan.unit.types": "Тип звено",
  "yes.option": "Да",
  "shipment.module.title": "Shipment Management",
  "shipment.breadcrumb": "Sample Shipment",
  "shipment.nav.dashboard": "Табло",
  "shipment.nav.createBox": "Create Box",
  "shipment.nav.receiveBox": "Receive Box",
  "shipment.dashboard.title": "Shipment Dashboard",
  "shipment.dashboard.description": "Manage shipment boxes and track referred samples",
  "shipment.dashboard.tabs.shipments": "Shipments",
  "shipment.dashboard.tabs.unassigned": "Unassigned Tests",
  "shipment.tab.boxes": "Shipment Boxes",
  "shipment.tab.unassignedSamples": "Unassigned Samples",
  "shipment.label.boxId": "Box ID",
  "shipment.label.createdDate": "Дата на създаване",
  "shipment.label.daysUnassigned": "Days Unassigned",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Приоритет",
  "shipment.label.referralTest": "Referral Test",
  "shipment.label.sampleCount": "Sample Count",
  "shipment.label.state": "Състояние",
  "shipment.label.tests": "Тестове",
  "shipment.filter.state": "Filter by State",
  "shipment.filter.facility": "Filter by Facility",
  "shipment.action.addSelected": "Add selected",
  "shipment.action.addToBox": "Add to Box",
  "shipment.action.cancelReferral": "Cancel Referral",
  "shipment.action.confirmRejection": "Confirm Rejection",
  "shipment.action.createBox": "Create New Box",
  "shipment.action.markAsLost": "Mark as Lost",
  "shipment.action.printManifest": "Print Manifest",
  "shipment.action.rejectSample": "Отхвърляне на проба",
  "shipment.action.saveAndMarkReady": "Save & Mark Ready to Send",
  "shipment.action.saveBox": "Save Box",
  "shipment.action.saveDraft": "Запази като чернова",
  "shipment.action.scanSample": "Scan Sample",
  "shipment.box.addSample": "Добавяне на проба",
  "shipment.box.addSampleDescription": "Select samples to add to this shipping box",
  "shipment.box.addSamples": "Add Samples",
  "shipment.box.details": "Box Details",
  "shipment.box.autoGenerate": "Auto-generate",
  "shipment.box.capacity": "Capacity",
  "shipment.box.capacityValue": "{capacity} samples",
  "shipment.box.create": "Create Box",
  "shipment.box.createDescription": "Create a new shipping box for referred samples",
  "shipment.box.created": "Created Date: ",
  "shipment.box.createdBy": "Created By :",
  "shipment.box.createdDate": "Дата на създаване",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Download Label",
  "shipment.box.downloadManifest": "Download Manifest",
  "shipment.box.generateLabel": "Generate Label",
  "shipment.box.generateManifest": "Generate Manifest",
  "shipment.box.id": "Box ID: ",
  "shipment.box.labelDownloaded": "Label downloaded successfully",
  "shipment.box.labelPrefix": "Label Prefix",
  "shipment.box.labelPrefixHelper": "Configured by administrator in Site Settings",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest downloaded successfully",
  "shipment.box.noSamples": "This box does not contain any samples yet",
  "shipment.box.noUnassignedSamples": "No unassigned samples found for this facility",
  "shipment.box.notes": "Бележки",
  "shipment.box.notesPlaceholder": "Enter any special handling instructions or notes...",
  "shipment.box.number": "Box Number",
  "shipment.box.readyConfirmation": "Are you sure you want to mark this box as ready to send?",
  "shipment.box.readySampleCount": "This box contains {count} sample(s)",
  "shipment.box.readyToSend": "Mark Ready to Send",
  "shipment.box.reconcile": "Reconcile",
  "shipment.box.removeSample": "Премахване на проба",
  "shipment.box.removeSampleConfirmation": "Are you sure you want to remove this sample from the box?",
  "shipment.box.resendManifest": "Resend Manifest",
  "shipment.box.sampleCount": "Sample Count",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} remaining)",
  "shipment.box.samplesAdded": "Samples Added",
  "shipment.box.samplesSelected": "{count} sample(s) selected",
  "shipment.box.scanExisting": "Scan existing",
  "shipment.box.scanExistingId": "Scan or enter existing Box ID",
  "shipment.box.scanExistingIdPlaceholder": "Scan barcode or type box ID",
  "shipment.box.sendBox": "Send Box",
  "shipment.box.sendConfirmation": "Are you sure you want to send this box?",
  "shipment.box.sendSampleCount": "This box contains {count} sample(s) that will be marked as sent",
  "shipment.box.state": "Състояние",
  "shipment.box.summary": "Summary",
  "shipment.box.temperature": "Temperature Requirement",
  "shipment.box.title": "Box {boxId}",
  "shipment.box.useExistingId": "Box ID Mode",
  "shipment.dashboard.boxNotFound": "No box found with ID \"{boxId}\". Try filtering the list instead.",
  "shipment.dashboard.scanBoxPlaceholder": "Search or scan Box ID (press Enter to navigate)",
  "shipment.error.addSample": "Failed to add sample to box",
  "shipment.error.assignToBox": "Failed to assign sample to box",
  "shipment.error.boxFull": "Box is full. Cannot add more samples.",
  "shipment.error.boxNotEmpty": "Box must have at least one sample",
  "shipment.error.boxNotFound": "Box not found",
  "shipment.error.cancelReferral": "Failed to cancel referral",
  "shipment.error.confirmReception": "Failed to confirm reception",
  "shipment.error.createBox": "Failed to create shipping box",
  "shipment.error.exceedsCapacity": "Cannot add {requested} sample(s). Only {available} slot(s) available.",
  "shipment.error.fetchBox": "Failed to fetch box information",
  "shipment.error.fetchBoxes": "Failed to fetch available boxes",
  "shipment.error.generateLabel": "Error generating shipping label",
  "shipment.error.generateManifest": "Error generating manifest",
  "shipment.error.invalidState": "Invalid box state for this operation",
  "shipment.error.markAsLost": "Failed to mark sample as lost",
  "shipment.error.markReady": "Failed to mark box as ready to send",
  "shipment.error.noDestinationFacility": "No destination facility specified for this sample",
  "shipment.error.noReferralId": "No referral ID available for this sample",
  "shipment.error.noSampleSelected": "Please select at least one sample",
  "shipment.error.partialReception": "Some sample status updates failed. Please try again.",
  "shipment.error.partialSampleAdd": "Only {added} of {total} samples were added to the box. It was left as a draft so you can add the rest.",
  "shipment.error.reasonRequired": "Please provide a reason",
  "shipment.error.reconcile": "Error reconciling box",
  "shipment.error.removeSample": "Failed to remove sample from box",
  "shipment.error.sampleAlreadyAssigned": "This sample is already assigned to a box",
  "shipment.error.sampleAlreadyInBox": "Sample already in box",
  "shipment.error.sampleNotFound": "Sample not found",
  "shipment.error.saveFailed": "Failed to save",
  "shipment.error.searchFailed": "Failed to search for sample. Please try again.",
  "shipment.error.selectBox": "Please select a box",
  "shipment.error.sendBox": "Failed to send box",
  "shipment.filter.clear": "Изчисти филтрите",
  "shipment.filter.dateFrom": "From Date",
  "shipment.filter.dateTo": "To Date",
  "shipment.filter.referenceLab": "Референтна лаборатория",
  "shipment.label.addedDate": "Added Date",
  "shipment.label.position": "Позиция",
  "shipment.label.samples": "Проби",
  "shipment.label.shippingLabel": "SHIPPING LABEL",
  "shipment.manifest.generated": "Generated:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Manifest recall is no longer available (7-day limit exceeded since send)",
  "shipment.manifest.regenerationExpired": "Manifest regeneration is no longer available (24-hour limit exceeded since send)",
  "shipment.manifest.serviceLocation": "Service Location:",
  "shipment.manifest.specimenBarcodes": "Specimen Barcodes",
  "shipment.manifest.title": "Shipping Manifest",
  "shipment.manifest.totalSamples": "Total Samples:",
  "shipment.modal.addToBox.existingBox": "Add to existing box",
  "shipment.modal.addToBox.mode": "Select an option",
  "shipment.modal.addToBox.newBox": "Create new box",
  "shipment.modal.addToBox.newBoxInfo.message": "You will be redirected to create a new box for this sample",
  "shipment.modal.addToBox.newBoxInfo.title": "Create New Box",
  "shipment.modal.addToBox.noDraftBoxes.message": "No draft boxes found for this destination. A new box will be created.",
  "shipment.modal.addToBox.noDraftBoxes.title": "No Draft Boxes Available",
  "shipment.modal.addToBox.selectBox": "Select Box",
  "shipment.modal.addToBox.title": "Add Sample to Box",
  "shipment.modal.cancelReferral.reason": "Reason for cancellation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Please explain why this referral is being cancelled...",
  "shipment.modal.cancelReferral.title": "Cancel Referral",
  "shipment.modal.cancelReferral.warning.message": "This action will permanently cancel the referral and cannot be undone.",
  "shipment.modal.cancelReferral.warning.title": "Предупреждение",
  "shipment.modal.createBox.cancel": "Отказ",
  "shipment.modal.createBox.submit": "Create",
  "shipment.modal.createBox.title": "Create New Box",
  "shipment.modal.markAsLost.reason": "Reason for marking as lost",
  "shipment.modal.markAsLost.reasonPlaceholder": "Please explain why this sample is being marked as lost...",
  "shipment.modal.markAsLost.title": "Mark Sample as Lost",
  "shipment.modal.markAsLost.warning.message": "This action will permanently mark the sample as lost and cannot be undone.",
  "shipment.modal.markAsLost.warning.title": "Предупреждение",
  "shipment.modal.rejectSample": "Отхвърляне на проба",
  "shipment.modal.rejectSampleMessage": "Are you sure you want to reject sample {accession}?",
  "shipment.nav.referenceLabResults": "Reference Lab Results",
  "shipment.nav.reports": "Отчети",
  "shipment.nav.settings": "Настройки",
  "shipment.notification.boxCreated": "Box created successfully",
  "shipment.notification.boxReadyToSend": "Box marked as Ready to Send",
  "shipment.notification.boxReconciled": "Box has been reconciled successfully",
  "shipment.notification.boxSent": "Box sent successfully",
  "shipment.notification.error": "An error occurred: {message}",
  "shipment.notification.partialSamplesAdded": "Only {added} of {total} samples added. Box capacity reached ({notAdded} not added).",
  "shipment.notification.receptionComplete": "Shipment received successfully",
  "shipment.notification.referralCancelled": "Referral cancelled successfully",
  "shipment.notification.sampleAdded": "Sample {accessionNumber} added with {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sample assigned to box successfully",
  "shipment.notification.sampleMarkedAsLost": "Sample marked as lost",
  "shipment.notification.sampleRejected": "Sample {accession} rejected: {reason}",
  "shipment.notification.sampleRemoved": "Sample removed from box",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} other {# samples added to box}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sample(s) removed due to capacity reduction.",
  "shipment.reception.acceptSample": "Accept Sample",
  "shipment.reception.applyToAll": "Apply status to all...",
  "shipment.reception.awaitingAcceptance": "Awaiting acceptance",
  "shipment.reception.confirmMessage": "Confirm reception of {count} sample(s)?",
  "shipment.reception.confirmReception": "Confirm Reception",
  "shipment.reception.damaged": "Damaged",
  "shipment.reception.description": "Scan box barcode to receive and verify samples",
  "shipment.reception.enterBoxId": "Please enter a box ID",
  "shipment.reception.generalNotes": "General Notes",
  "shipment.reception.generalNotesPlaceholder": "Enter general reception notes",
  "shipment.reception.importError": "Error importing shipments from remote server",
  "shipment.reception.importFromFhir": "Import from FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Incoming Shipments",
  "shipment.reception.leaked": "Leaked",
  "shipment.reception.markAllMissing": "Mark All Missing",
  "shipment.reception.markAllReceived": "Mark All Received",
  "shipment.reception.missing": "Missing",
  "shipment.reception.noIncomingBoxes": "No incoming shipments. Click 'Import from FHIR' to check for new shipments.",
  "shipment.reception.notes": "Бележки",
  "shipment.reception.notesPlaceholder": "Enter notes if needed",
  "shipment.reception.notesRequired": "Notes are required for samples not received in good condition",
  "shipment.reception.notesRequiredPlaceholder": "Required: describe the issue",
  "shipment.reception.openBox": "Open",
  "shipment.reception.originFacility": "От",
  "shipment.reception.pending": "Pending",
  "shipment.reception.pendingAcceptance": "Specimens Awaiting Acceptance",
  "shipment.reception.received": "Received",
  "shipment.reception.referralOrder": "Referral Order",
  "shipment.reception.rejected": "Rejected",
  "shipment.reception.sampleCountSummary": "{accepted} accepted / {expected} expected",
  "shipment.reception.sampleNotFound": "Sample {accessionNumber} not found in this box",
  "shipment.reception.sampleScanned": "Sample {accessionNumber} checked in as received",
  "shipment.reception.sampleVerification": "Sample Verification",
  "shipment.reception.scanBox": "Box ID / Barcode",
  "shipment.reception.scanBoxPlaceholder": "Scan or enter box barcode",
  "shipment.reception.scanButton": "Scan Box",
  "shipment.reception.scanSample": "Scan Sample ID",
  "shipment.reception.scanSampleButton": "Check In Sample",
  "shipment.reception.scanSamplePlaceholder": "Scan or type sample accession number",
  "shipment.reception.shipped": "Shipped",
  "shipment.reception.specimen": "Проба",
  "shipment.reception.status": "Reception Status",
  "shipment.reception.title": "Receive Shipment",
  "shipment.reception.unresolved": "No matching order",
  "shipment.rejection.damaged": "Damaged",
  "shipment.rejection.expired": "Изтекъл срок",
  "shipment.rejection.insufficientVolume": "Insufficient Volume",
  "shipment.rejection.other": "Друг",
  "shipment.rejection.reason": "Rejection Reason",
  "shipment.rejection.wrongType": "Wrong Sample Type",
  "shipment.report.contents": "Contents",
  "shipment.report.description": "Generate and export shipment reports by box, date, destination, or reference lab",
  "shipment.report.export.excel": "Export Excel",
  "shipment.report.export.pdf": "Export PDF",
  "shipment.report.generate": "Генерирай отчет",
  "shipment.report.noResults": "No shipment records found for the selected filters",
  "shipment.report.receivedDate": "Дата на получаване",
  "shipment.report.receivedStatus": "Received Status",
  "shipment.report.receiver": "Receiver",
  "shipment.report.receivingUser": "Receiving User",
  "shipment.report.sender": "Sender",
  "shipment.report.sentDate": "Дата на изпращане",
  "shipment.report.title": "Shipment Reports",
  "shipment.report.totalBoxes": "Total Boxes",
  "shipment.report.totalSamples": "Общо проби",
  "shipment.sample.accessionNumber": "Номер на акцесия",
  "shipment.sample.multipleMatches": "Multiple samples match — select which to add",
  "shipment.sample.remove": "Премахни",
  "shipment.sample.search": "Search sample by accession number",
  "shipment.sample.searchPlaceholder": "Scan or enter accession number",
  "shipment.sample.status": "Статус",
  "shipment.sample.type": "Тип проба",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Box Label Configuration",
  "shipment.settings.description": "Configure shipment module settings",
  "shipment.settings.fhirConfig": "FHIR Mapping Options",
  "shipment.settings.fhirConfigDesc": "Configure SupplyDelivery mapping and specimen container types for FHIR interoperability",
  "shipment.settings.fhirConfigNote": "FHIR mapping is configured via application properties. Contact your system administrator for changes.",
  "shipment.settings.fhirConfigSaveError": "Error saving FHIR mapping configuration",
  "shipment.settings.fhirConfigSaved": "FHIR mapping configuration saved",
  "shipment.settings.fhirContainerType": "Specimen Container Type (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Display Name",
  "shipment.settings.fhirNonConformity": "Non-Conformity Codes (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "SNOMED CT Code",
  "shipment.settings.manageFacilities": "Manage Facility Registry",
  "shipment.settings.manageFacilitiesDesc": "Add, edit, or remove reference laboratory destinations",
  "shipment.settings.manageUsers": "Manage Users",
  "shipment.settings.manageUsersDesc": "Configure user accounts and roles for the shipment module",
  "shipment.settings.prefixHelperText": "Prefix used when generating new box IDs (e.g. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Preview: {preview}",
  "shipment.settings.prefixRequired": "Box label prefix is required",
  "shipment.settings.prefixSaveError": "Error saving box label prefix",
  "shipment.settings.prefixSaved": "Box label prefix saved successfully",
  "shipment.settings.siteOrgDescription": "Select the organization that represents this laboratory. Only shipments destined for this organization will be imported from remote FHIR servers.",
  "shipment.settings.siteOrgLabel": "This Laboratory",
  "shipment.settings.siteOrgSaveError": "Error saving site organization",
  "workflow.clinical": "Clinical",
  "workflow.environmental": "Environmental / Other",
  "provider.name": "Provider Name",
  "provider.name.placeholder": "Enter provider name",
  "provider.phone": "Provider Phone",
  "provider.search.helper": "Enter provider name or phone number and press Search.",
  "site.search": "Site Search",
  "site.name": "Име на обекта",
  "site.name.placeholder": "Enter site name",
  "site.location": "Местоположение",
  "site.type": "Тип",
  "site.department": "Department / Ward / Unit",
  "site.department.selectFirst": "Select facility first...",
  "site.department.choose": "Select a department...",
  "site.department.none": "No subunits available",
  "sample.filterByLabUnit": "Filter by Lab Unit",
  "sample.allLabUnits": "All Lab Units",
  "sample.orderPanels": "Поръчване на панели",
  "sample.orderTests": "Поръчване на тестове",
  "sample.referToReferenceLab": "Препрати теста към референтна лаборатория",
  "sample.optional.info": "Sample and test selection is optional at this step. Tests and sample type can be specified later during collection.",
  "panel.search.placeholder": "Изберете наличен панел",
  "test.search.placeholder": "Изберете наличен тест",
  "test.timeHolding": "SOP Max Holding Time (minutes)",
  "select.regimen": "Select Regimen...",
  "select": "Select...",
  "generating": "Генериране...",
  "label.order": "Order Label",
  "label.sample": "Sample Label",
  "label.slide": "Slide Label",
  "label.block": "Block Label",
  "label.freezer": "Freezer Label",
  "environmental.coming.soon": "Environmental workflow",
  "environmental.location.info": "Location hierarchy fields (Region/District/Town-Village) and GPS capture will be available here.",
  "env.collectionConditions.title": "Default Collection Conditions",
  "env.collectionConditions.subtitle": "Defaults applied to all samples in this batch.",
  "env.collectionMethod": "Collection Method",
  "env.waterTemp": "Water Temp (°C)",
  "env.ambientTemp": "Ambient Temp (°C)",
  "env.weather": "Weather",
  "env.preservationMethod": "Preservation Method",
  "env.preservationMethod.placeholder": "e.g., HNO3 acidification, 4°C cooler",
  "env.fieldNotes": "Field Notes",
  "env.fieldNotes.placeholder": "Enter field observations...",
  "env.sample.manifest.title": "Per-Sample Manifest",
  "env.sample.manifest.subtitle": "one row = one physical sample",
  "env.sample.container": "Container",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "e.g. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "e.g. 106.8456",
  "env.sample.locationDetails": "Location Details",
  "env.sample.locationDetails.placeholder": "e.g., Inlet, Bank...",
  "env.sample.collected": "Collected",
  "env.sample.duplicate": "Duplicate sample",
  "env.sample.addRow": "+ Add sample row",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "Tests & Panels",
  "env.sample.tests.required": "required",
  "env.complianceStandards.title": "Applicable Compliance Standards",
  "env.complianceStandards.subtitle": "Select the regulatory standards that apply to this order.",
  "env.complianceStandards.label": "Compliance Standards",
  "env.complianceStandards.placeholder": "Select standards...",
  "env.complianceStandards.empty": "No active compliance standards configured. Add them in Administration → Compliance Standards.",
  "order.dashboard.samplingSite": "Sampling Site",
  "order.search.placeholder.env": "Search by site name or lab number...",
  "order.filter.dateFrom": "От",
  "order.filter.dateTo": "До",
  "program.placeholder": "Type to filter or select from the list",
  "program.helper": "Type to filter or select from the list. Selecting a program displays its specific Additional Order Information fields below.",
  "patient.externalSearch": "Външно търсене",
  "patient.results": "Резултати на пациента",
  "patient.id.helper": "Enter subject number, national ID, or ST number.",
  "patient.id.placeholder": "Въведете ID на пациента",
  "patient.lastName.placeholder": "Въведете фамилия на пациента",
  "patient.firstName.placeholder": "Въведете име на пациента",
  "patient.natId": "Unique Health ID",
  "patient.dataSource": "Data Source",
  "patient.noResults": "0-0 of 0 items",
  "patient.new.info": "Enter new patient information below. The patient will be created when the order is saved.",
  "pagination.showing": "Showing {start}-{end} of {total} tests",
  "results.found.for": "results found for \"{term}\"",
  "selected": "Избрани",
  "shipment.settings.siteOrgSaved": "Site organization saved (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Site Organization (FHIR)",
  "shipment.settings.title": "Shipment Settings",
  "shipment.state.cancelled": "Анулиран",
  "shipment.state.draft": "Чернова",
  "shipment.state.inTransit": "In Transit",
  "shipment.state.lostInTransit": "Lost in Transit",
  "shipment.state.partiallyReceived": "Partially Received",
  "shipment.state.readyToSend": "Ready to Send",
  "shipment.state.received": "Received",
  "shipment.state.reconciled": "Reconciled",
  "shipment.state.sent": "Sent",
  "shipment.stats.delivered": "Delivered",
  "shipment.stats.inTransit": "In Transit",
  "shipment.stats.reconciled": "Reconciled",
  "shipment.stats.totalSamples": "Общо проби",
  "shipment.temperature.ambient": "Ambient (Room Temperature)",
  "shipment.temperature.deepFrozen": "Deep Frozen (-80°C)",
  "shipment.temperature.dryIce": "Dry Ice",
  "shipment.temperature.frozen": "Frozen (-20°C)",
  "shipment.temperature.refrigerated": "Refrigerated (2-8°C)",
  "shipment.validation.addSample": "Add at least one sample",
  "shipment.validation.selectDestination": "Select a destination facility",
  "qc.dashboard.title": "Quality Control Dashboard",
  "qc.dashboard.lastUpdate": "Last Updated",
  "qc.dashboard.complianceStatus": "Compliance Status",
  "qc.dashboard.compliant": "Compliant",
  "qc.dashboard.warning": "Предупреждение",
  "qc.dashboard.nonCompliant": "Non-Compliant",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Last Result",
  "qc.dashboard.noInstruments": "No instruments configured",
  "qc.dashboard.subtitle": "Monitor instrument QC status and alerts",
  "qc.dashboard.loading": "Loading dashboard data...",
  "qc.dashboard.refresh": "Refresh",
  "qc.dashboard.lastUpdated": "Last Updated",
  "qc.dashboard.export.title": "Export QC Data",
  "qc.dashboard.export.selectInstrument": "Select an instrument",
  "qc.dashboard.export.dateError": "End date must be on or after the start date.",
  "qc.dashboard.error.title": "Грешка",
  "qc.dashboard.error.loadFailed": "Failed to load dashboard data. Please try again.",
  "qc.dashboard.tab.instruments": "Инструменти",
  "qc.dashboard.tab.alerts": "Alerts",
  "qc.dashboard.summary.inControl": "Instruments In Control",
  "qc.dashboard.summary.warningStatus": "Warning Status",
  "qc.dashboard.summary.outOfControl": "Out of Control",
  "qc.dashboard.summary.passRate": "% Instruments In Control",
  "qc.dashboard.summary.ofTotal": "{percentage}% of total instruments",
  "qc.dashboard.instruments.title": "Instrument Quality Control Status",
  "qc.dashboard.instruments.subtitle": "Monitor compliance status and QC performance for all laboratory instruments",
  "qc.dashboard.instruments.search": "Search instruments...",
  "qc.dashboard.instruments.col.id": "Instrument ID",
  "qc.dashboard.instruments.col.name": "Instrument Name",
  "qc.dashboard.instruments.col.type": "Тип",
  "qc.dashboard.instruments.col.location": "Местоположение",
  "qc.dashboard.instruments.col.status": "Статус",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Recent Violations",
  "qc.dashboard.instruments.col.lastUpdate": "Последна актуализация",
  "qc.dashboard.instruments.col.actions": "Действия",
  "qc.dashboard.instruments.view": "Преглед",
  "qc.dashboard.instruments.status.green": "In Control",
  "qc.dashboard.instruments.status.yellow": "Предупреждение",
  "qc.dashboard.instruments.status.red": "Out of Control",
  "qc.dashboard.instruments.status.notConfigured": "Not configured",
  "qc.dashboard.instruments.status.unknown": "Неизвестен",
  "qc.dashboard.instruments.noViolations": "No violations",
  "qc.dashboard.instruments.empty": "No instruments found",
  "qc.dashboard.alerts.title": "QC Violations & Alerts",
  "qc.dashboard.alerts.subtitle": "Showing violations from last {period}",
  "qc.dashboard.alerts.timePeriod": "Time Period",
  "qc.dashboard.alerts.timePeriod.24h": "Последните 24 часа",
  "qc.dashboard.alerts.timePeriod.72h": "Last 72 Hours",
  "qc.dashboard.alerts.timePeriod.7d": "Last 7 Days",
  "qc.dashboard.alerts.timePeriod.30d": "Last 30 Days",
  "qc.dashboard.alerts.timePeriod.all": "All Time",
  "qc.dashboard.alerts.active": "Active QC Violations",
  "qc.dashboard.alerts.active.count": "{count} unacknowledged violation(s) requiring attention",
  "qc.dashboard.alerts.active.empty": "No active violations",
  "qc.dashboard.alerts.acknowledge": "Потвърди",
  "qc.dashboard.alerts.acknowledged": "Acknowledged Violations",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) have been acknowledged",
  "qc.dashboard.alerts.acknowledged.empty": "No acknowledged violations",
  "qc.dashboard.alerts.col.severity": "Сериозност",
  "qc.dashboard.alerts.col.time": "Време",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Правило",
  "qc.dashboard.alerts.col.acknowledgedBy": "Acknowledged By",
  "qc.dashboard.alerts.col.acknowledgedDate": "Acknowledged Date",
  "qc.dashboard.banner.title": "{count} active QC violation(s) require attention",
  "qc.dashboard.banner.viewAll": "View all alerts",
  "qc.violations.error.acknowledgeFailed": "Failed to acknowledge violation",
  "qc.chart.axis.date": "Дата/Час",
  "qc.chart.axis.run": "Run",
  "qc.chart.axis.value": "Standard Deviations (σ)",
  "qc.instrument.notFound": "Instrument not found",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Sigma performance",
  "qc.chart.sigma.notCalculable": "Not calculable — TEa not configured",
  "qc.chart.sigma.bias": "Bias not applied (no peer data)",
  "qc.chart.sigma.WORLD_CLASS": "World-class",
  "qc.chart.sigma.ACCEPTABLE": "Acceptable",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Poor",
  "qc.chart.title": "Quality Control Chart",
  "qc.chart.loading": "Loading control chart…",
  "qc.chart.error.title": "Unable to load control chart",
  "qc.chart.tabs.label": "Control chart levels",
  "qc.chart.filter.allLevels": "All levels",
  "qc.chart.filter.selectLot": "Select lot",
  "qc.chart.action.zoomIn": "Zoom in",
  "qc.chart.action.zoomOut": "Zoom out",
  "qc.chart.action.zoomReset": "Reset zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Mean",
  "qc.chart.noData": "No QC data available",
  "qc.chart.tooltip.date": "Дата",
  "qc.chart.tooltip.value": "Стойност",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Z-Score",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Levey-Jennings Chart",
  "qc.charts.dateRange": "Период",
  "qc.charts.controlLevel": "Control Level",
  "qc.charts.export": "Export Chart",
  "qc.charts.noData": "No QC data available",
  "qc.violations.title": "QC Violations",
  "qc.violations.severity": "Сериозност",
  "qc.violations.rule": "Правило",
  "qc.violations.date": "Дата",
  "qc.violations.status": "Статус",
  "qc.violations.unresolved": "Unresolved",
  "qc.violations.resolved": "Resolved",
  "qc.violations.acknowledged": "Потвърдена",
  "qc.correctiveActions.title": "Коригиращи действия",
  "qc.correctiveActions.create": "Create Corrective Action",
  "qc.correctiveActions.type": "Тип действие",
  "qc.correctiveActions.description": "Описание",
  "qc.correctiveActions.assignedTo": "Assigned To",
  "qc.correctiveActions.status": "Статус",
  "qc.correctiveActions.pending": "Pending",
  "qc.correctiveActions.inProgress": "В ход",
  "qc.correctiveActions.completed": "Завършен",
  "qc.correctiveActions.resolutionNotes": "Resolution Notes",
  "qc.alerts.title": "QC Alerts",
  "qc.alerts.markAsRead": "Маркирай като прочетено",
  "qc.alerts.viewDetails": "Виж подробности",
  "qc.rules.title": "Westgard Rules Configuration",
  "qc.rules.enable": "Enable",
  "qc.rules.disable": "Disable",
  "qc.rules.preset": "Preset Configuration",
  "qc.rules.basic": "Basic",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Comprehensive",
  "qc.rules.1₂ₛ.description": "One control exceeds ±2SD",
  "qc.rules.1₃ₛ.description": "One control exceeds ±3SD",
  "qc.rules.2₂ₛ.description": "Two consecutive controls exceed ±2SD in same direction",
  "qc.rules.R₄ₛ.description": "Range between two controls exceeds 4SD",
  "qc.rules.4₁ₛ.description": "Four consecutive controls exceed ±1SD in same direction",
  "qc.rules.10ₓ.description": "Ten consecutive controls on same side of mean",
  "qc.rules.3₁ₛ.description": "Three consecutive controls exceed ±1SD in same direction",
  "qc.rules.7ₜ.description": "Seven consecutive controls trending in same direction",
  "qc.ruleConfig.title": "Rule Configuration",
  "qc.ruleConfig.subtitle": "Configure Westgard rules per analyzer and test combination",
  "qc.ruleConfig.field.analyzer": "Анализатор",
  "qc.ruleConfig.field.selectAnalyzer": "Select an analyzer",
  "qc.ruleConfig.field.test": "Тест",
  "qc.ruleConfig.field.selectTest": "Select a test",
  "qc.ruleConfig.field.severity": "Сериозност",
  "qc.ruleConfig.severity.warning": "Предупреждение",
  "qc.ruleConfig.severity.rejection": "Rejection",
  "qc.ruleConfig.category.rejection": "Rejection Rules",
  "qc.ruleConfig.category.warning": "Warning Rules",
  "qc.ruleConfig.action.reset": "Reset to Defaults",
  "qc.ruleConfig.loading": "Loading rule configuration...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Select an analyzer and test to configure Westgard rules.",
  "qc.ruleConfig.error.title": "Грешка",
  "qc.ruleConfig.error.selectAnalyzerTest": "Please select both an analyzer and a test.",
  "qc.ruleConfig.error.saveFailed": "Failed to save rule configuration.",
  "qc.ruleConfig.success.title": "Успех",
  "qc.ruleConfig.success.saved": "Rule configuration saved successfully.",
  "qc.ruleConfig.table.title": "Configured Rule Sets",
  "qc.ruleConfig.table.empty": "No rule configurations found.",
  "qc.ruleConfig.field.enabledRules": "Enabled Rules",
  "qc.ruleConfig.unconfigured.title": "Unconfigured Control Mappings",
  "qc.ruleConfig.unconfigured.subtitle": "Control lots without Westgard rule configurations",
  "qc.ruleConfig.unconfigured.configure": "Configure",
  "qc.ruleConfig.unconfigured.activeLots": "Active Lots",
  "qc.ruleConfig.modal.title.edit": "Edit Rule Configuration",
  "qc.ruleConfig.modal.title.create": "Create Rule Configuration",
  "button.saving": "Запазване...",
  "qc.controlLots.title": "Control Lots",
  "qc.controlLots.create": "Create Control Lot",
  "qc.controlLots.productName": "Product Name",
  "qc.controlLots.lotNumber": "Номер на партида",
  "qc.controlLots.level": "Control Level",
  "qc.controlLots.statisticsMethod": "Statistics Calculation Method",
  "qc.controlLots.initialRuns": "Initial Runs",
  "qc.controlLots.rolling": "Rolling Window",
  "qc.controlLots.manufacturerFixed": "Manufacturer Fixed",
  "qc.controlLots.activationDate": "Activation Date",
  "qc.controlLots.expirationDate": "Дата на изтичане",
  "qc.controlLots.status.active": "Активен",
  "qc.controlLots.status.establishment": "Establishment",
  "qc.controlLots.status.expired": "Изтекъл срок",
  "qc.controlLots.subtitle": "Manage QC control lots for Westgard rule evaluation",
  "qc.controlLots.empty": "No control lots found",
  "qc.controlLot.filter.allStatuses": "Всички статуси",
  "qc.controlLot.status.establishment": "Establishment",
  "qc.controlLot.status.active": "Активен",
  "qc.controlLot.status.expired": "Изтекъл срок",
  "qc.controlLot.field.lotNumber": "Номер на партида",
  "qc.controlLot.field.lotNumberPlaceholder": "Enter lot number",
  "qc.controlLot.field.material": "Control Material",
  "qc.controlLot.field.materialPlaceholder": "Enter material name",
  "qc.controlLot.field.manufacturer": "Производител",
  "qc.controlLot.field.level": "Control Level",
  "qc.controlLot.field.selectLevel": "Select level",
  "qc.controlLot.field.expiration": "Дата на изтичане",
  "qc.controlLot.field.analyzer": "Анализатор",
  "qc.controlLot.field.selectAnalyzer": "Изберете анализатор",
  "qc.controlLot.field.analyzerHelper": "Optional. Choose \"Bench / no analyzer\" for a manual method run at the bench without an instrument.",
  "qc.controlLot.analyzer.bench": "Bench / no analyzer (manual method)",
  "qc.controlLot.field.test": "Тест",
  "qc.controlLot.field.selectTest": "Select test",
  "qc.controlLot.field.isActive": "Статус",
  "qc.controlLot.field.inactive": "Неактивен",
  "qc.controlLot.field.active": "Активен",
  "qc.controlLot.field.status": "Статус",
  "qc.controlLot.loading": "Зареждане...",
  "qc.controlLot.error.title": "Грешка",
  "qc.controlLot.error.saveFailed": "Failed to save control lot",
  "qc.controlLot.error.statsRequired": "Manufacturer-fixed lots need a mean and standard deviation. Click \"Configure\" to enter them before saving.",
  "qc.controlLot.error.benchNeedsFixedStats": "A bench lot has no analyzer accumulating runs, so it must use manufacturer-fixed statistics. Click \"Configure\" to enter a mean and standard deviation, or select an analyzer for this lot.",
  "qc.controlLot.new.title": "New Control Lot",
  "qc.controlLot.viewChart": "View chart",
  "qc.controlLot.new.subtitle": "Create a new QC control lot",
  "qc.controlLot.edit.title": "Edit Control Lot",
  "qc.controlLot.edit.subtitle": "Update control lot configuration",
  "qc.controlLot.validation.lotNumberRequired": "Lot number is required",
  "qc.controlLot.validation.materialRequired": "Material is required",
  "qc.controlLot.validation.levelRequired": "Control level is required",
  "qc.controlLot.validation.expirationRequired": "Expiration date is required",
  "qc.controlLot.validation.analyzerRequired": "Анализаторът е задължителен",
  "qc.controlLot.validation.testRequired": "Test is required",
  "qc.controlLot.level.low": "Low",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "High",
  "qc.controlLot.statistics.title": "Statistics Configuration",
  "qc.controlLot.statistics.configure": "Configure",
  "qc.controlLot.statistics.method": "Calculation Method",
  "qc.controlLot.statistics.mean": "Mean",
  "qc.controlLot.statistics.sd": "Standard Deviation",
  "qc.controlLot.statistics.config.title": "Statistics Configuration",
  "qc.controlLot.statistics.config.label": "Configure statistics method",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Manufacturer Fixed",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Use manufacturer-provided mean and SD values",
  "qc.controlLot.statistics.method.rolling": "Rolling Window",
  "qc.controlLot.statistics.method.rolling.description": "Recalculate from the most recent N results",
  "qc.controlLot.statistics.method.initial_runs": "Initial Runs",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculate once from the first N establishment runs",
  "qc.controlLot.statistics.manufacturerValues": "Manufacturer Values",
  "qc.controlLot.statistics.rollingConfig": "Rolling Configuration",
  "qc.controlLot.statistics.windowSize": "Window Size",
  "qc.controlLot.statistics.windowSize.helper": "Number of recent results to include in calculation",
  "qc.controlLot.statistics.initialRunsConfig": "Initial Runs Configuration",
  "qc.controlLot.statistics.initialRunsRequired": "Runs Required",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Number of establishment runs before statistics are calculated",
  "qc.instrumentDetail.analytesMonitored": "Analytes Monitored",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Activity Timeline",
  "qc.instrumentDetail.tab.controlChart": "Control Chart",
  "qc.instrumentDetail.timeline.empty": "No alerts or corrective actions recorded for the selected time period",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Corrective Action",
  "qc.instrumentDetail.timeline.loading": "Loading activity timeline...",
  "qc.instrumentDetail.chart.selectAnalyte": "Select Analyte",
  "qc.instrumentDetail.chart.loading": "Loading control chart...",
  "qc.instrumentDetail.chart.noData": "No QC data available for this analyte",
  "qc.instrumentDetail.chart.activeRules": "Active QC Rules",
  "qc.instrumentDetail.chart.noRules": "No active rules configured",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Mean (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Std Dev (s)",
  "qc.instrumentDetail.error.loadFailed": "Failed to load instrument details",
  "qc.instrumentDetail.notConfigured.title": "Operational QC not configured",
  "qc.instrumentDetail.notConfigured.description": "No active control lots or QC results are linked to this analyzer.",
  "question.text.required": "Question text is required",
  "compliance.legend.limitTypes": "LIMIT TYPES:",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Качествено",
  "compliance.limitType.MAXIMUM": "High Limit ≤",
  "compliance.limitType.MINIMUM": "Low Limit ≥",
  "compliance.limitType.RANGE": "Нормални граници",
  "compliance.limitType.BORDERLINE": "Borderline 🚩",
  "compliance.limitType.DESCRIPTIVE": "Качествено",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Value Mapping",
  "compliance.status.ACTIVE": "Активен",
  "compliance.status.DRAFT": "Чернова",
  "compliance.status.SUPERSEDED": "Superseded",
  "compliance.status.ARCHIVED": "Архивирано",
  "compliance.standard.placeholder.name": "e.g., PP No. 22/2021 — Water Quality",
  "compliance.standard.placeholder.issuingBody": "e.g., Government of Indonesia",
  "compliance.standard.placeholder.regulationNumber": "e.g., PP 22/2021",
  "compliance.standard.placeholder.version": "e.g., 2021",
  "compliance.standard.placeholder.countryRegion": "e.g., Indonesia",
  "compliance.standard.placeholder.description": "Optional. Full description of the standard's scope.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Lower / Min",
  "compliance.threshold.placeholder.upper": "Upper / Max",
  "compliance.threshold.placeholder.unit": "Единица",
  "compliance.standard.archive": "Archive",
  "compliance.standard.archiveHeading": "Archive Compliance Standard",
  "compliance.standard.archivePrompt": "Archive this standard? Existing evaluated results stay linked to it for audit, but the standard will be hidden from active selection lists. This action can be reverted by editing the standard's status back to Active.",
  "compliance.standard.archived": "Compliance standard archived.",
  "compliance.standard.archiveError": "Could not archive this standard.",
  "button.complianceStandard.copy": "Copy Standard",
  "compliance.standard.copied": "Compliance standard copied as a new Draft.",
  "compliance.standard.copyError": "Could not copy this standard.",
  "compliance.standard.viewLinkedTests": "View Linked Tests",
  "compliance.testEditor.groupBy": "Group by",
  "compliance.testEditor.section.configuration": "Configuration",
  "compliance.testEditor.section.organization": "Organization",
  "compliance.testEditor.section.resources": "Resources",
  "compliance.testEditor.section.automation": "Automation",
  "compliance.testEditor.section.compliance": "Compliance",
  "compliance.testEditor.tab.compliance": "Compliance",
  "compliance.testEditor.tabPlaceholder": "Coming with the Test Editor surface — manage this from the Modify Test page for now.",
  "compliance.parameterGroup.editBtn": "Редактиране",
  "compliance.parameterGroup.moveUp": "Move up",
  "compliance.parameterGroup.moveDown": "Move down",
  "compliance.parameterGroup.updateError": "Could not update parameter group.",
  "compliance.testEditor.standardInactiveBanner": "This test has thresholds linked to {name} which is now {status}. Results will no longer be evaluated against this standard.",
  "compliance.standard.viewLinkedTests.heading": "Linked Tests — {name}",
  "compliance.standard.viewLinkedTests.empty": "No tests are currently linked to this standard.",
  "compliance.filter.status": "Статус",
  "compliance.filter.region": "Здравен регион",
  "compliance.filter.allStatuses": "Всички статуси",
  "compliance.filter.allRegions": "All Regions",
  "compliance.filter.sampleType": "Тип проба",
  "compliance.filter.allSampleTypes": "All Sample Types",
  "compliance.sampleTypes.addLabel": "Add sample type",
  "compliance.sampleTypes.noneConfigured": "None configured",
  "compliance.sampleTypes.noneTitle": "No sample types configured yet.",
  "compliance.sampleTypes.noneSubtitle": "Add at least one sample type before linking tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "По подразбиране",
  "compliance.standard.groups": "Groups",
  "compliance.standard.tests": "Тестове",
  "compliance.standard.expiryDate": "Expiry Date",
  "compliance.parameterGroups.heading": "Parameter Groups & Linked Tests",
  "compliance.parameterGroups.requireSampleTypes": "Configure the standard's fields and sample types first, then link tests.",
  "compliance.button.save": "Запази",
  "compliance.button.saving": "Saving…",
  "compliance.parameterGroup.createError": "Could not add parameter group.",
  "compliance.parameterGroup.deleteHeading": "Delete Parameter Group",
  "compliance.parameterGroup.deletePrompt": "Delete the parameter group {name} and all of its thresholds? This cannot be undone.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Could not save this row.",
  "compliance.threshold.deleteError": "Could not remove this row.",
  "compliance.validation.required": "This field is required.",
  "compliance.validation.expiryAfterEffective": "Expiry date must be on or after the effective date.",
  "compliance.validation.missingUpper": "Upper limit is required.",
  "compliance.validation.missingLower": "Lower limit is required.",
  "compliance.validation.missingBounds": "Both lower and upper bounds are required.",
  "compliance.validation.lowerGtUpper": "Lower bound must be less than or equal to upper bound.",
  "compliance.validation.missingDescriptive": "Qualitative value is required.",
  "compliance.linkTest.selectNoOptions": "This test is select-list but has no options configured in the test catalog. Add result options in test management before linking it to a compliance standard.",
  "compliance.linkTest.resultTypeLegend": "Тип резултат",
  "compliance.linkTest.resultType.numeric": "Numeric (use limit values)",
  "compliance.linkTest.resultType.select": "Select list (map options to status)",
  "compliance.linkTest.optionsHint": "Add the result options for this test (e.g. 'Absent', 'Present'). The next step lets you map each one to a compliance status.",
  "compliance.linkTest.optionLabel": "Option value",
  "compliance.linkTest.optionPlaceholder": "e.g. Absent",
  "compliance.linkTest.optionsRequired": "Add at least one option above before mapping statuses.",
  "compliance.admin.title": "Compliance Standards Administration",
  "compliance.admin.tile.explain": "Manage compliance standards, parameter groups, and per-test thresholds (e.g. PP 22/2021, WHO Drinking Water).",
  "compliance.tabs.standardsAdmin": "Compliance Standards List",
  "compliance.tabs.testThresholds": "Compliance Tab (Test Editor)",
  "compliance.testEditor.back": "Назад",
  "compliance.testEditor.editTest": "Edit Test:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Sample Type:",
  "compliance.testEditor.resultType": "Result Type:",
  "compliance.testEditor.saveTest": "Save Test",
  "compliance.testEditor.saveDisabledHint": "Other test-editor tabs are not yet wired in this iteration.",
  "compliance.testEditor.thresholdsHeading": "Compliance Thresholds for",
  "compliance.testEditor.addThreshold": "Add Threshold",
  "compliance.testEditor.addThresholdHeading": "Link {name} to a compliance standard",
  "compliance.testEditor.pickStandard": "Compliance standard",
  "compliance.testEditor.pickStandardPlaceholder": "-- Select a standard --",
  "compliance.testEditor.pickGroup": "Parameter group",
  "compliance.testEditor.pickGroupPlaceholder": "-- Select a parameter group --",
  "compliance.testEditor.pickGroupHint": "Pick a standard and parameter group above to configure the threshold.",
  "compliance.testEditor.unlink": "Unlink",
  "compliance.testEditor.unlinkHeading": "Unlink Threshold",
  "compliance.testEditor.unlinkPrompt": "Remove this threshold from {test}? The threshold itself stays on the standard's parameter group; only the link to this specific test is removed.",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "Expand row",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Parameter Group",
  "compliance.testEditor.col.limitType": "Limit Type",
  "compliance.testEditor.col.thresholdRange": "Threshold / Range",
  "compliance.testEditor.col.unit": "Единица",
  "compliance.testEditor.col.effective": "Effective",
  "compliance.testEditor.col.status": "Статус",
  "compliance.testThresholds.selectHint": "Select a test to view its compliance thresholds linked across standards.",
  "compliance.testThresholds.overviewHeading": "Tests linked to compliance standards",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "No tests are linked to compliance standards yet.",
  "compliance.testThresholds.overviewEmptyHint": "CSV-seeded thresholds at parameter-group level appear in Tab 1 (Compliance Standards Admin), not here. Search above to pick a test from the catalog and link it to a standard.",
  "compliance.testThresholds.noLinkedMatches": "No linked tests match \"{q}\".",
  "compliance.testThresholds.addSection": "Add a test to compliance",
  "compliance.testThresholds.col.test": "Тест",
  "compliance.testThresholds.col.code": "Код",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Sample Types",
  "compliance.testThresholds.col.thresholdCount": "# Thresholds",
  "compliance.testThresholds.col.standardCount": "# Standards",
  "compliance.testThresholds.openEditor": "Open",
  "compliance.testThresholds.title": "Test Compliance Thresholds",
  "compliance.testThresholds.tile.explain": "View compliance thresholds linked to a specific test, grouped by standard and parameter group.",
  "compliance.testThresholds.searchLabel": "Search test",
  "compliance.testThresholds.searchPlaceholder": "Filter test list…",
  "compliance.testThresholds.test": "Тест",
  "compliance.testThresholds.selectPlaceholder": "-- Select a test --",
  "compliance.testThresholds.empty": "No compliance thresholds are linked to this test yet. Click + Add Threshold above to link it to a compliance standard's parameter group.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Limit Type",
  "compliance.testThresholds.value": "Стойност",
  "compliance.testThresholds.note": "Бележка",
  "compliance.testThresholds.unknownStandard": "Unknown standard",
  "compliance.button.openAdmin": "Open Compliance Standards Admin",
  "compliance.button.addStandard": "Add Standard",
  "compliance.button.saveStandard": "Save Standard",
  "compliance.button.linkTest": "Link Test to Group",
  "compliance.button.saveLimits": "Save Limits",
  "compliance.button.saveMapping": "Save Mapping",
  "compliance.search": "Search standards",
  "compliance.search.placeholder": "Search by name, issuing body, regulation, country…",
  "compliance.list.empty": "No compliance standards yet.",
  "compliance.standard.name": "Standard Name",
  "compliance.standard.issuingBody": "Issuing Body",
  "compliance.standard.regulationNumber": "Regulation Number",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Country / Region",
  "compliance.standard.status": "Статус",
  "compliance.standard.effectiveDate": "Effective Date",
  "compliance.standard.description": "Описание",
  "compliance.standard.addNew": "Add New Compliance Standard",
  "compliance.standard.edit": "Edit Compliance Standard",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Compliance standard saved.",
  "compliance.standard.saveError": "Could not save standard.",
  "compliance.standard.saveBeforeGroups": "Save the standard before adding parameter groups.",
  "compliance.standard.deleted": "Compliance standard deleted.",
  "compliance.standard.deleteError": "Could not delete standard (it may be pre-seeded or have linked thresholds).",
  "compliance.standard.deleteHeading": "Delete Compliance Standard",
  "compliance.standard.deletePrompt": "Are you sure you want to delete this standard? Pre-seeded standards and standards with linked thresholds cannot be deleted.",
  "compliance.sampleTypes.heading": "Applicable Sample Types",
  "compliance.sampleTypes.explicitHint": "Declare which sample type categories this standard applies to. These selections drive the test filter when linking tests.",
  "compliance.sampleTypes.empty": "No sample types declared yet.",
  "compliance.sampleTypes.selectPlaceholder": "Select sample type...",
  "compliance.sampleTypes.addBtn": "Add Sample Type",
  "compliance.sampleTypes.remove": "Премахни",
  "compliance.parameterGroups": "Parameter Groups",
  "compliance.parameterGroups.empty": "No parameter groups defined yet.",
  "compliance.parameterGroups.add": "Add Parameter Group",
  "compliance.parameterGroup.name": "Group name",
  "compliance.parameterGroup.description": "Описание",
  "compliance.parameterGroup.deleteBtn": "Изтрий",
  "compliance.label.tests": "tests",
  "compliance.linkedTest.name": "Тест",
  "compliance.linkedTest.sampleTypes": "Sample Types",
  "compliance.linkedTest.limits": "Limits Configured",
  "compliance.linkedTest.editLimits": "Edit limits",
  "compliance.linkedTest.unlink": "Remove from group",
  "compliance.linkedTest.unlinkHeading": "Remove Test from Group",
  "compliance.linkedTest.unlinkConfirm": "Премахни",
  "compliance.linkedTest.unlinkPrompt": "Remove this test from the group? All threshold definitions for this test in this group will be deleted.",
  "compliance.group.noTests": "No tests linked to this group yet. Link tests to define compliance thresholds for evaluation.",
  "compliance.linkTest.heading": "Link Test to Group",
  "compliance.linkTest.step1": "Step 1 — Filter by Sample Type",
  "compliance.linkTest.step2": "Step 2 — Search & Select Test",
  "compliance.linkTest.step3Numeric": "Step 3 — Configure Limits",
  "compliance.linkTest.step3Select": "Step 3 — Compliance Value Mapping",
  "compliance.linkTest.filterByST": "Filter by sample type:",
  "compliance.linkTest.searchTest": "Search test catalog",
  "compliance.linkTest.searchPlaceholder": "Type to search by name or code...",
  "compliance.linkTest.noResults": "No matching tests found.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Изчисти избраното",
  "compliance.multiLimit.editHeading": "Configure Limits",
  "compliance.multiLimit.hint": "Enable one or more limit types for this test. At least one limit type must be enabled.",
  "compliance.multiLimit.type": "Limit Type",
  "compliance.multiLimit.lower": "Lower",
  "compliance.multiLimit.upper": "Upper",
  "compliance.multiLimit.unit": "Единица",
  "compliance.multiLimit.note": "Note / Advisory",
  "compliance.multiLimit.descriptive.placeholder": "e.g., No odor, Absent, Clear",
  "compliance.multiLimit.note.placeholder": "Optional note",
  "compliance.limitType.high": "High Limit ≤",
  "compliance.limitType.high.hint": "Non-compliant if result exceeds upper limit",
  "compliance.limitType.low": "Low Limit ≥",
  "compliance.limitType.low.hint": "Non-compliant if result is below lower limit",
  "compliance.limitType.range": "Нормални граници",
  "compliance.limitType.range.hint": "Compliant within lower–upper range",
  "compliance.limitType.borderline": "Borderline (Advisory)",
  "compliance.limitType.borderline.hint": "Advisory zone — triggers review flag, not fail",
  "compliance.limitType.descriptive": "Qualitative / Descriptive",
  "compliance.limitType.descriptive.hint": "Text value evaluated by analyst",
  "compliance.selectMap.editHeading": "Compliance Mapping",
  "compliance.selectMap.hint": "Map each result option to its compliance status. Options come from the test catalog.",
  "compliance.selectMap.option": "Result Option",
  "compliance.selectMap.status": "Compliance Status",
  "compliance.selectMap.preview": "Предварителен преглед",
  "compliance.selectMap.badge": "Value Mapping",
  "compliance.selectMap.optionsLabel": "options mapped",
  "compliance.selectMap.statusForOption": "Compliance status for {option}",
  "compliance.status.compliant": "Compliant",
  "compliance.status.borderline": "Borderline",
  "compliance.status.nonCompliant": "Non-Compliant",
  "compliance.status.compliantWithIcon": "Compliant ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non-Compliant ✗",
  "compliance.linkedTest.noLimits": "No limits configured",
  "compliance.threshold.savedThresholds": "Compliance thresholds linked to the test.",
  "compliance.threshold.savedValueMap": "Value-mapping threshold saved.",
  "compliance.threshold.savedPartialError": "Some thresholds could not be saved. Review the highlighted rows.",
  "compliance.threshold.unlinked": "Threshold unlinked from the test.",
  "compliance.threshold.unlinkError": "Could not unlink this threshold.",
  "notification.title.success": "Успех",
  "notification.title.error": "Грешка",
  "sidenav.label.admin.vectorSurveillance": "Vector Surveillance",
  "vector.admin.title": "Vector Surveillance Setup",
  "vector.admin.groups": "Organism Groups",
  "vector.admin.group.code": "Код",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Color Tag",
  "vector.admin.group.description": "Описание",
  "vector.admin.active": "Активен",
  "vector.admin.system": "System",
  "vector.admin.trapTypes": "Trap Types",
  "vector.admin.trapType.name": "Име",
  "vector.admin.trapType.description": "Описание",
  "vector.admin.species": "Species",
  "vector.admin.selectGroup": "Select a group on the left to manage its trap types and species.",
  "vector.admin.newGroup": "New group (unsaved)",
  "vector.admin.newTrapType": "New trap type",
  "vector.admin.newSpecies": "New species",
  "vector.admin.saveGroup": "Save group",
  "vector.admin.saveTrap": "Save trap",
  "vector.admin.saveSpecies": "Save species",
  "vector.admin.addGroup": "+ Add group",
  "vector.admin.addTrapType": "+ Add trap type",
  "vector.admin.addSpecies": "+ Add species",
  "vector.admin.locked": "locked",
  "vector.admin.systemGroup": "System-protected group",
  "vector.admin.systemGroup.desc": "The code is locked because this group is referenced by core reports and seed data. You may still edit the label, color, and description.",
  "vector.admin.usedBy": "Used by",
  "vector.admin.status": "Статус",
  "vector.admin.status.active": "Активен",
  "vector.admin.status.inactive": "Неактивен",
  "vector.admin.group": "Organism group",
  "vector.admin.trapType.group": "Target organism group",
  "vector.admin.trapType.groups": "Organism groups",
  "vector.admin.trapType.sampleTypes": "Sample types",
  "vector.admin.sampleType": "Sample type",
  "vector.admin.search.groups": "Search by code or label...",
  "vector.admin.search.traps": "Search trap name or description...",
  "vector.admin.search.species": "Search genus or species...",
  "vector.admin.samplingSites": "Sampling Sites",
  "vector.admin.samplingSite.newSite": "New site",
  "vector.admin.samplingSite.allSites": "All Sites",
  "vector.admin.samplingSite.code": "Код",
  "vector.admin.samplingSite.name": "Име на обекта",
  "vector.admin.samplingSite.type": "Site Type",
  "vector.admin.samplingSite.region": "Здравен регион",
  "vector.admin.samplingSite.district": "Здравен район",
  "vector.admin.samplingSite.contactName": "Contact Person",
  "vector.admin.samplingSite.contactPhone": "Contact Phone",
  "vector.admin.samplingSite.gpsLatitude": "GPS Latitude",
  "vector.admin.samplingSite.gpsLongitude": "GPS Longitude",
  "vector.admin.samplingSite.environmentalZone": "Environmental Zone",
  "vector.admin.samplingSite.address": "Адрес",
  "vector.admin.samplingSite.description": "Описание",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Last Collection",
  "vector.admin.samplingSite.search": "Search by code, name, region...",
  "vector.admin.samplingSite.saveSite": "Save site",
  "vector.admin.samplingSites.registry": "Sampling Site Registry",
  "vector.admin.samplingSite.deactivate": "Деактивирай",
  "vector.admin.samplingSite.activate": "Активирай",
  "vector.admin.samplingSite.location": "Местоположение",
  "vector.admin.samplingSite.allTypes": "All types",
  "vector.admin.samplingSite.subtype": "Subtype",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. River, Well, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "Град",
  "vector.admin.samplingSite.addressLocation": "Address Location",
  "vector.admin.samplingSite.addressSearch.placeholder": "Search location to auto-fill dropdowns...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Последна промяна",
  "label.noResults": "Няма намерени резултати",
  "vector.admin.addSite": "+ New Site",
  "vector.order.title": "New Vector Order",
  "vector.order.subtitle": "Lab unit: Vector Surveillance Lab — Vector domain active.",
  "vector.order.samplingSite": "Sampling Site",
  "vector.order.site.code": "Site Code",
  "vector.order.site.helper": "Only active surveillance sites appear in results. GPS coordinates are pre-filled from the site record.",
  "vector.order.site.name": "Име на обекта",
  "vector.order.site.placeholder": "Search by site name or code...",
  "vector.order.site.type": "Site Type",
  "vector.order.specimen": "Проба",
  "vector.order.organism": "Animal / Organism",
  "vector.order.organism.hint": "Common name — e.g., Mosquito, Tick, Rodent, Sandfly.",
  "vector.order.organism.placeholder": "Search organism or species...",
  "vector.order.quantity": "Количество",
  "vector.order.quantity.hint": "Number of organisms in this pool.",
  "vector.order.requester.section": "Requester / Ordering Programme",
  "vector.order.requester": "Заявител",
  "vector.order.requester.placeholder": "Search by organisation name or code...",
  "vector.order.panels": "Поръчване на панели",
  "vector.order.panels.search": "Choose available panel",
  "vector.order.tests": "Поръчване на тестове",
  "vector.order.tests.search": "Choose available test",
  "vector.order.collectionContext": "Collection Context (optional — bionomics capture)",
  "vector.order.timeOfDay": "Time of Day",
  "vector.order.timeOfDay.dawn": "Dawn",
  "vector.order.timeOfDay.day": "Day",
  "vector.order.timeOfDay.dusk": "Dusk",
  "vector.order.timeOfDay.night": "Night",
  "vector.order.restingContext": "Resting Context",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Human-Biting Catch",
  "vector.order.humanBitingCatch.hint": "specimen came from a human-landing collection",
  "vector.order.collectionNotes": "Collection Notes",
  "vector.order.collectionNotes.placeholder": "Weather, trap conditions, anomalies...",
  "vector.admin.group.code.placeholder": "e.g., SANDFLY",
  "vector.admin.group.label.placeholder": "e.g., Sandfly",
  "vector.species.genus.placeholder": "e.g., Mansonia",
  "vector.species.species.placeholder": "e.g., uniformis",
  "vector.species.subspecies.placeholder": "e.g., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Species",
  "vector.species.subspecies": "Subspecies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Lifecycle Stages",
  "vector.species.pathogenCategory": "Pathogen category",
  "vector.species.lifecycleCategory": "Lifecycle category",
  "workflow.vector": "Vector Surveillance",
  "vector.sampleType": "Тип проба",
  "vector.organismGroup": "Organism Group",
  "vector.species": "Species",
  "vector.animalOrganism": "Animal/Organism",
  "vector.animalOrganism.add": "Add Animal/Organism",
  "vector.animalOrganism.remove": "Remove Animal/Organism",
  "vector.collectedVolume": "Quantity in Pool",
  "vector.lifecycleStage": "Етап на жизнения цикъл",
  "vector.trapCount": "Traps Deployed",
  "vector.trapNights": "Nights Deployed",
  "vector.trapType": "Trap Type",
  "vector.poolingMethod": "Pooling Method",
  "vector.poolCount": "Number of Pools",
  "vector.samplesPerPool": "Specimens per Pool",
  "vector.totalSpecimens": "Total Specimens",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogeneous",
  "vector.random": "Random",
  "vector.collectionSite": "Collection Site",
  "vector.collectionSiteName": "Collection Site Name",
  "vector.gpsLatitude": "GPS Latitude",
  "vector.gpsLongitude": "GPS Longitude",
  "patient.search.merged.tag": "Merged",
  "patient.merged.banner.title": "This patient record was merged",
  "patient.merged.banner.subtitle": "Active records are kept on Patient {target}.",
  "patient.merged.banner.subtitle.noTarget": "This record has been merged into another patient.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Labels",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Preset Name",
  "admin.testCatalog.labels.col.defaultQty": "Default Qty",
  "admin.testCatalog.labels.col.maxQty": "Max Qty",
  "admin.testCatalog.labels.col.allowOverride": "Allow Override",
  "admin.testCatalog.labels.col.actions": "Действия",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Add Label Type",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Заключено",
  "admin.testCatalog.labels.preview.locked": "Заключено",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Ред",
  "orderEntry.labels.col.sample": "Проба",
  "orderEntry.labels.col.quantity": "Количество",
  "orderEntry.labels.orderRow.header": "Поръчка",
  "orderEntry.labels.sampleRow.header": "Sample {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS",
  "label.patientHistory.filterByCategory": "Filter by test category",
  "label.patientHistory.testCategories": "Test categories",
  "label.patientHistory.tree": "Tree",
  "label.patientHistory.showTree": "Show tree",
  "label.patientHistory.resetTree": "Reset tree",
  "label.patientHistory.viewResults": "View {count} results",
  "label.patientHistory.emptyState": "There are no {displayText} to display for this patient",
  "label.patientHistory.record": "Record {displayText}",
  "label.patientHistory.dataLoadError": "Data Load Error",
  "label.patientHistory.errorCopy": "Sorry, there was a problem displaying this information. You can try to reload this page, or contact the site administrator and quote the error code above.",
  "label.patientHistory.backToTimeline": "Back to timeline",
  "label.patientHistory.returnToTimeline": "Return to timeline",
  "label.patientHistory.timeOfTest": "Time of Test",
  "label.patientHistory.observations": "observations",
  "label.patientHistory.range.oneDay": "1 day",
  "label.patientHistory.range.fiveDays": "5 days",
  "label.patientHistory.range.oneMonth": "1 month",
  "label.patientHistory.range.sixMonths": "6 months",
  "label.patientHistory.range.oneYear": "1 year",
  "label.patientHistory.range.fiveYears": "5 years",
  "label.patientHistory.range.all": "Всички",
  "label.patientHistory.date": "Дата",
  "address.search.no.results": "No addresses found for '{term}'",
  "address.search.placeholder": "Search for address (type at least 2 characters)...",
  "address.search.results.count": "{count} results found",
  "alert.error": "Грешка",
  "alert.warning": "Предупреждение",
  "analyzer.errorDetails.noLogsAvailable": "No logs available",
  "analyzer.fieldSelector.placeholder": "Search and select field...",
  "analyzer.fieldSelector.title": "Select OpenELIS Field",
  "analyzer.form.columnMappings": "Column Mappings (JSON)",
  "analyzer.form.columnMappings.helperText": "Maps file column names to internal field names",
  "analyzer.form.delimiter": "Разделител",
  "analyzer.form.fileFormat": "File Format",
  "analyzer.form.fileImport.title": "File Import Settings",
  "analyzer.form.filePattern": "Файлов шаблон",
  "analyzer.form.filePattern.helperText": "Glob pattern to match result files",
  "analyzer.form.hasHeader": "File has header row",
  "analyzer.form.importDirectory": "Директория за импорт",
  "analyzer.form.importDirectory.helperText": "Directory the bridge watches for incoming result files",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Column mappings must be valid JSON",
  "analyzer.form.validation.importDirectory.required": "Import directory is required for file-based analyzers",
  "analyzer.form.validation.port.invalid": "Port must be a number between 1 and 65535",
  "analyzer.qc.batch.failure.subtitle": "QC controls in this batch have failures. Review QC results below before accepting patient results.",
  "analyzer.qc.batch.failure.title": "QC Controls Failed",
  "analyzer.qc.controls.hidden": "QC controls hidden from patient view",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Order Information",
  "barcode.label.info.labnumber": "Номер на акцесия",
  "button.close": "Затвори",
  "button.collapse": "Collapse",
  "button.expand": "Expand",
  "button.home": "Начало",
  "button.new.search": "New Search",
  "column.name.labNo": "Lab #",
  "env.collectionConditions.helper": "Search for an existing sampling site or create a new one. Sites are reusable across orders — like patients in clinical workflows.",
  "env.collectionMethod.placeholder": "e.g., Grab sample, Composite 24h",
  "env.conditions": "Environmental Conditions",
  "env.conditions.placeholder": "e.g., 20°C, clear weather, dry season",
  "env.regulatoryReference": "Regulatory Reference",
  "env.regulatoryReference.placeholder": "e.g., PP No. 22/2021 Batu Mutu Air",
  "env.samplingSite.title": "Subject — Sampling Site",
  "env.site.address": "Адрес",
  "env.site.addressSearch.placeholder": "Search for location to auto-fill dropdowns below...",
  "env.site.code": "Site Code",
  "env.site.code.placeholder": "Auto-generated (or enter manually)",
  "env.site.contactPerson": "Contact Person",
  "env.site.contactPerson.placeholder": "Name of site custodian or contact",
  "env.site.contactPhone": "Contact Phone",
  "env.site.description": "Site Description",
  "env.site.description.placeholder": "e.g., Downstream monitoring point near floodgate",
  "env.site.helperText": "Register a new sampling site. The site will be saved to the Site Registry and can be reused for future orders.",
  "env.site.name": "Име на обекта",
  "env.site.name.placeholder": "e.g., Sungai Ciliwung — Manggarai",
  "env.site.newTab": "New Site",
  "env.site.saveAndSelect": "Save & Select Site",
  "env.site.searchLabel": "Име на обекта",
  "env.site.searchPlaceholder": "e.g., Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Search for Site",
  "env.site.streetAddress": "Адрес",
  "env.site.streetAddress.placeholder": "Street address or location reference",
  "env.site.subtype": "Subtype",
  "env.site.subtype.placeholder": "e.g., River, Well, BG-Sentinel, Fixed Station",
  "env.site.type": "Site Type",
  "env.site.type.select": "Select Type...",
  "env.site.zone": "Environmental Zone",
  "env.site.zone.select": "Select Zone...",
  "error.dateRange.start": "Please select Start and end date.",
  "error.loading.metrics": "Error loading metrics",
  "error.nonconform.report.data.found": "No data found",
  "error.report.csv.dateType": "Моля, изберете тип дата.",
  "error.required.fields": "Please fill in all required fields",
  "error.save.sample": "Error saving sample",
  "error.validation.failed": "Validation failed",
  "error.value": "Please select a value.",
  "esig.context.saveResults": "Save {count} result(s) for accession {accession}",
  "esig.context.saveResultsMulti": "Save {count} result(s) across {accessionCount} accessions",
  "esig.context.validateResults": "Validate {count} result(s) for accession {accession}",
  "esig.context.validateResultsMulti": "Validate {count} result(s) across {accessionCount} accessions",
  "fhir.questionnaire.title": "Допълнителна информация",
  "genericSample.default.fields.title": "Информация за пробата",
  "genericSample.import.success": "Import successful",
  "genericSample.notebook.label": "Избор на бележник",
  "genericSample.order.newOrder": "Create Another Sample",
  "genericSample.search.title": "Търсене по номер на акцесия",
  "http.success": "Success!",
  "label.button.assign": "Задай",
  "label.button.create": "Create",
  "label.button.saving": "Запазване...",
  "label.button.view": "Виж отчета",
  "label.code": "Код",
  "label.editing": "Editing",
  "label.label": "Label",
  "label.name": "Име",
  "label.panel": "Панел",
  "label.tests": "tests",
  "loading.label": "Зареждане...",
  "loading.metrics": "Loading metrics...",
  "locale.save.error": "Failed to save language",
  "logging.management.tail.clear": "Изчисти",
  "logging.management.tail.disconnected": "Stream disconnected. Toggle off and on to reconnect.",
  "logging.management.tail.label": "Live application log",
  "logging.management.tail.off": "Off",
  "logging.management.tail.on": "On",
  "logging.management.tail.stream": "Live stream",
  "nationalID.title": "Външен ID",
  "nce.button.linkSelected": "Link Selected Samples",
  "nce.button.submit": "Submit NCE",
  "nce.error.numberGeneration": "Failed to generate NCE number. Please try again.",
  "nce.field.dateOfEvent": "Дата на събитието",
  "nce.field.description": "Описание",
  "nce.field.nceNumber": "NCE номер",
  "nce.field.proposedAction.helper": "Separate from CAPA actions assigned during corrective action workflow",
  "nce.field.proposedAction.placeholder": "Recommended next steps...",
  "nce.field.reporterName": "Reporter Name",
  "nce.field.reportingUnit": "Докладващо звено",
  "nce.field.subcategory": "Subcategory",
  "nce.field.suspectedCauses.helper": "Initial assessment only - formal root cause determined during investigation",
  "nce.field.suspectedCauses.placeholder": "Reporter",
  "nce.form.subtitle": "Document a quality event and link to affected samples and results",
  "nce.form.title": "Report Non-Conformity Event",
  "nce.linkSamples.helper": "Search for orders above to link samples to this NCE. This step is optional.",
  "nce.section.attachments": "Прикачени файлове",
  "nce.section.classification": "Classification",
  "nce.section.details": "Details",
  "nce.section.linkSamples": "Link to Samples / Results (Optional)",
  "nce.section.reporterContext": "Reporter & Event Context",
  "nce.select.subcategory": "Select subcategory...",
  "nce.severity.critical.desc": "Patient safety risk, regulatory violation",
  "nce.severity.major.desc": "Significant quality or operational impact",
  "nce.severity.minor.desc": "Limited impact, easily corrected",
  "nonconform.corrective.requiredFields": "Fill all corrective-action fields (action, person responsible, date completed, and at least one action type), or leave the row entirely empty.",
  "nonconform.view.requiredFields": "Lab component, NCE category, NCE type, severity consequence and recurrence are all required.",
  "notebook.sample.create": "Create",
  "notebook.sample.create.title": "Create New Sample",
  "notebook.sample.edit": "Редактиране",
  "notebook.sample.edit.title": "Редактиране на проба",
  "notebook.sample.import": "Импорт",
  "notebook.sample.import.title": "Импорт на проби",
  "notebook.sample.order.info": "This sample will be associated with the current notebook.",
  "notification.warning": "Предупреждение",
  "order.entry.setup.batch": "Групово въвеждане на поръчки",
  "order.legend.patient1": "Инфо за пациента",
  "pagination.next": "Следваща страница",
  "pagination.previous": "Предишна страница",
  "patient.fetch.error": "Could not load patient. The id may be invalid or the server is unreachable.",
  "patient.firstName": "Име",
  "patient.lastName": "Фамилия",
  "print.barcode.all": "Print All Barcodes ({count})",
  "sample.item.id": "Sample Item ID",
  "sample.label": "Проба",
  "sample.noPanels": "No panels available for this sample type",
  "sample.noTests": "No tests available for this sample type",
  "sample.selectType.first": "Select a sample type above to see available panels and tests",
  "sample.testsCount": "{count} tests available",
  "sample.types": "Проби",
  "save.error.msg": "Error saving",
  "saving.label": "Запазване...",
  "select.label.analyzer": "Избор на анализатор",
  "site.code": "Код",
  "steps.complete": "steps",
  "storage.audit.empty": "No movements recorded for this sample yet.",
  "storage.audit.empty.title": "No movements",
  "storage.audit.fetch.error": "Could not load audit trail.",
  "storage.audit.fetch.error.title": "Грешка",
  "storage.audit.from": "От",
  "storage.audit.movedBy": "Moved By",
  "storage.audit.movementDate": "Movement Date",
  "storage.audit.reason": "Reason",
  "storage.audit.to": "До",
  "storage.box.code.helper": "Up to 10 characters",
  "storage.confirm.disposal": "Confirm Disposal",
  "storage.dashboard.title": "Съхранение",
  "storage.disposal.method": "Disposal Method",
  "storage.disposal.method.placeholder": "Select method...",
  "storage.disposal.notes": "Additional Notes (optional)",
  "storage.disposal.notes.placeholder": "Enter any additional notes...",
  "storage.disposal.reason": "Причина за бракуване",
  "storage.disposal.reason.placeholder": "Select reason...",
  "storage.dispose.confirmation": "I confirm that I want to permanently dispose of this sample. This action cannot be undone.",
  "storage.dispose.error": "Disposal failed",
  "storage.dispose.instructions.subtitle": "Please ensure proper disposal procedures are followed according to laboratory safety protocols.",
  "storage.dispose.instructions.title": "Disposal Instructions",
  "storage.dispose.location.note": "Sample will be removed from this location upon disposal",
  "storage.dispose.sample": "Dispose Sample",
  "storage.dispose.sample.subtitle": "Permanently dispose of sample {sampleId}",
  "storage.dispose.warning.subtitle": "The sample will be marked as disposed and removed from storage.",
  "storage.dispose.warning.title": "This action cannot be undone",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Редактиране",
  "storage.editbox.heading": "Edit Box",
  "storage.error": "Грешка",
  "storage.error.save": "Failed to save location",
  "storage.filter.select.location": "Select location...",
  "storage.filter.selected": "Selected:",
  "storage.location.assigned.error": "Failed to assign location",
  "storage.location.assigned.success": "Location assigned successfully",
  "storage.location.created": "{level} created",
  "storage.location.deleted": "{level} deleted",
  "storage.location.no.results": "No locations found",
  "storage.location.type.devices": "devices",
  "storage.location.type.racks": "racks",
  "storage.location.type.rooms": "rooms",
  "storage.location.type.shelves": "shelves",
  "storage.location.updated": "{level} updated",
  "storage.manage.location": "Manage Location",
  "storage.nav.rack": "Стелаж",
  "storage.sample.actions": "Sample actions",
  "storage.sampleitem.accession": "Акцесия на проба",
  "storage.sampleitem.location": "Storage location",
  "storage.sampleitem.status": "Статус",
  "storage.sampleitem.type": "Тип",
  "storage.search.location.label": "Search for a storage location",
  "storage.search.location.placeholder": "Type 2+ characters to search…",
  "storage.skipRemaining": "Skip storage for unassigned samples ({count}) - will be processed immediately",
  "storage.view.audit": "View Audit",
  "storage.view.audit.subtitle": "Movement history for sample {sampleId}",
  "storage.view.audit.title": "Storage Audit Trail",
  "systemDefaultPayloadTemplate.messageTemplate": "Message template",
  "systemDefaultPayloadTemplate.subjectTemplate": "Subject template",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "Invalid IP address format (IPv4 or IPv6)",
  "validation.invalid.port": "Port must be between 1 and 65535",
  "validation.required": "Това поле е задължително",
  "common.accept": "Приеми",
  "common.accessionNumber": "Номер на акцесия",
  "common.action": "Действие",
  "common.actions": "Действия",
  "common.active": "Активен",
  "common.addTests": "Добавяне на тестове",
  "common.aliquots": "аликоти",
  "common.all": "Всички",
  "common.allStatuses": "Всички статуси",
  "common.analyzer": "Анализатор",
  "common.analyzers": "Анализатори",
  "common.auditTrail": "Одитна следа",
  "common.back": "Назад",
  "common.boxId": "Box ID",
  "common.byUnit": "По звено",
  "common.cancel": "Отказ",
  "common.category": "Категория",
  "common.clinical": "Clinical",
  "common.code": "Код",
  "common.collected": "Collected",
  "common.collectionDate": "Дата на вземане",
  "common.complete": "Завършено",
  "common.completed": "Завършен",
  "common.confirm": "Потвърди",
  "common.correctiveActions": "Коригиращи действия",
  "common.createAliquot": "Създаване на аликот",
  "common.critical": "Критична",
  "common.dashboard": "Табло",
  "common.date": "Дата",
  "common.dateRange": "Период",
  "common.deactivate": "Деактивирай",
  "common.delete": "Изтрий",
  "common.description": "Описание",
  "common.draft": "Чернова",
  "common.edit": "Редактиране",
  "common.editOrder": "Редактиране на поръчка",
  "common.email": "Имейл",
  "common.enterResults": "Въвеждане на резултати",
  "common.error": "Грешка",
  "common.expired": "Изтекъл срок",
  "common.exportPdf": "Export PDF",
  "common.failed": "Неуспешно",
  "common.filterByStatus": "Филтриране по статус",
  "common.firstName": "Име",
  "common.from": "От",
  "common.generateReport": "Генерирай отчет",
  "common.home": "Начало",
  "common.inProgress": "В ход",
  "common.inactive": "Неактивен",
  "common.labNumber": "Лабораторен номер",
  "common.lastName": "Фамилия",
  "common.loading": "Зареждане...",
  "common.location": "Местоположение",
  "common.mean": "Mean",
  "common.name": "Име",
  "common.nationalId": "Външен ID",
  "common.new": "New",
  "common.none": "Няма",
  "common.normal": "Normal",
  "common.normalRange": "Нормални граници",
  "common.notes": "Бележки",
  "common.order": "Поръчка",
  "common.overdue": "Overdue",
  "common.panels": "Панели",
  "common.participants": "Participants",
  "common.patient": "Пациент",
  "common.pending": "Pending",
  "common.position": "Позиция",
  "common.printLabel": "Печат на етикет",
  "common.priority": "Приоритет",
  "common.program": "Програма",
  "common.programName": "Име на програмата",
  "common.provider": "Доставчик",
  "common.quantity": "Количество",
  "common.received": "Received",
  "common.referenceLab": "Референтна лаборатория",
  "common.reject": "Отхвърли",
  "common.remove": "Премахни",
  "common.removeSelection": "Remove {name}",
  "common.reports": "Отчети",
  "common.requester": "Заявител",
  "common.result": "Резултат",
  "common.results": "Резултати",
  "common.room": "Стая",
  "common.routine": "Рутинни",
  "common.sample": "Проба",
  "common.sampleId": "ID на проба",
  "common.sampleManagement": "Управление на проби",
  "common.sampleType": "Тип проба",
  "common.samples": "Проби",
  "common.samplingSite": "Sampling Site",
  "common.save": "Запази",
  "common.saveFailed": "Запазването е неуспешно",
  "common.saving": "Запазване...",
  "common.search": "Търсене",
  "common.select": "Избор",
  "common.severity": "Сериозност",
  "common.siteName": "Име на обекта",
  "common.species": "Species",
  "common.standard": "Standard",
  "common.status": "Статус",
  "common.storageLocation": "Място за съхранение",
  "common.study": "Проучване",
  "common.test": "Тест",
  "common.testName": "Име на тест",
  "common.tests": "Тестове",
  "common.type": "Тип",
  "common.unit": "Единица",
  "common.user": "Потребител",
  "common.value": "Стойност",
  "common.view": "Преглед",
  "common.warning": "Предупреждение",
  "label.testCatalog.alerts.field.component": "Result component",
  "label.testCatalog.alerts.field.componentHelp": "Which result this alert watches. Leave unset to watch every component of this test.",
  "label.testCatalog.alerts.field.sampleType": "Sample type",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Which specimen this alert watches. Leave unset to watch every sample type this test runs on.",
  "label.testCatalog.alerts.scope.anyComponent": "Any component",
  "label.testCatalog.alerts.scope.anySampleType": "Any sample type",
  "label.testCatalog.alerts.col.scope": "Applies to",
  "label.testCatalog.alerts.scope.wholeTest": "Whole test",
  "microbiology.ast.breakpointStandard": "Breakpoint standard",
  "microbiology.ast.hint": "Record MIC or zone readings, review interpretations, and document overrides inline.",
  "microbiology.ast.noOverride": "No override",
  "microbiology.ast.reading": "AST reading",
  "microbiology.case.isolates.hint": "Add and identify clinically significant growth before AST.",
  "microbiology.isolate.contaminant": "Contaminant",
  "microbiology.isolate.edit": "Edit isolate",
  "microbiology.isolate.identificationStatus": "Identification status",
  "microbiology.isolate.normalFlora": "Normal flora",
  "microbiology.isolate.organism": "Organism",
  "microbiology.isolate.organism.freeText": "Enter organism as free text",
  "microbiology.isolate.significant": "Clinically significant",
  "microbiology.isolate.unknown": "Неизвестен",
  "microbiology.isolate.update": "Save identification",
  "microbiology.enum.AST_REVIEW_REQUIRED": "AST Review Required",
  "microbiology.enum.AWAITING_RESULTS": "Awaiting Results",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Antibiotic Mapping Required",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Case Finalization Required",
  "microbiology.enum.AMENDED": "Amended",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Amendment Action Failed",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Culture Protocol Changed",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Amendment Already Open",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Amendment History Load Failed",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Amendment In Progress",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "New AST Run Required for Amendment",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Amendment Not Open",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Amendment Reason Required",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Amendment Requires Final Release",
  "microbiology.enum.ACKNOWLEDGED": "Потвърдена",
  "microbiology.enum.AMENDMENT_CANCELLED": "Amendment Cancelled",
  "microbiology.enum.AMENDMENT_OPENED": "Amendment Opened",
  "microbiology.enum.AMENDMENT_RELEASED": "Amendment Released",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Amendment Source AST Must Be Reportable",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Analyzer Flags Acknowledged",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "Analyzer QC Failed",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Analyzer Results Received",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "AST Attempt Reason Required",
  "microbiology.enum.AST_ENTRY": "AST Entry",
  "microbiology.enum.AST_IN_PROGRESS": "AST In Progress",
  "microbiology.enum.AST_READY": "AST Ready",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Repeat or Retest Required",
  "microbiology.enum.AST_REVIEW": "AST Review",
  "microbiology.enum.AST_REVIEWED": "AST Reviewed",
  "microbiology.enum.AST_READING_OVERRIDDEN": "AST Reading Overridden",
  "microbiology.enum.AST_READING_RECORDED": "AST Reading Recorded",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "Reportable AST Selected",
  "microbiology.enum.AST_RUN_CREATED": "AST Run Created",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST Run Invalidated",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "AST Run Method Mismatch",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST QC Overridden",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "AST Setup Unavailable",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "AST Source Run Review Required",
  "microbiology.enum.ANALYZER": "Анализатор",
  "microbiology.enum.BROTH_MICRODILUTION": "Broth Microdilution",
  "microbiology.enum.CASE": "Case",
  "microbiology.enum.CASE_CREATED": "Case Created",
  "microbiology.enum.CASE_REVIEW": "Case Review",
  "microbiology.enum.CANCELLED": "Анулиран",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Clinically significant",
  "microbiology.enum.CLOSED": "Closed",
  "microbiology.enum.CONFIRMED": "Confirmed",
  "microbiology.enum.CONTAMINANT": "Contaminant",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Critical Communication Acknowledged",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Critical Communication Closed",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Critical Communication Logged",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Critical Follow-Up Required",
  "microbiology.enum.DISK_DIFFUSION": "Disk Diffusion",
  "microbiology.enum.EMAIL": "Имейл",
  "microbiology.enum.EMERGENCY": "Emergency",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Неуспешно",
  "microbiology.enum.FINAL": "Final",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Final Report Released",
  "microbiology.enum.GROWTH_DETECTED": "Growth Detected",
  "microbiology.enum.HIGH": "High",
  "microbiology.enum.IDENTIFICATION": "Identification",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "Incubating",
  "microbiology.enum.INPATIENT": "Inpatient",
  "microbiology.enum.IN_PROGRESS": "В ход",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "In Person",
  "microbiology.enum.INOCULATION_RECORDED": "Inoculation Recorded",
  "microbiology.enum.ISOLATE": "Isolate",
  "microbiology.enum.ISOLATE_CREATED": "Isolate Created",
  "microbiology.enum.ISOLATE_ID": "Isolate ID",
  "microbiology.enum.ISOLATE_REQUIRED": "Isolate Required",
  "microbiology.enum.ISOLATE_UPDATED": "Isolate Updated",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Unspecified MIC Technique",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Unspecified Zone Technique",
  "microbiology.enum.MANUAL_NOTE": "Manual Note",
  "microbiology.enum.MANUAL_ENTRY": "Manual Entry",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "Inoculation Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "Protocol Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Select a Different Protocol",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Assign a Workflow Before Selecting a Protocol",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "Subculture Source Must Belong to This Case",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "Workflow Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Confirm Preservation of Existing Work",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Workflow Classification Required",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "Culture Method Is Not Compatible with the Workflow",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Workflow Is Not Supported",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "A Case Already Exists for This Workflow",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Select a Different Workflow",
  "microbiology.enum.NO_GROWTH_READY": "No Growth Ready",
  "microbiology.enum.NORMAL_FLORA": "Normal flora",
  "microbiology.enum.NEEDS_WORKFLOW": "Needs Workflow",
  "microbiology.enum.NOT_READY": "Not Ready",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Nonconformance Reported",
  "microbiology.enum.NONE": "Няма",
  "microbiology.enum.OPEN": "Open",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Organism Mapping Required",
  "microbiology.enum.ORGANISM": "Organism",
  "microbiology.enum.ORIGINAL": "Original",
  "microbiology.enum.OTHER": "Друг",
  "microbiology.enum.OUTPATIENT": "Outpatient",
  "microbiology.enum.PENDING": "Pending",
  "microbiology.enum.PASSED": "Успешно",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Телефон",
  "microbiology.enum.POSITIVE_SIGNAL": "Positive Signal",
  "microbiology.enum.PRELIM_RELEASED": "Preliminary Released",
  "microbiology.enum.PRELIMINARY": "Preliminary",
  "microbiology.enum.PRELIMINARY_RELEASED": "Preliminary Released",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Preliminary Report Released",
  "microbiology.enum.QC_FAILED": "QC Failed",
  "microbiology.enum.RECEIVED": "Received",
  "microbiology.enum.RELEASED": "Released",
  "microbiology.enum.REPEAT": "Repeat",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Reportable AST Run Required",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Reportable AST Run Must Be Reviewed",
  "microbiology.enum.RESULT": "Резултат",
  "microbiology.enum.RESULTS_IN": "Results In",
  "microbiology.enum.RETEST": "Повторен тест",
  "microbiology.enum.REVIEW_READY": "Review Ready",
  "microbiology.enum.REVIEWED": "Reviewed",
  "microbiology.enum.INTERMEDIATE": "Intermediate",
  "microbiology.enum.LOST_SPECIMEN": "Lost Specimen",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Lost Specimen - Positive Culture",
  "microbiology.enum.NO_BREAKPOINT": "No breakpoint",
  "microbiology.enum.RESISTANT": "Resistant",
  "microbiology.enum.ROUTINE": "Рутинни",
  "microbiology.enum.SAMPLE_ITEM": "Sample Item",
  "microbiology.enum.SETUP": "Настройка",
  "microbiology.enum.SETUP_RECORDED": "Setup Recorded",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Specimen Lost",
  "microbiology.enum.STAGE_CHANGED": "Stage Changed",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subculture Recorded",
  "microbiology.enum.UNASSIGNED": "Unassigned",
  "microbiology.enum.UNKNOWN_ERROR": "Unknown Error",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Workflow Changed",
  "microbiology.enum.ZONE": "Zone",
  "microbiology.enum.FINAL_RELEASED": "Final Released",
  "microbiology.enum.SUSCEPTIBLE": "Susceptible",
  "microbiology.enum.UNKNOWN": "Неизвестен",
  "rulebuilder.label.selectComponent": "Select Component",
  "testcalculation.label.selectComponent": "Select Component",
  "testcalculation.label.finalComponent": "Result Component",
  "qc.dashboard.tab.bench": "Bench QC",
  "qc.bench.source.all": "All bench sources",
  "qc.bench.source.manual": "Manual quantitative",
  "qc.bench.source.rdt": "Rapid test (RDT)",
  "qc.bench.column.runs": "Controls run",
  "qc.bench.column.lastRun": "Last run",
  "qc.bench.empty": "No manual or rapid-test controls were recorded in this period.",
  "microbiology.case.activityNote": "Activity note",
  "microbiology.case.accessionNumber": "Номер на акцесия",
  "microbiology.case.actionError": "Culture action could not be completed",
  "microbiology.case.action.markNoGrowth": "Mark no growth ready",
  "microbiology.case.action.recordGrowth": "Record growth detected",
  "microbiology.case.action.rejectCase": "Reject case",
  "microbiology.case.action.setIncubating": "Set incubating",
  "microbiology.case.action.startInoculation": "Start inoculation",
  "microbiology.case.createIsolate": "Create isolate",
  "microbiology.case.cultureAction": "Culture action",
  "microbiology.case.atmosphere": "Atmosphere",
  "microbiology.case.eyebrow": "Microbiology case workbench",
  "microbiology.case.sectionExpanded": "{section} expanded",
  "microbiology.case.sectionStatus": "Section status",
  "microbiology.case.error": "Microbiology case error",
  "microbiology.case.isolateLabel": "Isolate label",
  "microbiology.case.isolates": "Isolates",
  "microbiology.case.isolates.empty": "No isolates recorded",
  "microbiology.case.loadError": "Unable to load microbiology case",
  "microbiology.case.lastActivityBy": "Last activity by",
  "microbiology.case.incubation": "Incubation",
  "microbiology.case.media": "Media or bottle",
  "microbiology.case.nextStage": "Next stage",
  "microbiology.case.patient": "Пациент",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# NCE} other {# NCEs}}",
  "microbiology.case.relatedWorkflows": "Related specimen workflows",
  "microbiology.case.requestingLocation": "Requesting location",
  "microbiology.case.preliminaryOrganism": "Preliminary organism",
  "microbiology.case.recordActivity": "Record activity",
  "microbiology.case.sampleItem": "Sample item",
  "microbiology.case.setup": "Inoculation",
  "microbiology.case.setup.hint": "Record the initial setup, media, or incubation step for this culture case.",
  "microbiology.case.significance": "Significance",
  "microbiology.case.specimenType": "Specimen type",
  "microbiology.case.timeline": "Case timeline",
  "microbiology.case.timeline.addNote": "Add note",
  "microbiology.case.timeline.auto": "Auto",
  "microbiology.case.timeline.culturePurposeChange": "{from} to {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Culture purpose changed",
  "microbiology.case.timeline.empty": "No case activity recorded",
  "microbiology.case.timeline.hint": "Recorded case activity is shown chronologically.",
  "microbiology.case.timeline.manual": "Manual",
  "microbiology.case.timeline.note": "Note or observation",
  "microbiology.case.timeline.noteExpanded": "Note form expanded",
  "microbiology.case.timeline.performedBy": "Performed by {actor}",
  "microbiology.case.timeline.saveNote": "Save note",
  "microbiology.case.timeline.showAll": "Show all {count} events",
  "microbiology.case.timeline.showRecent": "Show recent {count} events",
  "microbiology.case.events": "events",
  "microbiology.case.finalLocked.message": "Isolate and AST changes are disabled after final release.",
  "microbiology.case.finalLocked.title": "Final case is read-only",
  "microbiology.case.title": "Microbiology case",
  "microbiology.case.workflow": "Работен процес",
  "microbiology.inoculation.addSubculture": "Add subculture",
  "microbiology.inoculation.empty": "No media recorded yet. Start inoculation to begin.",
  "microbiology.inoculation.hint": "Record each bottle or plate and retain its culture lineage.",
  "microbiology.inoculation.identifier": "Bottle or plate ID",
  "microbiology.inoculation.identifierHint": "Scan or type the identifier.",
  "microbiology.inoculation.parent": "Parent media",
  "microbiology.inoculation.parentPlaceholder": "Choose the source bottle or plate",
  "microbiology.inoculation.primaryExpanded": "Inoculation form expanded",
  "microbiology.inoculation.primary": "Основен",
  "microbiology.inoculation.recorded": "Recorded media",
  "microbiology.inoculation.save": "Save media",
  "microbiology.inoculation.source": "Source",
  "microbiology.inoculation.start": "Start inoculation",
  "microbiology.inoculation.subcultureExpanded": "Subculture form expanded",
  "microbiology.inoculation.subculture": "Subculture",
  "microbiology.amendment.actionError": "Amendment action could not be completed",
  "microbiology.amendment.cancel": "Cancel amendment",
  "microbiology.amendment.cancelReason": "Cancellation reason",
  "microbiology.amendment.cancelled": "Amendment cancelled; the final case is locked again",
  "microbiology.amendment.correctsVersion": "Corrects version {number}",
  "microbiology.amendment.hint": "Correct a final report without replacing its released history.",
  "microbiology.amendment.history": "Amendment history",
  "microbiology.amendment.inProgress.message": "Record the correction and release or cancel this amendment to lock the case again.",
  "microbiology.amendment.inProgress.title": "Amendment in progress",
  "microbiology.amendment.noReportVersions": "No final report versions recorded",
  "microbiology.amendment.none": "No amendments recorded",
  "microbiology.amendment.number": "Amendment",
  "microbiology.amendment.numberValue": "Amendment {number}",
  "microbiology.amendment.open": "Open amendment",
  "microbiology.amendment.opened": "Amendment opened; clinical corrections are now enabled",
  "microbiology.amendment.reason": "Amendment reason",
  "microbiology.amendment.release": "Release amended report",
  "microbiology.amendment.released": "Amended report released; the case is locked again",
  "microbiology.amendment.reportVersions": "Released report versions",
  "microbiology.amendment.status": "Статус",
  "microbiology.amendment.status.closed": "No open amendment",
  "microbiology.amendment.status.open": "Open amendment",
  "microbiology.amendment.title": "Amendments",
  "microbiology.amendment.version": "Version {number}",
  "microbiology.ast.antibiotic": "Antibiotic",
  "microbiology.ast.acceptResults": "Accept results",
  "microbiology.ast.acknowledgeFlags": "Acknowledge reviewed flags",
  "microbiology.ast.analyzer": "Анализатор",
  "microbiology.ast.analyzerOrganism": "Analyzer organism: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Card or panel {card} · software {version}",
  "microbiology.ast.analyzerResolutionReason": "Reason and corrective action",
  "microbiology.ast.actionError": "AST action could not be completed",
  "microbiology.ast.adjustPanel": "Adjust panel",
  "microbiology.ast.orderedAntibiotics": "Antibiotics to test",
  "microbiology.ast.actions": "Действия",
  "microbiology.ast.applyOverride": "Apply override",
  "microbiology.ast.attempt": "Attempt",
  "microbiology.ast.attemptMethod": "Attempt method",
  "microbiology.ast.attemptNumber": "Attempt {number}",
  "microbiology.ast.attemptReason": "Reason",
  "microbiology.ast.attemptScope": "Repeat scope",
  "microbiology.ast.attempts": "AST attempts",
  "microbiology.ast.attemptType": "Attempt type",
  "microbiology.ast.awaitingAnalyzerResults": "Awaiting analyzer results",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Results will appear automatically when the connected analyzer sends them. Unmatched events are retained in Analyzer Import Issues.",
  "microbiology.ast.awaitingSetupCount": "{count} awaiting setup",
  "microbiology.ast.cardId": "Card or panel ID",
  "microbiology.ast.entryMode": "Result entry",
  "microbiology.ast.entryMode.analyzer": "Connected analyzer",
  "microbiology.ast.entryMode.manual": "Manual entry",
  "microbiology.ast.expertFlags": "Analyzer expert flags require review",
  "microbiology.ast.hideOriginal": "Hide history",
  "microbiology.ast.historyTo": "to",
  "microbiology.ast.interpretation": "Интерпретация",
  "microbiology.ast.instrumentInterpretation": "Analyzer: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Invalidate and start new run",
  "microbiology.ast.includedInReport": "Included in report",
  "microbiology.ast.initialAttemptReason": "Initial attempt",
  "microbiology.ast.isolate": "Isolate",
  "microbiology.ast.method": "Method",
  "microbiology.ast.matchedBy": "Matched breakpoint",
  "microbiology.ast.measurement.mic": "MIC (ug/mL)",
  "microbiology.ast.measurement.zone": "Zone diameter (mm)",
  "microbiology.ast.noBreakpointGuidance": "No standard breakpoint. Interpret this reading according to the local SOP.",
  "microbiology.ast.noBreakpointTitle": "Local interpretation required",
  "microbiology.ast.noIsolate": "Create an isolate before recording AST",
  "microbiology.ast.noSourceAttempt": "Original attempt",
  "microbiology.ast.notIncludedInReport": "Not included",
  "microbiology.ast.newAttempt": "New repeat or retest",
  "microbiology.ast.noRunsYet": "No runs yet",
  "microbiology.ast.antibioticToRepeat": "Antibiotic to repeat",
  "microbiology.ast.override": "Override interpretation",
  "microbiology.ast.overrideHistory": "Override history",
  "microbiology.ast.optionsExpanded": "{section} options expanded.",
  "microbiology.ast.overrideReason": "Override reason",
  "microbiology.ast.orderedPanel": "Ordered AST panel",
  "microbiology.ast.organismMismatch": "Analyzer organism differs from the case isolate",
  "microbiology.ast.organismMismatchDetail": "The analyzer identity is informational. Review the discrepancy; the confirmed case isolate remains authoritative.",
  "microbiology.ast.overrideQc": "Override QC flag",
  "microbiology.ast.panel": "AST panel",
  "microbiology.ast.panelAdjustmentReason": "Reason for panel adjustment",
  "microbiology.ast.panelProvenance.organismDefault": "Ordered from the identified organism's configured default",
  "microbiology.ast.rawValue": "Result value",
  "microbiology.ast.qcFailed": "Analyzer QC failed",
  "microbiology.ast.qcFailedDetail": "QC reference {reference}. Result acceptance is blocked until this run is invalidated or a supervisor documents an override.",
  "microbiology.ast.replacementCardId": "New card or panel ID",
  "microbiology.ast.resultsReady": "Analyzer results ready for review",
  "microbiology.ast.resultsReadyDetail": "Review discrepancies, missing breakpoints, and expert flags before accepting these results.",
  "microbiology.ast.runsComplete": "{complete} / {total} runs complete",
  "microbiology.ast.pendingIdentificationCount": "{count} pending identification",
  "microbiology.ast.reasonForAttempt": "Reason for repeat or retest",
  "microbiology.ast.recordReading": "Record AST reading",
  "microbiology.ast.reviewRun": "Review AST run",
  "microbiology.ast.repeat": "Repeat",
  "microbiology.ast.revertOverride": "Revert to original",
  "microbiology.ast.revertReason": "Reason for reverting override",
  "microbiology.ast.reporting": "Reporting",
  "microbiology.ast.retest": "Повторен тест",
  "microbiology.ast.selectAntibiotic": "Select antibiotic",
  "microbiology.ast.singleAntibiotic": "Single antibiotic",
  "microbiology.ast.wholePanel": "Whole panel",
  "microbiology.ast.runStatus": "AST run status",
  "microbiology.ast.startRun": "Start AST run",
  "microbiology.ast.startAttempt": "Start {type} attempt",
  "microbiology.ast.sourceAttempt": "Source",
  "microbiology.ast.source": "Reading source",
  "microbiology.ast.showOriginal": "Show original",
  "microbiology.ast.title": "Manual AST",
  "microbiology.ast.useAttemptForReporting": "Use attempt {number} for reporting",
  "microbiology.ast.useForReporting": "Use for reporting",
  "microbiology.ast.view": "Преглед",
  "microbiology.ast.viewAttempt": "View attempt {number}",
  "microbiology.ast.viewing": "Viewing",
  "microbiology.ast.viewingAttempt": "Viewing attempt {number}",
  "microbiology.critical.acknowledge": "Потвърди",
  "microbiology.critical.followUp": "Follow-up needed",
  "microbiology.critical.hint": "Log critical-result callbacks and acknowledge them inline.",
  "microbiology.critical.log": "Log communication",
  "microbiology.critical.logForIsolate": "Log critical notification for {isolate}",
  "microbiology.critical.logNotification": "Log critical notification",
  "microbiology.critical.method": "Communication method",
  "microbiology.critical.message": "Съобщение",
  "microbiology.critical.messageRequired": "Message is required",
  "microbiology.critical.none": "No critical communications logged",
  "microbiology.critical.recipient": "Recipient",
  "microbiology.critical.recipientContact": "Recipient contact",
  "microbiology.critical.required": "Choose a target and provide the recipient and message.",
  "microbiology.critical.resolution": "Resolution note",
  "microbiology.critical.resolutionRequired": "A resolution note is required before closing communication.",
  "microbiology.critical.close": "Close communication",
  "microbiology.critical.target": "Critical result target",
  "microbiology.critical.targetId": "Target record",
  "microbiology.critical.title": "Critical communication",
  "microbiology.caseInfo.no": "Не",
  "microbiology.caseInfo.notProvided": "Not provided",
  "microbiology.caseInfo.summary": "Case information summary",
  "microbiology.caseInfo.yes": "Да",
  "microbiology.currentStep.open": "Open {step}",
  "microbiology.currentStep.title": "Current step",
  "microbiology.cultureAction.error": "The culture state could not be updated.",
  "microbiology.cultureAction.noGrowth.confirm": "Confirm no growth",
  "microbiology.cultureAction.noGrowth.detail": "Confirm that the required incubation period is complete and no growth was detected.",
  "microbiology.cultureAction.noGrowth.title": "Mark culture as no growth",
  "microbiology.cultureAction.positive.confirm": "Confirm positive signal",
  "microbiology.cultureAction.positive.detail": "Confirm the positive signal. The next action is to subculture and record the Gram stain.",
  "microbiology.cultureAction.positive.title": "Mark culture positive",
  "microbiology.nce.category": "Категория",
  "microbiology.nce.configurationBlockerTitle": "Configuration required",
  "microbiology.nce.configurationLoadError": "NCE categories and reporting units could not be loaded.",
  "microbiology.nce.critical": "Критична",
  "microbiology.nce.description": "Описание",
  "microbiology.nce.disposition": "Disposition",
  "microbiology.nce.errorTitle": "Nonconformance could not be reported",
  "microbiology.nce.flagOnly": "Flag only",
  "microbiology.nce.immediateAction": "Immediate action",
  "microbiology.nce.lostTypeMissing": "The active NCE configuration does not include a Specimen lost type.",
  "microbiology.nce.major": "Major",
  "microbiology.nce.markLost": "Mark lost",
  "microbiology.nce.markLostHint": "Record the physical specimen as lost and reject affected open tests.",
  "microbiology.nce.markLostTitle": "Mark specimen lost",
  "microbiology.nce.minor": "Minor",
  "microbiology.nce.rejectTests": "Reject affected tests",
  "microbiology.nce.retest": "Retest AST",
  "microbiology.nce.retestLoadError": "Reviewed AST runs could not be loaded. Try again before selecting Retest AST.",
  "microbiology.nce.sourceAstRun": "AST run to retest",
  "microbiology.nce.report": "Report NCE",
  "microbiology.nce.reportHint": "Record a nonconformance against this specimen and choose its disposition.",
  "microbiology.nce.reportingUnit": "Reporting unit",
  "microbiology.nce.reportTitle": "Report nonconformance",
  "microbiology.nce.required": "Choose a category, reporting unit, and severity, and provide a description.",
  "microbiology.nce.sectionTitle": "Nonconformance",
  "microbiology.nce.severity": "Сериозност",
  "microbiology.nce.submitError": "The nonconformance could not be saved.",
  "microbiology.nce.title": "Заглавие",
  "microbiology.nce.type": "Тип",
  "microbiology.isolate.identify": "Identify organism",
  "microbiology.isolate.reidentify": "Reidentify",
  "microbiology.isolate.identified": "Identified",
  "microbiology.isolate.pending": "Identification pending",
  "microbiology.isolate.gramStain": "Gram stain",
  "microbiology.isolate.colonyMorphology": "Colony morphology",
  "microbiology.isolate.identification": "Identification",
  "microbiology.isolate.identificationMethod": "ID method",
  "microbiology.isolate.identificationConfidence": "ID confidence (%)",
  "microbiology.isolate.identificationChange": "{previous} to {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Identification history",
  "microbiology.isolate.identificationReason": "Re-identification reason",
  "microbiology.isolate.organism.select": "Select an organism",
  "microbiology.isolate.unidentified": "Unidentified",
  "microbiology.ast.identificationRequired": "Identify the isolate before setting up AST.",
  "microbiology.next.createIsolate": "Inoculation recorded. Add significant growth or mark the case ready for no-growth handling.",
  "microbiology.next.completeAmendment": "Amendment open. Record the correction, review the report, then release the amended version.",
  "microbiology.next.classifyWorkflow": "Choose the correct workflow and Culture Method before beginning profile-specific work.",
  "microbiology.next.finalReleased": "Final report released. Review surveillance readiness before export.",
  "microbiology.next.incubating": "Incubating. Mark the case positive when growth is signaled, or mark no growth when the required incubation period is complete.",
  "microbiology.next.subculturePositive": "Positive signal recorded. Subculture the bottle and record the Gram stain.",
  "microbiology.next.recordSetup": "Case received. Record initial setup to begin incubation.",
  "microbiology.next.release": "AST reviewed. Confirm report readiness and release the final report.",
  "microbiology.next.noGrowthRelease": "No growth recorded. Review and release the final negative report.",
  "microbiology.next.reviewAst": "Isolate recorded. Complete and review AST before release.",
  "microbiology.next.title": "Next step",
  "microbiology.navigation.backToWorklist": "Back to microbiology worklist",
  "microbiology.navigation.menu": "Microbiology",
  "microbiology.navigation.worklist": "Microbiology worklist",
  "microbiology.orderEntry.discardConfirm": "Discard details",
  "microbiology.orderEntry.discardHeading": "Remove microbiology workflow?",
  "microbiology.orderEntry.discardMessage": "Removing the final culture test will discard the microbiology program details entered for this order.",
  "microbiology.orderEntry.programDerived": "Microbiology is derived from the selected culture test.",
  "microbiology.orderEntry.programDiscardHeading": "Discard Microbiology details?",
  "microbiology.orderEntry.programDiscardMessage": "You have entered Microbiology details. Changing the Program will discard them.",
  "order.context.workflowProgress": "Order workflow progress",
  "microbiology.orderEntry.hint": "These details travel with the routed culture case so the laboratory can begin setup without re-entering the order context.",
  "microbiology.orderEntry.incomplete": "Configure the Microbiology Program before saving this culture order.",
  "microbiology.orderEntry.programMissingMessage": "Microbiology Program is not configured for this order workflow.",
  "microbiology.orderEntry.programMissingTitle": "Program configuration required",
  "microbiology.orderEntry.routingMessage": "This will create a Microbiology Case for culture and susceptibility testing.",
  "microbiology.orderEntry.routingTitle": "Culture workflow selected",
  "microbiology.orderEntry.title": "Microbiology Program Details",
  "microbiology.culturePurpose.clinical": "Clinical diagnosis or treatment",
  "microbiology.culturePurpose.label": "Culture purpose",
  "microbiology.culturePurpose.screening": "Active screening or carriage",
  "microbiology.culturePurpose.unspecified": "Unspecified",
  "microbiology.orderDetail.antibioticExposure": "Patient has recent antibiotic exposure (within 2 weeks)",
  "microbiology.orderDetail.admissionDate": "Date of admission",
  "microbiology.orderDetail.admissionDateFuture": "Date of admission cannot be in the future.",
  "microbiology.orderDetail.admissionDateHelper": "Date admitted as an inpatient. Leave blank when it is not known.",
  "microbiology.orderDetail.admissionDateOutpatient": "Outpatients are not admitted - recorded as community-origin.",
  "microbiology.orderDetail.collectionDateContext": "Collection date: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Collected {days} days after admission - hospital-origin for surveillance.",
  "microbiology.orderDetail.collectionTimingCommunity": "Collected {days} days after admission - community-origin for surveillance.",
  "microbiology.orderDetail.clinicalHistory": "Clinical history",
  "microbiology.orderDetail.cultureMethod": "Culture Protocol",
  "microbiology.orderDetail.hint": "Capture the order context the lab needs for culture setup and critical-result follow-up.",
  "microbiology.orderDetail.numberOfSets": "Number of sets",
  "microbiology.orderDetail.numberOfSets.helper": "Collection groups, such as two blood-culture sets drawn from different sites. Not the specimen count or volume.",
  "microbiology.orderDetail.patientOrigin": "Patient origin",
  "microbiology.orderDetail.protocolDerived": "Derived",
  "microbiology.orderDetail.protocolHelper": "From the ordered test. Change it at the bench if the workup differs.",
  "microbiology.orderDetail.protocolUnset": "Not set - the bench will select a protocol",
  "microbiology.orderDetail.protocolUnsetTitle": "Protocol not set",
  "microbiology.orderDetail.save": "Save order detail",
  "microbiology.orderDetail.title": "Order detail",
  "microbiology.patientOrigin.emergency": "Emergency department",
  "microbiology.patientOrigin.icu": "Intensive care unit",
  "microbiology.patientOrigin.inpatient": "Inpatient ward",
  "microbiology.patientOrigin.other": "Друг",
  "microbiology.patientOrigin.outpatient": "Outpatient clinic",
  "microbiology.progress.ast": "AST results",
  "microbiology.progress.caseInfo": "Case info",
  "microbiology.progress.inoculation": "Inoculation",
  "microbiology.progress.isolates": "Isolates",
  "microbiology.progress.reports": "Отчети",
  "microbiology.progress.review": "Expert review",
  "microbiology.progress.timeline": "Timeline",
  "microbiology.progress.title": "Case progress",
  "microbiology.protocol.change": "Change protocol",
  "microbiology.protocol.error": "Protocol could not be changed",
  "microbiology.protocol.field": "Culture protocol",
  "microbiology.protocol.helper": "The protocol controls the planned media and incubation recipe. Recorded inoculations are never rewritten.",
  "microbiology.protocol.inactive": "Неактивен",
  "microbiology.protocol.loading": "Loading protocol",
  "microbiology.protocol.noChoices": "No other active protocol is linked to this ordered test and workflow.",
  "microbiology.protocol.noneMessage": "The ordered test did not provide a default. Select a protocol at the bench.",
  "microbiology.protocol.noneTitle": "No protocol set",
  "microbiology.protocol.placeholder": "Select a protocol",
  "microbiology.protocol.reason": "Reason for protocol change",
  "microbiology.protocol.save": "Save protocol",
  "microbiology.protocol.set": "Set protocol",
  "microbiology.protocol.title": "Culture protocol",
  "microbiology.protocol.updated": "Protocol updated",
  "microbiology.case.timeline.protocolChanged": "Culture protocol changed from {from} to {to}: {reason}",
  "microbiology.workflowChange.apply": "Apply workflow",
  "microbiology.workflowChange.error": "Workflow could not be changed",
  "microbiology.workflowChange.help": "Correct the workflow and Culture Method while preserving this case's existing history.",
  "microbiology.workflowChange.methodPlaceholder": "Choose a Culture Method",
  "microbiology.workflowChange.preserveConfirmation": "Preserve the existing setup, isolate, and AST history under the corrected workflow",
  "microbiology.workflowChange.preserveWarning": "This case already contains clinical work. The current stage and recorded history will be retained.",
  "microbiology.workflowChange.preserveWarningTitle": "Existing work will be preserved",
  "microbiology.workflowChange.reason": "Reason for change",
  "microbiology.workflowChange.requiredMessage": "Culture setup, isolate work, AST, and reporting are held until this case is classified.",
  "microbiology.workflowChange.requiredTitle": "Workflow classification required",
  "microbiology.workflowChange.title": "Change workflow",
  "microbiology.workflowChange.unassignedHelp": "Classify this case before beginning culture setup, isolate work, AST, or reporting.",
  "microbiology.workflowChange.workflow": "Работен процес",
  "microbiology.workflowChange.workflowPlaceholder": "Choose a workflow",
  "microbiology.readiness.blocked": "Final release blocked",
  "microbiology.readiness.ready": "Final release ready",
  "microbiology.reagentLots.blocked": "Blocked: {reason}",
  "microbiology.reagentLots.context": "Bench context",
  "microbiology.reagentLots.context.AST_SETUP": "AST setup",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Culture setup",
  "microbiology.reagentLots.empty": "No reagents are linked to this test.",
  "microbiology.reagentLots.fefo": "FEFO - use first",
  "microbiology.reagentLots.fifo.tooltip": "Lots are ordered by earliest expiry, then by receipt date when expiry is unavailable.",
  "microbiology.reagentLots.hint": "Select the exact lot used for each linked reagent or consumable.",
  "microbiology.reagentLots.history": "Recorded lot usage",
  "microbiology.reagentLots.legend": "Available lots for {reagent}",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "No expiry recorded",
  "microbiology.reagentLots.noLots": "No inventory lots are available for this reagent.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} available, expires {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Quantity per test: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} lot {lot} expired; pick another lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} lot {lot} no longer has enough quantity; pick another lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} lot {lot} failed QC; pick a QC-passed lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} lot {lot} has not passed QC; pick a QC-passed lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} lot {lot} is no longer available; refresh and pick another lot.",
  "microbiology.reagentLots.qc.FAILED": "QC failed",
  "microbiology.reagentLots.qc.PASSED": "QC passed",
  "microbiology.reagentLots.qc.PENDING": "QC pending",
  "microbiology.reagentLots.qc.QUARANTINED": "QC quarantined",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Консумирана",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Изтекъл срок",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Неактивен",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Insufficient quantity",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC failed",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "QC not passed",
  "microbiology.reagentLots.reagent": "Reagent or consumable",
  "microbiology.reagentLots.recorded": "Recorded",
  "microbiology.reagentLots.role.PRIMARY": "Основен",
  "microbiology.reagentLots.role.SECONDARY": "Secondary",
  "microbiology.reagentLots.scan.ambiguous": "That lot number matches more than one linked reagent. Select the lot in its reagent list.",
  "microbiology.reagentLots.scan.label": "Scan or enter lot number",
  "microbiology.reagentLots.scan.notFound": "No linked lot matches that lot number.",
  "microbiology.reagentLots.scan.placeholder": "Scan or enter the exact lot number",
  "microbiology.reagentLots.scan.selected": "Selected lot {lot}.",
  "microbiology.reagentLots.status": "Current lot status",
  "microbiology.reagentLots.status.ACTIVE": "Активен",
  "microbiology.reagentLots.status.CONSUMED": "Консумирана",
  "microbiology.reagentLots.status.IN_USE": "In use",
  "microbiology.reagentLots.title": "Reagent and lot traceability",
  "microbiology.reagentLots.used": "Quantity used",
  "microbiology.release.failed": "The report could not be released. Review the requirements and try again.",
  "microbiology.release.final": "Release final report",
  "microbiology.release.finalReleased": "Final report released",
  "microbiology.release.hint": "Release reports only when readiness checks pass.",
  "microbiology.release.mappingConfigured": "Patient-report mapping configured",
  "microbiology.release.mappingRequired": "Patient-report mapping required for final release",
  "microbiology.release.noReportableContent": "No reportable microbiology content is ready.",
  "microbiology.release.notEvaluated": "Readiness has not been evaluated yet",
  "microbiology.release.patientReport": "Patient report preview",
  "microbiology.release.preliminary": "Release preliminary report",
  "microbiology.release.readinessChecks": "Final release readiness",
  "microbiology.release.title": "Report readiness",
  "microbiology.release.viewPatientResults": "View patient results",
  "microbiology.release.useAmendment": "Release the corrected version from Amendments",
  "microbiology.release.whonetChecks": "WHONET readiness",
  "microbiology.whonet.blocked": "WHONET export blocked",
  "microbiology.whonet.ready": "WHONET export ready",
  "microbiology.worklist.clearFilters": "Clear filters",
  "microbiology.worklist.column.action": "Действие",
  "microbiology.worklist.column.context": "Context",
  "microbiology.worklist.column.due": "Due action",
  "microbiology.worklist.column.flags": "Flags",
  "microbiology.worklist.column.isolate": "Isolate",
  "microbiology.worklist.column.labNumber": "Lab #",
  "microbiology.worklist.column.lastActivity": "Last activity by",
  "microbiology.worklist.column.organism": "Organism",
  "microbiology.worklist.column.panel": "Панел",
  "microbiology.worklist.column.patient": "Пациент",
  "microbiology.worklist.column.priority": "Приоритет",
  "microbiology.worklist.column.sample": "Sample item",
  "microbiology.worklist.column.specimen": "Проба",
  "microbiology.worklist.column.stage": "Етап",
  "microbiology.worklist.column.started": "Started",
  "microbiology.worklist.column.status": "Статус",
  "microbiology.worklist.column.urgency": "Urgency",
  "microbiology.worklist.column.workflow": "Работен процес",
  "microbiology.worklist.critical": "Critical communication",
  "microbiology.worklist.dueDetail.ast_entry": "Set up AST for the identified isolate.",
  "microbiology.worklist.dueDetail.ast_review": "Review reported susceptibility results.",
  "microbiology.worklist.dueDetail.case_review": "Review report readiness and release.",
  "microbiology.worklist.dueDetail.isolate_id": "Record growth and identify an isolate.",
  "microbiology.worklist.dueDetail.incubating": "Day {day} of {max}",
  "microbiology.worklist.dueDetail.setup": "Record initial culture setup.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Subculture and record the Gram stain.",
  "microbiology.worklist.empty.ast": "No AST runs match. Clear the search or choose a different status.",
  "microbiology.worklist.empty.cultures": "No cultures match. Clear the search or choose a different status.",
  "microbiology.worklist.expertRulesUnavailable": "OpenELIS expert-rule flags are available in Phase 1B. Analyzer-reported flags are shown when present.",
  "microbiology.worklist.filters": "Worklist filters",
  "microbiology.worklist.filter.allActions": "All actions",
  "microbiology.worklist.filter.allStages": "All stages",
  "microbiology.worklist.filter.allUrgencies": "All urgency levels",
  "microbiology.worklist.filter.allWorkflows": "All workflows",
  "microbiology.worklist.filter.activeAst": "Active work",
  "microbiology.worklist.filter.astStatus": "AST status",
  "microbiology.worklist.filter.dueAction": "Due action",
  "microbiology.worklist.filter.reviewed": "Reviewed",
  "microbiology.worklist.filter.stage": "Етап",
  "microbiology.worklist.filter.urgency": "Urgency",
  "microbiology.worklist.filter.workflow": "Работен процес",
  "microbiology.worklist.flagsUnavailable": "Expert rules (Phase 1B)",
  "microbiology.worklist.loadError.subtitle": "The queue could not be loaded. Try refreshing the page.",
  "microbiology.worklist.loadError.title": "Unable to load microbiology worklist",
  "microbiology.worklist.linkedWorkflows": "Linked · {count} workflows",
  "microbiology.worklist.editAst": "Edit AST",
  "microbiology.worklist.grain.ast": "AST runs",
  "microbiology.worklist.grain.cultures": "Cultures",
  "microbiology.worklist.notSet": "Not set",
  "microbiology.worklist.notStarted": "Not started",
  "microbiology.worklist.markLost": "Mark lost",
  "microbiology.worklist.markNoGrowth": "Mark no growth",
  "microbiology.worklist.markPositive": "Mark positive",
  "microbiology.worklist.openCase": "Open case",
  "microbiology.worklist.newAstAttempt": "Set up new AST run",
  "microbiology.worklist.newPositive": "New positive",
  "microbiology.worklist.phase1b": "Available in Phase 1B",
  "microbiology.worklist.print": "Print list",
  "microbiology.worklist.qcDashboard": "QC dashboard",
  "microbiology.worklist.queueStatus": "Shared queue",
  "microbiology.worklist.refresh": "Refresh now",
  "microbiology.worklist.rowActions": "Row actions",
  "microbiology.worklist.recentActivity.empty": "No recent microbiology activity.",
  "microbiology.worklist.recentActivity.title": "Recent activity ({count})",
  "microbiology.worklist.resistance.hint": "Analyzer-reported flags completed today; OpenELIS expert-rule detection remains Phase 1B.",
  "microbiology.worklist.resistance.title": "Today's resistance hits",
  "microbiology.worklist.search.ast": "Search lab number, patient, isolate, organism, or panel",
  "microbiology.worklist.search.cultures": "Search lab number, patient, specimen, or workflow",
  "microbiology.worklist.sharedQueue": "Shared laboratory queue",
  "microbiology.worklist.siblings": "Sibling workflows",
  "microbiology.worklist.setupAst": "Set up AST",
  "microbiology.worklist.sort": "Sort",
  "microbiology.worklist.sort.newest": "Newest activity",
  "microbiology.worklist.sort.priority": "Приоритет",
  "microbiology.worklist.sort.workflow": "Работен процес",
  "microbiology.worklist.subtitle": "Prioritize culture cases by workflow stage, urgency, and required laboratory action.",
  "microbiology.worklist.summary.astReview": "AST review",
  "microbiology.worklist.summary.astInProgress": "In progress",
  "microbiology.worklist.summary.astInQueue": "In queue",
  "microbiology.worklist.summary.astPendingSetup": "Pending setup",
  "microbiology.worklist.summary.astResultsIn": "Results in - review",
  "microbiology.worklist.summary.caseReview": "Ready for case review",
  "microbiology.worklist.summary.critical": "Open critical follow-ups",
  "microbiology.worklist.summary.growthDetected": "Growth detected",
  "microbiology.worklist.summary.hint": "Select a queue to update the case list.",
  "microbiology.worklist.summary.identification": "Identification in progress",
  "microbiology.worklist.summary.incubating": "Incubating",
  "microbiology.worklist.summary.positive": "Positive",
  "microbiology.worklist.summary.expertFlags": "Expert flags (1B)",
  "microbiology.worklist.summary.title": "Work needing action",
  "microbiology.worklist.summary.totalPending": "Total pending",
  "microbiology.worklist.table.hint": "Cases are ordered by urgency and the next required action.",
  "microbiology.worklist.table.astTitle": "AST runs",
  "microbiology.worklist.table.title": "Open microbiology cases",
  "microbiology.worklist.viewAudit": "View audit",
  "microbiology.worklist.viewReviewedAst": "View reviewed AST",
  "microbiology.worklist.whonetExport": "Export to WHONET",
  "microbiology.worklist.surveillance.title": "Surveillance scope",
  "microbiology.worklist.surveillance.description": "Narrow the AST rows by reporting period and structured surveillance fields. Operational queue filters do not change the export population.",
  "microbiology.worklist.ast.automaticResults": "Analyzer results arrive automatically",
  "microbiology.worklist.ast.automaticResultsDetail": "Connected instruments send results directly to the case. Failed or unmatched events are retained in Analyzer Import Issues.",
  "microbiology.worklist.ast.awaitingResults": "Awaiting analyzer results",
  "microbiology.worklist.ast.pendingIdentification": "Identification pending",
  "microbiology.worklist.ast.resultsInBadge": "Results in",
  "microbiology.worklist.title": "Microbiology worklist",
  "microbiology.worklist.updated": "Updated {seconds}s ago · auto-refresh 30s",
  "microbiology.admin.action.deactivate": "Деактивирай",
  "microbiology.admin.action.moveDown": "Move down",
  "microbiology.admin.action.moveUp": "Move up",
  "microbiology.admin.action.reactivate": "Reactivate",
  "microbiology.admin.actions": "Row actions",
  "microbiology.admin.antibiotics.add": "Add antibiotic",
  "microbiology.admin.antibiotics.description": "Antimicrobial vocabulary used by AST panels and breakpoint rules.",
  "microbiology.admin.antibiotics.edit": "Antibiotic",
  "microbiology.admin.antibiotics.title": "Antibiotics",
  "microbiology.admin.astPanels.add": "Add AST panel",
  "microbiology.admin.astPanels.antibiotic": "Antibiotic",
  "microbiology.admin.astPanels.behavior.always": "Always",
  "microbiology.admin.astPanels.behavior.cascade": "Cascade",
  "microbiology.admin.astPanels.behavior.resistant": "Only when resistant",
  "microbiology.admin.astPanels.current": "Current",
  "microbiology.admin.astPanels.confirmDeactivate": "Publish version {version} as unavailable for new work? Existing AST runs will retain their original panel version.",
  "microbiology.admin.astPanels.confirmPublish": "Publish version {version}? Existing AST runs will retain their original panel version.",
  "microbiology.admin.astPanels.confirmTitle": "Confirm panel publication",
  "microbiology.admin.astPanels.historical": "Historical",
  "microbiology.admin.astPanels.loadingEditor": "AST panel administration is loading.",
  "microbiology.admin.astPanels.publishVersion": "Publish new version",
  "microbiology.admin.astPanels.readOnly": "This historical version is read-only. Open the current version to publish a change.",
  "microbiology.admin.astPanels.reportBehavior": "Report behavior",
  "microbiology.admin.astPanels.tier": "Tier",
  "microbiology.admin.astPanels.title": "AST panels",
  "microbiology.admin.astPanels.version": "Version",
  "microbiology.admin.astPanels.versionNotice": "Saving creates a new panel version; existing AST runs keep their original version.",
  "microbiology.admin.astPanels.viewVersion": "View version",
  "microbiology.admin.breakpoints.activate": "Activate standard",
  "microbiology.admin.breakpoints.applyValid": "Apply valid rows",
  "microbiology.admin.breakpoints.archive": "Archive standard",
  "microbiology.admin.breakpoints.archiveConfirm": "This standard will remain available to historical AST runs but cannot be selected for new work.",
  "microbiology.admin.breakpoints.back": "Back to standards",
  "microbiology.admin.breakpoints.breakpointType": "Breakpoint type",
  "microbiology.admin.breakpoints.chooseFile": "Choose CSV file",
  "microbiology.admin.breakpoints.correction.add": "Add local correction",
  "microbiology.admin.breakpoints.correction.edit": "Edit local correction",
  "microbiology.admin.breakpoints.count.imported": "{count} imported",
  "microbiology.admin.breakpoints.count.skipped": "{count} skipped",
  "microbiology.admin.breakpoints.count.unchanged": "{count} unchanged",
  "microbiology.admin.breakpoints.count.valid": "{count} valid",
  "microbiology.admin.breakpoints.csv": "Breakpoint CSV",
  "microbiology.admin.breakpoints.description": "Loaded breakpoint standards and the version active for new AST runs.",
  "microbiology.admin.breakpoints.detail": "Breakpoint rules",
  "microbiology.admin.breakpoints.downloadRejected": "Download rejected rows",
  "microbiology.admin.breakpoints.effectiveDate": "Effective date",
  "microbiology.admin.breakpoints.import": "Import CSV",
  "microbiology.admin.breakpoints.intermediate": "Intermediate",
  "microbiology.admin.breakpoints.intermediateLower": "Intermediate lower",
  "microbiology.admin.breakpoints.intermediateUpper": "Intermediate upper",
  "microbiology.admin.breakpoints.groupOption": "Group: {name}",
  "microbiology.admin.breakpoints.method.all": "All methods",
  "microbiology.admin.breakpoints.method.zone": "Zone",
  "microbiology.admin.breakpoints.organism": "Organism or group",
  "microbiology.admin.breakpoints.organismGroup": "Organism group",
  "microbiology.admin.breakpoints.publisher": "Publisher",
  "microbiology.admin.breakpoints.resistant": "Resistant",
  "microbiology.admin.breakpoints.rowError": "Row {row}",
  "microbiology.admin.breakpoints.rules": "Rules",
  "microbiology.admin.breakpoints.source": "Source",
  "microbiology.admin.breakpoints.source.imported": "Imported",
  "microbiology.admin.breakpoints.source.local": "Local correction",
  "microbiology.admin.breakpoints.source.manual": "Manual",
  "microbiology.admin.breakpoints.specimen": "Specimen context",
  "microbiology.admin.breakpoints.specimen.any": "Any specimen",
  "microbiology.admin.breakpoints.status.active": "Активен",
  "microbiology.admin.breakpoints.status.archived": "Архивирано",
  "microbiology.admin.breakpoints.status.loaded": "Loaded",
  "microbiology.admin.breakpoints.susceptible": "Susceptible",
  "microbiology.admin.breakpoints.title": "Breakpoint standards",
  "microbiology.admin.breakpoints.units": "Единици",
  "microbiology.admin.breakpoints.view": "View rules",
  "microbiology.admin.filter.all": "Всички",
  "microbiology.admin.sort": "Sort",
  "microbiology.admin.sort.nameAsc": "Name A-Z",
  "microbiology.admin.sort.nameDesc": "Name Z-A",
  "microbiology.admin.cultureSetups.add": "Add culture setup",
  "microbiology.admin.cultureSetups.description": "Culture defaults associated with existing laboratory methods.",
  "microbiology.admin.cultureSetups.edit": "Culture setup",
  "microbiology.admin.cultureSetups.title": "Culture methods",
  "microbiology.admin.deactivate.impact": "{name} is used by {count, plural, one {# existing workflow record} other {# existing workflow records}}. Deactivation prevents new selection but preserves those historical references.",
  "microbiology.admin.deactivate.title": "Review deactivation impact",
  "microbiology.admin.deactivated": "Reference deactivated",
  "microbiology.admin.empty": "No matching reference records",
  "microbiology.admin.error.save": "The reference record could not be saved.",
  "microbiology.admin.error.title": "Unable to complete request",
  "microbiology.admin.field.active": "Available for new work",
  "microbiology.admin.field.atmosphere": "Atmosphere defaults",
  "microbiology.admin.field.class": "Class",
  "microbiology.admin.field.code": "Код",
  "microbiology.admin.field.defaultPanel": "Default AST panel",
  "microbiology.admin.field.defaultPanelId": "Default AST panel ID",
  "microbiology.admin.field.gramStain": "Gram stain",
  "microbiology.admin.field.group": "Organism group",
  "microbiology.admin.field.incubation": "Incubation defaults",
  "microbiology.admin.field.incubationHours": "Routine read interval (hours)",
  "microbiology.admin.field.subcultureAtHours": "Subculture at (hours)",
  "microbiology.admin.field.maxIncubationDays": "Maximum incubation (days)",
  "microbiology.admin.field.media": "Media defaults",
  "microbiology.admin.field.method": "Method",
  "microbiology.admin.field.methodId": "Method ID",
  "microbiology.admin.field.name": "Име",
  "microbiology.admin.field.notes": "Бележки",
  "microbiology.admin.field.oclCode": "OCL code",
  "microbiology.admin.field.reportableAnalyteId": "Reportable analyte ID",
  "microbiology.admin.field.route": "Route",
  "microbiology.admin.field.shortName": "Short name",
  "microbiology.admin.field.significance": "Initial significance",
  "microbiology.admin.field.whonetCode": "WHONET code",
  "microbiology.admin.field.workflow": "Работен процес",
  "microbiology.admin.organisms.add": "Add organism",
  "microbiology.admin.organisms.description": "Organism vocabulary used by culture identification and AST.",
  "microbiology.admin.organisms.edit": "Organism",
  "microbiology.admin.organisms.title": "Организми",
  "microbiology.admin.patientOrigins.description": "Configured patient origin choices used during microbiology order entry and WHONET export.",
  "microbiology.admin.patientOrigins.title": "Patient origins",
  "microbiology.admin.reactivated": "Reference reactivated",
  "microbiology.admin.route.both": "Oral and IV",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "Topical",
  "microbiology.admin.saved": "Reference saved",
  "microbiology.admin.search": "Search reference data",
  "microbiology.admin.sections": "Microbiology reference sections",
  "microbiology.admin.significance.possible": "Possible pathogen",
  "microbiology.admin.significance.rare": "Rare pathogen",
  "microbiology.admin.significance.usually": "Usually significant",
  "microbiology.admin.status": "Статус",
  "microbiology.admin.status.active": "Активен",
  "microbiology.admin.status.all": "All statuses",
  "microbiology.admin.status.inactive": "Неактивен",
  "microbiology.admin.title": "Microbiology reference data",
  "microbiology.admin.workflow.all": "All workflows",
  "microbiology.workflow.bacteriology": "Bacteriology",
  "microbiology.workflow.mycobacteriology": "Микобактериология",
  "microbiology.workflow.mycology": "Микология",
  "microbiology.workflow.parasitology": "Паразитология",
  "button.add": "Добави",
  "button.remove": "Премахни",
  "sidenav.label.microbiology": "Microbiology",
  "sidenav.label.microbiology.worklist": "Microbiology worklist",
  "sidenav.label.microbiology.whonet": "WHONET export",
  "microbiology.whonet.title": "WHONET export",
  "microbiology.whonet.eyebrow": "Routine bacteriology surveillance",
  "microbiology.whonet.subtitle": "Review finalized culture and AST data before generating the current OpenELIS surveillance CSV for WHONET validation.",
  "microbiology.whonet.progress": "WHONET export progress",
  "microbiology.whonet.step.configure": "Configure",
  "microbiology.whonet.step.preview": "Предварителен преглед",
  "microbiology.whonet.step.generate": "Генерирай",
  "microbiology.whonet.configure.title": "Configure export",
  "microbiology.whonet.configure.description": "Choose the reporting period and the isolates to include.",
  "microbiology.whonet.from": "От",
  "microbiology.whonet.to": "До",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "The end date must be on or after the start date.",
  "microbiology.whonet.period.preset": "Reporting period",
  "microbiology.whonet.period.thisMonth": "This Month",
  "microbiology.whonet.period.lastMonth": "Last Month",
  "microbiology.whonet.period.thisQuarter": "This Quarter",
  "microbiology.whonet.period.custom": "Персонализирано",
  "microbiology.whonet.source.worklist.title": "Scope provided by the AST worklist",
  "microbiology.whonet.source.worklist.description": "The reporting period and structured surveillance filters came from the AST worklist. They remain editable here.",
  "microbiology.whonet.source.worklist.clear": "Clear worklist scope",
  "microbiology.whonet.significance": "Inclusion",
  "microbiology.whonet.significance.clinical": "Clinically significant isolates",
  "microbiology.whonet.significance.all": "All isolates",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Clinically significant",
  "microbiology.whonet.significance.CONTAMINANT": "Contaminant",
  "microbiology.whonet.significance.NORMAL_FLORA": "Normal flora",
  "microbiology.whonet.significance.UNKNOWN": "Not classified",
  "microbiology.whonet.culturePurpose.description": "Clinical cultures are included by default. Add other populations explicitly when the surveillance question requires them.",
  "microbiology.whonet.culturePurpose.includeScreening": "Include active screening or carriage cultures",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Include historical cultures with unspecified purpose",
  "microbiology.whonet.culturePurpose.title": "Culture purpose",
  "microbiology.whonet.filter.specimen": "Specimen types",
  "microbiology.whonet.filter.organism": "Организми",
  "microbiology.whonet.filter.origin": "Patient origins",
  "microbiology.whonet.filter.any": "Всяко",
  "microbiology.whonet.filter.choose": "Choose values",
  "microbiology.whonet.dedup": "De-duplication",
  "microbiology.whonet.dedup.apply": "Apply first-isolate selection",
  "microbiology.whonet.dedup.apply.help": "Collapse repeat isolates for the same patient and organism within the selected window.",
  "microbiology.whonet.dedup.advanced": "Adjust first-isolate policy",
  "microbiology.whonet.dedup.window": "Window length",
  "microbiology.whonet.dedup.window.help": "Repeats at the exact selected-day boundary begin a new window.",
  "microbiology.whonet.dedup.sevenDay": "7 days",
  "microbiology.whonet.dedup.fourteenDay": "14 days",
  "microbiology.whonet.dedup.thirtyDay": "30 days",
  "microbiology.whonet.dedup.basis": "Window date",
  "microbiology.whonet.dedup.basis.collection": "Specimen collection date",
  "microbiology.whonet.dedup.basis.release": "Final result-release date",
  "microbiology.whonet.dedup.basis.help": "Choose whether the window follows specimen collection or final result release. The reporting period always follows collection date.",
  "microbiology.whonet.dedup.scope": "Specimen-source scope",
  "microbiology.whonet.dedup.scope.any": "Any specimen source",
  "microbiology.whonet.dedup.scope.same": "Same specimen source only",
  "microbiology.whonet.dedup.scope.help": "Any source compares the patient and organism across specimen types; same source compares within each specimen type.",
  "microbiology.whonet.dedup.contaminants": "Exclude probable contaminants before selection",
  "microbiology.whonet.dedup.contaminants.help": "Remove probable contaminants before choosing the first representative isolate.",
  "microbiology.whonet.dedup.profile": "Susceptibility profile",
  "microbiology.whonet.dedup.profile.insensitive": "Ignore changed S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Treat changed S/I/R as new",
  "microbiology.whonet.dedup.profile.help": "Profile-sensitive selection counts a different reviewed antibiotic S/I/R pattern as a new isolate within the window.",
  "microbiology.whonet.dedup.none": "No de-duplication",
  "microbiology.whonet.preview.action": "Preview export",
  "microbiology.whonet.preview.title": "Предварителен преглед",
  "microbiology.whonet.preview.description": "These counts and rows will be used when the CSV is generated.",
  "microbiology.whonet.generate.action": "Generate CSV",
  "microbiology.whonet.count.cases": "Finalized cases",
  "microbiology.whonet.count.clinicalPurpose": "Clinical cultures",
  "microbiology.whonet.count.screeningPurpose": "Screening cultures",
  "microbiology.whonet.count.unspecifiedPurpose": "Unspecified cultures",
  "microbiology.whonet.count.purposeIncluded": "After culture-purpose selection",
  "microbiology.whonet.count.isolates": "Isolates found",
  "microbiology.whonet.count.specimen": "After specimen filter",
  "microbiology.whonet.count.organism": "After organism filter",
  "microbiology.whonet.count.origin": "After origin filter",
  "microbiology.whonet.count.included": "Isolates included",
  "microbiology.whonet.count.deduplicated": "After de-duplication",
  "microbiology.whonet.count.mappable": "Mappable isolates",
  "microbiology.whonet.count.rows": "Eligible rows",
  "microbiology.whonet.count.excluded": "Rows excluded",
  "microbiology.whonet.mapping.title": "Mapping readiness",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# row excluded} other {# rows excluded}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Fix organism mapping",
  "microbiology.whonet.mapping.fixAntibiotic": "Fix antibiotic mapping",
  "microbiology.whonet.mapping.fixSpecimen": "Fix specimen mapping",
  "microbiology.whonet.table.title": "Eligible AST rows",
  "microbiology.whonet.table.description": "Reviewed, reportable AST readings with the mappings required by this export.",
  "microbiology.whonet.table.accession": "Lab number",
  "microbiology.whonet.table.specimen": "Проба",
  "microbiology.whonet.table.organism": "Organism",
  "microbiology.whonet.table.antibiotic": "Antibiotic",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Method",
  "microbiology.whonet.error.title": "WHONET export could not be completed",
  "microbiology.whonet.error.invalidRequest": "Review the reporting period and export options, then try again.",
  "microbiology.whonet.error.blocked": "No valid rows remain. Resolve the listed readiness issues before generating the CSV.",
  "microbiology.whonet.error.network": "The export service could not be reached. Try again when the connection is available.",
  "microbiology.whonet.error.generic": "The export request could not be completed.",
  "microbiology.whonet.preview.loading": "Preparing the export preview.",
  "microbiology.whonet.preview.announced": "Preview ready with {count, plural, one {# eligible row} other {# eligible rows}}.",
  "microbiology.whonet.generated.title": "CSV generated",
  "microbiology.whonet.generated.subtitle": "The validated export was downloaded and its audit summary was recorded.",
  "catalog.import.title": "Import Catalog (CSV)",
  "catalog.import.description": "Load test catalog files without editing tests one at a time. Preview checks each file against the catalog as it stands and keeps nothing, so a row that needs a lab unit, specimen or test another file in the same upload creates is listed as skipped until you apply. Apply loads the files in order and saves them with the configuration, so the next restart loads exactly what you applied.",
  "catalog.import.dropzone": "Add CSV files",
  "catalog.import.preview": "Предварителен преглед",
  "catalog.import.apply": "Приложи",
  "catalog.import.remove": "Премахни",
  "catalog.import.plan.title": "What these files would do",
  "catalog.import.result.title": "What was loaded",
  "catalog.import.column.file": "File",
  "catalog.import.column.domain": "Catalog area",
  "catalog.import.column.created": "Създадено",
  "catalog.import.column.updated": "Актуализирано",
  "catalog.import.column.skipped": "Skipped",
  "catalog.import.column.name": "Name in the file",
  "catalog.import.column.where": "Where it appeared",
  "catalog.import.column.use": "Use this record",
  "catalog.import.file.error": "This file could not be read",
  "catalog.import.applied": "The catalog files were applied.",
  "catalog.import.applied.partial": "Some catalog files were not loaded. The table says which, and why.",
  "catalog.import.apply.failed": "The catalog files were not applied.",
  "catalog.import.apply.hint": "Preview the files first. Apply opens once the preview shows no file errors.",
  "catalog.import.failed": "The catalog files could not be sent.",
  "catalog.import.unresolved.title": "Needs your decision",
  "catalog.import.unresolved.description": "Names the import could not match to a record. Point each one at the record it means, or skip it. Remembering a name resolves it by itself next time.",
  "catalog.import.unresolved.empty": "Nothing is waiting for a decision.",
  "catalog.import.remember": "Remember this name",
  "catalog.import.resolve": "Use",
  "catalog.import.skip": "Skip",
  "sidenav.label.admin.catalogImport": "Import Catalog (CSV)",
  "reporting.design.subtitle": "Create a CSV for a new question or rerun a familiar report for a new period.",
  "reporting.design.overview": "Export overview",
  "reporting.design.newTitle": "Create a new export",
  "reporting.design.newHelp": "Choose the kind of report, the fields you need, and a reporting period. Your work remains available if you visit the queue or return later.",
  "reporting.design.savedTitle": "Use a saved report",
  "reporting.design.savedHelp": "Reuse saved fields and filters, then choose a fresh reporting period.",
  "reporting.design.start": "Start a new export",
  "reporting.design.continue": "Continue current export",
  "reporting.design.newExport": "New export",
  "reporting.design.useReport": "Use report",
  "reporting.design.savedFields": "{count} saved fields · reporting period is never saved",
  "reporting.design.steps": "Export steps",
  "reporting.design.chooseColumns": "Choose columns",
  "reporting.design.setFilters": "Set Filters",
  "reporting.design.reviewSubmit": "Review & Submit",
  "reporting.design.typeQuestion": "What kind of information do you need?",
  "reporting.design.typeHelp": "Choose one report type so every CSV row has a clear meaning. You can change the type until you select fields.",
  "reporting.design.type.SAMPLE_TESTING": "Sample & Testing",
  "reporting.design.type.REFERRALS": "Препращания",
  "reporting.design.type.NON_CONFORMANCE": "Non-Conformance",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Orders, results, patients & turnaround times",
  "reporting.design.typeHelp.REFERRALS": "Tests referred to other labs · preserves returned results and pending referrals",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Rejected samples & non-conforming events · preserves linked specimens and separate occurrences",
  "reporting.design.pending": "Not yet connected",
  "reporting.design.building": "You’re building a {type} report.",
  "reporting.design.changeType": "Change type and clear fields",
  "reporting.design.chooseType": "Choose a report type to see its fields.",
  "reporting.design.configuredReports": "Configured reports",
  "reporting.design.chooseConfigured": "Choose a configured report",
  "reporting.design.available": "Available fields",
  "reporting.design.findField": "Find a field",
  "reporting.design.searchPlaceholder": "Search all fields and groups…",
  "reporting.design.clearSearch": "Clear search",
  "reporting.design.fieldCount": "{count} fields across {groups} groups",
  "reporting.design.matchCount": "{count} matching fields across {groups} groups",
  "reporting.design.expansion": "Expand or collapse field groups",
  "reporting.design.expandAll": "Expand all",
  "reporting.design.collapseAll": "Collapse all",
  "reporting.design.groupCount": "{added} / {total} added",
  "reporting.design.scrollCatalog": "Scrollable field catalog",
  "reporting.design.addShown": "Add all shown",
  "reporting.design.removeShown": "Remove shown",
  "reporting.design.addShownGroup": "Add all shown {group} fields",
  "reporting.design.removeShownGroup": "Remove all shown {group} fields",
  "reporting.design.addField": "Add {field}",
  "reporting.design.addedField": "Added {field}",
  "reporting.design.add": "+ Add",
  "reporting.design.added": "Added",
  "reporting.design.noFields": "No fields match your search.",
  "reporting.design.selectedCount": "Your CSV columns ({count})",
  "reporting.design.orderHelp": "Drag a handle to change column order, or use the arrows. Arrow keys move the focused handle; Home and End move it to the first or last position.",
  "reporting.design.columnOrder": "CSV columns in order",
  "reporting.design.drag": "Drag {field} to reorder",
  "reporting.design.move": "Move {field}",
  "reporting.design.emptyColumns": "Add fields to build your CSV.",
  "reporting.design.addedMessage": "{field} added. {count} columns.",
  "reporting.design.removedMessage": "{field} removed. {count} columns.",
  "reporting.design.columnViews": "Column builder views",
  "reporting.design.yourColumns": "Your columns ({count})",
  "reporting.design.csvPreview": "CSV preview",
  "reporting.design.previewHelp": "Column layout in the order it will appear in your downloaded CSV.",
  "reporting.design.scrollPreview": "Scrollable CSV preview",
  "reporting.design.nextFilters": "Next: Set Filters",
  "reporting.design.nextReview": "Next: Review & Submit",
  "reporting.design.scopeFilters": "Scope Filters (Optional)",
  "reporting.design.periodDays": "{count, plural, one {# day} other {# days}}",
  "reporting.design.moreFilters": "Show more filters",
  "reporting.design.hideFilters": "Hide more filters",
  "reporting.design.sampleStatus": "Sample Status",
  "reporting.design.referringSite": "Referring Site",
  "reporting.design.reviewConfiguration": "Review Configuration",
  "reporting.design.dateFilters": "Date Range and filters",
  "reporting.design.testStatus": "Test and status",
  "reporting.design.change": "Change",
  "reporting.design.deliveryHelp": "Your CSV will be generated in the background. Download it here when ready, or return to My Report Queue.",
  "reporting.design.fileName": "File name",
  "reporting.design.customFileName": "Custom file name",
  "reporting.design.fileNamePending": "A file name is generated automatically. Custom names are not yet connected.",
  "reporting.design.saveLater": "Save these report settings for later",
  "reporting.design.saveSettings": "Save report settings",
  "reporting.design.queueHelp": "View and download your queued CSV exports.",
  "reporting.design.queue.jobName": "Job Name",
  "reporting.design.queue.report": "Отчет",
  "reporting.design.queue.size": "Rows / File Size",
  "reporting.design.queue.submitted": "Submitted At",
  "reporting.design.queuePending": "Active jobs refresh automatically. Retry failed exports, cancel queued work or rerun expired reports with fresh dates. Job deletion is not yet connected.",
  "reporting.design.details": "Details",
  "reporting.design.expires": "Available until {date}",
  "reporting.design.jobsShown": "Showing {count} jobs",
  "reporting.design.jobAction.EXPIRED": "Re-run",
  "reporting.design.labScope": "Lab Scope",
  "reporting.design.reviewFields": "Selected Fields ({count})",
  "reporting.recovery.cancelTitle": "Cancel export",
  "reporting.recovery.keepQueued": "Keep queued",
  "reporting.recovery.cancelHelp": "Cancel this queued export? If processing has already started, it will continue and you can return to its result.",
  "reporting.job.cannotCancel": "This export has already started or finished and cannot be cancelled.",
  "reporting.job.cannotRetry": "Only a failed export can be retried. Use the current job or start a new export.",
  "reporting.job.interrupted": "Processing was interrupted. Retry this export to generate a new file.",
  "reporting.job.claimLost": "This export is no longer assigned to the current worker. Return to the queue for its status.",
  "sidenav.section.main": "Main Menu",
  "sidenav.section.patientOrders": "Patient & Orders",
  "sidenav.section.administration": "Administration",
  "sidenav.workflow.orderTest": "Order Test",
  "sidenav.workflow.resultsValidation": "Results Validation",
  "sidenav.workflow.patientManagement": "Patient Management",
  "sidenav.moreTools": "More tools",
  "reporting.menu.otherReports": "Other reports",
  "reporting.menu.patientPrintQueue": "Patient Report Print Queue",
  "common.icon": "Icon",
  "menu.presentation.style": "Display as",
  "menu.presentation.item": "Menu item",
  "menu.presentation.section": "Section heading",
  "menu.configuration.managed": "Managed by instance configuration",
  "menu.configuration.description": "Update menu visibility, section headings and icons. Settings managed by this instance are read-only here.",
  "menu.configuration.loadError": "Menu settings could not be loaded.",
  "menu.configuration.saved": "Menu settings saved.",
  "menu.presentation.sectionHint": "Section headings group their child menu items without a link.",
  "menu.presentation.sectionIconHint": "Icons are shown on menu items, not section headings."
}
